import { z } from "zod";
export const zCategoryIdPathRoot = z.unknown();
export const zBackofficeCategoriesAllIconSettingsRoot = z.unknown();
export const zBackofficeCategoriesImagesUploadUrlRoot = z.unknown();
export const zBackofficeCategoriesCollectionRoot = z.unknown();
export const zBackofficeCategoriesItemRoot = z.unknown();
export const zPublicCategoriesCollectionRoot = z.unknown();
export const zAllCategoryIconSettingRoot = z.object({
    imageUrl: z.union([z.url(), z.null()]),
    updatedAt: z.union([z.iso.datetime().readonly(), z.null()]).readonly(),
});
export const zAllCategoryIconSetting = zAllCategoryIconSettingRoot;
export const zAllCategoryIconSettingUpdateRoot = z.object({
    imageUrl: z.optional(z.union([z.url().max(2048), z.null()])),
});
export const zAllCategoryIconSettingUpdate = zAllCategoryIconSettingUpdateRoot;
export const zCategoryRoot = z.object({
    id: z.uuid().readonly(),
    name: z.string().min(1).max(255),
    description: z.optional(z.union([z.string(), z.null()])),
    displayOrder: z.int().gte(0),
    imageUrl: z.optional(z.union([z.url(), z.null()])),
    thumbnailImageUrl: z.optional(z.union([z.url(), z.null()])),
    parentId: z.optional(z.union([z.uuid(), z.null()])),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
    deletedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
});
export const zCategory = zCategoryRoot;
export const zCategoryCreateRoot = z.object({
    name: z.string().min(1).max(255),
    description: z.optional(z.string()),
    displayOrder: z.int().gte(0),
    imageUrl: z.optional(z.url()),
    thumbnailImageUrl: z.optional(z.url()),
    parentId: z.optional(z.union([z.uuid(), z.null()])),
});
export const zCategoryCreate = zCategoryCreateRoot;
export const zCategoryImageUploadUrlRoot = z.object({
    uploadUrl: z.url(),
    imageUrl: z.url(),
    expiresIn: z.int().gte(1),
    expiresAt: z.iso.datetime(),
});
export const zCategoryImageUploadUrl = zCategoryImageUploadUrlRoot;
export const zCategoryListRoot = z.object({
    categories: z.array(zCategoryRoot),
    totalCount: z.int().gte(0),
    allCategoryImageUrl: z.optional(z.union([z.url(), z.null()])),
});
export const zCategoryList = zCategoryListRoot;
export const zCategorySummaryRoot = z.object({
    id: z.uuid(),
    name: z.string(),
    displayOrder: z.int(),
    imageUrl: z.optional(z.union([z.url(), z.null()])),
    thumbnailImageUrl: z.optional(z.union([z.url(), z.null()])),
    parentId: z.optional(z.union([z.uuid(), z.null()])),
    deletedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
});
export const zCategorySummary = zCategorySummaryRoot;
export const zCategoryUpdateRoot = z.object({
    name: z.optional(z.union([z.string().min(1).max(255), z.null()])),
    description: z.optional(z.union([z.string(), z.null()])),
    displayOrder: z.optional(z.union([z.int().gte(0), z.null()])),
    imageUrl: z.optional(z.union([z.url(), z.null()])),
    thumbnailImageUrl: z.optional(z.union([z.url(), z.null()])),
    parentId: z.optional(z.union([z.uuid(), z.null()])),
});
export const zCategoryUpdate = zCategoryUpdateRoot;
export const zBannerIdPathRoot = z.unknown();
export const zNoticeIdPathRoot = z.unknown();
export const zPageIdPathRoot = z.unknown();
export const zBackofficeBannerDisplayOrdersRoot = z.unknown();
export const zBackofficeBannersImagesUploadUrlRoot = z.unknown();
export const zBackofficeBannersCollectionRoot = z.unknown();
export const zBackofficeBannersItemRoot = z.unknown();
export const zBackofficeContentFilesUploadUrlRoot = z.unknown();
export const zBackofficeContentPagesCollectionRoot = z.unknown();
export const zBackofficeContentPagesItemRoot = z.unknown();
export const zBackofficeNoticesCollectionRoot = z.unknown();
export const zBackofficeNoticesItemRoot = z.unknown();
export const zPublicBannersRoot = z.unknown();
export const zPublicContentPagesItemRoot = z.unknown();
export const zPublicNoticeBannersRoot = z.unknown();
export const zPublicNoticePopupsRoot = z.unknown();
export const zPublicNoticesCollectionRoot = z.unknown();
export const zPublicNoticesItemRoot = z.unknown();
export const zActiveBannerRoot = z.object({
    bannerId: z.uuid(),
    imageUrl: z.url(),
    linkUrl: z.optional(z.union([z.url(), z.null()])),
    displayOrder: z.int(),
});
export const zActiveBannerListRoot = z.object({
    banners: z.array(zActiveBannerRoot),
});
export const zBannerImageUploadUrlRoot = z.object({
    uploadUrl: z.url(),
    imageUrl: z.url(),
    expiresIn: z.int().gte(1),
    expiresAt: z.iso.datetime(),
});
export const zBannerReorderRoot = z.object({
    orderedBannerIds: z.array(z.uuid()),
});
export const zBannerStatusRoot = z.enum(["ACTIVE", "INACTIVE"]);
export const zBannerRoot = z.object({
    bannerId: z.uuid().readonly(),
    title: z.string().max(100),
    imageUrl: z.url().max(500),
    linkUrl: z.optional(z.union([z.url().max(500), z.null()])),
    displayOrder: z.int().gte(0),
    displayFrom: z.optional(z.union([z.iso.datetime(), z.null()])),
    displayUntil: z.optional(z.union([z.iso.datetime(), z.null()])),
    status: zBannerStatusRoot,
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zBannerCreateRoot = z.object({
    title: z.string().max(100),
    imageUrl: z.url().max(500),
    linkUrl: z.optional(z.union([z.url().max(500), z.null()])),
    displayOrder: z.int().gte(0),
    displayFrom: z.optional(z.union([z.iso.datetime(), z.null()])),
    displayUntil: z.optional(z.union([z.iso.datetime(), z.null()])),
    status: z.optional(zBannerStatusRoot),
});
export const zBannerListRoot = z.object({
    banners: z.array(zBannerRoot),
    totalCount: z.int().gte(0),
});
export const zBannerUpdateRoot = z.object({
    title: z.optional(z.union([z.string().max(100), z.null()])),
    imageUrl: z.optional(z.union([z.url().max(500), z.null()])),
    linkUrl: z.optional(z.union([z.url().max(500), z.null()])),
    displayOrder: z.optional(z.union([z.int().gte(0), z.null()])),
    displayFrom: z.optional(z.union([z.iso.datetime(), z.null()])),
    displayUntil: z.optional(z.union([z.iso.datetime(), z.null()])),
    status: z.optional(z.union([zBannerStatusRoot, z.null()])),
});
export const zContentFilePurposeRoot = z.enum(["IMAGE", "ATTACHMENT"]);
export const zContentFileUploadUrlRoot = z.object({
    uploadUrl: z.url(),
    fileUrl: z.url(),
    expiresIn: z.int(),
    expiresAt: z.iso.datetime(),
});
export const zContentPageAttachmentRoot = z.object({
    fileName: z.string().max(255),
    fileUrl: z.url().max(1000),
    mimeType: z.string().max(150),
    sizeBytes: z.int().gte(0),
});
export const zContentPageRoot = z.object({
    pageId: z.uuid().readonly(),
    title: z.string().max(200),
    contentHtml: z.string(),
    attachments: z.array(zContentPageAttachmentRoot).max(10),
    isPublished: z.boolean(),
    publicPath: z.string(),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zContentPageCreateRoot = z.object({
    title: z.string().max(200),
    contentHtml: z.string(),
    attachments: z.optional(z.array(zContentPageAttachmentRoot).max(10)),
    isPublished: z.optional(z.boolean()).default(true),
});
export const zContentPageListRoot = z.object({
    pages: z.array(zContentPageRoot),
    totalCount: z.int().gte(0),
});
export const zContentPageUpdateRoot = z.object({
    title: z.optional(z.string().max(200)),
    contentHtml: z.optional(z.string()),
    attachments: z.optional(z.array(zContentPageAttachmentRoot).max(10)),
    isPublished: z.optional(z.boolean()),
});
export const zNoticePopupDismissPolicyRoot = z.enum([
    "ALLOW_HIDE_FOR_DAY",
    "SHOW_EVERY_LAUNCH",
]);
export const zNoticeRoot = z.object({
    noticeId: z.uuid().readonly(),
    title: z.string().max(200),
    contentHtml: z.string(),
    isPublished: z.boolean(),
    isPinned: z.boolean(),
    publishedAt: z.union([z.iso.datetime(), z.null()]),
    popupEnabled: z.boolean(),
    popupStartAt: z.union([z.iso.datetime(), z.null()]),
    popupEndAt: z.union([z.iso.datetime(), z.null()]),
    popupImageUrl: z.union([z.url().max(1000), z.null()]),
    popupDismissPolicy: zNoticePopupDismissPolicyRoot,
    popupPriority: z.int().gte(0),
    bannerEnabled: z.boolean(),
    bannerImageUrl: z.union([z.url().max(1000), z.null()]),
    bannerPriority: z.int().gte(0),
    categoryIds: z.array(z.uuid()).max(50),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
    publicPath: z.string().readonly(),
});
export const zNoticeCreateRoot = z.object({
    title: z.string().max(200),
    contentHtml: z.string(),
    isPublished: z.optional(z.boolean()).default(false),
    isPinned: z.optional(z.boolean()).default(false),
    popupEnabled: z.optional(z.boolean()).default(false),
    popupStartAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    popupEndAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    popupImageUrl: z.optional(z.union([z.url().max(1000), z.null()])),
    popupDismissPolicy: z.optional(zNoticePopupDismissPolicyRoot),
    popupPriority: z.optional(z.int().gte(0)).default(0),
    bannerEnabled: z.optional(z.boolean()).default(false),
    bannerImageUrl: z.optional(z.union([z.url().max(1000), z.null()])),
    bannerPriority: z.optional(z.int().gte(0)).default(0),
    categoryIds: z.optional(z.array(z.uuid()).max(50)).default([]),
});
export const zNoticeListRoot = z.object({
    notices: z.array(zNoticeRoot),
    totalCount: z.int().gte(0),
});
export const zNoticeUpdateRoot = z.object({
    title: z.optional(z.string().max(200)),
    contentHtml: z.optional(z.string()),
    isPublished: z.optional(z.boolean()),
    isPinned: z.optional(z.boolean()),
    popupEnabled: z.optional(z.boolean()),
    popupStartAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    popupEndAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    popupImageUrl: z.optional(z.union([z.url().max(1000), z.null()])),
    popupDismissPolicy: z.optional(zNoticePopupDismissPolicyRoot),
    popupPriority: z.optional(z.int().gte(0)),
    bannerEnabled: z.optional(z.boolean()),
    bannerImageUrl: z.optional(z.union([z.url().max(1000), z.null()])),
    bannerPriority: z.optional(z.int().gte(0)),
    categoryIds: z.optional(z.array(z.uuid()).max(50)),
});
export const zPublicContentPageRoot = z.object({
    pageId: z.uuid(),
    title: z.string(),
    contentHtml: z.string(),
    attachments: z.array(zContentPageAttachmentRoot),
    updatedAt: z.iso.datetime(),
});
export const zPublicNoticeAdjacentRoot = z.object({
    noticeId: z.uuid(),
    title: z.string(),
});
export const zPublicNoticeRoot = z.object({
    noticeId: z.uuid(),
    title: z.string(),
    contentHtml: z.string(),
    isPinned: z.boolean(),
    publishedAt: z.iso.datetime(),
    previousNotice: z.union([zPublicNoticeAdjacentRoot, z.null()]),
    nextNotice: z.union([zPublicNoticeAdjacentRoot, z.null()]),
});
export const zPublicNoticeBannerRoot = z.object({
    noticeId: z.uuid(),
    title: z.string(),
    imageUrl: z.url(),
    categoryIds: z.array(z.uuid()),
});
export const zPublicNoticeBannerListRoot = z.object({
    banners: z.array(zPublicNoticeBannerRoot).max(10),
});
export const zPublicNoticePopupRoot = z.object({
    noticeId: z.uuid(),
    title: z.string(),
    imageUrl: z.url(),
    canHideForDay: z.boolean(),
});
export const zPublicNoticePopupListRoot = z.object({
    popups: z.array(zPublicNoticePopupRoot).max(5),
});
export const zPublicNoticeSummaryRoot = z.object({
    noticeId: z.uuid(),
    title: z.string(),
    isPinned: z.boolean(),
    publishedAt: z.iso.datetime(),
});
export const zPublicNoticeListRoot = z.object({
    notices: z.array(zPublicNoticeSummaryRoot),
    totalCount: z.int().gte(0),
    page: z.int().gte(1),
    pageSize: z.int().gte(1),
    hasNextPage: z.boolean(),
});
export const zDealerBuyerHistoriesItemRoot = z.unknown();
export const zDealerBuyerNewOrdersItemRoot = z.unknown();
export const zDealerDashboardSummaryRoot = z.unknown();
export const zDealerSalesHistoryCollectionRoot = z.unknown();
export const zDealerDashboardSummaryRoot2 = z.unknown();
export const zDealerDashboardOrderCountsRoot = z.object({
    paymentPending: z.int().gte(0),
    paid: z.int().gte(0),
    shipped: z.int().gte(0),
    delivered: z.int().gte(0),
    confirmed: z.int().gte(0),
    allCancelled: z.int().gte(0),
});
export const zDealerDashboardOrderCounts = zDealerDashboardOrderCountsRoot;
export const zUserSearchRoleQueryRoot = z.unknown();
export const zUserIdPathRoot = z.unknown();
export const zAdminAuthLoginRoot = z.unknown();
export const zAdminAuthRefreshRoot = z.unknown();
export const zAdminUsersSuspendRoot = z.unknown();
export const zAppInstallationsItemRoot = z.unknown();
export const zAuthDealerProxyTokensRoot = z.unknown();
export const zBackofficeAdminAccountsIdPasswordRoot = z.unknown();
export const zBackofficeAdminAccountsIdRoot = z.unknown();
export const zBackofficeAdminAccountsRoot = z.unknown();
export const zBackofficeAdminHistoriesRoot = z.unknown();
export const zBackofficeAdminLoginLocksLockIdReleaseRoot = z.unknown();
export const zBackofficeAdminLoginLocksRoot = z.unknown();
export const zBackofficeAppInstallationsSummaryRoot = z.unknown();
export const zBackofficeDatabaseResetRoot = z.unknown();
export const zBackofficeDealerHistoriesRoot = z.unknown();
export const zBackofficeNotificationSettingsSummaryRoot = z.unknown();
export const zBackofficeProfileImagesUploadUrlRoot = z.unknown();
export const zBackofficeUserHistoriesRoot = z.unknown();
export const zBackofficeUsersUserIdActivateRoot = z.unknown();
export const zBackofficeUsersUserIdAdminMemosRoot = z.unknown();
export const zBackofficeUsersUserIdDealerProxySessionsRoot = z.unknown();
export const zBackofficeUsersUserIdForceChangeNicknameRoot = z.unknown();
export const zBackofficeUsersUserIdGrantDealerPermissionRoot = z.unknown();
export const zBackofficeUsersUserIdInterestCategoriesRepromptRequestsRoot = z.unknown();
export const zBackofficeUsersUserIdInterestCategoriesRoot = z.unknown();
export const zBackofficeUsersUserIdProfileImagesRoot = z.unknown();
export const zBackofficeUsersUserIdRevokeDealerPermissionRoot = z.unknown();
export const zBackofficeUsersUserIdRoot = z.unknown();
export const zBackofficeUsersRoot = z.unknown();
export const zPublicAuthKakaoLoginRoot = z.unknown();
export const zPublicAuthNaverExchangeRoot = z.unknown();
export const zPublicAuthSocialLoginRoot = z.unknown();
export const zPublicAuthSocialSignupRoot = z.unknown();
export const zUsersDeviceTokensRoot = z.unknown();
export const zUsersInterestCategoriesRoot = z.unknown();
export const zUsersItemRoot = z.unknown();
export const zUsersLoginRoot = z.unknown();
export const zUsersNotificationSettingsRoot = z.unknown();
export const zUsersPhoneNumberRoot = z.unknown();
export const zUsersPhoneVerificationCodesRoot = z.unknown();
export const zUsersProfileImagesUploadUrlRoot = z.unknown();
export const zUsersProfileRoot = z.unknown();
export const zUsersRefreshRoot = z.unknown();
export const zUsersRegisterRoot = z.unknown();
export const zUsersSearchRoot = z.unknown();
export const zUsersUserIdWithdrawRoot = z.unknown();
export const zUsersVerifyPhoneRoot = z.unknown();
export const zBackofficeUserInterestCategoriesRoot = z.unknown();
export const zDealerPermissionResultRoot = z.unknown();
export const zDeviceTokenRoot = z.unknown();
export const zNotificationSettingsRoot = z.unknown();
export const zPhoneVerificationCodeSentRoot = z.unknown();
export const zProfileSummaryRoot = z.unknown();
export const zPublicUserSearchListRoot = z.unknown();
export const zUserAccountListRoot = z.unknown();
export const zUserAccountStatusRoot = z.unknown();
export const zUserDetailsRoot = z.unknown();
export const zUserInterestCategoriesRoot = z.unknown();
export const zUserPhoneNumberRoot = z.unknown();
export const zVerificationResultRoot = z.unknown();
export const zWithdrawUserAccountBlockedErrorRoot = z.unknown();
export const zWithdrawUserAccountResponseRoot = z.unknown();
export const zAdminLevelRoot = z.enum(["SUPER_ADMIN"]);
export const zAdminAccountCreateRoot = z.object({
    username: z
        .string()
        .min(4)
        .max(50)
        .regex(/^[a-zA-Z0-9_]+$/),
    adminLevel: zAdminLevelRoot,
});
export const zAdminLoginLockRoot = z.object({
    lockId: z.uuid().readonly(),
    purpose: z.enum(["ADMIN_BO", "STAGING_QA"]),
    scope: z.enum(["IP", "USERNAME"]),
    adminId: z.uuid().readonly(),
    adminUsername: z.union([z.string().readonly(), z.null()]).readonly(),
    ipAddress: z.union([z.string().readonly(), z.null()]).readonly(),
    lockedUntil: z.iso.datetime().readonly(),
    lastFailedAt: z.iso.datetime().readonly(),
});
export const zAdminLoginRequestRoot = z.object({
    username: z
        .string()
        .min(4)
        .max(50)
        .regex(/^[a-zA-Z0-9_]+$/),
});
export const zAdminMemoEntryRoot = z.object({
    adminMemoId: z.uuid().readonly(),
    content: z.string(),
    createdBy: z.string().readonly(),
    createdAt: z.iso.datetime().readonly(),
});
export const zAdminMemoEntry = zAdminMemoEntryRoot;
export const zAdminPasswordChangeRoot = z.object({
    currentPassword: z.string().min(8),
    newPassword: z.string().min(8),
});
export const zAdminStatusRoot = z.enum(["ACTIVE", "SUSPENDED", "DELETED"]);
export const zAdminAccountRoot = z.object({
    id: z.uuid().readonly(),
    username: z
        .string()
        .min(4)
        .max(50)
        .regex(/^[a-zA-Z0-9_]+$/),
    adminLevel: zAdminLevelRoot,
    status: zAdminStatusRoot,
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
    lastLoginAt: z.union([z.iso.datetime().readonly(), z.null()]).readonly(),
});
export const zAdminAccountUpdateRoot = z.object({
    adminLevel: z.optional(z.union([zAdminLevelRoot, z.null()])),
    status: z.optional(z.union([zAdminStatusRoot, z.null()])),
});
export const zAdminLoginResponseRoot = z.object({
    accessToken: z.string().readonly(),
    refreshToken: z.string().readonly(),
    expiresIn: z.int().readonly(),
    admin: zAdminAccountRoot,
});
export const zAppInstallationRoot = z.object({
    installationId: z.string(),
    userId: z.union([z.uuid(), z.null()]),
    platform: z.enum(["ANDROID", "IOS"]),
    appVersion: z.string(),
    buildNumber: z.int(),
    previousBuildNumber: z.union([z.int(), z.null()]),
    appUpdatedAt: z.iso.datetime(),
    firstSeenAt: z.iso.datetime(),
    lastSeenAt: z.iso.datetime(),
    reportCount: z.int(),
});
export const zAppInstallation = zAppInstallationRoot;
export const zBackofficeAppVersionSummaryRoot = z.object({
    status: z.enum(["ACTIVE", "SUSPENDED", "WITHDRAWN", "ALL"]),
    totalUsers: z.int().gte(0),
    rows: z.array(z.object({
        platform: z.enum(["ANDROID", "IOS"]),
        appVersion: z.string(),
        buildNumber: z.int(),
        userCount: z.int().gte(0),
    })),
});
export const zBackofficeProfileImageChangeRoot = z.object({
    profileImageUrl: z.union([z.url().max(2048), z.null()]),
    reason: z.string().min(1).max(500),
});
export const zBackofficeProfileImageChangeResultRoot = z.object({
    userId: z.uuid().readonly(),
    profileImage: z.union([z.string().readonly(), z.null()]).readonly(),
});
export const zBackofficeUserAccountDetailsDealerPermissionDetails = z.object({
    grantedAt: z.iso.datetime().readonly(),
    grantedBy: z.string().readonly(),
});
export const zBackofficeUserAccountDetailsSuspensionDetails = z.object({
    type: z.enum(["TEMPORARY", "PERMANENT"]),
    reason: z.string(),
    suspendedBy: z.string().readonly(),
    expiresAt: z.optional(z.union([z.iso.datetime(), z.null()])),
});
export const zConsentTypeRoot = z.enum(["PHONE_NUMBER_COLLECTION"]);
export const zBackofficeUserAccountDetailsUserConsentItem = z.object({
    consentType: zConsentTypeRoot,
    consentedAt: z.iso.datetime().readonly(),
});
export const zCreateAdminMemoRequestRoot = z.object({
    content: z.string().min(1),
});
export const zCreateAdminMemoRequest = zCreateAdminMemoRequestRoot;
export const zDatabaseResetRequestRoot = z.object({
    password: z.string().max(50),
    reason: z.string().min(10).max(500),
});
export const zDatabaseResetRequest = zDatabaseResetRequestRoot;
export const zDatabaseResetResponseRoot = z.object({
    success: z.boolean().readonly(),
    resetAt: z.iso.datetime().readonly(),
    tablesCleared: z.int().readonly(),
    message: z.string().readonly(),
});
export const zDatabaseResetResponse = zDatabaseResetResponseRoot;
export const zDealerHistoryActorTypeRoot = z.enum(["DEALER", "ADMIN_PROXY"]);
export const zDealerHistoryChannelRoot = z.enum(["DEALER_BACKOFFICE", "APP"]);
export const zDealerPermissionResultRoot2 = z.object({
    userId: z.string().readonly(),
    status: z.enum(["GRANTED", "REVOKED"]),
    performedBy: z.string().readonly(),
    performedAt: z.iso.datetime().readonly(),
});
export const zDealerPermissionRevokeRoot = z.object({
    revokedBy: z.string(),
    reason: z.string().min(10).max(1000),
});
export const zDealerProxySessionExchangeRequestRoot = z.object({
    code: z.string().min(1).max(200),
});
export const zDealerProxySessionStartRoot = z.object({
    proxySessionId: z.uuid().readonly(),
    code: z.string().readonly(),
    codeExpiresIn: z.int().gte(1).readonly(),
    expiresAt: z.iso.datetime().readonly(),
});
export const zDeviceTokenRoot2 = z.object({
    id: z.string().readonly(),
    userId: z.string().readonly(),
    token: z.string(),
    platform: z.enum(["ANDROID", "IOS"]),
    installationId: z.string(),
    isActive: z.boolean(),
    lastUsedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zDeviceToken = zDeviceTokenRoot2;
export const zDeviceTokenRegistrationRoot = z.object({
    token: z.string().min(10).max(500),
    platform: z.enum(["ANDROID", "IOS"]),
    installationId: z.string().min(1).max(100),
});
export const zDeviceTokenRegistration = zDeviceTokenRegistrationRoot;
export const zForceNicknameChangeRoot = z.object({
    newNickname: z.string().min(2).max(10),
    changedBy: z.string(),
    reason: z.string().min(1).max(1000),
});
export const zGrantDealerPermissionRequestRoot = z.object({
    grantedBy: z.string(),
    notes: z.optional(z.union([z.string().max(1000), z.null()])),
});
export const zInterestCategoryRepromptRequestRoot = z.object({
    requestId: z.uuid().readonly(),
    scope: z.enum(["GLOBAL", "USER"]),
    userId: z.union([z.string(), z.null()]),
    reason: z.string().min(1).max(300),
    source: z.enum([
        "ADMIN",
        "CATEGORY_CREATED",
        "CATEGORY_UPDATED",
        "CATEGORY_DELETED",
    ]),
    requestedBy: z.union([z.string(), z.null()]),
    requestedAt: z.iso.datetime().readonly(),
});
export const zInterestCategoryRepromptRequest = zInterestCategoryRepromptRequestRoot;
export const zBackofficeUserInterestCategoriesRoot2 = z.object({
    userId: z.string().readonly(),
    categoryIds: z.array(z.uuid()).max(50),
    setAt: z.union([z.iso.datetime(), z.null()]),
    shouldPrompt: z.boolean(),
    promptReason: z.union([z.string(), z.null()]),
    pendingRequest: z.union([zInterestCategoryRepromptRequestRoot, z.null()]),
    latestGlobalRequest: z.union([
        zInterestCategoryRepromptRequestRoot,
        z.null(),
    ]),
});
export const zBackofficeUserInterestCategories = zBackofficeUserInterestCategoriesRoot2;
export const zInterestCategoryRepromptRequestCreateRoot = z.object({
    reason: z.string().min(1).max(300),
});
export const zInterestCategoryRepromptRequestCreate = zInterestCategoryRepromptRequestCreateRoot;
export const zKakaoCodeLoginRoot = z.object({
    code: z.string().min(1),
    redirectUri: z.string().min(1),
});
export const zNaverCodeExchangeRoot = z.object({
    code: z.string().min(1),
    state: z.string().min(1),
});
export const zNaverTokenResponseRoot = z.object({
    accessToken: z.string().min(1),
});
export const zNotificationPermissionStatusRoot = z.enum([
    "GRANTED",
    "PROVISIONAL",
    "DENIED",
    "NOT_DETERMINED",
]);
export const zAppInstallationReportRoot = z.object({
    platform: z.enum(["ANDROID", "IOS"]),
    appVersion: z.string().min(1).max(50),
    buildNumber: z.int().gte(0),
    osVersion: z.optional(z.union([z.string().max(50), z.null()])),
    deviceModel: z.optional(z.union([z.string().max(100), z.null()])),
    otaUpdateId: z.optional(z.union([z.string().max(100), z.null()])),
    oneSignalSubscriptionId: z.optional(z.union([z.string().max(100), z.null()])),
    notificationPermission: z.optional(zNotificationPermissionStatusRoot),
});
export const zAppInstallationReport = zAppInstallationReportRoot;
export const zNotificationSettingKeyRoot = z.enum([
    "BROADCAST_ALL",
    "BROADCAST",
    "BROADCAST_INTEREST",
    "MESSAGE",
    "ORDER",
    "PROMOTION",
    "LOUNGE",
    "CHANNEL_PUSH",
    "CHANNEL_IN_APP",
]);
export const zBackofficeNotificationSettingsSummaryRoot2 = z.object({
    status: z.enum(["ACTIVE", "SUSPENDED", "WITHDRAWN", "ALL"]),
    totalUsers: z.int().gte(0),
    items: z.array(z.object({
        setting: zNotificationSettingKeyRoot,
        enabledCount: z.int().gte(0),
        disabledCount: z.int().gte(0),
    })),
    osPermission: z.object({
        grantedCount: z.int().gte(0),
        blockedCount: z.int().gte(0),
        unknownCount: z.int().gte(0),
        judgmentDays: z.int().gte(1),
        showUnknown: z.boolean(),
    }),
});
export const zNotificationSettingsRoot2 = z.object({
    userId: z.string().readonly(),
    broadcastNotifications: z.boolean(),
    messageNotifications: z.boolean(),
    orderNotifications: z.boolean(),
    promotionNotifications: z.boolean(),
    loungeNotifications: z.boolean(),
    channels: z.array(z.enum(["PUSH", "IN_APP"])).min(1),
    quietHoursEnabled: z.boolean(),
    quietHoursStart: z.union([z.iso.time(), z.null()]),
    quietHoursEnd: z.union([z.iso.time(), z.null()]),
});
export const zNotificationSettingsUpdateRoot = z.object({
    broadcastNotifications: z.optional(z.union([z.boolean(), z.null()])),
    messageNotifications: z.optional(z.union([z.boolean(), z.null()])),
    orderNotifications: z.optional(z.union([z.boolean(), z.null()])),
    promotionNotifications: z.optional(z.union([z.boolean(), z.null()])),
    loungeNotifications: z.optional(z.union([z.boolean(), z.null()])),
    channels: z.optional(z.union([z.array(z.enum(["PUSH", "IN_APP"])).min(1), z.null()])),
    quietHoursEnabled: z.optional(z.union([z.boolean(), z.null()])),
    quietHoursStart: z.optional(z.union([z.iso.time(), z.null()])),
    quietHoursEnd: z.optional(z.union([z.iso.time(), z.null()])),
});
export const zOperationActorTypeRoot = z.enum(["ADMIN", "SYSTEM"]);
export const zOperationDomainRoot = z.enum([
    "USER",
    "ORDER",
    "SHIPMENT",
    "SETTLEMENT",
    "PAYMENT",
    "PRODUCT",
    "SALES",
    "BROADCAST",
    "COMMUNITY",
    "NOTIFICATION",
    "CONTENT",
    "CONFIG",
    "ADMIN_ACCOUNT",
    "POINT",
    "DEALER_PROXY",
    "OTHER",
]);
export const zAdminHistoryEntryRoot = z.object({
    historyId: z.uuid().readonly(),
    actorType: zOperationActorTypeRoot,
    adminId: z.union([z.uuid().readonly(), z.null()]).readonly(),
    adminUsername: z.union([z.string().readonly(), z.null()]).readonly(),
    actingDealerId: z.union([z.uuid().readonly(), z.null()]).readonly(),
    actingDealerNickname: z.union([z.string().readonly(), z.null()]).readonly(),
    proxySessionId: z.union([z.uuid().readonly(), z.null()]).readonly(),
    domain: zOperationDomainRoot,
    action: z.string().max(64).readonly(),
    targetType: z.union([z.string().readonly(), z.null()]).readonly(),
    targetId: z.union([z.string().readonly(), z.null()]).readonly(),
    targetLabel: z.union([z.string().readonly(), z.null()]).readonly(),
    before: z
        .union([z.record(z.string(), z.unknown()).readonly(), z.null()])
        .readonly(),
    after: z
        .union([z.record(z.string(), z.unknown()).readonly(), z.null()])
        .readonly(),
    reason: z.union([z.string().readonly(), z.null()]).readonly(),
    requestMethod: z.string().readonly(),
    requestPath: z.string().readonly(),
    createdAt: z.iso.datetime().readonly(),
});
export const zDealerHistoryEntryRoot = z.object({
    historyId: z.uuid().readonly(),
    dealerId: z.uuid().readonly(),
    dealerNickname: z.union([z.string().readonly(), z.null()]).readonly(),
    channel: zDealerHistoryChannelRoot,
    actorType: zDealerHistoryActorTypeRoot,
    adminHistoryId: z.union([z.uuid().readonly(), z.null()]).readonly(),
    domain: zOperationDomainRoot,
    action: z.string().max(64).readonly(),
    targetType: z.union([z.string().readonly(), z.null()]).readonly(),
    targetId: z.union([z.string().readonly(), z.null()]).readonly(),
    targetLabel: z.union([z.string().readonly(), z.null()]).readonly(),
    before: z
        .union([z.record(z.string(), z.unknown()).readonly(), z.null()])
        .readonly(),
    after: z
        .union([z.record(z.string(), z.unknown()).readonly(), z.null()])
        .readonly(),
    reason: z.union([z.string().readonly(), z.null()]).readonly(),
    requestMethod: z.string().readonly(),
    requestPath: z.string().readonly(),
    createdAt: z.iso.datetime().readonly(),
});
export const zOsNotificationPermissionStateRoot = z.enum([
    "GRANTED",
    "BLOCKED",
    "UNKNOWN",
]);
export const zPhoneVerificationCodeSentRoot2 = z.object({
    expiresAt: z.iso.datetime().readonly(),
    resendAvailableAt: z.iso.datetime().readonly(),
});
export const zProfileImageUploadUrlRoot = z.object({
    uploadUrl: z.url(),
    imageUrl: z.url(),
    expiresIn: z.int().gte(1),
    expiresAt: z.iso.datetime(),
});
export const zPublicUserSearchResultRoot = z.object({
    userId: z.string(),
    nickname: z.string(),
    profileImage: z.optional(z.union([z.url(), z.null()])),
    bio: z.optional(z.union([z.string(), z.null()])),
    roles: z.array(z.enum(["COLLECTOR", "DEALER"])),
    followerCount: z.int(),
    followingCount: z.int(),
    joinedAt: z.iso.datetime(),
    blockingStatus: z.optional(z.nullable(z.enum(["NONE", "YOU_BLOCKED_THEM", "THEY_BLOCKED_YOU", "MUTUAL_BLOCK"]))),
});
export const zRefreshTokenRequestRoot = z.object({
    refreshToken: z.string(),
});
export const zRefreshTokenResponseRoot = z.object({
    accessToken: z.string().readonly(),
    refreshToken: z.string().readonly(),
    expiresIn: z.int().readonly(),
});
export const zSocialLoginCredentialRoot = z.object({
    type: z.enum(["TOKEN", "CODE"]),
    token: z.optional(z.union([z.string(), z.null()])),
    code: z.optional(z.union([z.string(), z.null()])),
    redirectUri: z.optional(z.union([z.string(), z.null()])),
    state: z.optional(z.union([z.string(), z.null()])),
});
export const zSocialLoginRequestRoot = z.object({
    provider: z.enum(["KAKAO", "NAVER", "GOOGLE", "APPLE"]),
    credential: zSocialLoginCredentialRoot,
    surface: z.enum(["WEB", "DEALER", "APP"]),
});
export const zSocialSignupRequestRoot = z.object({
    signupTicket: z.string().min(1),
    nickname: z.string().min(2).max(10),
    termsAccepted: z.literal(true),
    referrerUserId: z.optional(z.union([z.uuid(), z.null()])),
});
export const zSocialSignupTicketRoot = z.object({
    ticket: z.string(),
    expiresIn: z.int(),
    previouslyWithdrawn: z.boolean(),
});
export const zThemeModeRoot = z.enum(["LIGHT", "DARK"]);
export const zProfileSummaryRoot2 = z.object({
    userId: z.string().readonly(),
    nickname: z.string(),
    profileImage: z.optional(z.union([z.url(), z.null()])),
    bio: z.optional(z.union([z.string(), z.null()])),
    themeMode: zThemeModeRoot,
    lastNicknameChangeAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    updatedAt: z.iso.datetime().readonly(),
});
export const zProfileUpdateRoot = z.object({
    nickname: z.optional(z.union([z.string().min(2).max(10), z.null()])),
    profileImage: z.optional(z.union([z.url(), z.null()])),
    bio: z.optional(z.union([z.string().max(500), z.null()])),
    themeMode: z.optional(zThemeModeRoot),
});
export const zUserAccountStatusRoot2 = z.object({
    userId: z.string().readonly(),
    status: z.enum(["ACTIVE", "SUSPENDED", "WITHDRAWN"]),
    suspendedBy: z.optional(z.union([z.string(), z.null()])),
    suspensionReason: z.optional(z.union([z.string(), z.null()])),
    suspensionType: z.optional(z.nullable(z.enum(["TEMPORARY", "PERMANENT"]))),
    suspensionExpiresAt: z.optional(z.union([z.iso.datetime(), z.null()])),
});
export const zUserActivateRoot = z.object({
    reason: z.optional(z.string().min(1).max(1000)),
});
export const zUserHistoryActorTypeRoot = z.enum([
    "SELF",
    "ADMIN",
    "SYSTEM",
    "DEALER",
]);
export const zUserHistoryCategoryRoot = z.enum([
    "PROFILE",
    "ACCOUNT",
    "DEALER",
    "ADMIN_ACTION",
    "POINT",
    "DELIVERY_ADDRESS",
    "PAYMENT_METHOD",
    "SOCIAL",
    "DEVICE",
]);
export const zUserHistoryEntryRoot = z.object({
    historyId: z.uuid().readonly(),
    userId: z.uuid().readonly(),
    userNickname: z.union([z.string().readonly(), z.null()]).readonly(),
    category: zUserHistoryCategoryRoot,
    action: z.string().max(64).readonly(),
    actorType: zUserHistoryActorTypeRoot,
    actorId: z.union([z.uuid().readonly(), z.null()]).readonly(),
    before: z
        .union([z.record(z.string(), z.unknown()).readonly(), z.null()])
        .readonly(),
    after: z
        .union([z.record(z.string(), z.unknown()).readonly(), z.null()])
        .readonly(),
    reason: z.union([z.string().readonly(), z.null()]).readonly(),
    createdAt: z.iso.datetime().readonly(),
});
export const zUserInterestCategoriesRoot2 = z.object({
    userId: z.string().readonly(),
    categoryIds: z.array(z.uuid()).max(50),
    updatedAt: z.union([z.iso.datetime().readonly(), z.null()]).readonly(),
});
export const zUserInterestCategories = zUserInterestCategoriesRoot2;
export const zUserInterestCategoriesUpdateRoot = z.object({
    categoryIds: z.array(z.uuid()).max(50),
});
export const zUserInterestCategoriesUpdate = zUserInterestCategoriesUpdateRoot;
export const zUserLoginRoot = z.object({
    socialProvider: z.enum(["GOOGLE", "APPLE", "KAKAO", "NAVER"]),
    idToken: z.string().min(1),
});
export const zUserRegisterRoot = z.object({
    socialProvider: z.enum(["GOOGLE", "APPLE", "KAKAO", "NAVER"]),
    idToken: z.string().min(1),
    socialEmail: z.optional(z.union([z.email(), z.null()])),
    nickname: z.string().min(2).max(10),
    termsAccepted: z.literal(true),
    referrerUserId: z.optional(z.union([z.uuid(), z.null()])),
});
export const zUserRoleRoot = z.enum(["COLLECTOR", "DEALER", "ADMIN"]);
export const zDealerProxySessionLoginRoot = z.object({
    accessToken: z.string().readonly(),
    expiresIn: z.int().gte(1).readonly(),
    expiresAt: z.iso.datetime().readonly(),
    proxySessionId: z.uuid().readonly(),
    adminUsername: z.string().readonly(),
    userId: z.uuid().readonly(),
    nickname: z.string().readonly(),
    profileImage: z.union([z.string().readonly(), z.null()]).readonly(),
    email: z.union([z.string().readonly(), z.null()]).readonly(),
    roles: z.array(zUserRoleRoot).min(1).readonly(),
});
export const zUserSuspendRoot = z.object({
    suspendedBy: z.string(),
    reason: z.string().min(10).max(1000),
    durationDays: z.optional(z.union([z.int().gte(1).lte(365), z.null()])),
});
export const zWithdrawUserAccountBlockedErrorRoot2 = z.object({
    code: z.string(),
    message: z.string(),
    blockingOrderIds: z.optional(z.array(z.string())),
});
export const zWithdrawUserAccountResponseRoot2 = z.object({
    userId: z.uuid().readonly(),
    withdrawnAt: z.iso.datetime().readonly(),
});
export const zBackofficeKpiDashboardExportCsvRoot = z.unknown();
export const zBackofficeKpiDashboardRoot = z.unknown();
export const zBackofficeKpiDashboardExportItemRoot = z.object({
    mau: z.int().gte(0),
    wau: z.int().gte(0),
    dau: z.int().gte(0),
    gmv: z.number().gte(0),
    orderCount: z.int().gte(0),
    paymentSuccessRate: z.number().gte(0).lte(100),
    feeRevenue: z.number().gte(0),
});
export const zBackofficeKpiDashboardExportItem = zBackofficeKpiDashboardExportItemRoot;
export const zBackofficeKpiDashboardExportResponseRoot = z.object({
    data: z.array(zBackofficeKpiDashboardExportItemRoot),
    totalItems: z.int(),
});
export const zBackofficeKpiDashboardExportResponse = zBackofficeKpiDashboardExportResponseRoot;
export const zBackofficeKpiDashboardResponseRoot = z.object({
    mau: z.int().gte(0),
    wau: z.int().gte(0),
    dau: z.int().gte(0),
    gmv: z.number().gte(0),
    orderCount: z.int().gte(0),
    paymentSuccessRate: z.number().gte(0).lte(100),
    feeRevenue: z.number().gte(0),
});
export const zBackofficeKpiDashboardResponse = zBackofficeKpiDashboardResponseRoot;
export const zKpiDashboardPeriodRoot = z.enum([
    "TODAY",
    "LAST_7_DAYS",
    "LAST_30_DAYS",
    "MONTHLY",
]);
export const zKpiDashboardPeriod = zKpiDashboardPeriodRoot;
export const zKpiDashboardSalesChannelRoot = z.enum([
    "ALL",
    "BROADCAST",
    "ALWAYS_ON",
]);
export const zKpiDashboardSalesChannel = zKpiDashboardSalesChannelRoot;
export const zAccountIdRoot = z.unknown();
export const zAsOfDateRoot = z.unknown();
export const zDealerIdRoot = z.unknown();
export const zEntryIdRoot = z.unknown();
export const zPeriodEndRoot = z.unknown();
export const zPeriodStartRoot = z.unknown();
export const zReportIdRoot = z.unknown();
export const zAccountsRoot = z.unknown();
export const zAccounts7BaccountId7dRoot = z.unknown();
export const zAccounts7BaccountId7dBalanceRoot = z.unknown();
export const zDealers7BdealerId7dBalanceRoot = z.unknown();
export const zJournalEntriesRoot = z.unknown();
export const zJournalEntries7BentryId7dRoot = z.unknown();
export const zJournalEntries7BentryId7dReverseRoot = z.unknown();
export const zReconciliationRoot = z.unknown();
export const zReconciliation7BreportId7dRoot = z.unknown();
export const zReconciliation7BreportId7dDiscrepanciesRoot = z.unknown();
export const zReconciliationControlAccountsRoot = z.unknown();
export const zTrialBalanceRoot = z.unknown();
export const zAccountResponseRoot = z.unknown();
export const zDealerBalanceResponseRoot = z.unknown();
export const zJournalEntryResponseRoot = z.unknown();
export const zReconciliationReportResponseRoot = z.unknown();
export const zTrialBalanceResponseRoot = z.unknown();
export const zAccountTypeRoot = z.enum([
    "ASSET",
    "LIABILITY",
    "EQUITY",
    "REVENUE",
    "EXPENSE",
]);
export const zBalanceStateRoot = z.enum([
    "PENDING",
    "AVAILABLE",
    "RESERVED",
    "SETTLED",
]);
export const zBalanceState = zBalanceStateRoot;
export const zControlAccountReconciliationRequestRoot = z.object({
    reconciliationDate: z.optional(z.iso.datetime()),
});
export const zCreateAccountRequestRoot = z.object({
    accountCode: z.string().regex(/^[0-9]{4,6}$/),
    accountName: z.string().min(1).max(200),
    accountType: zAccountTypeRoot,
    dealerId: z.optional(z.union([z.string(), z.null()])),
});
export const zDiscrepancySeverityRoot = z.enum([
    "LOW",
    "MEDIUM",
    "HIGH",
    "CRITICAL",
]);
export const zDiscrepancyRoot = z.object({
    "discrepancy-id": z.string().readonly(),
    "discrepancy-type": z.string(),
    "affected-records": z.array(z.string()).min(1),
    severity: zDiscrepancySeverityRoot,
    description: z.string().min(1).max(1000),
    "detected-at": z.iso.datetime().readonly(),
});
export const zEntryStatusRoot = z.enum(["DRAFT", "POSTED"]);
export const zEntryTypeRoot = z.enum(["DEBIT", "CREDIT"]);
export const zReconciliationStatusRoot = z.enum([
    "IN_PROGRESS",
    "COMPLETED",
    "FAILED",
]);
export const zReconciliationReportRoot = z.object({
    reconciliationReportId: z.string().readonly(),
    periodStart: z.iso.datetime(),
    periodEnd: z.iso.datetime(),
    targetContext: z.enum(["PAYMENT", "SETTLEMENT", "CONTROL_ACCOUNT"]),
    status: zReconciliationStatusRoot,
    totalLedgerEntries: z.int().gte(0),
    totalExternalRecords: z.int().gte(0),
    discrepancyCount: z.int().gte(0),
    startedAt: z.iso.datetime().readonly(),
    completedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    metadata: z.optional(z.union([z.record(z.string(), z.unknown()), z.null()])),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zReverseJournalEntryRequestRoot = z.object({
    reversalReason: z.string().min(1).max(500),
    reversalDate: z.optional(z.union([z.iso.datetime(), z.null()])),
});
export const zStartReconciliationRequestRoot = z.object({
    reconciliationPeriod: z.object({
        start: z.iso.datetime(),
        end: z.iso.datetime(),
    }),
    targetContext: z.enum(["PAYMENT", "SETTLEMENT"]),
});
export const zUpdateAccountRequestRoot = z.object({
    accountName: z.string().min(1).max(200),
});
export const zBroadcastIdPathRoot = z.unknown();
export const zCategoryIdQueryRoot = z.unknown();
export const zCursorQueryRoot = z.unknown();
export const zDateFromQueryRoot = z.unknown();
export const zDateToQueryRoot = z.unknown();
export const zDealerIdQueryRoot = z.unknown();
export const zLimitQueryRoot = z.unknown();
export const zLiveSnapshotIdPathRoot = z.unknown();
export const zUserIdQueryRoot = z.unknown();
export const zBackofficeLiveSnapshotsCollectionRoot = z.unknown();
export const zBackofficeLiveSnapshotsItemHideRoot = z.unknown();
export const zBackofficeLiveSnapshotsItemUnhideRoot = z.unknown();
export const zBackofficeLiveSnapshotsItemRoot = z.unknown();
export const zLiveSnapshotsBroadcastBuyersRoot = z.unknown();
export const zLiveSnapshotsCollectionRoot = z.unknown();
export const zLiveSnapshotsImagesUploadUrlRoot = z.unknown();
export const zLiveSnapshotsItemDeleteRoot = z.unknown();
export const zLiveSnapshotsItemRoot = z.unknown();
export const zBackofficeLiveSnapshotHideRoot = z.object({
    reason: z.string().min(10).max(1000),
});
export const zLiveSnapshotBroadcastRoot = z.object({
    broadcastId: z.uuid(),
    title: z.string(),
    isLive: z.boolean(),
});
export const zLiveSnapshotBuyerRoot = z.object({
    userId: z.union([z.string(), z.null()]),
    nickname: z.string(),
    profileImageUrl: z.union([z.url(), z.null()]),
    isAnonymous: z.boolean(),
});
export const zLiveSnapshotCategoryRoot = z.object({
    categoryId: z.uuid(),
    name: z.string(),
});
export const zLiveSnapshotCreateRoot = z.object({
    broadcastId: z.uuid(),
    buyerId: z.optional(z.uuid()),
    sourceType: z.optional(z.enum(["AUCTION", "INSTANT_PURCHASE", "GIVEAWAY"])),
    sourceId: z.optional(z.uuid()),
    imageUrl: z.url().max(2048),
    dealerMemo: z.optional(z.string().max(200)),
});
export const zLiveSnapshotImageUploadUrlRoot = z.object({
    uploadUrl: z.url(),
    imageUrl: z.url(),
    expiresIn: z.int().gte(1),
    expiresAt: z.iso.datetime(),
});
export const zLiveSnapshotSummaryRoot = z.object({
    liveSnapshotId: z.uuid().readonly(),
    imageUrl: z.url(),
    broadcastTitle: z.string(),
    productName: z.string(),
    categories: z.optional(z.array(zLiveSnapshotCategoryRoot)),
    dealerMemo: z.optional(z.union([z.string(), z.null()])),
    buyer: z.union([zLiveSnapshotBuyerRoot, z.null()]),
    createdAt: z.iso.datetime().readonly(),
});
export const zLiveSnapshotListRoot = z.object({
    data: z.array(zLiveSnapshotSummaryRoot),
    nextCursor: z.union([z.string(), z.null()]),
});
export const zMethodKeyPathRoot = z.unknown();
export const zBrandpayPaymentMethodsCollectionRoot = z.unknown();
export const zBrandpayPaymentMethodsItemRoot = z.unknown();
export const zBrandpayPaymentMethodsMainRoot = z.unknown();
export const zBrandpayRegistrationStatusRoot = z.unknown();
export const zPaymentsCallbackRoot = z.unknown();
export const zBrandPayPaymentMethodRoot = z.object({
    paymentMethodId: z.uuid().readonly(),
    methodKey: z.string().readonly(),
    brandPayMethodId: z.string().readonly(),
    methodType: z.enum(["CARD", "BANK_ACCOUNT"]),
    gateway: z.string().readonly(),
    cardIssuer: z.string().readonly(),
    cardAlias: z.union([z.string().readonly(), z.null()]).readonly(),
    maskedCardNumber: z.union([z.string().readonly(), z.null()]).readonly(),
    lastFourDigits: z.string().readonly(),
    isDefault: z.boolean().readonly(),
    isActive: z.boolean().readonly(),
    createdAt: z.iso.datetime().readonly(),
});
export const zBrandPayPaymentMethod = zBrandPayPaymentMethodRoot;
export const zBrandPayRegistrationStatusRoot = z.object({
    isRegistered: z.boolean().readonly(),
    isBillingAuthorized: z.boolean().readonly(),
    hasPaymentMethod: z.boolean().readonly(),
});
export const zBrandPayRegistrationStatus = zBrandPayRegistrationStatusRoot;
export const zSetBrandPayMainCardRequestRoot = z.object({
    methodKey: z.string(),
});
export const zSetBrandPayMainCardRequest = zSetBrandPayMainCardRequestRoot;
export const zBeforeMessageIdQueryRoot = z.unknown();
export const zCategoryIdQueryRoot2 = z.unknown();
export const zChatRoomIdPathRoot = z.unknown();
export const zCreatorIdQueryRoot = z.unknown();
export const zDealerChatRoomJoinedOnlyQueryRoot = z.unknown();
export const zDealerChatRoomSearchQueryRoot = z.unknown();
export const zDealerChatRoomSortQueryRoot = z.unknown();
export const zLimitQueryRoot2 = z.unknown();
export const zMessageIdPathRoot = z.unknown();
export const zMyChatRoomSearchQueryRoot = z.unknown();
export const zMyChatRoomSortQueryRoot = z.unknown();
export const zMyChatRoomTypeQueryRoot = z.unknown();
export const zMyChatRoomUnreadOnlyQueryRoot = z.unknown();
export const zOpenChatRoomIdPathRoot = z.unknown();
export const zBackofficeDealerChatRoomSettingsRoot = z.unknown();
export const zBackofficeDmConversationsCollectionRoot = z.unknown();
export const zBackofficeDmConversationsItemMessagesCollectionRoot = z.unknown();
export const zBackofficeMessagesCollectionRoot = z.unknown();
export const zBackofficeOpenChatRoomsThumbnailsUploadUrlRoot = z.unknown();
export const zBackofficeOpenChatRoomsCollectionRoot = z.unknown();
export const zBackofficeOpenChatRoomsItemCloseRoot = z.unknown();
export const zBackofficeOpenChatRoomsItemKickUserRoot = z.unknown();
export const zBackofficeOpenChatRoomsItemKickedUsersCollectionRoot = z.unknown();
export const zBackofficeOpenChatRoomsItemKickedUsersItemRoot = z.unknown();
export const zBackofficeOpenChatRoomsItemMessagesCollectionRoot = z.unknown();
export const zBackofficeOpenChatRoomsItemMessagesItemDeleteRoot = z.unknown();
export const zBackofficeOpenChatRoomsItemUpdateCategoryRoot = z.unknown();
export const zBackofficeOpenChatRoomsItemUpdateThumbnailRoot = z.unknown();
export const zBackofficeOpenChatRoomsItemUpdateTitleRoot = z.unknown();
export const zBackofficeSupportChatsCollectionRoot = z.unknown();
export const zBackofficeSupportChatsItemMessagesCollectionRoot = z.unknown();
export const zBackofficeSupportChatsItemReadsRoot = z.unknown();
export const zChatRoomsMessagesCollectionRoot = z.unknown();
export const zChatRoomsMessagesItemRoot = z.unknown();
export const zChatRoomsCollectionRoot = z.unknown();
export const zChatRoomsItemImagesRoot = z.unknown();
export const zChatRoomsItemReadRoot = z.unknown();
export const zChatRoomsItemRoot = z.unknown();
export const zDealerChatRoomsCollectionRoot = z.unknown();
export const zDealerChatRoomsCreationEligibilityRoot = z.unknown();
export const zDealerChatRoomsItemKickUserRoot = z.unknown();
export const zMyChatRoomsCollectionRoot = z.unknown();
export const zOpenChatRoomsMessagesCollectionRoot = z.unknown();
export const zOpenChatRoomsMessagesImageRoot = z.unknown();
export const zOpenChatRoomsMessagesItemRoot = z.unknown();
export const zOpenChatRoomsCollectionRoot = z.unknown();
export const zOpenChatRoomsCommunityHomeRoot = z.unknown();
export const zOpenChatRoomsItemJoinRoot = z.unknown();
export const zOpenChatRoomsItemLeaveRoot = z.unknown();
export const zOpenChatRoomsItemParticipantsRoot = z.unknown();
export const zOpenChatRoomsItemRoot = z.unknown();
export const zChatRoomRoot = z.unknown();
export const zChatRoomListRoot = z.unknown();
export const zMessageListRoot = z.unknown();
export const zMyChatRoomListRoot = z.unknown();
export const zOpenChatRoomRoot = z.unknown();
export const zOpenChatRoomListRoot = z.unknown();
export const zBackofficeOpenChatRoomRoot = z.object({
    id: z.string().readonly(),
    title: z.string(),
    thumbnail: z.optional(z.union([z.url(), z.null()])),
    categoryId: z.string(),
    categoryName: z.string(),
    categoryDeletedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    currentParticipantCount: z.int().gte(0),
    status: z.enum(["OPEN", "CLOSED", "ARCHIVED"]),
    createdAt: z.iso.datetime().readonly(),
    roomKind: z.optional(z.enum(["COMMUNITY", "DEALER"])),
    creatorNickname: z.optional(z.union([z.string().readonly(), z.null()]).readonly()),
    kickedUserCount: z.optional(z.int().gte(0).readonly()),
});
export const zBackofficeOpenChatRoom = zBackofficeOpenChatRoomRoot;
export const zBackofficeSupportChatRoomOpenRoot = z.object({
    userId: z.uuid(),
});
export const zChatRoomCreateRoot = z.object({
    dealerId: z.string(),
    buyerId: z.string(),
});
export const zDealerChatRoomCreateRoot = z.object({
    title: z.string().min(1).max(50),
    categoryId: z.uuid(),
    noticeBanner: z.optional(z.union([z.string().max(500), z.null()])),
});
export const zDealerChatRoomCreate = zDealerChatRoomCreateRoot;
export const zDealerChatRoomCreationEligibilityRoot = z.object({
    canCreate: z.boolean(),
    openRoomCount: z.int().gte(0),
    maxRoomsPerDealer: z.int().gte(0),
    fullCategoryIds: z.array(z.uuid()),
});
export const zDealerChatRoomCreationEligibility = zDealerChatRoomCreationEligibilityRoot;
export const zDealerChatRoomSettingsRoot = z.object({
    maxRoomsPerDealer: z.int().gte(0).lte(100),
    sortOrder: z.enum(["PARTICIPANTS_DESC", "CREATED_AT_DESC"]),
    updatedAt: z.iso.datetime(),
    updatedByAdminId: z.union([z.uuid(), z.null()]),
});
export const zDealerChatRoomSettings = zDealerChatRoomSettingsRoot;
export const zDealerChatRoomSettingsUpdateRoot = z.object({
    maxRoomsPerDealer: z.int().gte(0).lte(100),
    sortOrder: z.enum(["PARTICIPANTS_DESC", "CREATED_AT_DESC"]),
});
export const zDealerChatRoomSettingsUpdate = zDealerChatRoomSettingsUpdateRoot;
export const zImageSendRoot = z.object({
    imageUrl: z.url(),
    imageUrls: z.optional(z.array(z.url()).min(1).max(20)),
});
export const zMessageSendRoot = z.object({
    content: z.string().min(1).max(5000),
});
export const zOpenChatImageSendRoot = z.object({
    imageUrl: z.url(),
    imageUrls: z.optional(z.array(z.url()).min(1).max(20)),
});
export const zOpenChatMessageSendRoot = z.object({
    content: z.string().min(1).max(5000),
});
export const zOpenChatRoomCreateRoot = z.object({
    title: z.string().min(1).max(100),
    thumbnail: z.optional(z.union([z.url(), z.null()])),
    maxParticipants: z.int().gte(2).lte(1000),
    categoryId: z.uuid(),
    noticeBanner: z.optional(z.union([z.string().max(500), z.null()])),
});
export const zOpenChatRoomParticipantRoot = z.object({
    userId: z.uuid(),
    nickname: z.string(),
    profileImageUrl: z.union([z.url(), z.null()]),
    isOwner: z.boolean(),
    joinedAt: z.iso.datetime(),
});
export const zOpenChatRoomThumbnailUploadUrlRoot = z.object({
    uploadUrl: z.url(),
    imageUrl: z.url(),
    expiresIn: z.int().gte(1),
    expiresAt: z.iso.datetime(),
});
export const zOpenChatRoomThumbnailUploadUrl = zOpenChatRoomThumbnailUploadUrlRoot;
export const zOpenChatRoomUpdateRoot = z.object({
    noticeBanner: z.union([z.string().max(500), z.null()]),
});
export const zLimitQueryRoot3 = z.unknown();
export const zNotificationDispatchIdPathRoot = z.unknown();
export const zNotificationIdPathRoot = z.unknown();
export const zNotificationSettingItemKeyPathRoot = z.unknown();
export const zNotificationTemplateCodePathRoot = z.unknown();
export const zTypeFilterQueryRoot = z.unknown();
export const zBackofficeBroadcastPushSendHistoriesCollectionRoot = z.unknown();
export const zBackofficeNotificationDispatchesAlimtalkTemplatesRoot = z.unknown();
export const zBackofficeNotificationDispatchesCancelRoot = z.unknown();
export const zBackofficeNotificationDispatchesCollectionRoot = z.unknown();
export const zBackofficeNotificationDispatchesPreviewRoot = z.unknown();
export const zBackofficeNotificationDispatchesRecipientPreviewsRoot = z.unknown();
export const zBackofficeNotificationOperationSettingsRoot = z.unknown();
export const zBackofficeNotificationSettingItemsCollectionRoot = z.unknown();
export const zBackofficeNotificationSettingItemsItemRoot = z.unknown();
export const zBackofficeNotificationTemplatesCollectionRoot = z.unknown();
export const zBackofficeNotificationTemplatesItemRoot = z.unknown();
export const zBackofficeNotificationsCollectionRoot = z.unknown();
export const zBackofficeUsersNotificationSettingItemsCollectionRoot = z.unknown();
export const zNotificationPreferencesItemRoot = z.unknown();
export const zNotificationsOpensCollectionRoot = z.unknown();
export const zNotificationsUnreadCollectionRoot = z.unknown();
export const zNotificationsCollectionRoot = z.unknown();
export const zNotificationsItemRoot = z.unknown();
export const zUsersNotificationSettingItemsCollectionRoot = z.unknown();
export const zUsersNotificationSettingItemsItemRoot = z.unknown();
export const zUsersNotificationsReadAllRoot = z.unknown();
export const zMarkAllNotificationsAsReadResponseRoot = z.unknown();
export const zNotificationRoot = z.unknown();
export const zNotificationListRoot = z.unknown();
export const zNotificationPreferenceRoot = z.unknown();
export const zAlimtalkProviderRoot = z.enum(["SOLAPI", "NHN"]);
export const zAlimtalkProviderStatusRoot = z.object({
    provider: zAlimtalkProviderRoot,
    configured: z.boolean(),
});
export const zBackofficeNotificationHistoryItemRoot = z.object({
    notificationId: z.uuid(),
    recipientUserId: z.uuid(),
    recipientNickname: z.optional(z.union([z.string(), z.null()])),
    templateCode: z.optional(z.union([z.string(), z.null()])),
    kindLabel: z.string(),
    reason: z.optional(z.union([z.string(), z.null()])),
    senderType: z.enum(["ADMIN", "USER", "SYSTEM"]),
    senderLabel: z.optional(z.union([z.string(), z.null()])),
    channel: z.enum(["PUSH", "IN_APP", "BOTH", "SMS", "ALIMTALK"]),
    status: z.enum(["PENDING", "SENT", "FAILED", "READ"]),
    pushProvider: z.optional(z.nullable(z.enum(["FCM", "FCM_FAKE", "ONESIGNAL", "SOLAPI", "NHN"]))),
    recipientPhone: z.optional(z.union([z.string(), z.null()])),
    title: z.string(),
    body: z.string(),
    createdAt: z.iso.datetime(),
    sentAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    readAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    openedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    errorMessage: z.optional(z.union([z.string(), z.null()])),
});
export const zBackofficeUserAppInstallationPermissionRoot = z.object({
    platform: z.enum(["IOS", "ANDROID"]),
    appVersion: z.string(),
    notificationPermission: z.optional(z.union([zNotificationPermissionStatusRoot, z.null()])),
    notificationPermissionCheckedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    lastSeenAt: z.iso.datetime(),
});
export const zBackofficeUserOsNotificationPermissionRoot = z.object({
    state: zOsNotificationPermissionStateRoot,
    judgmentDays: z.int().gte(1),
    installations: z.array(zBackofficeUserAppInstallationPermissionRoot),
});
export const zBroadcastPushSendHistoryCreateRoot = z.object({
    title: z.string().min(1).max(100),
    body: z.string().min(1).max(500),
});
export const zBroadcastPushSendStatusRoot = z.enum([
    "PENDING",
    "SUCCEEDED",
    "PARTIALLY_FAILED",
    "FAILED",
]);
export const zBroadcastPushSendHistoryRoot = z.object({
    broadcastPushSendHistoryId: z.uuid().readonly(),
    title: z.string().min(1).max(100),
    body: z.string().min(1).max(500),
    recipientCount: z.int().gte(0).readonly(),
    sentByAdminId: z.uuid().readonly(),
    sentByAdminUsername: z.optional(z.union([z.string().readonly(), z.null()]).readonly()),
    sentAt: z.iso.datetime().readonly(),
    status: zBroadcastPushSendStatusRoot,
    sentCount: z.int().gte(0).readonly(),
    invalidTokenCount: z.int().gte(0).readonly(),
    transientErrorCount: z.int().gte(0).readonly(),
    fatalErrorCount: z.int().gte(0).readonly(),
    lastErrorCode: z.optional(z.union([z.string().readonly(), z.null()]).readonly()),
    lastErrorMessage: z.optional(z.union([z.string().readonly(), z.null()]).readonly()),
    completedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
});
export const zMarkAllNotificationsAsReadResponseRoot2 = z.object({
    updatedCount: z.int().gte(0),
});
export const zNotificationChannelRoot = z.enum(["PUSH", "IN_APP", "BOTH"]);
export const zNotificationDispatchAlimtalkTemplateRoot = z.object({
    templateCode: z.string(),
    name: z.string(),
    content: z.string(),
    settingName: z.string(),
    variables: z.array(z.string()),
});
export const zNotificationDispatchAlimtalkTemplateChoiceRoot = z.object({
    provider: zAlimtalkProviderRoot,
    templateCode: z.string(),
    templateName: z.string(),
    variables: z.record(z.string(), z.string()),
});
export const zNotificationDispatchAlimtalkTemplateListRoot = z.object({
    provider: zAlimtalkProviderRoot,
    configured: z.boolean(),
    registeredTemplateCodes: z.array(z.string()),
    templates: z.array(zNotificationDispatchAlimtalkTemplateRoot),
});
export const zNotificationDispatchCategoryRoot = z.enum([
    "BROADCAST",
    "PRODUCT",
    "LOUNGE",
    "NOTICE",
    "EVENT",
    "PROMOTION",
]);
export const zNotificationDispatchChannelRoot = z.enum([
    "PUSH",
    "INBOX",
    "SMS",
    "ALIMTALK",
]);
export const zNotificationDispatchContentTypeRoot = z.enum([
    "BROADCAST",
    "PRODUCT",
    "LOUNGE",
]);
export const zNotificationDispatchPreviewRoot = z.object({
    targetUserCount: z.int().gte(0).readonly(),
    reachableUserCount: z.int().gte(0).readonly(),
    deviceCount: z.union([z.int().gte(0).readonly(), z.null()]).readonly(),
    promotionConsentApplied: z.boolean().readonly(),
});
export const zNotificationDispatchRecipientRoot = z.object({
    userId: z.uuid().readonly(),
    nickname: z.union([z.string().readonly(), z.null()]).readonly(),
    roles: z.array(z.enum(["COLLECTOR", "DEALER", "ADMIN"])).readonly(),
    sendable: z.boolean().readonly(),
    unsendableReason: z.nullable(z.enum(["NO_DEVICE", "NO_PHONE", "PHONE_NOT_VERIFIED"])),
    phone: z.union([z.string().readonly(), z.null()]).readonly(),
    activeDeviceCount: z.union([z.int().gte(0).readonly(), z.null()]).readonly(),
    joinedAt: z.iso.datetime().readonly(),
    lastAccessAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
});
export const zNotificationDispatchStatusRoot = z.enum([
    "PENDING",
    "SCHEDULED",
    "SUCCEEDED",
    "PARTIALLY_FAILED",
    "FAILED",
    "CANCELED",
]);
export const zNotificationDispatchTargetRoot = z.object({
    mode: z.enum(["ALL", "FILTER", "USERS"]),
    userIds: z.optional(z.array(z.uuid()).max(500)),
    roles: z.optional(z.array(z.enum(["COLLECTOR", "DEALER"])).max(2)),
    joinedFrom: z.optional(z.iso.date()),
    joinedTo: z.optional(z.iso.date()),
    lastAccessFrom: z.optional(z.iso.date()),
    lastAccessTo: z.optional(z.iso.date()),
    interestCategoryIds: z.optional(z.array(z.uuid()).max(50)),
    followedDealerId: z.optional(z.uuid()),
    reminderBroadcastId: z.optional(z.uuid()),
    purchase: z.optional(z.enum(["HAS", "NEVER"])),
    purchasedFrom: z.optional(z.iso.date()),
    purchasedTo: z.optional(z.iso.date()),
    purchasedDealerId: z.optional(z.uuid()),
    promotionConsent: z.optional(z.boolean()),
    appPlatform: z.optional(z.enum(["ANDROID", "IOS"])),
});
export const zNotificationDispatchRoot = z.object({
    notificationDispatchId: z.uuid().readonly(),
    channel: zNotificationDispatchChannelRoot,
    category: z.union([zNotificationDispatchCategoryRoot, z.null()]),
    title: z.string().readonly(),
    body: z.string().readonly(),
    linkUrl: z.optional(z.union([z.string().readonly(), z.null()]).readonly()),
    contentType: z.optional(z.union([zNotificationDispatchContentTypeRoot, z.null()])),
    contentId: z.optional(z.union([z.uuid().readonly(), z.null()]).readonly()),
    contentTitle: z.optional(z.union([z.string().readonly(), z.null()]).readonly()),
    target: z.union([zNotificationDispatchTargetRoot, z.null()]),
    saveToInbox: z.optional(z.union([z.boolean().readonly(), z.null()]).readonly()),
    recipientCount: z.int().gte(0).readonly(),
    sentByAdminId: z.uuid().readonly(),
    sentByAdminUsername: z.optional(z.union([z.string().readonly(), z.null()]).readonly()),
    sentAt: z.iso.datetime().readonly(),
    scheduledAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    canceledAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    status: zNotificationDispatchStatusRoot,
    sentCount: z.int().gte(0).readonly(),
    invalidTokenCount: z.int().gte(0).readonly(),
    transientErrorCount: z.int().gte(0).readonly(),
    fatalErrorCount: z.int().gte(0).readonly(),
    lastErrorCode: z.optional(z.union([z.string().readonly(), z.null()]).readonly()),
    lastErrorMessage: z.optional(z.union([z.string().readonly(), z.null()]).readonly()),
    completedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    alimtalkTemplate: z.optional(z.union([zNotificationDispatchAlimtalkTemplateChoiceRoot, z.null()])),
});
export const zNotificationDispatchCreateRoot = z.object({
    alimtalkTemplateCode: z.optional(z.string().min(1).max(100)),
    alimtalkVariables: z.optional(z.record(z.string(), z.string().max(1000))),
    channel: zNotificationDispatchChannelRoot,
    category: zNotificationDispatchCategoryRoot,
    title: z.optional(z.string().min(1).max(100)),
    body: z.optional(z.string().min(1).max(1000)),
    linkUrl: z.optional(z
        .string()
        .min(1)
        .max(500)
        .regex(/^boltb:\/\//)),
    contentType: z.optional(zNotificationDispatchContentTypeRoot),
    contentId: z.optional(z.uuid()),
    contentTitle: z.optional(z.string().max(500)),
    target: zNotificationDispatchTargetRoot,
    saveToInbox: z.optional(z.boolean()),
    scheduledAt: z.optional(z.iso.datetime()),
});
export const zNotificationDispatchPreviewRequestRoot = z.object({
    channel: zNotificationDispatchChannelRoot,
    category: zNotificationDispatchCategoryRoot,
    target: zNotificationDispatchTargetRoot,
});
export const zNotificationDispatchRecipientSearchRoot = z.object({
    channel: zNotificationDispatchChannelRoot,
    category: zNotificationDispatchCategoryRoot,
    target: zNotificationDispatchTargetRoot,
    page: z.optional(z.int().gte(1)),
    pageSize: z.optional(z.int().gte(1).lte(100)),
});
export const zNotificationForegroundDisplayRoot = z.enum([
    "SNACKBAR",
    "NONE",
    "SYSTEM",
]);
export const zNotificationInboxCategoryRoot = z.enum(["ACTIVITY", "FOLLOWING"]);
export const zNotificationInboxTabRoot = z.object({
    key: z.string(),
    label: z.string(),
});
export const zNotificationOpenCreateRoot = z.object({
    notificationId: z.optional(z.uuid()),
    broadcastPushHistoryId: z.optional(z.uuid()),
});
export const zNotificationOperationSettingsRoot = z.object({
    osPermissionShowUnknown: z.boolean(),
    osPermissionJudgmentDays: z.int().gte(1).lte(365),
    permissionPromptEnabled: z.boolean(),
    permissionPromptReplaceFirstRun: z.boolean(),
    permissionPromptIntervalDays: z.int().gte(1).lte(365),
    permissionPromptMaxCount: z.int().gte(1).lte(20),
    permissionPromptUndeterminedTitle: z.string().min(1).max(40),
    permissionPromptUndeterminedBody: z.string().min(1).max(150),
    permissionPromptUndeterminedConfirm: z.string().min(1).max(10),
    permissionPromptDeniedTitle: z.string().min(1).max(40),
    permissionPromptDeniedBody: z.string().min(1).max(150),
    permissionPromptDeniedCancel: z.string().min(1).max(10),
    permissionPromptDeniedConfirm: z.string().min(1).max(10),
    pushOpenMarksRead: z.boolean(),
    operatorPushSaveToInbox: z.boolean(),
    alimtalkProvider: zAlimtalkProviderRoot,
    alimtalkProviders: z.array(zAlimtalkProviderStatusRoot).readonly(),
    updatedAt: z.union([z.iso.datetime(), z.null()]),
    updatedByAdminId: z.union([z.uuid(), z.null()]),
});
export const zNotificationOperationSettingsUpdateRoot = z.object({
    osPermissionShowUnknown: z.optional(z.boolean()),
    osPermissionJudgmentDays: z.optional(z.int().gte(1).lte(365)),
    permissionPromptEnabled: z.optional(z.boolean()),
    permissionPromptReplaceFirstRun: z.optional(z.boolean()),
    permissionPromptIntervalDays: z.optional(z.int().gte(1).lte(365)),
    permissionPromptMaxCount: z.optional(z.int().gte(1).lte(20)),
    permissionPromptUndeterminedTitle: z.optional(z.string().min(1).max(40)),
    permissionPromptUndeterminedBody: z.optional(z.string().min(1).max(150)),
    permissionPromptUndeterminedConfirm: z.optional(z.string().min(1).max(10)),
    permissionPromptDeniedTitle: z.optional(z.string().min(1).max(40)),
    permissionPromptDeniedBody: z.optional(z.string().min(1).max(150)),
    permissionPromptDeniedCancel: z.optional(z.string().min(1).max(10)),
    permissionPromptDeniedConfirm: z.optional(z.string().min(1).max(10)),
    pushOpenMarksRead: z.optional(z.boolean()),
    operatorPushSaveToInbox: z.optional(z.boolean()),
    alimtalkProvider: z.optional(zAlimtalkProviderRoot),
});
export const zNotificationPreferenceRoot2 = z.object({
    userId: z.string().readonly(),
    broadcastNotifications: z.boolean(),
    messageNotifications: z.boolean(),
    orderNotifications: z.boolean(),
    promotionNotifications: z.boolean(),
    loungeNotifications: z.boolean(),
    systemNotifications: z.boolean().readonly(),
    channels: z.array(z.enum(["PUSH", "IN_APP"])).min(1),
    quietHoursEnabled: z.boolean(),
    quietHoursStart: z.optional(z.union([z.iso.time(), z.null()])),
    quietHoursEnd: z.optional(z.union([z.iso.time(), z.null()])),
    updatedAt: z.iso.datetime().readonly(),
});
export const zNotificationPreferenceUpdateRoot = z.object({
    broadcastNotifications: z.optional(z.union([z.boolean(), z.null()])),
    messageNotifications: z.optional(z.union([z.boolean(), z.null()])),
    orderNotifications: z.optional(z.union([z.boolean(), z.null()])),
    promotionNotifications: z.optional(z.union([z.boolean(), z.null()])),
    loungeNotifications: z.optional(z.union([z.boolean(), z.null()])),
    channels: z.optional(z.union([z.array(z.enum(["PUSH", "IN_APP"])).min(1), z.null()])),
    quietHoursEnabled: z.optional(z.union([z.boolean(), z.null()])),
    quietHoursStart: z.optional(z.union([z.iso.time(), z.null()])),
    quietHoursEnd: z.optional(z.union([z.iso.time(), z.null()])),
});
export const zNotificationSettingItemRoot = z.object({
    key: z.string().readonly(),
    legacy: z.boolean().readonly(),
    groupTitle: z.union([z.string(), z.null()]),
    label: z.string(),
    description: z.string(),
    sortOrder: z.int(),
    active: z.boolean(),
    defaultEnabled: z.boolean(),
    includedByKey: z.union([z.string(), z.null()]),
    turnOffConfirmTitle: z.union([z.string(), z.null()]),
    turnOffConfirmBody: z.union([z.string(), z.null()]),
    updatedAt: z.union([z.iso.datetime().readonly(), z.null()]).readonly(),
    updatedByAdminId: z.union([z.string().readonly(), z.null()]).readonly(),
});
export const zNotificationSettingItemListRoot = z.object({
    items: z.array(zNotificationSettingItemRoot),
});
export const zNotificationSettingItemStateRoot = z.object({
    key: z.string(),
    groupTitle: z.union([z.string(), z.null()]),
    label: z.string(),
    description: z.string(),
    active: z.boolean(),
    enabled: z.boolean(),
    displayEnabled: z.boolean(),
    editable: z.boolean(),
    disabledReason: z.union([z.string(), z.null()]),
    turnOffConfirmTitle: z.union([z.string(), z.null()]),
    turnOffConfirmBody: z.union([z.string(), z.null()]),
});
export const zBackofficeUserNotificationSettingsRoot = z.object({
    items: z.array(zNotificationSettingItemStateRoot),
    osPermission: zBackofficeUserOsNotificationPermissionRoot,
});
export const zNotificationSettingItemStateListRoot = z.object({
    items: z.array(zNotificationSettingItemStateRoot),
});
export const zNotificationSettingItemUpdateRoot = z.object({
    groupTitle: z.optional(z.union([z.string(), z.null()])),
    label: z.optional(z.string()),
    description: z.optional(z.string()),
    sortOrder: z.optional(z.int()),
    active: z.optional(z.boolean()),
    defaultEnabled: z.optional(z.boolean()),
    includedByKey: z.optional(z.union([z.string(), z.null()])),
    turnOffConfirmTitle: z.optional(z.union([z.string(), z.null()])),
    turnOffConfirmBody: z.optional(z.union([z.string(), z.null()])),
});
export const zNotificationSettingItemValueUpdateRoot = z.object({
    enabled: z.boolean(),
});
export const zNotificationStatusRoot = z.enum([
    "PENDING",
    "SENT",
    "FAILED",
    "READ",
]);
export const zNotificationTemplateCategoryRoot = z.enum([
    "BROADCAST",
    "MESSAGE",
    "SOCIAL",
    "ORDER_BUYER",
    "ORDER_SELLER",
    "OPERATOR",
]);
export const zNotificationTemplateChannelFilterRoot = z.enum([
    "PUSH",
    "IN_APP",
    "ALIMTALK",
]);
export const zNotificationTemplateDeliveryMethodRoot = z.enum([
    "APP",
    "ALIMTALK",
]);
export const zNotificationTemplatePreferenceKeyRoot = z.enum([
    "NONE",
    "BROADCAST",
    "MESSAGE",
    "LOUNGE",
    "ORDER",
    "PROMOTION",
    "BROADCAST_ALL",
    "BROADCAST_INTEREST",
]);
export const zNotificationTemplateUpdateRoot = z.object({
    enabled: z.optional(z.boolean()),
    pushEnabled: z.optional(z.boolean()),
    inAppEnabled: z.optional(z.boolean()),
    titleTemplate: z.optional(z.string().max(100)),
    bodyTemplate: z.optional(z.string().max(1000)),
    preferenceKey: z.optional(zNotificationTemplatePreferenceKeyRoot),
    respectQuietHours: z.optional(z.boolean()),
    inboxCategory: z.optional(zNotificationInboxCategoryRoot),
    foregroundDisplay: z.optional(zNotificationForegroundDisplayRoot),
    suppressOnTargetScreen: z.optional(z.boolean()),
    alimtalkTemplateId: z.optional(z.string().max(100)),
    nhnAlimtalkTemplateCode: z.optional(z.string().max(20)),
});
export const zNotificationTemplateVariableRoot = z.object({
    key: z.string(),
    description: z.string(),
});
export const zNotificationTemplateRoot = z.object({
    code: z.string().readonly(),
    name: z.string().readonly(),
    category: zNotificationTemplateCategoryRoot,
    deliveryMethod: zNotificationTemplateDeliveryMethodRoot,
    recipientDescription: z.string().readonly(),
    triggerDescription: z.string().readonly(),
    pushType: z.union([z.string().readonly(), z.null()]).readonly(),
    deepLinkPattern: z.union([z.string().readonly(), z.null()]).readonly(),
    variables: z.array(zNotificationTemplateVariableRoot).readonly(),
    enabled: z.boolean(),
    pushEnabled: z.boolean(),
    inAppEnabled: z.boolean(),
    titleTemplate: z.union([z.string(), z.null()]),
    bodyTemplate: z.string(),
    preferenceKey: zNotificationTemplatePreferenceKeyRoot,
    respectQuietHours: z.boolean(),
    inboxCategory: zNotificationInboxCategoryRoot,
    foregroundDisplay: zNotificationForegroundDisplayRoot,
    suppressOnTargetScreen: z.boolean(),
    alimtalkTemplateId: z.union([z.string(), z.null()]),
    nhnAlimtalkTemplateCode: z.union([z.string().max(20), z.null()]),
    defaultTitleTemplate: z.union([z.string().readonly(), z.null()]).readonly(),
    defaultBodyTemplate: z.string().readonly(),
    updatedAt: z.union([z.iso.datetime().readonly(), z.null()]).readonly(),
    updatedByAdminId: z.union([z.uuid().readonly(), z.null()]).readonly(),
});
export const zNotificationTemplateListRoot = z.object({
    templates: z.array(zNotificationTemplateRoot),
});
export const zNotificationTypeRoot = z.enum([
    "BROADCAST",
    "MESSAGE",
    "ORDER",
    "PROMOTION",
    "SYSTEM",
]);
export const zNotificationRoot2 = z.object({
    notificationId: z.string().readonly(),
    userId: z.string().readonly(),
    sourceEventId: z.optional(z.union([z.string(), z.null()])),
    type: zNotificationTypeRoot,
    title: z.string().min(1).max(100),
    body: z.string().min(1).max(500),
    data: z.optional(z.union([z.record(z.string(), z.unknown()), z.null()])),
    channel: zNotificationChannelRoot,
    status: zNotificationStatusRoot,
    sentAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    readAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    retryCount: z.int().gte(0).lte(3).readonly(),
    errorMessage: z.optional(z.union([z.string().readonly(), z.null()]).readonly()),
    createdAt: z.iso.datetime().readonly(),
    inboxCategory: z.optional(zNotificationInboxCategoryRoot),
});
export const zNotificationListRoot2 = z.object({
    notifications: z.array(zNotificationRoot2),
    unreadCount: z.int().gte(0),
    totalCount: z.int().gte(0),
    page: z.optional(z.union([z.int().gte(1), z.null()])),
    inboxTabs: z.optional(z.array(zNotificationInboxTabRoot)),
});
export const zAddressIdPathRoot = z.unknown();
export const zBuyerIdPathRoot = z.unknown();
export const zCancellationIdPathRoot = z.unknown();
export const zFulfillmentOrderIdPathRoot = z.unknown();
export const zOrderIdPathRoot = z.unknown();
export const zReturnIdPathRoot = z.unknown();
export const zShipmentIdPathRoot = z.unknown();
export const zUserIdPathRoot2 = z.unknown();
export const zBackofficeFulfillmentOrdersCollectionRoot = z.unknown();
export const zBackofficeFulfillmentOrdersItemForceCancelRefundRoot = z.unknown();
export const zBackofficeFulfillmentOrdersItemRoot = z.unknown();
export const zBackofficeFulfillmentOrdersShipmentTrackingRoot = z.unknown();
export const zBackofficeFulfillmentOrdersShippingAddressRoot = z.unknown();
export const zBackofficeOrdersCollectionRoot = z.unknown();
export const zBackofficeOrdersItemForceCancelRefundRoot = z.unknown();
export const zBackofficeOrdersItemShippingFeeRefundRoot = z.unknown();
export const zBackofficeOrdersItemRoot = z.unknown();
export const zBackofficeReturnsCollectionRoot = z.unknown();
export const zBackofficeReturnsItemForceApproveRefundRoot = z.unknown();
export const zBackofficeReturnsItemRoot = z.unknown();
export const zBackofficeShipmentsCollectionRoot = z.unknown();
export const zBackofficeShipmentsItemRoot = z.unknown();
export const zBackofficeUsersUserIdDeliveryAddressesRoot = z.unknown();
export const zBuyersOrdersRoot = z.unknown();
export const zCancellationRequestsReceivedCollectionRoot = z.unknown();
export const zCancellationRequestsReceivedItemRoot = z.unknown();
export const zCancellationRequestsApproveRoot = z.unknown();
export const zCancellationRequestsBatchApprovalsRoot = z.unknown();
export const zCancellationRequestsRejectRoot = z.unknown();
export const zDeliveryAddressesCollectionRoot = z.unknown();
export const zDeliveryAddressesItemRoot = z.unknown();
export const zDeliveryAddressesSetDefaultRoot = z.unknown();
export const zFulfillmentOrdersCountsRoot = z.unknown();
export const zFulfillmentOrdersMineCollectionRoot = z.unknown();
export const zFulfillmentOrdersReceivedCollectionRoot = z.unknown();
export const zFulfillmentOrdersBatchCancellationRequestsRoot = z.unknown();
export const zFulfillmentOrdersBuyerDeliveryAddressesRoot = z.unknown();
export const zFulfillmentOrdersCancellationRequestsRoot = z.unknown();
export const zFulfillmentOrdersConfirmRoot = z.unknown();
export const zFulfillmentOrdersConfirmationRequestsRoot = z.unknown();
export const zFulfillmentOrdersDeliverRoot = z.unknown();
export const zFulfillmentOrdersItemRoot = z.unknown();
export const zFulfillmentOrdersReturnRequestsRoot = z.unknown();
export const zFulfillmentOrdersShipRoot = z.unknown();
export const zFulfillmentOrdersShipmentTrackingRoot = z.unknown();
export const zFulfillmentOrdersShippingAddressRoot = z.unknown();
export const zFulfillmentOrdersTrackingStatusRoot = z.unknown();
export const zOrdersMineCollectionRoot = z.unknown();
export const zOrdersReceivedAnnualSalesRoot = z.unknown();
export const zOrdersReceivedCollectionRoot = z.unknown();
export const zOrdersCancellationRequestsRoot = z.unknown();
export const zOrdersCollectionRoot = z.unknown();
export const zOrdersItemRoot = z.unknown();
export const zOrdersRepayRoot = z.unknown();
export const zOrdersReturnsCollectionRoot = z.unknown();
export const zOrdersReturnsItemRoot = z.unknown();
export const zOrdersShippingFeeRefundRoot = z.unknown();
export const zReturnsMineCollectionRoot = z.unknown();
export const zReturnsReceivedCollectionRoot = z.unknown();
export const zReturnsApproveRoot = z.unknown();
export const zReturnsImagesUploadUrlRoot = z.unknown();
export const zReturnsRejectRoot = z.unknown();
export const zShipmentsItemRoot = z.unknown();
export const zTrackingValidationsRoot = z.unknown();
export const zUsersDeliveryAddressesRoot = z.unknown();
export const zBatchApproveCancellationResultRoot = z.object({
    cancellationId: z.string(),
    success: z.boolean(),
    error: z.optional(z.union([z.string(), z.null()])),
});
export const zBatchApproveCancellationResult = zBatchApproveCancellationResultRoot;
export const zBatchApproveCancellationsRequestRoot = z.object({
    cancellationIds: z.array(z.string()).min(1).max(100),
});
export const zBatchApproveCancellationsRequest = zBatchApproveCancellationsRequestRoot;
export const zBatchApproveCancellationsResponseRoot = z.object({
    processedCount: z.int().gte(0),
    failedCount: z.int().gte(0),
    results: z.array(zBatchApproveCancellationResultRoot),
});
export const zBatchApproveCancellationsResponse = zBatchApproveCancellationsResponseRoot;
export const zBatchCancelOrdersRequestRoot = z.object({
    orderIds: z.array(z.string()).min(1).max(100),
    reasonType: z.enum(["BUYER_CHANGED_MIND", "BUYER_FOUND_BETTER_PRICE"]),
    reasonDescription: z.optional(z.union([z.string().max(500), z.null()])),
});
export const zBatchCancelOrdersRequest = zBatchCancelOrdersRequestRoot;
export const zCancelOrderRequestRoot = z.object({
    reason: z.optional(z.string()),
});
export const zCancellationRequestCreateRoot = z.object({
    reasonType: z.enum(["BUYER_CHANGED_MIND", "BUYER_FOUND_BETTER_PRICE"]),
    reasonDescription: z.optional(z.union([z.string().max(500), z.null()])),
});
export const zCancellationRequestCreate = zCancellationRequestCreateRoot;
export const zCarrierTrackingInfoRoot = z.object({
    level: z.int().gte(1).lte(6),
    completed: z.boolean(),
    lastEventAt: z.union([z.iso.datetime(), z.null()]),
    lastEventLocation: z.union([z.string(), z.null()]),
    lastEventDescription: z.union([z.string(), z.null()]),
});
export const zCarrierTrackingInfo = zCarrierTrackingInfoRoot;
export const zChangeFulfillmentOrderShippingAddressRequestRoot = z.object({
    addressId: z.uuid(),
    reason: z.optional(z.string().max(200)),
});
export const zConfirmFulfillmentOrderResponseRoot = z.object({
    fulfillmentOrderId: z.string(),
    status: z.enum(["CONFIRMED"]),
    confirmedOrderIds: z.array(z.string()),
    skippedOrderIds: z.array(z.string()),
    confirmedAt: z.iso.datetime(),
});
export const zConfirmFulfillmentOrderResponse = zConfirmFulfillmentOrderResponseRoot;
export const zDeliveryAddressRoot = z.object({
    addressId: z.string().readonly(),
    userId: z.string().readonly(),
    recipientName: z.string().min(1).max(100),
    phoneNumber: z.string().regex(/^01[016789]-?\d{3,4}-?\d{4}$/),
    postalCode: z.string().regex(/^\d{5}$/),
    addressLine1: z.string().min(1).max(200),
    addressLine2: z.optional(z.union([z.string().max(200), z.null()])),
    nickname: z.optional(z.union([z.string().max(50), z.null()])),
    isDefault: z.boolean().readonly(),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zChangeFulfillmentOrderShippingAddressResponseRoot = z.object({
    fulfillmentOrderId: z.uuid(),
    shippingAddress: zDeliveryAddressRoot,
    changedFulfillmentOrderIds: z.array(z.uuid()),
    changedOrderCount: z.int().gte(0),
});
export const zDeliveryAddressCreateRoot = z.object({
    recipientName: z.string().min(1).max(100),
    phoneNumber: z.string().regex(/^01[016789]-?\d{3,4}-?\d{4}$/),
    postalCode: z.string().regex(/^\d{5}$/),
    addressLine1: z.string().min(1).max(200),
    addressLine2: z.optional(z.union([z.string().max(200), z.null()])),
    nickname: z.optional(z.union([z.string().max(50), z.null()])),
});
export const zDeliveryAddressUpdateRoot = z.object({
    recipientName: z.optional(z.union([z.string().min(1).max(100), z.null()])),
    phoneNumber: z.optional(z.union([z.string().regex(/^01[016789]-?\d{3,4}-?\d{4}$/), z.null()])),
    postalCode: z.optional(z.union([z.string().regex(/^\d{5}$/), z.null()])),
    addressLine1: z.optional(z.union([z.string().min(1).max(200), z.null()])),
    addressLine2: z.optional(z.union([z.string().max(200), z.null()])),
    nickname: z.optional(z.union([z.string().max(50), z.null()])),
});
export const zForceApproveRefundReturnRequestRoot = z.object({
    reason: z.optional(z.string().min(1)),
});
export const zForceApproveRefundReturnRequest = zForceApproveRefundReturnRequestRoot;
export const zForceCancelRefundFulfillmentOrderRequestRoot = z.object({
    reason: z.optional(z.string().min(1)),
});
export const zForceCancelRefundFulfillmentOrderRequest = zForceCancelRefundFulfillmentOrderRequestRoot;
export const zForceCancelRefundFulfillmentOrderResponseRoot = z.object({
    fulfillmentOrderId: z.string(),
    cancelledOrderIds: z.array(z.string()),
    skippedOrderIds: z.array(z.string()),
});
export const zForceCancelRefundFulfillmentOrderResponse = zForceCancelRefundFulfillmentOrderResponseRoot;
export const zForceCancelRefundOrderRequestRoot = z.object({
    reason: z.optional(z.string().min(1)),
});
export const zForceCancelRefundOrderRequest = zForceCancelRefundOrderRequestRoot;
export const zFulfillmentOrderAnnotationRoot = z.enum([
    "NONE",
    "PARTIAL_CANCEL",
    "PARTIAL_RETURN",
    "PARTIAL_CANCEL_AND_RETURN",
]);
export const zFulfillmentOrderAnnotation = zFulfillmentOrderAnnotationRoot;
export const zFulfillmentOrderBuyerDeliveryAddressesResponseRoot = z.object({
    data: z.array(zDeliveryAddressRoot),
});
export const zFulfillmentOrderCancellationSkippedOrderRoot = z.object({
    orderId: z.string(),
    reason: z.enum([
        "NOT_FOUND",
        "ALREADY_DISPATCHED",
        "CONFIRMED",
        "NOT_CANCELLABLE",
        "EXISTING_REQUEST",
    ]),
});
export const zFulfillmentOrderCancellationSkippedOrder = zFulfillmentOrderCancellationSkippedOrderRoot;
export const zFulfillmentOrderConfirmationRequestResponseRoot = z.object({
    fulfillmentOrderId: z.string(),
    requestedAt: z.iso.datetime(),
    confirmationRequestCount: z.int().gte(1),
    nextConfirmationRequestAvailableAt: z.iso.datetime(),
});
export const zFulfillmentOrderCountsRoot = z.object({
    paymentPending: z.int().gte(0),
    paid: z.int().gte(0),
    shipped: z.int().gte(0),
    delivered: z.int().gte(0),
    confirmed: z.int().gte(0),
    allCancelled: z.int().gte(0),
});
export const zFulfillmentOrderCounts = zFulfillmentOrderCountsRoot;
export const zFulfillmentOrderDisplayStatusRoot = z.enum([
    "PAYMENT_PENDING",
    "AWAITING_REPAYMENT",
    "PAID",
    "SHIPPED",
    "DELIVERED",
    "CONFIRMED",
    "ALL_CANCELLED",
    "ALL_RETURNED",
]);
export const zFulfillmentOrderDisplayStatus = zFulfillmentOrderDisplayStatusRoot;
export const zFulfillmentOrderReturnCreateRoot = z.object({
    returnReason: z.enum([
        "WRONG_DELIVERY",
        "MISSING_ITEMS",
        "DAMAGED_DEFECTIVE",
        "NOT_AS_DESCRIBED",
        "OTHER",
    ]),
    returnDescription: z.optional(z.union([z.string().max(1000), z.null()])),
    images: z.optional(z.array(z.url()).max(5)).default([]),
    orderIds: z.optional(z.array(z.uuid())),
});
export const zFulfillmentOrderReturnSkippedOrderRoot = z.object({
    orderId: z.string(),
    reason: z.enum([
        "NOT_FOUND",
        "NOT_YET_DISPATCHED",
        "CONFIRMED",
        "GIVEAWAY",
        "NOT_RETURNABLE",
        "EXISTING_REQUEST",
    ]),
});
export const zFulfillmentOrderReturnSkippedOrder = zFulfillmentOrderReturnSkippedOrderRoot;
export const zFulfillmentOrderTrackingResponseRoot = z.object({
    status: z.enum([
        "OK",
        "NO_TRACKING_INFO",
        "NOT_FOUND",
        "UNSUPPORTED_CARRIER",
        "NOT_CONFIGURED",
        "PROVIDER_ERROR",
    ]),
    tracking: z.union([zCarrierTrackingInfoRoot, z.null()]),
});
export const zFulfillmentOrderTrackingResponse = zFulfillmentOrderTrackingResponseRoot;
export const zMarkFulfillmentOrderDeliveredResponseRoot = z.object({
    fulfillmentOrderId: z.string(),
    status: z.enum(["DELIVERED"]),
    deliveredOrderIds: z.array(z.string()),
    skippedOrderIds: z.array(z.string()),
    deliveredAt: z.iso.datetime(),
});
export const zMarkFulfillmentOrderDeliveredResponse = zMarkFulfillmentOrderDeliveredResponseRoot;
export const zRejectCancellationRequestBodyRoot = z.object({
    rejectionReason: z.string().min(1).max(500),
});
export const zRejectCancellationRequestBody = zRejectCancellationRequestBodyRoot;
export const zRejectReturnRequestRoot = z.object({
    rejectionReason: z.string().min(1).max(500),
});
export const zRepayOrderResponseRoot = z.object({
    orderId: z.string(),
    status: z.enum(["PAID"]),
    paidAt: z.iso.datetime(),
});
export const zRepayOrderResponse = zRepayOrderResponseRoot;
export const zReturnImageUploadUrlRoot = z.object({
    uploadUrl: z.url(),
    imageUrl: z.url(),
    expiresIn: z.int().gte(1),
    expiresAt: z.iso.datetime(),
});
export const zReturnImageUploadUrl = zReturnImageUploadUrlRoot;
export const zReturnItemCreateRoot = z.object({
    productListingId: z.string(),
    productName: z.string(),
    quantity: z.int().gte(1),
    reason: z.string(),
});
export const zReturnCreateRoot = z.object({
    returnItems: z.array(zReturnItemCreateRoot).min(1),
    returnReason: z.enum([
        "WRONG_DELIVERY",
        "MISSING_ITEMS",
        "DAMAGED_DEFECTIVE",
        "NOT_AS_DESCRIBED",
        "OTHER",
    ]),
    returnDescription: z.optional(z.union([z.string().max(1000), z.null()])),
    images: z.optional(z.array(z.url()).max(5)).default([]),
});
export const zSaleTypeRoot = z.enum([
    "MARKETPLACE",
    "INSTANT_PURCHASE",
    "GENERAL_AUCTION",
    "FIRST_COME_AUCTION",
    "BLIND_AUCTION",
    "AUCTION",
    "GROUP_BUY",
    "GIVEAWAY",
]);
export const zSaleType = zSaleTypeRoot;
export const zShipFulfillmentOrderResponseRoot = z.object({
    fulfillmentOrderId: z.string(),
    status: z.enum(["SHIPPED"]),
    shippedFulfillmentOrderIds: z.array(z.string()),
    shippedOrderIds: z.array(z.string()),
    skippedOrderIds: z.array(z.string()),
    shippedAt: z.iso.datetime(),
});
export const zShipFulfillmentOrderResponse = zShipFulfillmentOrderResponseRoot;
export const zShippingFeeRefundRequestRoot = z.object({
    reason: z.optional(z.string().min(1)),
});
export const zShippingOptionRoot = z.enum(["STANDARD", "QUICK_DIRECT"]);
export const zShippingOption = zShippingOptionRoot;
export const zSnapshotImageRoot = z.object({
    url: z.url(),
    width: z.int(),
    height: z.int(),
    order: z.int(),
});
export const zTrackingUpdateRoot = z.object({
    timestamp: z.iso.datetime(),
    status: z.string(),
    location: z.string(),
    description: z.string(),
});
export const zTrackingUpdate = zTrackingUpdateRoot;
export const zTrackingValidationResponseRoot = z.object({
    status: z.enum([
        "VALID",
        "NOT_FOUND",
        "UNSUPPORTED_CARRIER",
        "NOT_CONFIGURED",
        "PROVIDER_ERROR",
    ]),
    tracking: z.union([zCarrierTrackingInfoRoot, z.null()]),
});
export const zTrackingValidationResponse = zTrackingValidationResponseRoot;
export const zPaymentIdPathRoot = z.unknown();
export const zPaymentMethodIdPathRoot = z.unknown();
export const zRefundIdPathRoot = z.unknown();
export const zBackofficePaymentsCollectionRoot = z.unknown();
export const zBackofficePaymentsItemRoot = z.unknown();
export const zBackofficeRefundsCollectionRoot = z.unknown();
export const zBackofficeRefundsItemForceProcessRoot = z.unknown();
export const zBackofficeRefundsItemRoot = z.unknown();
export const zPaymentMethodsCollectionRoot = z.unknown();
export const zPaymentMethodsItemRoot = z.unknown();
export const zPaymentMethodsSetDefaultRoot = z.unknown();
export const zPaymentsCollectionRoot = z.unknown();
export const zPaymentsItemRoot = z.unknown();
export const zPaymentsRefundRoot = z.unknown();
export const zRefundsItemRoot = z.unknown();
export const zWebhooksPaymentAuthorizeRoot = z.unknown();
export const zPaymentDetailsRoot = z.unknown();
export const zPaymentMethodRoot = z.unknown();
export const zRefundRoot = z.unknown();
export const zWebhookAcceptedRoot = z.unknown();
export const zAuthorizePaymentWebhookRoot = z.object({
    orderId: z.uuid(),
    paymentKey: z.string(),
    amount: z.number().gte(100).lte(100000000),
});
export const zForceProcessRefundRequestRoot = z.object({
    reason: z.optional(z.string().min(1)),
});
export const zForceProcessRefundRequest = zForceProcessRefundRequestRoot;
export const zPaymentGatewayRoot = z.enum(["STRIPE", "TOSS_PAYMENTS"]);
export const zPaymentMethodCreateRoot = z.object({
    userId: z.string(),
    nickname: z.optional(z.union([z.string().max(50), z.null()])),
});
export const zPaymentMethodTypeRoot = z.enum([
    "CREDIT_CARD",
    "DEBIT_CARD",
    "TOSS_PAY_EASY_PAYMENT",
]);
export const zPaymentMethodRoot2 = z.object({
    paymentMethodId: z.string().readonly(),
    userId: z.string(),
    methodType: zPaymentMethodTypeRoot,
    gateway: zPaymentGatewayRoot,
    cardIssuer: z.optional(z.union([z.string(), z.null()])),
    lastFourDigits: z.string().regex(/^[0-9]{4}$/),
    expiryDate: z.optional(z.union([z.string().regex(/^(0[1-9]|1[0-2])\/[0-9]{2}$/), z.null()])),
    nickname: z.optional(z.union([z.string().max(50), z.null()])),
    isDefault: z.boolean(),
    isActive: z.boolean().readonly(),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zPaymentStatusRoot = z.enum([
    "PENDING",
    "AUTHORIZED",
    "CAPTURED",
    "FAILED",
    "CANCELLED",
    "REFUNDED",
]);
export const zRefundReasonRoot = z.enum([
    "CUSTOMER_REQUEST",
    "ORDER_CANCELLED",
    "RETURN_APPROVED",
    "PAYMENT_ERROR",
]);
export const zRefundStatusRoot = z.enum([
    "PENDING",
    "PROCESSING",
    "COMPLETED",
    "FAILED",
]);
export const zBroadcastChatNoticeIdPathRoot = z.unknown();
export const zPlatformPathRoot = z.unknown();
export const zBackofficeAppDownloadSettingsRoot = z.unknown();
export const zBackofficeAppUiSettingsResetsRoot = z.unknown();
export const zBackofficeAppUiSettingsRoot = z.unknown();
export const zBackofficeAppVersionPoliciesCollectionRoot = z.unknown();
export const zBackofficeAppVersionPoliciesItemRoot = z.unknown();
export const zBackofficeBoltbMarketSectionAllowedCategoriesRoot = z.unknown();
export const zBackofficeBroadcastChatNoticeSettingsRoot = z.unknown();
export const zBackofficeBroadcastChatNoticesCollectionRoot = z.unknown();
export const zBackofficeBroadcastChatNoticesItemRoot = z.unknown();
export const zBackofficeBroadcastChatNoticesOrderRoot = z.unknown();
export const zBackofficeChatBannedWordsCollectionRoot = z.unknown();
export const zBackofficeChatBannedWordsItemRoot = z.unknown();
export const zBackofficeCommissionConfigsRoot = z.unknown();
export const zBackofficeCompanyInfoSettingsRoot = z.unknown();
export const zBackofficeFeeRatesRoot = z.unknown();
export const zBackofficeMobileRuntimePoliciesCollectionRoot = z.unknown();
export const zBackofficeMobileRuntimePoliciesItemRoot = z.unknown();
export const zBackofficePgFeeConfigsRoot = z.unknown();
export const zBackofficeSettlementConfigsRoot = z.unknown();
export const zBackofficeUiConfigFilesCollectionRoot = z.unknown();
export const zBackofficeUiConfigFilesDraftsRoot = z.unknown();
export const zBackofficeUiConfigFilesItemRoot = z.unknown();
export const zBackofficeUiConfigFilesPublishesRoot = z.unknown();
export const zBackofficeUiConfigFilesRevertsRoot = z.unknown();
export const zBackofficeUiConfigFilesSwitchesRoot = z.unknown();
export const zPublicAppDownloadSettingsRoot = z.unknown();
export const zPublicAppSyncChangesRoot = z.unknown();
export const zPublicAppVersionPoliciesCollectionRoot = z.unknown();
export const zPublicBoltbMarketSectionAllowedCategoriesRoot = z.unknown();
export const zPublicBroadcastChatNoticeConfigRoot = z.unknown();
export const zPublicCompanyInfoSettingsRoot = z.unknown();
export const zPublicMobileRuntimePolicyRoot = z.unknown();
export const zPublicPagesItemRoot = z.unknown();
export const zPublicUiConfigFilesCollectionRoot = z.unknown();
export const zPublicUiConfigFilesVersionRoot = z.unknown();
export const zAppDownloadSocialLinkRoot = z.object({
    id: z.string().regex(/^[a-z0-9-]{1,40}$/),
    name: z.string().min(1).max(30),
    url: z.string().max(2048),
    iconUrl: z.union([z.string().max(1000), z.null()]),
    visible: z.boolean(),
});
export const zAppDownloadSocialLink = zAppDownloadSocialLinkRoot;
export const zAppDownloadSettingRoot = z.object({
    qrImageUrl: z.union([z.string(), z.null()]),
    socialLinks: z.array(zAppDownloadSocialLinkRoot),
    googlePlayUrl: z.union([z.string().max(2048), z.null()]),
    appStoreUrl: z.union([z.string().max(2048), z.null()]),
    googlePlayButtonImageUrl: z.union([z.string().max(1000), z.null()]),
    appStoreButtonImageUrl: z.union([z.string().max(1000), z.null()]),
    updatedAt: z.union([z.iso.datetime(), z.null()]),
});
export const zAppDownloadSetting = zAppDownloadSettingRoot;
export const zAppDownloadSettingUpdateRoot = z.object({
    qrImageUrl: z.union([z.string().max(1000), z.null()]),
    socialLinks: z.array(zAppDownloadSocialLinkRoot).max(20),
    googlePlayUrl: z.optional(z.union([z.string().max(2048), z.null()])),
    appStoreUrl: z.optional(z.union([z.string().max(2048), z.null()])),
    googlePlayButtonImageUrl: z.optional(z.union([z.string().max(1000), z.null()])),
    appStoreButtonImageUrl: z.optional(z.union([z.string().max(1000), z.null()])),
});
export const zAppDownloadSettingUpdate = zAppDownloadSettingUpdateRoot;
export const zAppSyncResourceFingerprintRoot = z.object({
    name: z.enum([
        "RUNTIME_POLICY",
        "APP_VERSION_POLICIES",
        "COMPANY_INFO",
        "BOLTB_MARKET_SECTION",
        "BANNERS",
        "CATEGORIES",
        "NOTICE_POPUPS",
        "NOTICE_BANNERS",
    ]),
    fingerprint: z.string().max(64),
});
export const zAppSyncResourceFingerprint = zAppSyncResourceFingerprintRoot;
export const zAppUiSettingResetRoot = z.object({
    baseRevision: z.int().gte(0),
    keys: z.union([z.array(z.string().max(120)), z.null()]),
});
export const zAppUiSettingReset = zAppUiSettingResetRoot;
export const zAppUiSettingValueRoot = z.union([
    z.boolean(),
    z.int(),
    z.string(),
    z.array(z.string()),
]);
export const zAppUiSettingValue = zAppUiSettingValueRoot;
export const zAppSyncUiChangesRoot = z.object({
    fullReplace: z.boolean(),
    values: z.record(z.string(), zAppUiSettingValueRoot),
});
export const zAppSyncUiChanges = zAppSyncUiChangesRoot;
export const zAppUiSettingRoot = z.object({
    key: z.string().max(120),
    value: zAppUiSettingValueRoot,
    defaultValue: zAppUiSettingValueRoot,
    isDefault: z.boolean(),
    changedAtRevision: z.int().gte(0),
    updatedByAdminId: z.union([z.uuid(), z.null()]),
    updatedAt: z.iso.datetime(),
});
export const zAppUiSetting = zAppUiSettingRoot;
export const zAppUiSettingListRoot = z.object({
    revision: z.int().gte(0),
    items: z.array(zAppUiSettingRoot),
});
export const zAppUiSettingList = zAppUiSettingListRoot;
export const zAppUiSettingUpdateRoot = z.object({
    baseRevision: z.int().gte(0),
    values: z.record(z.string(), zAppUiSettingValueRoot),
});
export const zAppUiSettingUpdate = zAppUiSettingUpdateRoot;
export const zAppVersionPolicyRoot = z.object({
    platform: z.enum(["IOS", "ANDROID"]),
    latestVersionName: z.union([z.string(), z.null()]),
    latestBuildNumber: z.union([z.int(), z.null()]),
    releasedAt: z.union([z.iso.datetime(), z.null()]),
    minSupportedBuildNumber: z.union([z.int(), z.null()]),
});
export const zAppVersionPolicy = zAppVersionPolicyRoot;
export const zAppVersionPolicyListRoot = z.object({
    policies: z.array(zAppVersionPolicyRoot),
});
export const zAppVersionPolicyList = zAppVersionPolicyListRoot;
export const zAppVersionPolicyUpdateRoot = z.object({
    minSupportedBuildNumber: z.union([z.int(), z.null()]),
});
export const zAppVersionPolicyUpdate = zAppVersionPolicyUpdateRoot;
export const zBoltbMarketSectionAllowedCategoryListRoot = z.object({
    categoryIds: z.array(z.uuid()),
});
export const zBoltbMarketSectionAllowedCategoryList = zBoltbMarketSectionAllowedCategoryListRoot;
export const zBoltbMarketSectionAllowedCategoryListUpdateRoot = z.object({
    categoryIds: z.array(z.uuid()),
});
export const zBoltbMarketSectionAllowedCategoryListUpdate = zBoltbMarketSectionAllowedCategoryListUpdateRoot;
export const zBroadcastChatNoticeRoot = z.object({
    id: z.uuid(),
    trigger: z.enum(["AUTO_CYCLE", "SALE_STARTED"]),
    locale: z.string(),
    content: z.string(),
    sortOrder: z.int(),
    isActive: z.boolean(),
    version: z.int(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
    updatedByAdminId: z.union([z.uuid(), z.null()]),
});
export const zBroadcastChatNotice = zBroadcastChatNoticeRoot;
export const zBroadcastChatNoticeCreateRoot = z.object({
    trigger: z.enum(["AUTO_CYCLE", "SALE_STARTED"]),
    locale: z.string(),
    content: z.optional(z.union([z.string(), z.null()])),
    sortOrder: z.optional(z.union([z.int(), z.null()])),
    isActive: z.optional(z.union([z.boolean(), z.null()])),
});
export const zBroadcastChatNoticeCreate = zBroadcastChatNoticeCreateRoot;
export const zBroadcastChatNoticeListRoot = z.object({
    items: z.array(zBroadcastChatNoticeRoot),
});
export const zBroadcastChatNoticeList = zBroadcastChatNoticeListRoot;
export const zBroadcastChatNoticeOrderItemRoot = z.object({
    noticeId: z.uuid(),
    version: z.int(),
});
export const zBroadcastChatNoticeOrderItem = zBroadcastChatNoticeOrderItemRoot;
export const zBroadcastChatNoticeOrderUpdateRoot = z.object({
    trigger: z.enum(["AUTO_CYCLE", "SALE_STARTED"]),
    locale: z.string(),
    items: z.array(zBroadcastChatNoticeOrderItemRoot),
});
export const zBroadcastChatNoticeOrderUpdate = zBroadcastChatNoticeOrderUpdateRoot;
export const zBroadcastChatNoticeSettingsLimitsRoot = z.object({
    contentMaxLength: z.int(),
    autoGuideIntervalSecondsMin: z.int(),
    autoGuideIntervalSecondsMax: z.int(),
    saleStartedNoticeDurationMsMin: z.int(),
    saleStartedNoticeDurationMsMax: z.int(),
    announcementMarqueeSpeedMin: z.int(),
    announcementMarqueeSpeedMax: z.int(),
    schedulerTickSeconds: z.int(),
});
export const zBroadcastChatNoticeSettingsLimits = zBroadcastChatNoticeSettingsLimitsRoot;
export const zBroadcastChatNoticeSettingsRoot = z.object({
    autoGuideIntervalSeconds: z.int(),
    saleStartedNoticeDurationMs: z.int(),
    announcementMarqueeSpeed: z.int(),
    version: z.union([z.int(), z.null()]),
    updatedAt: z.union([z.iso.datetime(), z.null()]),
    updatedByAdminId: z.union([z.uuid(), z.null()]),
    limits: zBroadcastChatNoticeSettingsLimitsRoot,
});
export const zBroadcastChatNoticeSettings = zBroadcastChatNoticeSettingsRoot;
export const zBroadcastChatNoticeSettingsUpdateRoot = z.object({
    version: z.optional(z.union([z.int(), z.null()])),
    autoGuideIntervalSeconds: z.int(),
    saleStartedNoticeDurationMs: z.int(),
    announcementMarqueeSpeed: z.int(),
});
export const zBroadcastChatNoticeSettingsUpdate = zBroadcastChatNoticeSettingsUpdateRoot;
export const zBroadcastChatNoticeUpdateRoot = z.object({
    version: z.int(),
    content: z.optional(z.union([z.string(), z.null()])),
    sortOrder: z.optional(z.union([z.int(), z.null()])),
    isActive: z.optional(z.union([z.boolean(), z.null()])),
});
export const zBroadcastChatNoticeUpdate = zBroadcastChatNoticeUpdateRoot;
export const zChatBannedWordRoot = z.object({
    wordId: z.uuid().readonly(),
    word: z.string(),
    createdAt: z.iso.datetime().readonly(),
});
export const zChatBannedWord = zChatBannedWordRoot;
export const zChatBannedWordCreateRoot = z.object({
    word: z.string().min(1).max(20),
});
export const zChatBannedWordCreate = zChatBannedWordCreateRoot;
export const zChatBannedWordListRoot = z.object({
    items: z.array(zChatBannedWordRoot),
    maxWordLength: z.int().gte(1),
});
export const zChatBannedWordList = zChatBannedWordListRoot;
export const zCommissionConfigRoot = z.object({
    configId: z.uuid().readonly(),
    commissionRatePercentage: z.number().gte(0).lte(30),
    effectiveFrom: z.iso.datetime(),
    updatedBy: z.string(),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zCommissionConfig = zCommissionConfigRoot;
export const zCommissionConfigUpdateRoot = z.object({
    commissionRatePercentage: z.number().gte(0).lte(30),
    effectiveFrom: z.iso.datetime(),
});
export const zCommissionConfigUpdate = zCommissionConfigUpdateRoot;
export const zCompanyInfoRoot = z.object({
    name: z.union([z.string(), z.null()]),
    addressLabel: z.union([z.string(), z.null()]),
    address: z.union([z.string(), z.null()]),
    representativeLabel: z.union([z.string(), z.null()]),
    representativeName: z.union([z.string(), z.null()]),
    businessNumberLabel: z.union([z.string(), z.null()]),
    businessNumber: z.union([z.string(), z.null()]),
    onlineMarketingNumberLabel: z.union([z.string(), z.null()]),
    onlineMarketingNumber: z.union([z.string(), z.null()]),
    hostingProviderLabel: z.union([z.string(), z.null()]),
    hostingProvider: z.union([z.string(), z.null()]),
    hostingProviderUrl: z.union([z.string(), z.null()]),
    email: z.union([z.string(), z.null()]),
    phone: z.union([z.string(), z.null()]),
    privacyPolicyLabel: z.union([z.string(), z.null()]),
    privacyPolicyUrl: z.union([z.string(), z.null()]),
    termsOfServiceLabel: z.union([z.string(), z.null()]),
    termsOfServiceUrl: z.union([z.string(), z.null()]),
    operatingPolicyLabel: z.union([z.string(), z.null()]),
    operatingPolicyUrl: z.union([z.string(), z.null()]),
    marketingConsentUrl: z.union([z.string(), z.null()]),
    noticeUrl: z.union([z.string(), z.null()]),
    sanctionHistoryUrl: z.union([z.string(), z.null()]),
    faqUrl: z.union([z.string(), z.null()]),
    penaltyPolicyUrl: z.union([z.string(), z.null()]),
    disclaimer: z.union([z.string(), z.null()]),
    updatedAt: z.union([z.iso.datetime().readonly(), z.null()]).readonly(),
});
export const zCompanyInfo = zCompanyInfoRoot;
export const zCompanyInfoUpdateRoot = z.object({
    name: z.optional(z.union([z.string().max(200), z.null()])),
    addressLabel: z.optional(z.union([z.string().max(100), z.null()])),
    address: z.optional(z.union([z.string().max(500), z.null()])),
    representativeLabel: z.optional(z.union([z.string().max(100), z.null()])),
    representativeName: z.optional(z.union([z.string().max(200), z.null()])),
    businessNumberLabel: z.optional(z.union([z.string().max(100), z.null()])),
    businessNumber: z.optional(z.union([z.string().max(100), z.null()])),
    onlineMarketingNumberLabel: z.optional(z.union([z.string().max(100), z.null()])),
    onlineMarketingNumber: z.optional(z.union([z.string().max(200), z.null()])),
    hostingProviderLabel: z.optional(z.union([z.string().max(100), z.null()])),
    hostingProvider: z.optional(z.union([z.string().max(200), z.null()])),
    hostingProviderUrl: z.optional(z.union([z.string().max(2048), z.null()])),
    email: z.optional(z.union([z.string().max(320), z.null()])),
    phone: z.optional(z.union([z.string().max(50), z.null()])),
    privacyPolicyLabel: z.optional(z.union([z.string().max(100), z.null()])),
    privacyPolicyUrl: z.optional(z.union([z.string().max(2048), z.null()])),
    termsOfServiceLabel: z.optional(z.union([z.string().max(100), z.null()])),
    termsOfServiceUrl: z.optional(z.union([z.string().max(2048), z.null()])),
    operatingPolicyLabel: z.optional(z.union([z.string().max(100), z.null()])),
    operatingPolicyUrl: z.optional(z.union([z.string().max(2048), z.null()])),
    marketingConsentUrl: z.optional(z.union([z.string().max(2048), z.null()])),
    noticeUrl: z.optional(z.union([z.string().max(2048), z.null()])),
    sanctionHistoryUrl: z.optional(z.union([z.string().max(2048), z.null()])),
    faqUrl: z.optional(z.union([z.string().max(2048), z.null()])),
    penaltyPolicyUrl: z.optional(z.union([z.string().max(2048), z.null()])),
    disclaimer: z.optional(z.union([z.string().max(2000), z.null()])),
});
export const zCompanyInfoUpdate = zCompanyInfoUpdateRoot;
export const zFeeRatesRoot = z.object({
    commissionRatePercentage: z.number(),
    pgFeeRatePercentage: z.number(),
    pgProvider: z.string(),
});
export const zFeeRates = zFeeRatesRoot;
export const zMobileRuntimeAgoraPolicyRoot = z.object({
    keepHardwareEncoder: z.boolean(),
    debugLog: z.boolean(),
});
export const zMobileRuntimeAgoraPolicy = zMobileRuntimeAgoraPolicyRoot;
export const zMobileRuntimeBroadcastCreationPolicyRoot = z.object({
    resolutions: z.array(z.string().max(20)).min(1).max(3),
    defaultResolution: z.string().max(20),
});
export const zMobileRuntimeBroadcastCreationPolicy = zMobileRuntimeBroadcastCreationPolicyRoot;
export const zMobileRuntimeLifecyclePolicyRoot = z.object({
    switches: z.object({
        viewerVideo: z.object({
            inactive: z.boolean(),
            background: z.boolean(),
        }),
        viewerAudio: z.object({
            inactive: z.boolean(),
            pip: z.boolean(),
            background: z.boolean(),
        }),
        viewerRealtime: z.object({
            pip: z.boolean(),
            background: z.boolean(),
        }),
        viewerPipAutoEnter: z.object({
            background: z.boolean(),
        }),
        viewerPipButton: z.object({
            active: z.boolean(),
        }),
        viewerPipCloseLeaves: z.object({
            pip: z.boolean(),
        }),
        viewerKeepAwake: z.object({
            active: z.boolean(),
        }),
        hostCamera: z.object({
            inactive: z.boolean(),
            background: z.boolean(),
        }),
        hostMic: z.object({
            inactive: z.boolean(),
            background: z.boolean(),
        }),
        hostHeartbeat: z.object({
            inactive: z.boolean(),
            background: z.boolean(),
        }),
        hostThermalMonitor: z.object({
            active: z.boolean(),
        }),
        hostKeepAwake: z.object({
            active: z.boolean(),
        }),
        hostMicRecovery: z.object({
            active: z.boolean(),
        }),
        inAppPushBanner: z.object({
            active: z.boolean(),
        }),
        telemetryCheckpoint: z.object({
            background: z.boolean(),
        }),
        policyRefetch: z.object({
            foregroundReturn: z.boolean(),
        }),
        appSync: z.object({
            foregroundReturn: z.boolean(),
        }),
        accountStatusCheck: z.object({
            foregroundReturn: z.boolean(),
        }),
        screenDataRefetch: z.object({
            foregroundReturn: z.boolean(),
        }),
        realtimeReconnect: z.object({
            foregroundReturn: z.boolean(),
        }),
        forceUpdateCheck: z.object({
            foregroundReturn: z.boolean(),
        }),
        telemetryResend: z.object({
            coldStart: z.boolean(),
        }),
        pendingPushLink: z.object({
            coldStart: z.boolean(),
        }),
    }),
    values: z.object({
        screenDataRefetchAfterSec: z.int().gte(0).lte(3600),
        accountStatusCheckAfterSec: z.int().gte(0).lte(3600),
        pendingPushLinkTtlMinutes: z.int().gte(1).lte(1440),
        telemetryCheckpointIntervalSec: z.int().gte(30).lte(600),
        hostMicRecoveryRetrySec: z.int().gte(5).lte(60),
        hostMicRecoveryMaxMinutes: z.int().gte(1).lte(30),
    }),
});
export const zMobileRuntimeLifecyclePolicy = zMobileRuntimeLifecyclePolicyRoot;
export const zMobileRuntimeLifecyclePolicyUpdateRoot = z.object({
    switches: z.optional(z.object({
        viewerVideo: z.optional(z.object({
            inactive: z.optional(z.boolean()),
            background: z.optional(z.boolean()),
        })),
        viewerAudio: z.optional(z.object({
            inactive: z.optional(z.boolean()),
            pip: z.optional(z.boolean()),
            background: z.optional(z.boolean()),
        })),
        viewerRealtime: z.optional(z.object({
            pip: z.optional(z.boolean()),
            background: z.optional(z.boolean()),
        })),
        viewerPipAutoEnter: z.optional(z.object({
            background: z.optional(z.boolean()),
        })),
        viewerPipButton: z.optional(z.object({
            active: z.optional(z.boolean()),
        })),
        viewerPipCloseLeaves: z.optional(z.object({
            pip: z.optional(z.boolean()),
        })),
        viewerKeepAwake: z.optional(z.object({
            active: z.optional(z.boolean()),
        })),
        hostCamera: z.optional(z.object({
            inactive: z.optional(z.boolean()),
            background: z.optional(z.boolean()),
        })),
        hostMic: z.optional(z.object({
            inactive: z.optional(z.boolean()),
            background: z.optional(z.boolean()),
        })),
        hostHeartbeat: z.optional(z.object({
            inactive: z.optional(z.boolean()),
            background: z.optional(z.boolean()),
        })),
        hostThermalMonitor: z.optional(z.object({
            active: z.optional(z.boolean()),
        })),
        hostKeepAwake: z.optional(z.object({
            active: z.optional(z.boolean()),
        })),
        hostMicRecovery: z.optional(z.object({
            active: z.optional(z.boolean()),
        })),
        inAppPushBanner: z.optional(z.object({
            active: z.optional(z.boolean()),
        })),
        telemetryCheckpoint: z.optional(z.object({
            background: z.optional(z.boolean()),
        })),
        policyRefetch: z.optional(z.object({
            foregroundReturn: z.optional(z.boolean()),
        })),
        appSync: z.optional(z.object({
            foregroundReturn: z.optional(z.boolean()),
        })),
        accountStatusCheck: z.optional(z.object({
            foregroundReturn: z.optional(z.boolean()),
        })),
        screenDataRefetch: z.optional(z.object({
            foregroundReturn: z.optional(z.boolean()),
        })),
        realtimeReconnect: z.optional(z.object({
            foregroundReturn: z.optional(z.boolean()),
        })),
        forceUpdateCheck: z.optional(z.object({
            foregroundReturn: z.optional(z.boolean()),
        })),
        telemetryResend: z.optional(z.object({
            coldStart: z.optional(z.boolean()),
        })),
        pendingPushLink: z.optional(z.object({
            coldStart: z.optional(z.boolean()),
        })),
    })),
    values: z.optional(z.object({
        screenDataRefetchAfterSec: z.optional(z.int().gte(0).lte(3600)),
        accountStatusCheckAfterSec: z.optional(z.int().gte(0).lte(3600)),
        pendingPushLinkTtlMinutes: z.optional(z.int().gte(1).lte(1440)),
        telemetryCheckpointIntervalSec: z.optional(z.int().gte(30).lte(600)),
        hostMicRecoveryRetrySec: z.optional(z.int().gte(5).lte(60)),
        hostMicRecoveryMaxMinutes: z.optional(z.int().gte(1).lte(30)),
    })),
});
export const zMobileRuntimeLifecyclePolicyUpdate = zMobileRuntimeLifecyclePolicyUpdateRoot;
export const zMobileRuntimePolicyRoot = z.object({
    platform: z.enum(["IOS", "ANDROID"]),
    enabled: z.boolean(),
    revision: z.int().gte(0),
    minSupportedBuildNumber: z.union([z.int().gte(1), z.null()]),
    publisherResolutionMode: z.enum(["BROADCAST", "FIXED"]),
    publisherFixedResolution: z.union([z.string().max(20), z.null()]),
    publisherFps: z.int().gte(1).lte(60),
    publisherBitrate360Kbps: z.int().gte(100).lte(10000),
    publisherBitrate540Kbps: z.int().gte(100).lte(10000),
    publisherBitrate720Kbps: z.int().gte(100).lte(10000),
    subscriberRenderFps: z.union([z.int().gte(1).lte(60), z.null()]),
    broadcastCreateResolutions: z.array(z.string().max(20)).min(1).max(3),
    broadcastCreateDefaultResolution: z.string().max(20),
    telemetryLevel: z.enum(["OFF", "SUMMARY", "DETAILED"]),
    telemetryDetailedRatePercent: z.int().gte(0).lte(100),
    telemetryDetailedUserIds: z.array(z.uuid()).max(200),
    agoraKeepHardwareEncoder: z.boolean(),
    agoraDebugLog: z.boolean(),
    lifecycle: zMobileRuntimeLifecyclePolicyRoot,
    updatedByAdminId: z.union([z.string(), z.null()]),
    updatedAt: z.union([z.iso.datetime(), z.null()]),
});
export const zMobileRuntimePolicy = zMobileRuntimePolicyRoot;
export const zMobileRuntimePolicyListRoot = z.object({
    policies: z.array(zMobileRuntimePolicyRoot),
});
export const zMobileRuntimePolicyList = zMobileRuntimePolicyListRoot;
export const zMobileRuntimePolicyUpdateRoot = z.object({
    enabled: z.boolean(),
    minSupportedBuildNumber: z.optional(z.union([z.int().gte(1), z.null()])),
    publisherResolutionMode: z.enum(["BROADCAST", "FIXED"]),
    publisherFixedResolution: z.optional(z.union([z.string().max(20), z.null()])),
    publisherFps: z.int().gte(1).lte(60),
    publisherBitrate360Kbps: z.int().gte(100).lte(10000),
    publisherBitrate540Kbps: z.int().gte(100).lte(10000),
    publisherBitrate720Kbps: z.int().gte(100).lte(10000),
    subscriberRenderFps: z.optional(z.union([z.int().gte(1).lte(60), z.null()])),
    broadcastCreateResolutions: z.array(z.string().max(20)).min(1).max(3),
    broadcastCreateDefaultResolution: z.string().max(20),
    telemetryLevel: z.enum(["OFF", "SUMMARY", "DETAILED"]),
    telemetryDetailedRatePercent: z.int().gte(0).lte(100),
    telemetryDetailedUserIds: z.array(z.uuid()).max(200),
    agoraKeepHardwareEncoder: z.optional(z.boolean()),
    agoraDebugLog: z.optional(z.boolean()),
    lifecycle: z.optional(zMobileRuntimeLifecyclePolicyUpdateRoot),
});
export const zMobileRuntimePolicyUpdate = zMobileRuntimePolicyUpdateRoot;
export const zMobileRuntimePublisherProfileRoot = z.object({
    resolutionMode: z.enum(["BROADCAST", "FIXED"]),
    fixedResolution: z.union([z.string().max(20), z.null()]),
    fps: z.int().gte(1).lte(60),
    bitrate360Kbps: z.int(),
    bitrate540Kbps: z.int(),
    bitrate720Kbps: z.int(),
});
export const zMobileRuntimePublisherProfile = zMobileRuntimePublisherProfileRoot;
export const zMobileRuntimeSubscriberProfileRoot = z.object({
    renderFps: z.union([z.int().gte(1).lte(60), z.null()]),
});
export const zMobileRuntimeSubscriberProfile = zMobileRuntimeSubscriberProfileRoot;
export const zMobileRuntimeTelemetryPolicyRoot = z.object({
    level: z.enum(["OFF", "SUMMARY", "DETAILED"]),
    detailedRatePercent: z.int().gte(0).lte(100),
    detailedForCurrentUser: z.boolean(),
});
export const zMobileRuntimeTelemetryPolicy = zMobileRuntimeTelemetryPolicyRoot;
export const zNotificationPermissionPromptDeniedTextRoot = z.object({
    title: z.string(),
    body: z.string(),
    cancelText: z.string(),
    confirmText: z.string(),
});
export const zNotificationPermissionPromptUndeterminedTextRoot = z.object({
    title: z.string(),
    body: z.string(),
    confirmText: z.string(),
});
export const zNotificationPermissionPromptPolicyRoot = z.object({
    replaceFirstRun: z.boolean(),
    intervalDays: z.int().gte(1),
    maxCount: z.int().gte(1),
    undetermined: zNotificationPermissionPromptUndeterminedTextRoot,
    denied: zNotificationPermissionPromptDeniedTextRoot,
});
export const zPgFeeConfigRoot = z.object({
    configId: z.uuid().readonly(),
    pgFeeRatePercentage: z.number().gte(0).lte(10),
    pgProvider: z.string(),
    effectiveFrom: z.iso.datetime(),
    updatedBy: z.string(),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zPgFeeConfig = zPgFeeConfigRoot;
export const zPgFeeConfigUpdateRoot = z.object({
    pgFeeRatePercentage: z.number().gte(0).lte(10),
    pgProvider: z.optional(z.string()),
    effectiveFrom: z.iso.datetime(),
});
export const zPgFeeConfigUpdate = zPgFeeConfigUpdateRoot;
export const zPublicBroadcastAnnouncementMarqueeRoot = z.object({
    speed: z.union([z.int(), z.null()]),
});
export const zPublicBroadcastAnnouncementMarquee = zPublicBroadcastAnnouncementMarqueeRoot;
export const zPublicBroadcastSaleStartedNoticeRoot = z.object({
    text: z.union([z.string(), z.null()]),
    locale: z.union([z.string(), z.null()]),
    durationMs: z.union([z.int(), z.null()]),
});
export const zPublicBroadcastSaleStartedNotice = zPublicBroadcastSaleStartedNoticeRoot;
export const zPublicBroadcastChatNoticeSettingsRoot = z.object({
    saleStartedNotice: zPublicBroadcastSaleStartedNoticeRoot,
    announcementMarquee: zPublicBroadcastAnnouncementMarqueeRoot,
});
export const zPublicBroadcastChatNoticeSettings = zPublicBroadcastChatNoticeSettingsRoot;
export const zPublicMobileRuntimePolicyRoot2 = z.object({
    schemaVersion: z.int(),
    platform: z.enum(["IOS", "ANDROID"]),
    revision: z.int().gte(0),
    enabled: z.boolean(),
    reason: z.enum([
        "CONFIGURED",
        "NOT_CONFIGURED",
        "DISABLED",
        "UNSUPPORTED_CLIENT",
    ]),
    publisher: z.union([zMobileRuntimePublisherProfileRoot, z.null()]),
    subscriber: z.union([zMobileRuntimeSubscriberProfileRoot, z.null()]),
    broadcastCreation: zMobileRuntimeBroadcastCreationPolicyRoot,
    telemetry: zMobileRuntimeTelemetryPolicyRoot,
    agora: zMobileRuntimeAgoraPolicyRoot,
    lifecycle: zMobileRuntimeLifecyclePolicyRoot,
    notifications: z.object({
        oneSignalAppId: z.union([z.uuid(), z.null()]),
        oneSignalSubscriptionReportEnabled: z.boolean(),
        notificationPermissionReportEnabled: z.boolean(),
        permissionPrompt: z.optional(z.union([zNotificationPermissionPromptPolicyRoot, z.null()])),
    }),
});
export const zPublicMobileRuntimePolicy = zPublicMobileRuntimePolicyRoot2;
export const zServerPageButtonBlockRoot = z.object({
    type: z.literal("button"),
    label: z.string().max(40),
    link: z.string().max(1000),
    style: z.optional(z.union([z.literal("primary"), z.literal("secondary")])),
});
export const zServerPageImageBlockRoot = z.object({
    type: z.literal("image"),
    imageUrl: z.url(),
    aspectRatio: z.union([
        z.literal("1:1"),
        z.literal("3:4"),
        z.literal("9:16"),
        z.literal("4:3"),
        z.literal("16:9"),
        z.literal("2:1"),
        z.literal("3:1"),
        z.literal("4:1"),
    ]),
    link: z.optional(z.string().max(1000)),
});
export const zServerPageNoticesBlockRoot = z.object({
    type: z.literal("notices"),
    title: z.optional(z.string().max(40)),
    maxItems: z.int().gte(1).lte(30),
    items: z.array(zPublicNoticeSummaryRoot),
});
export const zServerPageSpacerBlockRoot = z.object({
    type: z.literal("spacer"),
    height: z.int().gte(0).lte(200),
});
export const zServerPageTextBlockRoot = z.object({
    type: z.literal("text"),
    title: z.optional(z.string().max(40)),
    body: z.optional(z.string().max(1000)),
    align: z.optional(z.union([z.literal("left"), z.literal("center")])),
});
export const zSettlementConfigRoot = z.object({
    configId: z.uuid().readonly(),
    holdPeriodDays: z.int().gte(0).lte(30),
    effectiveFrom: z.iso.datetime(),
    updatedBy: z.string(),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zSettlementConfig = zSettlementConfigRoot;
export const zSettlementConfigUpdateRoot = z.object({
    holdPeriodDays: z.int().gte(0).lte(30),
    effectiveFrom: z.iso.datetime(),
});
export const zSettlementConfigUpdate = zSettlementConfigUpdateRoot;
export const zUiConfigApplyPolicyRoot = z.enum([
    "NEXT_LAUNCH",
    "SAFE_POINT",
    "URGENT",
    "IMMEDIATE",
]);
export const zUiConfigDraftSaveRoot = z.object({
    payload: z.record(z.string(), z.unknown()),
    expectedDraftUpdatedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
});
export const zUiConfigFileSummaryRoot = z.object({
    name: z.string().max(64),
    schemaVersion: z.int().gte(1),
    publishedVersion: z.int().gte(0),
    fingerprint: z.union([z.string(), z.null()]),
    publishedAt: z.union([z.iso.datetime(), z.null()]),
    hasDraft: z.boolean(),
    draftUpdatedAt: z.union([z.iso.datetime(), z.null()]),
    forceBuiltIn: z.boolean(),
});
export const zUiConfigFileListRoot = z.object({
    items: z.array(zUiConfigFileSummaryRoot),
});
export const zUiConfigFileUpdateRoot = z.object({
    name: z.string().max(64),
    version: z.int().gte(0),
    fingerprint: z.string().length(64),
    schemaVersion: z.int().gte(1),
    applyPolicy: zUiConfigApplyPolicyRoot,
    forceBuiltIn: z.boolean(),
    payload: z.union([z.record(z.string(), z.unknown()), z.null()]),
});
export const zAppSyncResultRoot = z.object({
    uiRevision: z.int().gte(0),
    unchanged: z.boolean(),
    ui: z.union([zAppSyncUiChangesRoot, z.null()]),
    changedResources: z.array(zAppSyncResourceFingerprintRoot),
    uiConfigFiles: z.optional(z.array(zUiConfigFileUpdateRoot)),
});
export const zAppSyncResult = zAppSyncResultRoot;
export const zUiConfigManifestEntryRoot = z.object({
    name: z.string().max(64),
    version: z.int().gte(1),
    fingerprint: z.string().length(64),
    schemaVersion: z.int().gte(1),
    applyPolicy: zUiConfigApplyPolicyRoot,
    forceBuiltIn: z.boolean(),
});
export const zUiConfigManifestRoot = z.object({
    files: z.array(zUiConfigManifestEntryRoot),
});
export const zUiConfigPublishRoot = z.object({
    expectedDraftUpdatedAt: z.iso.datetime(),
    applyPolicy: zUiConfigApplyPolicyRoot,
});
export const zUiConfigRevertRoot = z.object({
    version: z.int().gte(1),
    applyPolicy: zUiConfigApplyPolicyRoot,
});
export const zUiConfigSwitchesRoot = z.object({
    forceBuiltIn: z.boolean(),
});
export const zUiConfigVersionContentRoot = z.object({
    name: z.string().max(64),
    version: z.int().gte(1),
    fingerprint: z.string().length(64),
    schemaVersion: z.int().gte(1),
    applyPolicy: zUiConfigApplyPolicyRoot,
    payload: z.record(z.string(), z.unknown()),
});
export const zUiConfigVersionSummaryRoot = z.object({
    version: z.int().gte(1),
    fingerprint: z.string().length(64),
    applyPolicy: zUiConfigApplyPolicyRoot,
    revertedFromVersion: z.union([z.int().gte(1), z.null()]),
    publishedByAdminId: z.union([z.uuid(), z.null()]),
    publishedAt: z.iso.datetime(),
});
export const zUiConfigFileDetailRoot = z.object({
    name: z.string().max(64),
    schemaVersion: z.int().gte(1),
    defaultApplyPolicy: zUiConfigApplyPolicyRoot,
    published: z.union([zUiConfigVersionContentRoot, z.null()]),
    draftPayload: z.union([z.record(z.string(), z.unknown()), z.null()]),
    draftUpdatedAt: z.union([z.iso.datetime(), z.null()]),
    draftUpdatedByAdminId: z.union([z.uuid(), z.null()]),
    codeDefaultPayload: z.record(z.string(), z.unknown()),
    forceBuiltIn: z.boolean(),
    versions: z.array(zUiConfigVersionSummaryRoot),
});
export const zUserIdPathRoot3 = z.unknown();
export const zBackofficeUsersUserIdPointsBalanceRoot = z.unknown();
export const zBackofficeUsersUserIdPointsCreditsRoot = z.unknown();
export const zBackofficeUsersUserIdPointsDebitsRoot = z.unknown();
export const zBackofficeUsersUserIdPointsTransactionsRoot = z.unknown();
export const zPointsMyBalanceRoot = z.unknown();
export const zPointsMyTransactionsRoot = z.unknown();
export const zBackofficeUserPointAdjustmentResponseRoot = z.object({
    pointTransactionId: z.uuid().readonly(),
    balance: z.int().gte(0),
    createdAt: z.iso.datetime().readonly(),
});
export const zBackofficeUserPointAdjustmentResponse = zBackofficeUserPointAdjustmentResponseRoot;
export const zBackofficeUserPointBalanceRoot = z.object({
    balance: z.int().gte(0),
});
export const zBackofficeUserPointBalance = zBackofficeUserPointBalanceRoot;
export const zBackofficeUserPointCreditRequestRoot = z.object({
    amount: z.int().gte(1),
    reason: z.string().min(1).max(1000),
});
export const zBackofficeUserPointCreditRequest = zBackofficeUserPointCreditRequestRoot;
export const zBackofficeUserPointDebitRequestRoot = z.object({
    amount: z.int().gte(1),
    reason: z.string().min(1).max(1000),
});
export const zBackofficeUserPointDebitRequest = zBackofficeUserPointDebitRequestRoot;
export const zMyPointBalanceRoot = z.object({
    balance: z.int().gte(0),
});
export const zMyPointBalance = zMyPointBalanceRoot;
export const zPointTransactionItemRoot = z.object({
    pointTransactionId: z.uuid().readonly(),
    amount: z.int(),
    transactionType: z.string(),
    description: z.optional(z.union([z.string(), z.null()])),
    adminId: z.optional(z.union([z.string(), z.null()])),
    createdAt: z.iso.datetime().readonly(),
});
export const zPointTransactionItem = zPointTransactionItemRoot;
export const zBroadcastIdPathRoot2 = z.unknown();
export const zGroupBuyIdPathRoot = z.unknown();
export const zProductIdPathRoot = z.unknown();
export const zBackofficeProductsCollectionRoot = z.unknown();
export const zBackofficeProductsItemCertificationRoot = z.unknown();
export const zBackofficeProductsItemHideRoot = z.unknown();
export const zBackofficeProductsItemUnhideRoot = z.unknown();
export const zBackofficeProductsItemRoot = z.unknown();
export const zBroadcastsItemProductsRoot = z.unknown();
export const zGroupBuysCollectionRoot = z.unknown();
export const zGroupBuysItemActivateRoot = z.unknown();
export const zGroupBuysItemBreakRoot = z.unknown();
export const zGroupBuysItemReleaseRoot = z.unknown();
export const zGroupBuysItemReserveRoot = z.unknown();
export const zGroupBuysItemRoot = z.unknown();
export const zProductsCollectionRoot = z.unknown();
export const zProductsImagesUploadUrlRoot = z.unknown();
export const zProductsItemArchiveRoot = z.unknown();
export const zProductsItemCategoriesRoot = z.unknown();
export const zProductsItemDetailsRoot = z.unknown();
export const zProductsItemGroupBuysRoot = z.unknown();
export const zProductsItemHideRoot = z.unknown();
export const zProductsItemImagesRoot = z.unknown();
export const zProductsItemPricingRoot = z.unknown();
export const zProductsItemPublishRoot = z.unknown();
export const zProductsItemSalesChannelRoot = z.unknown();
export const zProductsItemUnhideRoot = z.unknown();
export const zProductsItemRoot = z.unknown();
export const zProductCertificationUpdateRoot = z.object({
    isBoltbCertified: z.boolean(),
});
export const zProductCertificationUpdate = zProductCertificationUpdateRoot;
export const zProductDetailsUpdateRoot = z.object({
    dealerId: z.optional(z.string()),
    name: z.optional(z.union([z.string().min(1).max(200), z.null()])),
    description: z.optional(z.union([z.string().max(2000), z.null()])),
});
export const zProductImageInputRoot = z.object({
    url: z.url(),
    width: z.int().gte(1),
    height: z.int().gte(1),
    size: z.int().gte(1),
    mimeType: z.enum(["image/jpeg", "image/png", "image/webp", "image/gif"]),
    order: z.int().gte(0),
});
export const zProductImageUploadUrlRoot = z.object({
    uploadUrl: z.url(),
    imageUrl: z.url(),
    expiresIn: z.int().gte(1),
    expiresAt: z.iso.datetime(),
});
export const zProductImagesUpdateRoot = z.object({
    images: z.array(zProductImageInputRoot).min(1).max(10),
});
export const zSlotReservationRoot = z.object({
    groupBuyListingId: z.string(),
    slotNumber: z.int().gte(1),
    buyerId: z.string(),
    reservedAt: z.iso.datetime(),
    status: z.enum(["RESERVED", "RELEASED", "COMPLETED"]),
});
export const zSlotReservationRequestRoot = z.object({
    buyerId: z.string(),
    slotNumber: z.int().gte(1),
});
export const zToggleSalesChannelRoot = z.object({
    salesChannel: z.enum(["BROADCAST", "MARKETPLACE"]),
    broadcastId: z.optional(z.union([z.string(), z.null()])),
});
export const zAuctionIdPathRoot = z.unknown();
export const zBroadcastIdPathRoot3 = z.unknown();
export const zGiveawayIdPathRoot = z.unknown();
export const zGroupBuyIdPathRoot2 = z.unknown();
export const zInstantPurchaseIdPathRoot = z.unknown();
export const zAuctionsCollectionRoot = z.unknown();
export const zAuctionsItemBidsRoot = z.unknown();
export const zAuctionsItemEndRoot = z.unknown();
export const zAuctionsItemPriceReductionRoot = z.unknown();
export const zAuctionsItemRevealRoot = z.unknown();
export const zAuctionsItemStartRoot = z.unknown();
export const zAuctionsItemRoot = z.unknown();
export const zAuctionsWithProductCollectionRoot = z.unknown();
export const zBackofficeAnonymousNicknameWordsCollectionRoot = z.unknown();
export const zBackofficeAnonymousNicknameWordsItemRoot = z.unknown();
export const zBackofficeAuctionsItemCancelRoot = z.unknown();
export const zBackofficeBroadcastSalesSettingsRoot = z.unknown();
export const zBackofficeInstantPurchasesItemEndRoot = z.unknown();
export const zBroadcastDefaultProductNameItemRoot = z.unknown();
export const zBroadcastProductCountsItemRoot = z.unknown();
export const zBroadcastSoldListingsCollectionRoot = z.unknown();
export const zBroadcastUnsoldListingsCollectionRoot = z.unknown();
export const zGiveawaysCollectionRoot = z.unknown();
export const zGiveawaysItemAnnounceRoot = z.unknown();
export const zGiveawaysItemCloseRoot = z.unknown();
export const zGiveawaysItemDrawRoot = z.unknown();
export const zGiveawaysItemEnterRoot = z.unknown();
export const zGiveawaysItemEntryTermsRoot = z.unknown();
export const zGiveawaysItemRoot = z.unknown();
export const zGiveawaysWithProductCollectionRoot = z.unknown();
export const zGroupBuysCollectionRoot2 = z.unknown();
export const zGroupBuysItemBreakCompleteRoot = z.unknown();
export const zGroupBuysItemBreakStartRoot = z.unknown();
export const zGroupBuysItemCancelRoot = z.unknown();
export const zGroupBuysItemSlotsConfirmRoot = z.unknown();
export const zGroupBuysItemSlotsReleaseRoot = z.unknown();
export const zGroupBuysItemSlotsReserveRoot = z.unknown();
export const zGroupBuysItemRoot2 = z.unknown();
export const zInstantPurchasesCollectionRoot = z.unknown();
export const zInstantPurchasesItemEndRoot = z.unknown();
export const zInstantPurchasesItemPurchaseRoot = z.unknown();
export const zInstantPurchasesItemUpdateQuantityRoot = z.unknown();
export const zInstantPurchasesItemRoot = z.unknown();
export const zInstantPurchasesWithProductCollectionRoot = z.unknown();
export const zMarketplacePurchasesCollectionRoot = z.unknown();
export const zAnonymousNicknameWordKindRoot = z.enum(["ADJECTIVE", "ANIMAL"]);
export const zAnonymousNicknameWordKind = zAnonymousNicknameWordKindRoot;
export const zAnonymousNicknameWordRoot = z.object({
    wordId: z.uuid().readonly(),
    kind: zAnonymousNicknameWordKindRoot,
    word: z.string(),
    createdAt: z.iso.datetime().readonly(),
});
export const zAnonymousNicknameWord = zAnonymousNicknameWordRoot;
export const zAnonymousNicknameWordCreateRoot = z.object({
    kind: zAnonymousNicknameWordKindRoot,
    word: z.string().min(1).max(10),
});
export const zAnonymousNicknameWordCreate = zAnonymousNicknameWordCreateRoot;
export const zAnonymousNicknameWordListRoot = z.object({
    adjectives: z.array(zAnonymousNicknameWordRoot),
    animals: z.array(zAnonymousNicknameWordRoot),
    minWordsPerKind: z.int().gte(1),
    maxWordLength: z.int().gte(1),
});
export const zAnonymousNicknameWordList = zAnonymousNicknameWordListRoot;
export const zAuctionUserParticipationStatusRoot = z.object({
    hasPlacedBid: z.boolean(),
    isCurrentWinner: z.boolean(),
});
export const zAuctionUserParticipationStatus = zAuctionUserParticipationStatusRoot;
export const zBroadcastProductCountsRoot = z.object({
    auctionCount: z.int().gte(0),
    instantPurchaseCount: z.int().gte(0),
    giveawayCount: z.int().gte(0),
});
export const zBroadcastSalesSettingsRoot = z.object({
    maxConcurrentInstantPurchases: z.int().gte(1).lte(2147483647),
    updatedAt: z.iso.datetime(),
    updatedByAdminId: z.union([z.uuid(), z.null()]),
});
export const zBroadcastSalesSettings = zBroadcastSalesSettingsRoot;
export const zBroadcastSalesSettingsUpdateRoot = z.object({
    maxConcurrentInstantPurchases: z.int().gte(1).lte(2147483647),
});
export const zBroadcastSalesSettingsUpdate = zBroadcastSalesSettingsUpdateRoot;
export const zBroadcastUnsoldListingRoot = z.object({
    transactionType: z.enum(["AUCTION", "INSTANT_PURCHASE", "GIVEAWAY"]),
    transactionId: z.uuid().readonly(),
    productListingId: z.uuid().readonly(),
    productName: z.string(),
    productImageUrl: z.union([z.url(), z.null()]),
    startingPrice: z.number(),
    startingPriceCurrency: z.string(),
    endTime: z.iso.datetime().readonly(),
});
export const zCancelGroupBuyRequestRoot = z.object({
    reason: z.optional(z.string()),
});
export const zDefaultProductNameRoot = z.object({
    defaultProductName: z.string(),
});
export const zEndSaleRequestRoot = z.object({
    reason: z.string().min(1),
});
export const zGiveawayEntryRoot = z.object({
    giveawayId: z.string(),
    userId: z.string(),
    enteredAt: z.iso.datetime(),
    eligible: z.boolean(),
});
export const zMarketplacePurchaseAcceptedRoot = z.object({
    orderId: z.uuid(),
    status: z.enum(["CREATED"]),
    message: z.string(),
});
export const zMarketplacePurchaseRequestRoot = z.object({
    productListingId: z.uuid(),
    quantity: z.int().gte(1),
    shippingAddressId: z.uuid(),
});
export const zPurchaseAcceptedRoot = z.object({
    instantPurchaseId: z.string(),
    orderId: z.uuid(),
    status: z.enum(["CREATED"]),
    message: z.string(),
});
export const zPurchaseRequestRoot = z.object({
    quantity: z.int().gte(1),
});
export const zQuantityUpdateRoot = z.object({
    availableQuantity: z.int().gte(0),
});
export const zSlotConfirmRequestRoot = z.object({
    slotNumber: z.int().gte(1),
    paymentId: z.string(),
});
export const zSlotReleaseRequestRoot = z.object({
    slotNumber: z.int().gte(1),
});
export const zCursorQueryRoot2 = z.unknown();
export const zDateFromQueryRoot2 = z.unknown();
export const zDateToQueryRoot2 = z.unknown();
export const zDealerIdQueryRoot2 = z.unknown();
export const zSettlementIdPathRoot = z.unknown();
export const zStatusFilterQueryRoot = z.unknown();
export const zBackofficeSettlementDealerOffsetsRoot = z.unknown();
export const zBackofficeSettlementsBatchChangeStatusRoot = z.unknown();
export const zBackofficeSettlementsBatchCompleteRoot = z.unknown();
export const zBackofficeSettlementsBatchStartProcessingRoot = z.unknown();
export const zBackofficeSettlementsCollectionRoot = z.unknown();
export const zBackofficeSettlementsExportCsvRoot = z.unknown();
export const zBackofficeSettlementsItemRoot = z.unknown();
export const zBackofficeSettlementsProcessCancelRoot = z.unknown();
export const zBackofficeSettlementsProcessCompleteRoot = z.unknown();
export const zBackofficeSettlementsProcessStartRoot = z.unknown();
export const zBackofficeSettlementsReversalRoot = z.unknown();
export const zSettlementAccountsItemRoot = z.unknown();
export const zSettlementsCollectionRoot = z.unknown();
export const zSettlementsConfirmRoot = z.unknown();
export const zSettlementsFailRoot = z.unknown();
export const zSettlementsItemRoot = z.unknown();
export const zSettlementsProcessPayoutRoot = z.unknown();
export const zSettlementsReportsExcelRoot = z.unknown();
export const zWebhooksSettlementCallbackRoot = z.unknown();
export const zPayoutResultRoot = z.unknown();
export const zSettlementRoot = z.unknown();
export const zSettlementAccountRoot = z.unknown();
export const zSettlementsListRoot = z.unknown();
export const zBackofficeSettlementDealerRoot = z.object({
    userId: z.string().readonly(),
    nickname: z.string(),
    sellerId: z.string().readonly(),
    profileImageUrl: z.union([z.url(), z.null()]),
});
export const zBackofficeSettlementDealer = zBackofficeSettlementDealerRoot;
export const zBatchChangeSettlementStatusResultRoot = z.object({
    settlementId: z.string(),
    success: z.boolean(),
    error: z.optional(z.union([z.string(), z.null()])),
});
export const zBatchChangeSettlementStatusResult = zBatchChangeSettlementStatusResultRoot;
export const zBatchChangeSettlementStatusResponseRoot = z.object({
    processedCount: z.int().gte(0),
    failedCount: z.int().gte(0),
    results: z.array(zBatchChangeSettlementStatusResultRoot),
});
export const zBatchChangeSettlementStatusResponse = zBatchChangeSettlementStatusResponseRoot;
export const zBatchCompleteSettlementResultRoot = z.object({
    settlementId: z.string(),
    success: z.boolean(),
    error: z.optional(z.union([z.string(), z.null()])),
});
export const zBatchCompleteSettlementResult = zBatchCompleteSettlementResultRoot;
export const zBatchCompleteSettlementsRequestRoot = z.object({
    settlementIds: z.array(z.string()).min(1).max(100),
});
export const zBatchCompleteSettlementsRequest = zBatchCompleteSettlementsRequestRoot;
export const zBatchCompleteSettlementsResponseRoot = z.object({
    processedCount: z.int().gte(0),
    failedCount: z.int().gte(0),
    results: z.array(zBatchCompleteSettlementResultRoot),
});
export const zBatchCompleteSettlementsResponse = zBatchCompleteSettlementsResponseRoot;
export const zBatchStartProcessingRequestRoot = z.object({
    settlementIds: z.array(z.string()).min(1).max(100),
});
export const zBatchStartProcessingRequest = zBatchStartProcessingRequestRoot;
export const zBatchStartProcessingResultRoot = z.object({
    settlementId: z.string(),
    success: z.boolean(),
    error: z.optional(z.union([z.string(), z.null()])),
});
export const zBatchStartProcessingResult = zBatchStartProcessingResultRoot;
export const zBatchStartProcessingResponseRoot = z.object({
    processedCount: z.int().gte(0),
    failedCount: z.int().gte(0),
    results: z.array(zBatchStartProcessingResultRoot),
});
export const zBatchStartProcessingResponse = zBatchStartProcessingResponseRoot;
export const zCallbackStatusRoot = z.enum(["SUCCESS", "FAILED"]);
export const zKoreanBankRoot = z.enum([
    "KOOKMIN",
    "SHINHAN",
    "WOORI",
    "HANA",
    "NH_NONGHYEOP",
    "LOCAL_NONGHYEOP",
    "IBK",
    "KDB",
    "CITI",
    "SC",
    "DAEGU",
    "BUSAN",
    "GWANGJU",
    "JEJU",
    "JEONBUK",
    "KYONGNAM",
    "SUHYEOP",
    "SUHYEOP_CENTRAL",
    "POST",
    "SAEMAUL",
    "SHINHYEOP",
    "SANLIM",
    "SAVING_BANK",
    "KAKAO_BANK",
    "K_BANK",
    "TOSS_BANK",
    "HSBC",
]);
export const zKoreanBank = zKoreanBankRoot;
export const zSettlementAccountRoot2 = z.object({
    accountId: z.string().readonly(),
    dealerId: z.string(),
    bankName: zKoreanBankRoot,
    accountNumber: z.string(),
    accountNumberMasked: z.string(),
    registeredAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zSettlementAccount = zSettlementAccountRoot2;
export const zSettlementAccountCreateRoot = z.object({
    bankName: zKoreanBankRoot,
    accountNumber: z
        .string()
        .min(8)
        .regex(/^[0-9\-]+$/),
});
export const zSettlementAccountCreate = zSettlementAccountCreateRoot;
export const zSettlementCallbackRequestRoot = z.object({
    settlementId: z.string(),
    transactionId: z.string(),
    status: zCallbackStatusRoot,
    paidAt: z.optional(z.iso.datetime()),
    failureReason: z.optional(z.string()),
    errorCode: z.optional(z.string()),
});
export const zSettlementCallbackResponseRoot = z.object({
    received: z.boolean(),
    settlementId: z.string(),
    processedAt: z.iso.datetime(),
});
export const zSettlementProcessResultRoot = z.object({
    settlementId: z.string(),
    success: z.boolean(),
    error: z.optional(z.union([z.string(), z.null()])),
});
export const zSettlementProcessResult = zSettlementProcessResultRoot;
export const zSettlementProcessResponseRoot = z.object({
    processedCount: z.int().gte(0),
    failedCount: z.int().gte(0),
    results: z.array(zSettlementProcessResultRoot),
});
export const zSettlementProcessResponse = zSettlementProcessResponseRoot;
export const zSettlementReportResponseRoot = z.object({
    fileName: z.string(),
    filePath: z.string(),
    downloadUrl: z.url(),
    generatedAt: z.iso.datetime(),
});
export const zSettlementStatusRoot = z.enum([
    "PENDING",
    "PROCESSING",
    "COMPLETED",
    "FAILED",
    "BLOCKED",
]);
export const zBackofficeSettlementExportItemRoot = z.object({
    settlementId: z.string().readonly(),
    settlementKind: z.optional(z.enum(["PRODUCT", "SHIPPING"])),
    shippingChargeId: z.optional(z.union([z.uuid().readonly(), z.null()]).readonly()),
    dealerId: z.string().readonly(),
    dealerNickname: z.string(),
    dealerSellerId: z.string().readonly(),
    orderId: z.string().readonly(),
    productAmount: z.number(),
    shippingFee: z.number(),
    totalPaymentAmount: z.number(),
    platformFeeAmount: z.number(),
    pgFeeAmount: z.number(),
    shippingPgFeeAmount: z.number(),
    payoutAmount: z.number(),
    netPayoutAmount: z.number(),
    status: zSettlementStatusRoot,
    eligibilityDate: z.iso.datetime(),
    orderCreatedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    orderConfirmedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    bankName: z.union([z.string(), z.null()]),
    accountNumber: z.union([z.string(), z.null()]),
});
export const zBackofficeSettlementExportItem = zBackofficeSettlementExportItemRoot;
export const zBackofficeSettlementExportResponseRoot = z.object({
    data: z.array(zBackofficeSettlementExportItemRoot),
    totalItems: z.int(),
});
export const zBackofficeSettlementExportResponse = zBackofficeSettlementExportResponseRoot;
export const zBatchChangeSettlementStatusRequestRoot = z.object({
    settlementIds: z.array(z.string()).min(1).max(100),
    targetStatus: zSettlementStatusRoot,
});
export const zBatchChangeSettlementStatusRequest = zBatchChangeSettlementStatusRequestRoot;
export const zPayoutResultRoot2 = z.object({
    settlementId: z.string(),
    paymentAgencyTransactionId: z.string(),
    commissionTransactionId: z.string(),
    status: zSettlementStatusRoot,
    initiatedAt: z.iso.datetime(),
});
export const zSettlementProcessFilterRequestRoot = z.object({
    status: z.optional(z.array(zSettlementStatusRoot)),
    dealerId: z.optional(z.string()),
    dateFrom: z.optional(z.iso.datetime()),
    dateTo: z.optional(z.iso.datetime()),
    search: z.optional(z.string()),
});
export const zSettlementProcessFilterRequest = zSettlementProcessFilterRequestRoot;
export const zSettlementReportRequestRoot = z.object({
    dealerId: z.optional(z.string()),
    status: z.optional(zSettlementStatusRoot),
    dateFrom: z.optional(z.iso.datetime()),
    dateTo: z.optional(z.iso.datetime()),
});
export const zCategoryIdPathRoot2 = z.unknown();
export const zCommentIdPathRoot = z.unknown();
export const zFollowNicknameSearchQueryRoot = z.unknown();
export const zFollowSourceQueryRoot = z.unknown();
export const zInvitationIdPathRoot = z.unknown();
export const zIsActiveQueryRoot = z.unknown();
export const zLoungeAuthorIdQueryRoot = z.unknown();
export const zLoungeCategoryIdQueryRoot = z.unknown();
export const zPostIdPathRoot = z.unknown();
export const zReportStatusQueryRoot = z.unknown();
export const zReportTargetTypeQueryRoot = z.unknown();
export const zReportIdPathRoot = z.unknown();
export const zStatusQueryRoot = z.unknown();
export const zTargetUserIdPathRoot = z.unknown();
export const zUserIdPathRoot4 = z.unknown();
export const zAdminReportReasonCategoriesCollectionRoot = z.unknown();
export const zAdminReportReasonCategoriesItemRoot = z.unknown();
export const zBackofficeLoungeCommentsItemDeleteRoot = z.unknown();
export const zBackofficeLoungeCommentsItemRepliesCollectionRoot = z.unknown();
export const zBackofficeLoungePostsCollectionRoot = z.unknown();
export const zBackofficeLoungePostsItemCommentsCollectionRoot = z.unknown();
export const zBackofficeLoungePostsItemDeleteRoot = z.unknown();
export const zBackofficeLoungePostsItemPinRoot = z.unknown();
export const zBackofficeLoungePostsItemUnpinRoot = z.unknown();
export const zBackofficeLoungePostsItemRoot = z.unknown();
export const zBackofficeUsersUserIdBlockedUsersRoot = z.unknown();
export const zInvitationsCollectionRoot = z.unknown();
export const zInvitationsItemAcceptRoot = z.unknown();
export const zLoungeCommentsMineCollectionRoot = z.unknown();
export const zLoungeCommentsItemLikesRoot = z.unknown();
export const zLoungeCommentsItemRepliesCollectionRoot = z.unknown();
export const zLoungeCommentsItemRoot = z.unknown();
export const zLoungePostsCollectionRoot = z.unknown();
export const zLoungePostsImagesUploadUrlRoot = z.unknown();
export const zLoungePostsItemCommentsCollectionRoot = z.unknown();
export const zLoungePostsItemLikesRoot = z.unknown();
export const zLoungePostsItemRoot = z.unknown();
export const zPublicUsersUserIdFollowerStatsRoot = z.unknown();
export const zPublicUsersUserIdProfileRoot = z.unknown();
export const zReferralLinksMyReferredUsersRoot = z.unknown();
export const zReferralLinksMyStatsRoot = z.unknown();
export const zReferralLinksMyRoot = z.unknown();
export const zReportReasonCategoriesCollectionRoot = z.unknown();
export const zReportsCollectionRoot = z.unknown();
export const zReportsItemRoot = z.unknown();
export const zUsersItemBlockItemRoot = z.unknown();
export const zUsersItemBlockRoot = z.unknown();
export const zUsersItemBlockedRoot = z.unknown();
export const zUsersItemFollowItemRoot = z.unknown();
export const zUsersItemFollowRoot = z.unknown();
export const zUsersItemFollowersRoot = z.unknown();
export const zUsersItemFollowingRoot = z.unknown();
export const zUsersItemInvitationsRoot = z.unknown();
export const zUsersItemReportRoot = z.unknown();
export const zAdminDeleteLoungeCommentRequestRoot = z.object({
    reason: z.string().min(10),
});
export const zAdminDeleteLoungeCommentRequest = zAdminDeleteLoungeCommentRequestRoot;
export const zAdminDeleteLoungePostRequestRoot = z.object({
    reason: z.string().min(10),
});
export const zAdminDeleteLoungePostRequest = zAdminDeleteLoungePostRequestRoot;
export const zBlockUserRequestRoot = z.object({
    blockedUserId: z.string().min(1),
    reason: z.optional(z.union([z.string(), z.null()])),
});
export const zCreateLoungeCommentRequestRoot = z.object({
    content: z.optional(z.union([z.string().max(500), z.null()])),
    imageUrl: z.optional(z.union([z.string(), z.null()])),
});
export const zCreateLoungeCommentResponseRoot = z.object({
    commentId: z.uuid(),
    postId: z.uuid(),
    content: z.string(),
    imageUrl: z.union([z.string(), z.null()]),
    createdAt: z.iso.datetime(),
});
export const zCreateReportReasonCategoryRequestRoot = z.object({
    name: z.string().min(1).max(100),
    description: z.optional(z.string().max(500)),
});
export const zFollowUserRequestRoot = z.object({
    followeeId: z.string().min(1),
    source: z.optional(z.string().max(64)),
});
export const zInvitationRoot = z.object({
    invitationId: z.string().readonly(),
    inviterId: z.string(),
    inviteePhone: z.string(),
    inviteeId: z.union([z.string().readonly(), z.null()]).readonly(),
    invitationCode: z.string().readonly(),
    status: z.enum(["PENDING", "ACCEPTED", "EXPIRED"]),
    sentAt: z.iso.datetime().readonly(),
    acceptedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    expiresAt: z.iso.datetime().readonly(),
});
export const zLoungeCommentAuthorRoot = z.object({
    userId: z.uuid(),
    nickname: z.string(),
    profileImageUrl: z.union([z.string(), z.null()]),
});
export const zLoungeCommentRoot = z.object({
    commentId: z.uuid(),
    postId: z.uuid(),
    author: zLoungeCommentAuthorRoot,
    parentCommentId: z.union([z.uuid(), z.null()]),
    content: z.union([z.string().max(500), z.null()]),
    imageUrl: z.union([z.string(), z.null()]),
    likeCount: z.int().gte(0),
    replyCount: z.int().gte(0),
    isLiked: z.union([z.boolean(), z.null()]),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
export const zLoungePostAuthorRoot = z.object({
    userId: z.string(),
    nickname: z.string(),
    profileImageUrl: z.union([z.url(), z.null()]),
});
export const zLoungePostImageRoot = z.object({
    url: z.url(),
    order: z.int().gte(0).lte(4),
});
export const zLoungePostImage = zLoungePostImageRoot;
export const zCreateLoungePostRequestRoot = z.object({
    categoryIds: z.array(z.uuid()).min(1).max(2),
    title: z.string().min(1).max(200),
    content: z.string().min(1),
    thumbnailUrl: z.optional(z.union([z.url(), z.null()])),
    images: z.optional(z.array(zLoungePostImageRoot).max(5)),
});
export const zLoungePostImageUploadUrlRoot = z.object({
    uploadUrl: z.url(),
    imageUrl: z.url(),
    expiresIn: z.int().gte(1),
    expiresAt: z.iso.datetime(),
});
export const zLoungePostImageUploadUrl = zLoungePostImageUploadUrlRoot;
export const zLoungePostSummaryRoot = z.object({
    postId: z.string().readonly(),
    categoryIds: z.array(z.uuid()),
    title: z.string(),
    content: z.string(),
    thumbnailUrl: z.union([z.url(), z.null()]),
    images: z.array(zLoungePostImageRoot).max(5),
    author: zLoungePostAuthorRoot,
    viewCount: z.int().gte(0),
    commentCount: z.int().gte(0),
    likeCount: z.int().gte(0),
    isLiked: z.union([z.boolean(), z.null()]),
    isPinned: z.boolean(),
    createdAt: z.iso.datetime().readonly(),
});
export const zMyLoungeCommentRoot = z.object({
    commentId: z.uuid(),
    postId: z.uuid(),
    postTitle: z.string(),
    author: zLoungeCommentAuthorRoot,
    parentCommentId: z.union([z.uuid(), z.null()]),
    content: z.string().max(500),
    imageUrl: z.union([z.string(), z.null()]),
    likeCount: z.int().gte(0),
    replyCount: z.int().gte(0),
    isLiked: z.union([z.boolean(), z.null()]),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
export const zMyLoungeComment = zMyLoungeCommentRoot;
export const zMyReferralStatsRoot = z.object({
    invitedCount: z.int().gte(0),
});
export const zMyReferralStats = zMyReferralStatsRoot;
export const zPublicFollowerStatsRoot = z.object({
    followersCount: z.int().gte(0),
    followingCount: z.int().gte(0),
});
export const zPublicUserProfileRoot = z.object({
    type: z.literal("profile"),
    userId: z.string(),
    nickname: z.string(),
    profileImage: z.optional(z.union([z.url(), z.null()])),
    bio: z.optional(z.union([z.string(), z.null()])),
    followerCount: z.int().gte(0),
    followingCount: z.int().gte(0),
    joinedAt: z.iso.datetime(),
    blockingStatus: z.optional(z.union([z.literal("NONE"), z.literal("YOU_BLOCKED_THEM"), z.null()])),
    followingStatus: z.optional(z.union([z.literal("FOLLOWING"), z.literal("NOT_FOLLOWING"), z.null()])),
    isDealer: z.boolean(),
});
export const zReferralLinkResponseRoot = z.object({
    referralLinkId: z.uuid().readonly(),
    userId: z.uuid().readonly(),
    referralCode: z.string(),
    shortUrl: z.url(),
    createdAt: z.iso.datetime().readonly(),
});
export const zReportReasonCategoryRoot = z.object({
    categoryId: z.uuid().readonly(),
    name: z.string().min(1).max(100),
    description: z.optional(z.union([z.string().max(500), z.null()])),
    isActive: z.boolean(),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zReportReasonCategoryListRoot = z.object({
    categories: z.array(zReportReasonCategoryRoot),
});
export const zReportUserRequestRoot = z.object({
    targetType: z.enum(["USER", "BROADCAST", "CHAT", "POST", "PRODUCT"]),
    targetEntityId: z.optional(z.string()),
    chatType: z.optional(z.enum(["BROADCAST_CHAT", "PRIVATE_DM", "OPEN_CHAT"])),
    messageId: z.optional(z.string()),
    categoryId: z.uuid(),
    detailedMessage: z.optional(z.string().min(1).max(2000)),
});
export const zReviewReportRequestRoot = z.object({
    resolution: z.optional(z.string().min(1).max(2000)),
    action: z.enum(["START_INVESTIGATION", "DISMISS", "WARN", "SUSPEND"]),
});
export const zSaveReferralLinkRequestRoot = z.object({
    shortUrl: z.url(),
});
export const zSendInvitationRequestRoot = z.object({
    inviteePhone: z
        .string()
        .min(1)
        .regex(/^\+?[1-9]\d{1,14}$/),
});
export const zUpdateLoungeCommentRequestRoot = z.object({
    content: z.optional(z.union([z.string().max(500), z.null()])),
    imageUrl: z.optional(z.union([z.string(), z.null()])),
});
export const zUpdateLoungePostRequestRoot = z.object({
    title: z.optional(z.union([z.string().min(1).max(200), z.null()])),
    content: z.optional(z.union([z.string().min(1), z.null()])),
    thumbnailUrl: z.optional(z.union([z.url(), z.null()])),
    images: z.optional(z.union([z.array(zLoungePostImageRoot).max(5), z.null()])),
});
export const zUpdateLoungePostRequest = zUpdateLoungePostRequestRoot;
export const zUpdateReportReasonCategoryRequestRoot = z.object({
    name: z.optional(z.union([z.string().min(1).max(100), z.null()])),
    description: z.optional(z.union([z.string().max(500), z.null()])),
    isActive: z.optional(z.union([z.boolean(), z.null()])),
});
export const zUserProfileSummaryRoot = z.object({
    userId: z.string().readonly(),
    nickname: z.string(),
    profileImage: z.optional(z.union([z.url(), z.null()])),
    bio: z.optional(z.union([z.string(), z.null()])),
    roles: z.array(zUserRoleRoot).min(1),
});
export const zBlockRelationshipRoot = z.object({
    relationshipId: z.string().readonly(),
    blockerId: z.string(),
    blockedId: z.string(),
    reason: z.optional(z.union([z.string(), z.null()])),
    blockedAt: z.iso.datetime().readonly(),
    userProfile: z.optional(z.union([zUserProfileSummaryRoot, z.null()])),
});
export const zBlockedUserItemRoot = z.object({
    relationshipId: z.string().readonly(),
    blockedId: z.string(),
    blockedAt: z.iso.datetime().readonly(),
    reason: z.optional(z.union([z.string(), z.null()])),
    userProfile: z.optional(z.union([zUserProfileSummaryRoot, z.null()])),
});
export const zFollowRelationshipRoot = z.object({
    relationshipId: z.string().readonly(),
    followerId: z.string(),
    followeeId: z.string(),
    followedAt: z.iso.datetime().readonly(),
    userProfile: z.optional(z.union([zUserProfileSummaryRoot, z.null()])),
    viewerIsFollowing: z.optional(z.union([z.boolean(), z.null()])),
});
export const zReferredUserItemRoot = z.object({
    userId: z.uuid(),
    referredAt: z.iso.datetime(),
    userProfile: zUserProfileSummaryRoot,
});
export const zReferredUserItem = zReferredUserItemRoot;
export const zBroadcastSearchQueryRoot = z.unknown();
export const zBroadcastIdPathRoot4 = z.unknown();
export const zCategoryIdQueryRoot3 = z.unknown();
export const zChatHistoryLimitQueryRoot = z.unknown();
export const zChatIdPathRoot = z.unknown();
export const zCursorQueryRoot3 = z.unknown();
export const zDealerBroadcastStatusQueryRoot = z.unknown();
export const zDealerIdPathRoot = z.unknown();
export const zLimitQueryRoot4 = z.unknown();
export const zMemoIdPathRoot = z.unknown();
export const zSinceSeqQueryRoot = z.unknown();
export const zTelemetrySessionIdPathRoot = z.unknown();
export const zUserIdPathRoot5 = z.unknown();
export const zWindowIndexPathRoot = z.unknown();
export const zAgoraChannelsCollectionRoot = z.unknown();
export const zAgoraSessionsHeartbeatsRoot = z.unknown();
export const zAgoraSessionsItemRoot = z.unknown();
export const zAgoraTokensGenerateRoot = z.unknown();
export const zBackofficeBroadcastChatCollectionRoot = z.unknown();
export const zBackofficeBroadcastChatItemRoot = z.unknown();
export const zBackofficeBroadcastHostPresenceSettingsRoot = z.unknown();
export const zBackofficeBroadcastTelemetrySessionsItemRoot = z.unknown();
export const zBackofficeBroadcastsCollectionRoot = z.unknown();
export const zBackofficeBroadcastsItemForceEndRoot = z.unknown();
export const zBackofficeBroadcastsItemRoot = z.unknown();
export const zBackofficeUsersUserIdBroadcastTelemetrySessionsRoot = z.unknown();
export const zBroadcastTelemetrySessionsItemWindowsItemRoot = z.unknown();
export const zBroadcastTelemetrySessionsItemRoot = z.unknown();
export const zBroadcastsThumbnailsUploadUrlRoot = z.unknown();
export const zBroadcastsCollectionRoot = z.unknown();
export const zBroadcastsFeaturedRoot = z.unknown();
export const zBroadcastsItemAdjacentRoot = z.unknown();
export const zBroadcastsItemAnnouncementRoot = z.unknown();
export const zBroadcastsItemBuyerCallsRoot = z.unknown();
export const zBroadcastsItemBuyerPresencesRoot = z.unknown();
export const zBroadcastsItemChatBanUserRoot = z.unknown();
export const zBroadcastsItemChatCollectionRoot = z.unknown();
export const zBroadcastsItemChatImageRoot = z.unknown();
export const zBroadcastsItemChatItemRoot = z.unknown();
export const zBroadcastsItemChatUserContextRoot = z.unknown();
export const zBroadcastsItemConfigRoot = z.unknown();
export const zBroadcastsItemEndRoot = z.unknown();
export const zBroadcastsItemMemosCollectionRoot = z.unknown();
export const zBroadcastsItemMemosImagesUploadUrlRoot = z.unknown();
export const zBroadcastsItemMemosItemRoot = z.unknown();
export const zBroadcastsItemRemindersRoot = z.unknown();
export const zBroadcastsItemSalesSummaryRoot = z.unknown();
export const zBroadcastsItemScreenStateRoot = z.unknown();
export const zBroadcastsItemStartRoot = z.unknown();
export const zBroadcastsItemViewerListRoot = z.unknown();
export const zBroadcastsItemViewersModeRoot = z.unknown();
export const zBroadcastsItemRoot = z.unknown();
export const zBroadcastsLiveCategoryIdsRoot = z.unknown();
export const zBroadcastsLiveRoot = z.unknown();
export const zBroadcastsScheduledItemRoot = z.unknown();
export const zBroadcastsScheduledRoot = z.unknown();
export const zBroadcastsTestRoot = z.unknown();
export const zBroadcastsTrendingRoot = z.unknown();
export const zDealersBroadcastsCollectionRoot = z.unknown();
export const zAdjacentBroadcastsRoot = z.object({
    previous: z.union([
        z.object({
            broadcastId: z.string(),
        }),
        z.null(),
    ]),
    next: z.union([
        z.object({
            broadcastId: z.string(),
        }),
        z.null(),
    ]),
});
export const zAdjacentBroadcasts = zAdjacentBroadcastsRoot;
export const zAgoraChannelCreateRoot = z.object({
    broadcastId: z.string(),
});
export const zAgoraChannelInfoRoot = z.object({
    channelName: z.string(),
    agoraAppId: z.string(),
    channelId: z.string(),
});
export const zAgoraSessionRequestRoot = z.object({
    sessionId: z.uuid(),
});
export const zAgoraTokenRequestRoot = z.object({
    broadcastId: z.string(),
    role: z.enum(["PUBLISHER", "SUBSCRIBER"]),
    deviceId: z.optional(z.string()),
    sessionId: z.optional(z.uuid()),
});
export const zAgoraTokenResponseRoot = z.object({
    token: z.string(),
    channelName: z.string(),
    uid: z.int(),
    expiresAt: z.iso.datetime(),
    sessionId: z.uuid(),
});
export const zAnnouncementUpdateRoot = z.object({
    announcement: z.string(),
});
export const zBackofficeDealerSummaryRoot = z.object({
    dealerId: z.uuid(),
    nickname: z.string(),
    profileImageUrl: z.union([z.url(), z.null()]),
});
export const zBackofficeDealerSummary = zBackofficeDealerSummaryRoot;
export const zBackofficeBroadcastRoot = z.object({
    broadcastId: z.uuid().readonly(),
    title: z.string(),
    thumbnail: z.union([z.string(), z.null()]),
    status: z.enum(["SCHEDULED", "LIVE", "ENDED"]),
    viewerCount: z.int().gte(0),
    scheduledStartTime: z.union([z.iso.datetime(), z.null()]),
    startTime: z.union([z.iso.datetime(), z.null()]),
    endTime: z.union([z.iso.datetime(), z.null()]),
    endReasonMessage: z.union([z.string(), z.null()]),
    isTestBroadcast: z.boolean(),
    createdAt: z.iso.datetime().readonly(),
    dealer: zBackofficeDealerSummaryRoot,
    categories: z.array(zCategorySummaryRoot),
});
export const zBroadcastBuyerCallCreateRoot = z.object({
    buyerId: z.uuid(),
});
export const zBroadcastBuyerCallCreate = zBroadcastBuyerCallCreateRoot;
export const zBroadcastBuyerPresenceRoot = z.object({
    userId: z.uuid(),
    isWatching: z.boolean(),
    callState: z.enum(["AVAILABLE", "CALLING", "FAILED"]),
    callAvailableAt: z.union([z.iso.datetime(), z.null()]),
});
export const zBroadcastBuyerPresence = zBroadcastBuyerPresenceRoot;
export const zBroadcastBuyerPresenceListRoot = z.object({
    data: z.array(zBroadcastBuyerPresenceRoot),
});
export const zBroadcastBuyerPresenceList = zBroadcastBuyerPresenceListRoot;
export const zBroadcastFramerateRoot = z.enum([
    "FPS_30",
    "FPS_35",
    "FPS_40",
    "FPS_45",
    "FPS_50",
    "FPS_55",
    "FPS_60",
]);
export const zBroadcastHostPresenceSettingsRoot = z.object({
    hostLostAutoEndEnabled: z.boolean(),
    hostLostAutoEndMinutes: z.int().gte(5).lte(120),
    hostAwayNoticeEnabled: z.boolean(),
    hostAwayNoticeSeconds: z.int().gte(45).lte(600),
    updatedAt: z.iso.datetime(),
    updatedByAdminId: z.union([z.uuid(), z.null()]),
});
export const zBroadcastHostPresenceSettings = zBroadcastHostPresenceSettingsRoot;
export const zBroadcastHostPresenceSettingsUpdateRoot = z.object({
    hostLostAutoEndEnabled: z.boolean(),
    hostLostAutoEndMinutes: z.int().gte(5).lte(120),
    hostAwayNoticeEnabled: z.boolean(),
    hostAwayNoticeSeconds: z.int().gte(45).lte(600),
});
export const zBroadcastHostPresenceSettingsUpdate = zBroadcastHostPresenceSettingsUpdateRoot;
export const zBroadcastReminderStatusRoot = z.object({
    broadcastId: z.string().readonly(),
    isReminderSet: z.boolean().readonly(),
    reminderCount: z.int().readonly(),
});
export const zBroadcastReminderStatus = zBroadcastReminderStatusRoot;
export const zBroadcastResolutionRoot = z.enum([
    "RESOLUTION_360P",
    "RESOLUTION_540P",
    "RESOLUTION_720P",
]);
export const zBroadcastSalesSummaryRoot = z.object({
    broadcastId: z.uuid(),
    totalAmount: z.int().gte(0),
    paidAmount: z.int().gte(0),
    pendingAmount: z.int().gte(0),
    pendingOrderCount: z.int().gte(0),
    computedAt: z.iso.datetime(),
});
export const zBroadcastSalesSummary = zBroadcastSalesSummaryRoot;
export const zBroadcastStatusRoot = z.enum(["SCHEDULED", "LIVE", "ENDED"]);
export const zBroadcastTelemetryErrorEventRoot = z.object({
    at: z.iso.datetime(),
    kind: z.string().max(60),
    code: z.optional(z.union([z.int(), z.null()])),
});
export const zBroadcastTelemetryErrorEvent = zBroadcastTelemetryErrorEventRoot;
export const zBroadcastTelemetryReportAckRoot = z.object({
    accepted: z.boolean(),
});
export const zBroadcastTelemetryReportAck = zBroadcastTelemetryReportAckRoot;
export const zBroadcastTelemetrySessionContextRoot = z.object({
    broadcastId: z.uuid(),
    installationId: z.string().min(1).max(100),
    platform: z.enum(["ANDROID", "IOS"]),
    isHost: z.boolean(),
    appVersion: z.string().max(50),
    buildNumber: z.int().gte(0),
    osVersion: z.optional(z.union([z.string().max(50), z.null()])),
    deviceModel: z.optional(z.union([z.string().max(100), z.null()])),
    policyRevision: z.optional(z.union([z.int().gte(0), z.null()])),
    telemetryLevel: z.enum(["SUMMARY", "DETAILED"]),
    startedAt: z.iso.datetime(),
});
export const zBroadcastTelemetrySessionContext = zBroadcastTelemetrySessionContextRoot;
export const zBroadcastTelemetrySessionReportRoot = z.object({
    context: zBroadcastTelemetrySessionContextRoot,
    endedAt: z.iso.datetime(),
    durationMs: z.int().gte(0),
    interactionCount: z.int().gte(0),
    interactionP50Ms: z.optional(z.number()),
    interactionP90Ms: z.optional(z.number()),
    interactionMaxMs: z.optional(z.number()),
    interactionJankyCount: z.int().gte(0),
    interactionSevereCount: z.int().gte(0),
    agoraRemoteAvgFps: z.optional(z.number()),
    agoraRemoteMinFps: z.optional(z.number()),
    agoraRemoteMaxFrozenRate: z.optional(z.number()),
    agoraRemoteTotalFrozenTimeMs: z.optional(z.int().gte(0)),
    agoraAvgBitrateKbps: z.optional(z.number()),
    agoraMaxPacketLoss: z.optional(z.number()),
    agoraRemoteMinBitrateKbps: z.optional(z.number().gte(0)),
    agoraRemoteVideoWidth: z.optional(z.int().gte(0)),
    agoraRemoteVideoHeight: z.optional(z.int().gte(0)),
    agoraRemoteVideoShortSideMin: z.optional(z.int().gte(0)),
    agoraRemoteVideoShortSideMax: z.optional(z.int().gte(0)),
    agoraLocalAvgFps: z.optional(z.number()),
    agoraLocalHwEncoderRatio: z.optional(z.number()),
    agoraLocalAvgEncoderFps: z.optional(z.number()),
    agoraLocalAvgCaptureFps: z.optional(z.number()),
    agoraLocalEncodedHeightMin: z.optional(z.int().gte(0)),
    agoraLocalEncodedHeightMax: z.optional(z.int().gte(0)),
    agoraLocalCodecType: z.optional(z.int()),
    loopLagP50Ms: z.optional(z.number()),
    loopLagP90Ms: z.optional(z.number()),
    loopLagMaxMs: z.optional(z.number()),
    loopLagStallTicks: z.optional(z.int().gte(0)),
    thermalMaxState: z.optional(z.int().gte(0).lte(3)),
    thermalSeriousOrCriticalSeconds: z.optional(z.int().gte(0)),
    batteryDropPct: z.optional(z.number()),
    batterySampleCount: z.int().gte(0),
    errorCount: z.int().gte(0),
    agoraErrorCount: z.int().gte(0),
    connectionLostCount: z.int().gte(0),
    mediaFailureCount: z.int().gte(0),
    hostMicLostCount: z.optional(z.int().gte(0)),
    hostMicRecoveredCount: z.optional(z.int().gte(0)),
    hostMicUnrecoveredCount: z.optional(z.int().gte(0)),
    hostMicRecoveryAttemptCount: z.optional(z.int().gte(0)),
    hostMicLostTotalMs: z.optional(z.int().gte(0)),
    hostMicLostMaxMs: z.optional(z.int().gte(0)),
    hostMicUserOffMs: z.optional(z.int().gte(0)),
    errorEvents: z.optional(z.array(zBroadcastTelemetryErrorEventRoot).max(200)),
});
export const zBroadcastTelemetrySessionReport = zBroadcastTelemetrySessionReportRoot;
export const zBroadcastTelemetrySessionSummaryRoot = z.object({
    sessionId: z.string(),
    broadcastId: z.string(),
    userId: z.union([z.string(), z.null()]),
    installationId: z.string(),
    platform: z.enum(["ANDROID", "IOS"]),
    isHost: z.boolean(),
    appVersion: z.string(),
    buildNumber: z.int(),
    osVersion: z.union([z.string(), z.null()]),
    deviceModel: z.union([z.string(), z.null()]),
    policyRevision: z.union([z.int(), z.null()]),
    telemetryLevel: z.enum(["SUMMARY", "DETAILED"]),
    startedAt: z.iso.datetime(),
    endedAt: z.union([z.iso.datetime(), z.null()]),
    durationMs: z.union([z.int(), z.null()]),
    interactionCount: z.int(),
    interactionP50Ms: z.union([z.number(), z.null()]),
    interactionP90Ms: z.union([z.number(), z.null()]),
    interactionMaxMs: z.union([z.number(), z.null()]),
    interactionJankyCount: z.int(),
    interactionSevereCount: z.int(),
    agoraRemoteAvgFps: z.union([z.number(), z.null()]),
    agoraRemoteMinFps: z.union([z.number(), z.null()]),
    agoraRemoteMaxFrozenRate: z.union([z.number(), z.null()]),
    agoraRemoteTotalFrozenTimeMs: z.union([z.int(), z.null()]),
    agoraAvgBitrateKbps: z.union([z.number(), z.null()]),
    agoraMaxPacketLoss: z.union([z.number(), z.null()]),
    agoraRemoteMinBitrateKbps: z.union([z.number(), z.null()]),
    agoraRemoteVideoWidth: z.union([z.int(), z.null()]),
    agoraRemoteVideoHeight: z.union([z.int(), z.null()]),
    agoraRemoteVideoShortSideMin: z.union([z.int(), z.null()]),
    agoraRemoteVideoShortSideMax: z.union([z.int(), z.null()]),
    agoraLocalAvgFps: z.union([z.number(), z.null()]),
    agoraLocalHwEncoderRatio: z.union([z.number(), z.null()]),
    agoraLocalAvgEncoderFps: z.union([z.number(), z.null()]),
    agoraLocalAvgCaptureFps: z.union([z.number(), z.null()]),
    agoraLocalEncodedHeightMin: z.union([z.int(), z.null()]),
    agoraLocalEncodedHeightMax: z.union([z.int(), z.null()]),
    agoraLocalCodecType: z.union([z.int(), z.null()]),
    loopLagP50Ms: z.union([z.number(), z.null()]),
    loopLagP90Ms: z.union([z.number(), z.null()]),
    loopLagMaxMs: z.union([z.number(), z.null()]),
    loopLagStallTicks: z.union([z.int(), z.null()]),
    thermalMaxState: z.union([z.int(), z.null()]),
    thermalSeriousOrCriticalSeconds: z.union([z.int(), z.null()]),
    batteryDropPct: z.union([z.number(), z.null()]),
    batterySampleCount: z.int(),
    errorCount: z.int(),
    agoraErrorCount: z.int(),
    connectionLostCount: z.int(),
    mediaFailureCount: z.int(),
    hostMicLostCount: z.int(),
    hostMicRecoveredCount: z.int(),
    hostMicUnrecoveredCount: z.int(),
    hostMicRecoveryAttemptCount: z.int(),
    hostMicLostTotalMs: z.int(),
    hostMicLostMaxMs: z.int(),
    hostMicUserOffMs: z.int(),
    windowCount: z.int(),
    summaryReportedAt: z.union([z.iso.datetime(), z.null()]),
});
export const zBroadcastTelemetrySessionSummary = zBroadcastTelemetrySessionSummaryRoot;
export const zBroadcastTelemetryWindowRoot = z.object({
    windowIndex: z.int(),
    windowStartedAt: z.iso.datetime(),
    windowEndedAt: z.iso.datetime(),
    durationMs: z.int(),
    elapsedMinutes: z.int(),
    interactionCount: z.int(),
    interactionP50Ms: z.union([z.number(), z.null()]),
    interactionP90Ms: z.union([z.number(), z.null()]),
    interactionMaxMs: z.union([z.number(), z.null()]),
    interactionJankyCount: z.int(),
    interactionSevereCount: z.int(),
    agoraRemoteAvgFps: z.union([z.number(), z.null()]),
    agoraRemoteMinFps: z.union([z.number(), z.null()]),
    agoraRemoteMaxFrozenRate: z.union([z.number(), z.null()]),
    agoraRemoteTotalFrozenTimeMs: z.union([z.int(), z.null()]),
    agoraAvgBitrateKbps: z.union([z.number(), z.null()]),
    agoraMaxPacketLoss: z.union([z.number(), z.null()]),
    agoraRemoteMinBitrateKbps: z.union([z.number(), z.null()]),
    agoraRemoteVideoWidth: z.union([z.int(), z.null()]),
    agoraRemoteVideoHeight: z.union([z.int(), z.null()]),
    agoraRemoteVideoShortSideMin: z.union([z.int(), z.null()]),
    agoraLocalAvgFps: z.union([z.number(), z.null()]),
    loopLagP90Ms: z.union([z.number(), z.null()]),
    loopLagMaxMs: z.union([z.number(), z.null()]),
    thermalState: z.union([z.int(), z.null()]),
    batteryLevel: z.union([z.number(), z.null()]),
});
export const zBroadcastTelemetryWindow = zBroadcastTelemetryWindowRoot;
export const zBroadcastTelemetrySessionDetailRoot = z.object({
    session: zBroadcastTelemetrySessionSummaryRoot,
    windows: z.array(zBroadcastTelemetryWindowRoot),
    errorEvents: z.array(zBroadcastTelemetryErrorEventRoot),
});
export const zBroadcastTelemetrySessionDetail = zBroadcastTelemetrySessionDetailRoot;
export const zBroadcastTelemetryWindowReportRoot = z.object({
    context: zBroadcastTelemetrySessionContextRoot,
    windowStartedAt: z.iso.datetime(),
    windowEndedAt: z.iso.datetime(),
    durationMs: z.int().gte(0),
    elapsedMinutes: z.int().gte(0),
    interactionCount: z.int().gte(0),
    interactionP50Ms: z.optional(z.number()),
    interactionP90Ms: z.optional(z.number()),
    interactionMaxMs: z.optional(z.number()),
    interactionJankyCount: z.int().gte(0),
    interactionSevereCount: z.int().gte(0),
    agoraRemoteAvgFps: z.optional(z.number()),
    agoraRemoteMinFps: z.optional(z.number()),
    agoraRemoteMaxFrozenRate: z.optional(z.number()),
    agoraRemoteTotalFrozenTimeMs: z.optional(z.int().gte(0)),
    agoraAvgBitrateKbps: z.optional(z.number()),
    agoraMaxPacketLoss: z.optional(z.number()),
    agoraRemoteMinBitrateKbps: z.optional(z.number().gte(0)),
    agoraRemoteVideoWidth: z.optional(z.int().gte(0)),
    agoraRemoteVideoHeight: z.optional(z.int().gte(0)),
    agoraRemoteVideoShortSideMin: z.optional(z.int().gte(0)),
    agoraLocalAvgFps: z.optional(z.number()),
    loopLagP90Ms: z.optional(z.number()),
    loopLagMaxMs: z.optional(z.number()),
    thermalState: z.optional(z.int().gte(0).lte(3)),
    batteryLevel: z.optional(z.number().gte(0).lte(1)),
});
export const zBroadcastTelemetryWindowReport = zBroadcastTelemetryWindowReportRoot;
export const zBroadcastThumbnailUploadUrlRoot = z.object({
    uploadUrl: z.url(),
    imageUrl: z.url(),
    expiresIn: z.int().gte(1),
    expiresAt: z.iso.datetime(),
});
export const zBroadcastTopPurchaserRoot = z.object({
    userId: z.string(),
    nickname: z.string(),
    profileImageUrl: z.optional(z.union([z.string(), z.null()])),
    totalAmount: z.int().gte(0),
});
export const zBroadcastTopPurchaser = zBroadcastTopPurchaserRoot;
export const zChatImageCreateRoot = z.object({
    imageUrl: z.url(),
});
export const zChatMessageCreateRoot = z.object({
    content: z.string().min(1),
});
export const zForceEndBroadcastRequestRoot = z.object({
    reason: z.string().min(10),
});
export const zForceEndBroadcastRequest = zForceEndBroadcastRequestRoot;
export const zGiveawaySummaryRoot = z.object({
    giveawayId: z.string(),
    status: z.enum(["IN_PROGRESS", "DRAWING", "COMPLETED"]),
    participantCount: z.int().gte(0),
    endsAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    productName: z.string(),
    productImageUrl: z.string(),
    eligibilityLabel: z.optional(z.string()),
});
export const zGroupPurchaseSummaryRoot = z.object({
    groupPurchaseId: z.string(),
    productName: z.string(),
    currentParticipants: z.int().gte(0),
    requiredParticipants: z.int().gte(1),
});
export const zLiveBroadcastCategoryIdsRoot = z.object({
    categoryIds: z.array(z.uuid()),
});
export const zLiveMemoRoot = z.object({
    memoId: z.string().readonly(),
    broadcastId: z.string(),
    dealerId: z.string(),
    content: z.string(),
    imageUrl: z.optional(z.union([z.string(), z.null()])),
    imageUrls: z.array(z.string()).max(100),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zLiveMemoCreateRoot = z.object({
    content: z.optional(z.string()),
    imageUrl: z.optional(z.union([z.string(), z.null()])),
    imageUrls: z.optional(z.array(z.string().min(1)).max(100)),
});
export const zLiveMemoImageUploadUrlRoot = z.object({
    uploadUrl: z.url(),
    imageUrl: z.url(),
    expiresIn: z.int().gte(1),
    expiresAt: z.iso.datetime(),
});
export const zLiveMemoUpdateRoot = z.object({
    content: z.optional(z.string()),
    imageUrl: z.optional(z.union([z.string(), z.null()])),
    imageUrls: z.optional(z.array(z.string().min(1)).max(100)),
});
export const zMessageTypeRoot = z.enum([
    "TEXT_MESSAGE",
    "IMAGE_MESSAGE",
    "SYSTEM",
]);
export const zSendMessageResponseRoot = z.object({
    messageId: z.string().readonly(),
});
export const zSenderTypeRoot = z.enum(["DEALER", "BUYER", "SYSTEM"]);
export const zChatMessageRoot = z.object({
    messageId: z.string().readonly(),
    broadcastId: z.string(),
    senderId: z.string(),
    senderType: zSenderTypeRoot,
    senderNickname: z.string(),
    senderAvatar: z.optional(z.union([z.string(), z.null()])),
    messageType: zMessageTypeRoot,
    content: z.optional(z.union([z.string(), z.null()])),
    imageUrl: z.optional(z.union([z.string(), z.null()])),
    sentAt: z.iso.datetime().readonly(),
    isDeleted: z.boolean(),
    emphasis: z.optional(z.nullable(z.enum(["ACCENT"]))),
    seq: z.optional(z.union([z.int().gte(1), z.null()])),
});
export const zTestBroadcastCreateRoot = z.object({
    title: z.optional(z.string().min(1)).default("Test Broadcast"),
    resolution: z.optional(z.enum(["RESOLUTION_360P", "RESOLUTION_540P", "RESOLUTION_720P"])),
});
export const zViewerItemRoot = z.object({
    userId: z.uuid(),
    nickname: z.string(),
    profileImageUrl: z.union([z.string(), z.null()]),
    isFollower: z.boolean(),
    viewerIsFollowing: z.optional(z.union([z.boolean(), z.null()])),
});
export const zViewerListResponseRoot = z.object({
    viewers: z.array(zViewerItemRoot),
    nextCursor: z.union([z.string(), z.null()]),
    totalCount: z.int().gte(0),
});
export const zViewingModeRoot = z.enum([
    "FOREGROUND",
    "BACKGROUND",
    "PIP",
    "WEB",
]);
export const zLinkRoot = z.unknown();
export const zXCorrelationIdRoot = z.unknown();
export const zXRequestIdRoot = z.unknown();
export const zBuyerNicknameQueryRoot = z.unknown();
export const zDealerIdQueryRoot3 = z.unknown();
export const zDealerNicknameQueryRoot = z.unknown();
export const zFilterRoot = z.unknown();
export const zIdPathRoot = z.unknown();
export const zPageSizeRoot = z.unknown();
export const zPageRoot = z.unknown();
export const zSortRoot = z.unknown();
export const z400BadRequestRoot = z.unknown();
export const z401UnauthorizedRoot = z.unknown();
export const z403ForbiddenRoot = z.unknown();
export const z404NotFoundRoot = z.unknown();
export const z409ConflictRoot = z.unknown();
export const z410GoneRoot = z.unknown();
export const z413PayloadTooLargeRoot = z.unknown();
export const z422UnprocessableEntityRoot = z.unknown();
export const z429TooManyRequestsRoot = z.unknown();
export const z500InternalServerErrorRoot = z.unknown();
export const z502BadGatewayRoot = z.unknown();
export const z503ServiceUnavailableRoot = z.unknown();
export const zActiveCancellationBriefRoot = z.object({
    cancellationId: z.string().readonly(),
    initiatedBy: z.optional(z.enum(["BUYER", "SYSTEM", "ADMIN"])),
    status: z.enum(["REQUESTED", "APPROVED", "COMPLETED", "REJECTED"]),
    reasonType: z.enum([
        "BUYER_CHANGED_MIND",
        "BUYER_FOUND_BETTER_PRICE",
        "DEALER_OUT_OF_STOCK",
        "DEALER_CANNOT_FULFILL",
        "PAYMENT_FAILED",
        "PAYMENT_EXPIRED",
        "SYSTEM_ERROR",
        "ADMIN_FORCE_CANCEL",
    ]),
    reasonDescription: z
        .union([z.string().max(500).readonly(), z.null()])
        .readonly(),
    rejectionReason: z.union([z.string().readonly(), z.null()]).readonly(),
});
export const zActiveReturnBriefRoot = z.object({
    returnId: z.string().readonly(),
    status: z.enum(["REQUESTED", "APPROVED", "REJECTED", "REFUNDED"]),
});
export const zBidderBriefRoot = z.object({
    bidderId: z.union([z.uuid().readonly(), z.null()]).readonly(),
    anonymousNickname: z.string(),
    isAnonymous: z.boolean(),
});
export const zBidderBrief = zBidderBriefRoot;
export const zBlockingStatusRoot = z.enum([
    "NONE",
    "YOU_BLOCKED_THEM",
    "THEY_BLOCKED_YOU",
    "MUTUAL_BLOCK",
]);
export const zBlockingStatus = zBlockingStatusRoot;
export const zBroadcastBriefRoot = z.object({
    broadcastId: z.uuid().readonly(),
    title: z.string(),
    thumbnailUrl: z.union([z.url(), z.null()]),
    broadcastStatus: z.enum(["SCHEDULED", "LIVE", "ENDED"]),
});
export const zBroadcastBrief = zBroadcastBriefRoot;
export const zCarrierRoot = z.enum([
    "KOREA_POST",
    "CJ_LOGISTICS",
    "HANJIN_SHIPPING",
    "LOTTE_LOGISTICS",
    "LOGEN_DELIVERY",
    "DAESIN",
    "KYUNGDONG_EXPRESS",
    "ILYANG_LOGISTICS",
    "CHUNIL_EXPRESS",
    "HAPDONG_EXPRESS",
    "GS_POSTBOX",
    "CU_POST",
    "KUNYOUNG_EXPRESS",
    "WOORI_EXPRESS",
    "NH_LOGISTICS",
]);
export const zCarrier = zCarrierRoot;
export const zChangeShipmentTrackingRequestRoot = z.object({
    carrier: zCarrierRoot,
    trackingNumber: z.string().min(1).max(100),
});
export const zChangeShipmentTrackingRequest = zChangeShipmentTrackingRequestRoot;
export const zChangeShipmentTrackingResponseRoot = z.object({
    fulfillmentOrderId: z.string(),
    carrier: zCarrierRoot,
    trackingNumber: z.string(),
    validationStatus: z.enum([
        "VALID",
        "NOT_FOUND",
        "NOT_CONFIGURED",
        "PROVIDER_ERROR",
    ]),
});
export const zChangeShipmentTrackingResponse = zChangeShipmentTrackingResponseRoot;
export const zShipFulfillmentOrderRequestRoot = z.object({
    shippingOption: zShippingOptionRoot,
    carrier: z.optional(z.union([zCarrierRoot, z.null()])),
    trackingNumber: z.optional(z.union([z.string().min(1), z.null()])),
    estimatedDelivery: z.optional(z.union([z.iso.datetime(), z.null()])),
});
export const zShipFulfillmentOrderRequest = zShipFulfillmentOrderRequestRoot;
export const zTrackingValidationRequestRoot = z.object({
    carrier: zCarrierRoot,
    trackingNumber: z.string().min(1).max(100),
});
export const zTrackingValidationRequest = zTrackingValidationRequestRoot;
export const zFieldValidationErrorRoot = z.object({
    field: z.string(),
    message: z.string(),
    code: z.optional(z.string()),
});
export const zFieldValidationError = zFieldValidationErrorRoot;
export const zMoneyNonNegativeRoot = z.object({
    amount: z.number().gte(0),
    currency: z.enum(["KRW"]),
});
export const zMoneyNonNegative = zMoneyNonNegativeRoot;
export const zParcelSummaryRoot = z.object({
    fulfillmentOrderIds: z.array(z.uuid()).readonly(),
    orderCount: z.int().gte(0).readonly(),
    summary: z
        .object({
        total: z.int().gte(0),
        active: z.int().gte(0),
        cancelled: z.int().gte(0),
        returned: z.int().gte(0),
    })
        .readonly(),
    totalAmount: zMoneyNonNegativeRoot,
    shippingFeeAmount: zMoneyNonNegativeRoot,
});
export const zShippingChargeRoot = z.object({
    shippingChargeId: z.uuid().readonly(),
    fulfillmentOrderId: z.uuid().readonly(),
    chargedOrderId: z.union([z.uuid().readonly(), z.null()]).readonly(),
    amount: zMoneyNonNegativeRoot,
    refundedAmount: zMoneyNonNegativeRoot,
    remainingAmount: zMoneyNonNegativeRoot,
    status: z.enum([
        "PENDING_CAPTURE",
        "CHARGED",
        "REFUNDED",
        "SETTLED",
        "SETTLED_THEN_REFUNDED",
    ]),
    isRefundable: z.boolean().readonly(),
});
export const zGiveawayCreateRoot = z.object({
    broadcastId: z.string(),
    productListingId: z.string(),
    shippingFee: zMoneyNonNegativeRoot,
    eligibilityRule: z.optional(z.enum(["ANYONE", "FOLLOWERS", "PURCHASERS"])),
    drawingType: z.optional(z.enum(["AUTO", "MANUAL"])),
});
export const zGiveawayEntryTermsRoot = z.object({
    giveawayId: z.string(),
    expectedShippingFee: zMoneyNonNegativeRoot,
    paymentMethodRequired: z.boolean(),
});
export const zGiveawayWithProductCreateRoot = z.object({
    broadcastId: z.string(),
    productName: z.string().min(1).max(200),
    imageUrl: z.url(),
    shippingFee: zMoneyNonNegativeRoot,
    eligibilityRule: z.optional(z.enum(["ANYONE", "FOLLOWERS", "PURCHASERS"])),
    drawingType: z.optional(z.enum(["AUTO", "MANUAL"])),
});
export const zBroadcastConfigUpdateRoot = z.object({
    shippingFee: z.optional(zMoneyNonNegativeRoot),
    autoLoadShippingFee: z.optional(z.boolean()),
    autoLoadAnnouncement: z.optional(z.boolean()),
});
export const zBroadcastCreateRoot = z.object({
    title: z.string().min(1),
    broadcastCategoryIds: z.array(z.uuid()).min(1).max(2),
    thumbnail: z.optional(z.union([z.string(), z.null()])),
    announcement: z.optional(z.union([z.string(), z.null()])),
    shippingFee: zMoneyNonNegativeRoot,
    startTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    autoLoadShippingFee: z.optional(z.boolean()).default(false),
    autoLoadAnnouncement: z.optional(z.boolean()).default(false),
    isAnonymousAuctionBroadcast: z.optional(z.boolean()).default(false),
    showTopPurchasersToHost: z.optional(z.boolean()).default(false),
    showTopPurchasersToViewers: z.optional(z.boolean()).default(false),
    framerate: z.optional(zBroadcastFramerateRoot),
    resolution: z.optional(z.enum(["RESOLUTION_360P", "RESOLUTION_540P", "RESOLUTION_720P"])),
});
export const zScheduledBroadcastRoot = z.object({
    broadcastId: z.string().readonly(),
    dealerId: z.string(),
    status: z.enum(["SCHEDULED"]),
    title: z.string(),
    thumbnail: z.optional(z.union([z.string(), z.null()])),
    announcement: z.optional(z.union([z.string(), z.null()])),
    shippingFee: zMoneyNonNegativeRoot,
    scheduledStartTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    autoLoadShippingFee: z.boolean(),
    autoLoadAnnouncement: z.boolean(),
    reminderCount: z.int().readonly(),
    isReminderSet: z.boolean().readonly(),
    categories: z.array(zCategorySummaryRoot),
    isTestBroadcast: z.boolean(),
    isAnonymousAuctionBroadcast: z.boolean(),
    showTopPurchasersToHost: z.boolean(),
    showTopPurchasersToViewers: z.boolean(),
    viewerCount: z.int().gte(0).readonly(),
    createdAt: z.iso.datetime().readonly(),
});
export const zScheduledBroadcastUpdateRoot = z.object({
    title: z.optional(z.string().min(1)),
    thumbnail: z.optional(z.union([z.string(), z.null()])),
    announcement: z.optional(z.union([z.string(), z.null()])),
    shippingFee: z.optional(zMoneyNonNegativeRoot),
    scheduledStartTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    autoLoadShippingFee: z.optional(z.boolean()),
    autoLoadAnnouncement: z.optional(z.boolean()),
    showTopPurchasersToHost: z.optional(z.boolean()),
    showTopPurchasersToViewers: z.optional(z.boolean()),
    broadcastCategoryIds: z.optional(z.array(z.uuid()).max(2)),
});
export const zOrderBriefRoot = z.object({
    orderId: z.uuid().readonly(),
    fulfillmentOrderId: z.string().readonly(),
    orderType: z.enum(["AUCTION", "INSTANT_PURCHASE", "GROUP_BUY", "GIVEAWAY"]),
    saleType: z.optional(zSaleTypeRoot),
    totalAmount: z.number(),
    orderStatus: z.enum([
        "CREATED",
        "PAYMENT_REQUESTED",
        "AWAITING_REPAYMENT",
        "PAID",
        "SHIPPED",
        "DELIVERED",
        "CONFIRMED",
        "CANCELLED",
        "RETURNED",
        "EXPIRED",
    ]),
    productListingId: z.optional(z.uuid().readonly()),
    createdAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    productName: z.optional(z.union([z.string().readonly(), z.null()]).readonly()),
    broadcastTitle: z.optional(z.union([z.string().readonly(), z.null()]).readonly()),
});
export const zOrderBrief = zOrderBriefRoot;
export const zProductBriefRoot = z.object({
    productListingId: z.string().readonly(),
    name: z.string(),
    thumbnailUrl: z.union([z.url(), z.null()]),
    price: z.number(),
});
export const zProductBrief = zProductBriefRoot;
export const zProfileUnavailableReasonRoot = z.enum([
    "NOT_FOUND",
    "DELETED",
    "SUSPENDED",
]);
export const zProfileUnavailableReason = zProfileUnavailableReasonRoot;
export const zProfileUnavailableResponseRoot = z.object({
    type: z.literal("unavailable"),
    userId: z.optional(z.string()),
    reason: zProfileUnavailableReasonRoot,
    message: z.string(),
    canUnblock: z.optional(z.boolean()),
});
export const zProfileUnavailableResponse = zProfileUnavailableResponseRoot;
export const zUserBriefRoot = z.object({
    userId: z.string().readonly(),
    nickname: z.string(),
    profileImageUrl: z.union([z.url(), z.null()]),
});
export const zUserBrief = zUserBriefRoot;
export const zBackofficeLiveSnapshotRoot = z.object({
    liveSnapshotId: z.uuid(),
    status: z.enum(["PUBLISHED", "HIDDEN", "DELETED"]),
    imageUrl: z.url(),
    productName: z.string(),
    broadcastId: z.uuid(),
    broadcastTitle: z.string(),
    dealerMemo: z.optional(z.union([z.string(), z.null()])),
    categories: z.array(zLiveSnapshotCategoryRoot),
    dealer: zUserBriefRoot,
    buyer: zUserBriefRoot,
    buyerAnonymousNickname: z.union([z.string(), z.null()]),
    buyerVisible: z.boolean(),
    sourceType: z.nullable(z.enum(["AUCTION", "INSTANT_PURCHASE", "GIVEAWAY"])),
    sourceId: z.union([z.uuid(), z.null()]),
    orderId: z.union([z.uuid(), z.null()]),
    hiddenAt: z.union([z.iso.datetime(), z.null()]),
    hiddenReason: z.union([z.string(), z.null()]),
    deletedAt: z.union([z.iso.datetime(), z.null()]),
    createdAt: z.iso.datetime(),
});
export const zLiveSnapshotBuyerCandidateListRoot = z.object({
    data: z.array(zUserBriefRoot),
});
export const zLiveSnapshotDetailRoot = z.object({
    liveSnapshotId: z.uuid().readonly(),
    imageUrl: z.url(),
    productName: z.string(),
    dealerMemo: z.optional(z.union([z.string(), z.null()])),
    buyer: z.union([zLiveSnapshotBuyerRoot, z.null()]),
    dealer: zUserBriefRoot,
    broadcast: zLiveSnapshotBroadcastRoot,
    categories: z.array(zLiveSnapshotCategoryRoot),
    canDelete: z.boolean(),
    createdAt: z.iso.datetime().readonly(),
});
export const zBackofficeDmConversationRoot = z.object({
    chatRoomId: z.uuid().readonly(),
    participants: z.tuple([zUserBriefRoot, zUserBriefRoot]).readonly(),
    lastMessage: z.union([z.string().readonly(), z.null()]).readonly(),
    messageCount: z.int().gte(0).readonly(),
    lastMessageAt: z.union([z.iso.datetime().readonly(), z.null()]).readonly(),
});
export const zBackofficeDmConversation = zBackofficeDmConversationRoot;
export const zBackofficeDmConversationDetailRoot = z.object({
    chatRoomId: z.uuid().readonly(),
    participants: z.tuple([zUserBriefRoot, zUserBriefRoot]).readonly(),
});
export const zBackofficeDmConversationDetail = zBackofficeDmConversationDetailRoot;
export const zBackofficeDmMessageRoot = z.object({
    messageId: z.uuid().readonly(),
    sender: zUserBriefRoot,
    messageType: z.enum(["TEXT", "IMAGE", "SYSTEM"]),
    content: z.union([z.string(), z.null()]),
    imageUrls: z.optional(z.array(z.string())),
    sentAt: z.iso.datetime().readonly(),
    isDeleted: z.boolean().readonly(),
    deletedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
});
export const zBackofficeDmMessage = zBackofficeDmMessageRoot;
export const zBackofficeMessageRoot = z.object({
    messageId: z.uuid().readonly(),
    sender: zUserBriefRoot,
    chatType: z.enum(["BROADCAST_CHAT", "PRIVATE_DM"]),
    messageType: z.enum(["TEXT", "IMAGE", "SYSTEM"]),
    content: z.union([z.string(), z.null()]),
    imageUrls: z.optional(z.array(z.string())),
    sentAt: z.iso.datetime().readonly(),
});
export const zBackofficeOpenChatMessageRoot = z.object({
    messageId: z.uuid().readonly(),
    sender: zUserBriefRoot,
    messageType: z.enum(["TEXT_MESSAGE", "IMAGE_MESSAGE"]),
    content: z.string().readonly(),
    imageUrl: z.optional(z.union([z.url().readonly(), z.null()]).readonly()),
    imageUrls: z.optional(z.array(z.string()).readonly()),
    sentAt: z.iso.datetime().readonly(),
    isDeleted: z.boolean().readonly(),
    deletedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
});
export const zBackofficeOpenChatMessage = zBackofficeOpenChatMessageRoot;
export const zMessageRoot = z.object({
    messageId: z.string().readonly(),
    roomId: z.string(),
    sender: zUserBriefRoot,
    content: z.string(),
    messageType: z.enum(["TEXT_MESSAGE", "IMAGE_MESSAGE"]),
    imageUrls: z.array(z.string()),
    sentAt: z.iso.datetime().readonly(),
    isDeleted: z.boolean(),
    deletedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
});
export const zChatRoomRoot2 = z.object({
    chatRoomId: z.string().readonly(),
    dealer: zUserBriefRoot,
    buyer: zUserBriefRoot,
    isActive: z.boolean(),
    createdAt: z.iso.datetime().readonly(),
    lastMessage: z.optional(zMessageRoot),
    lastMessageAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    unreadCount: z.optional(z.int().readonly()),
});
export const zMessageListRoot2 = z.object({
    messages: z.array(zMessageRoot),
    hasMore: z.boolean(),
    nextCursor: z.optional(z.union([z.string(), z.null()])),
});
export const zMyChatRoomOpenRoot = z.object({
    roomType: z.enum(["OPEN"]),
    id: z.string().readonly(),
    title: z.string(),
    thumbnail: z.optional(z.union([z.url(), z.null()])),
    maxParticipants: z.int().gte(1),
    currentParticipantCount: z.int().gte(0),
    messageCount: z.int().readonly(),
    status: z.enum(["OPEN", "CLOSED", "ARCHIVED"]),
    noticeBanner: z.optional(z.union([z.string(), z.null()])),
    categoryId: z.optional(z.union([z.uuid().readonly(), z.null()]).readonly()),
    category: z.optional(z.union([zCategorySummaryRoot, z.null()])),
    createdAt: z.iso.datetime().readonly(),
    lastMessage: z.optional(zMessageRoot),
    lastMessageAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    unreadCount: z.optional(z.int().readonly()),
    creator: zUserBriefRoot,
});
export const zMyChatRoomPrivateRoot = z.object({
    roomType: z.enum(["PRIVATE"]),
    chatRoomId: z.string().readonly(),
    dealer: zUserBriefRoot,
    buyer: zUserBriefRoot,
    isActive: z.boolean(),
    createdAt: z.iso.datetime().readonly(),
    lastMessage: z.optional(zMessageRoot),
    lastMessageAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    unreadCount: z.optional(z.int().readonly()),
});
export const zMyChatRoomRoot = z.union([
    z
        .object({
        roomType: z.literal("MyChatRoomPrivate_root"),
    })
        .and(zMyChatRoomPrivateRoot),
    z
        .object({
        roomType: z.literal("MyChatRoomOpen_root"),
    })
        .and(zMyChatRoomOpenRoot),
]);
export const zOpenChatRoomRoot2 = z.object({
    id: z.string().readonly(),
    title: z.string(),
    thumbnail: z.optional(z.union([z.url(), z.null()])),
    maxParticipants: z.int().gte(1),
    currentParticipantCount: z.int().gte(0),
    messageCount: z.int().readonly(),
    status: z.enum(["OPEN", "CLOSED", "ARCHIVED"]),
    noticeBanner: z.optional(z.union([z.string(), z.null()])),
    categoryId: z.optional(z.union([z.uuid().readonly(), z.null()]).readonly()),
    category: z.optional(z.union([zCategorySummaryRoot, z.null()])),
    createdAt: z.iso.datetime().readonly(),
    lastMessageAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    creator: zUserBriefRoot,
    isMember: z.optional(z.boolean().readonly()),
    roomKind: z.optional(z.enum(["COMMUNITY", "DEALER"])),
    isOwner: z.optional(z.boolean().readonly()),
});
export const zShipmentRoot = z.object({
    shipmentId: z.string().readonly(),
    fulfillmentOrderId: z.string().readonly(),
    combinedShippingGroupId: z.optional(z.union([z.uuid().readonly(), z.null()]).readonly()),
    buyer: zUserBriefRoot,
    shippingOption: zShippingOptionRoot,
    carrier: z.union([zCarrierRoot, z.null()]),
    trackingNumber: z.union([z.string(), z.null()]),
    status: z.enum([
        "PREPARING",
        "IN_TRANSIT",
        "OUT_FOR_DELIVERY",
        "DELIVERED",
        "FAILED",
    ]),
    shippedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    estimatedDelivery: z.optional(z.union([z.iso.datetime(), z.null()])),
    actualDelivery: z.optional(z.union([z.iso.datetime(), z.null()])),
    foOrderCount: z.optional(z.union([z.int().gte(1), z.null()])),
    trackingUpdates: z.optional(z.union([z.array(zTrackingUpdateRoot), z.null()])),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zShipment = zShipmentRoot;
export const zBroadcastSoldListingRoot = z.object({
    transactionType: z.enum(["AUCTION", "INSTANT_PURCHASE", "GIVEAWAY"]),
    transactionId: z.uuid().readonly(),
    instantPurchaseId: z.union([z.uuid().readonly(), z.null()]).readonly(),
    productListingId: z.uuid().readonly(),
    productName: z.string(),
    productImageUrl: z.union([z.url(), z.null()]),
    tradePrice: z.number(),
    tradePriceCurrency: z.string(),
    buyer: zUserBriefRoot,
    confirmationTime: z.iso.datetime().readonly(),
    slotNumber: z.union([z.int(), z.null()]),
    liveSnapshotId: z.optional(z.union([z.uuid(), z.null()])),
    canCreateLiveSnapshot: z.optional(z.boolean()),
});
export const zInstantPurchaseBuyerRoot = z.object({
    orderId: z.string().readonly(),
    saleOrderNumber: z.optional(z.union([z.int().gte(1).readonly(), z.null()]).readonly()),
    purchaseNumber: z.optional(z.union([z.int().gte(1).readonly(), z.null()]).readonly()),
    buyer: zUserBriefRoot,
    quantity: z.int().gte(1),
    purchasedAt: z.iso.datetime().readonly(),
});
export const zInstantPurchaseBuyer = zInstantPurchaseBuyerRoot;
export const zBackofficeLoungeCommentRoot = z.object({
    commentId: z.string().readonly(),
    postId: z.string(),
    parentCommentId: z.union([z.string(), z.null()]),
    author: zUserBriefRoot,
    content: z.union([z.string(), z.null()]),
    imageUrl: z.union([z.string(), z.null()]),
    likeCount: z.int().gte(0),
    replyCount: z.int().gte(0),
    status: z.enum(["PUBLISHED", "HIDDEN", "DELETED"]),
    createdAt: z.iso.datetime().readonly(),
});
export const zBackofficeLoungeComment = zBackofficeLoungeCommentRoot;
export const zBackofficeLoungePostDetailRoot = z.object({
    postId: z.string().readonly(),
    title: z.string(),
    content: z.string(),
    author: zUserBriefRoot,
    categories: z.array(zCategorySummaryRoot),
    commentCount: z.int().gte(0),
    likeCount: z.int().gte(0),
    viewCount: z.int().gte(0),
    status: z.enum(["PUBLISHED", "HIDDEN", "DELETED"]),
    isPinned: z.boolean(),
    pinnedAt: z.union([z.iso.datetime(), z.null()]),
    images: z.array(zLoungePostImageRoot),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zBackofficeLoungePostDetail = zBackofficeLoungePostDetailRoot;
export const zBackofficeLoungePostSummaryRoot = z.object({
    postId: z.string().readonly(),
    title: z.string(),
    author: zUserBriefRoot,
    categories: z.array(zCategorySummaryRoot),
    commentCount: z.int().gte(0),
    likeCount: z.int().gte(0),
    viewCount: z.int().gte(0),
    status: z.enum(["PUBLISHED", "HIDDEN", "DELETED"]),
    isPinned: z.boolean(),
    pinnedAt: z.union([z.iso.datetime(), z.null()]),
    images: z.array(zLoungePostImageRoot),
    createdAt: z.iso.datetime().readonly(),
});
export const zBackofficeLoungePostSummary = zBackofficeLoungePostSummaryRoot;
export const zReportBroadcastContextRoot = z.object({
    targetType: z.enum(["BROADCAST"]),
    broadcast: zBroadcastBriefRoot,
    dealer: zUserBriefRoot,
});
export const zReportBroadcastContext = zReportBroadcastContextRoot;
export const zReportContextMessageRoot = z.object({
    messageId: z.string().readonly(),
    sender: zUserBriefRoot,
    messageType: z.enum(["TEXT_MESSAGE", "IMAGE_MESSAGE", "SYSTEM"]),
    content: z.union([z.string(), z.null()]),
    sentAt: z.iso.datetime().readonly(),
    isReportedMessage: z.boolean(),
    isDeleted: z.boolean(),
});
export const zReportContextMessage = zReportContextMessageRoot;
export const zReportChatContextRoot = z.object({
    targetType: z.enum(["CHAT"]),
    chatType: z.enum(["BROADCAST_CHAT", "PRIVATE_DM", "OPEN_CHAT"]),
    broadcast: z.union([zBroadcastBriefRoot, z.null()]),
    chatRoom: z.union([
        z.object({
            chatRoomId: z.string(),
            participants: z.tuple([zUserBriefRoot, zUserBriefRoot]),
        }),
        z.null(),
    ]),
    openChatRoom: z.union([
        z.object({
            openChatRoomId: z.string(),
            title: z.string(),
        }),
        z.null(),
    ]),
    surroundingMessages: z.array(zReportContextMessageRoot).readonly(),
});
export const zReportChatContext = zReportChatContextRoot;
export const zReportPostContextRoot = z.object({
    targetType: z.enum(["POST"]),
    postId: z.string().readonly(),
    title: z.string().readonly(),
    author: zUserBriefRoot,
});
export const zReportPostContext = zReportPostContextRoot;
export const zReportProductContextRoot = z.object({
    targetType: z.enum(["PRODUCT"]),
    productListingId: z.string().readonly(),
    name: z.string().readonly(),
    thumbnailUrl: z.union([z.url().readonly(), z.null()]).readonly(),
    dealer: zUserBriefRoot,
});
export const zReportProductContext = zReportProductContextRoot;
export const zReportUserContextRoot = z.object({
    targetType: z.enum(["USER"]),
    user: zUserBriefRoot,
});
export const zReportUserContext = zReportUserContextRoot;
export const zReportTargetContextRoot = z.union([
    z
        .object({
        targetType: z.literal("ReportUserContext_root"),
    })
        .and(zReportUserContextRoot),
    z
        .object({
        targetType: z.literal("ReportBroadcastContext_root"),
    })
        .and(zReportBroadcastContextRoot),
    z
        .object({
        targetType: z.literal("ReportChatContext_root"),
    })
        .and(zReportChatContextRoot),
    z
        .object({
        targetType: z.literal("ReportPostContext_root"),
    })
        .and(zReportPostContextRoot),
    z
        .object({
        targetType: z.literal("ReportProductContext_root"),
    })
        .and(zReportProductContextRoot),
]);
export const zReportTargetContext = zReportTargetContextRoot;
export const zUserReportRoot = z.object({
    reportId: z.string().readonly(),
    reporterId: z.string(),
    reportedId: z.string(),
    targetType: z.enum(["USER", "BROADCAST", "CHAT", "POST", "PRODUCT"]),
    targetEntityId: z.string(),
    chatType: z.optional(z.nullable(z.enum(["BROADCAST_CHAT", "PRIVATE_DM", "OPEN_CHAT"]))),
    messageId: z.optional(z.union([z.string(), z.null()])),
    reporter: zUserBriefRoot,
    reported: zUserBriefRoot,
    categoryId: z.uuid(),
    category: z.object({
        name: z.string(),
        description: z.union([z.string(), z.null()]),
    }),
    detailedMessage: z.optional(z.union([z.string(), z.null()])),
    reason: z.optional(z.union([z.string(), z.null()])),
    status: z.enum(["PENDING", "UNDER_REVIEW", "RESOLVED", "REJECTED"]),
    reportedAt: z.iso.datetime().readonly(),
    reviewedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    resolution: z.optional(z.union([z.string(), z.null()])),
    resolutionType: z.optional(z.nullable(z.enum(["DISMISS", "WARN", "SUSPEND"]))),
    reviewedBy: z.optional(z.union([z.string(), z.null()])),
});
export const zUserReportDetailRoot = z.object({
    reportId: z.string().readonly(),
    reporterId: z.string(),
    reportedId: z.string(),
    targetType: z.enum(["USER", "BROADCAST", "CHAT", "POST", "PRODUCT"]),
    targetEntityId: z.string(),
    chatType: z.optional(z.nullable(z.enum(["BROADCAST_CHAT", "PRIVATE_DM", "OPEN_CHAT"]))),
    messageId: z.optional(z.union([z.string(), z.null()])),
    reporter: zUserBriefRoot,
    reported: zUserBriefRoot,
    categoryId: z.uuid(),
    category: z.object({
        name: z.string(),
        description: z.union([z.string(), z.null()]),
    }),
    detailedMessage: z.optional(z.union([z.string(), z.null()])),
    reason: z.optional(z.union([z.string(), z.null()])),
    status: z.enum(["PENDING", "UNDER_REVIEW", "RESOLVED", "REJECTED"]),
    reportedAt: z.iso.datetime().readonly(),
    reviewedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    resolution: z.optional(z.union([z.string(), z.null()])),
    resolutionType: z.optional(z.nullable(z.enum(["DISMISS", "WARN", "SUSPEND"]))),
    reviewedBy: z.optional(z.union([z.string(), z.null()])),
    targetContext: zReportTargetContextRoot,
});
export const zUserReportDetail = zUserReportDetailRoot;
export const zBroadcastRoot = z.object({
    broadcastId: z.string().readonly(),
    dealer: zUserBriefRoot,
    broadcastCategoryIds: z.array(z.uuid()),
    status: zBroadcastStatusRoot,
    title: z.string(),
    thumbnail: z.optional(z.union([z.string(), z.null()])),
    announcement: z.optional(z.union([z.string(), z.null()])),
    shippingFee: zMoneyNonNegativeRoot,
    scheduledStartTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    startTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    endTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    endReasonMessage: z.optional(z.union([z.string(), z.null()])),
    viewerCount: z.int().gte(0),
    isTestBroadcast: z.boolean(),
    isAnonymousAuctionBroadcast: z.boolean(),
    autoLoadShippingFee: z.optional(z.boolean()),
    autoLoadAnnouncement: z.optional(z.boolean()),
    framerate: zBroadcastFramerateRoot,
    resolution: zBroadcastResolutionRoot,
    agoraBroadcastId: z.optional(z.union([z.string(), z.null()])),
    agoraChannelName: z.optional(z.union([z.string(), z.null()])),
    createdAt: z.iso.datetime().readonly(),
});
export const zServerPageLiveBroadcastsBlockRoot = z.object({
    type: z.literal("liveBroadcasts"),
    title: z.optional(z.string().max(40)),
    maxItems: z.int().gte(1).lte(30),
    items: z.array(zBroadcastRoot),
});
export const zServerPageScheduledBroadcastsBlockRoot = z.object({
    type: z.literal("scheduledBroadcasts"),
    title: z.optional(z.string().max(40)),
    maxItems: z.int().gte(1).lte(30),
    items: z.array(zBroadcastRoot),
});
export const zBroadcastDetailsRoot = z.object({
    broadcastId: z.string().readonly(),
    dealer: zUserBriefRoot,
    broadcastCategoryIds: z.array(z.uuid()),
    status: zBroadcastStatusRoot,
    title: z.string(),
    thumbnail: z.optional(z.union([z.string(), z.null()])),
    announcement: z.optional(z.union([z.string(), z.null()])),
    shippingFee: zMoneyNonNegativeRoot,
    scheduledStartTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    startTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    endTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    endReasonMessage: z.optional(z.union([z.string(), z.null()])),
    viewerCount: z.int().gte(0),
    isTestBroadcast: z.boolean(),
    isAnonymousAuctionBroadcast: z.boolean(),
    showTopPurchasersToHost: z.boolean(),
    showTopPurchasersToViewers: z.boolean(),
    autoLoadShippingFee: z.optional(z.boolean()),
    autoLoadAnnouncement: z.optional(z.boolean()),
    framerate: zBroadcastFramerateRoot,
    resolution: zBroadcastResolutionRoot,
    agoraBroadcastId: z.optional(z.union([z.string(), z.null()])),
    agoraChannelName: z.optional(z.union([z.string(), z.null()])),
    streamUrl: z.optional(z.union([z.string(), z.null()])),
    reminderCount: z.int().readonly(),
    isReminderSet: z.boolean().readonly(),
    createdAt: z.iso.datetime().readonly(),
    hasMemo: z.boolean().readonly(),
    topPurchasers: z.optional(z.array(zBroadcastTopPurchaserRoot)),
});
export const zViewerBriefRoot = z.object({
    viewerId: z.union([z.uuid().readonly(), z.null()]).readonly(),
    nickname: z.string(),
    profileImageUrl: z.optional(z.union([z.url(), z.null()])),
    viewingMode: z.enum(["FOREGROUND", "BACKGROUND", "PIP", "WEB"]),
});
export const zViewerBrief = zViewerBriefRoot;
export const zWinnerBriefRoot = z.object({
    winnerId: z.union([z.uuid().readonly(), z.null()]).readonly(),
    nickname: z.union([z.string(), z.null()]),
    anonymousNickname: z.string(),
    profileImageUrl: z.union([z.url(), z.null()]),
});
export const zGiveawayRoot = z.object({
    giveawayId: z.string().readonly(),
    broadcast: zBroadcastBriefRoot,
    productListingId: z.string(),
    product: zProductBriefRoot,
    dealerId: z.string(),
    shippingFee: zMoneyNonNegativeRoot,
    totalEntries: z.int().gte(0),
    eligibilityRule: z.enum(["ANYONE", "FOLLOWERS", "PURCHASERS"]),
    eligibilityLabel: z.optional(z.string()),
    drawingType: z.enum(["AUTO", "MANUAL"]),
    winner: z.optional(z.union([zWinnerBriefRoot, z.null()])),
    status: z.enum(["OPEN", "CLOSED", "DRAWN"]),
    createdAt: z.iso.datetime().readonly(),
    drawnAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    updatedAt: z.iso.datetime().readonly(),
});
export const zGiveawayWinnerRoot = z.object({
    giveawayId: z.string(),
    winner: zWinnerBriefRoot,
    drawnAt: z.iso.datetime(),
    announcedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
});
export const zAddressRoot = z.object({
    recipient: z.string(),
    phone: z.string(),
    postalCode: z.string(),
    addressLine1: z.string(),
    addressLine2: z.optional(z.union([z.string(), z.null()])),
    city: z.string(),
    province: z.string(),
    country: z.string(),
});
export const zAddress = zAddressRoot;
export const zMoneyRoot = z.object({
    amount: z.number().gte(0),
    currency: z.enum(["KRW"]),
});
export const zMoney = zMoneyRoot;
export const zDealerDashboardSummaryRoot22 = z.object({
    annualRevenue: zMoneyRoot,
    orderCounts: zDealerDashboardOrderCountsRoot,
    pendingReturnsCount: z.int().gte(0),
    pendingCancellationsCount: z.int().gte(0),
});
export const zDealerDashboardSummary = zDealerDashboardSummaryRoot22;
export const zAccountRoot = z.object({
    accountId: z.string().readonly(),
    accountCode: z.string().regex(/^[0-9]{4,6}$/),
    accountName: z.string().min(1).max(200),
    accountType: zAccountTypeRoot,
    balance: zMoneyRoot,
    dealerId: z.union([z.string(), z.null()]),
    dealer: z.union([zUserBriefRoot, z.null()]),
    balanceState: z.union([zBalanceStateRoot, z.null()]),
    isActive: z.boolean().default(true),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zAccountBalanceResponseRoot = z.object({
    accountId: z.string(),
    accountCode: z.string(),
    accountName: z.string(),
    accountType: zAccountTypeRoot,
    balance: zMoneyRoot,
    debitTotal: zMoneyRoot,
    creditTotal: zMoneyRoot,
    asOfDate: z.iso.datetime(),
});
export const zDealerBalanceResponseRoot2 = z.object({
    dealerId: z.string(),
    platformBalance: zMoneyRoot,
    pendingSettlements: zMoneyRoot,
    totalRevenue: zMoneyRoot,
    totalCommission: zMoneyRoot,
    asOfDate: z.iso.datetime(),
    lastUpdated: z.iso.datetime(),
});
export const zEntryLineRoot = z.object({
    accountId: z.string(),
    amount: zMoneyRoot,
    type: zEntryTypeRoot,
    accountName: z.string().readonly(),
    accountCode: z
        .string()
        .regex(/^[0-9]{4,6}$/)
        .readonly(),
    description: z.string().min(1).max(500),
});
export const zCreateJournalEntryRequestRoot = z.object({
    transactionId: z.string().min(1).max(255),
    transactionType: z.enum([
        "PAYMENT",
        "REFUND",
        "SETTLEMENT",
        "COMMISSION",
        "ADJUSTMENT",
        "REVERSAL",
        "BALANCE_TRANSITION",
    ]),
    entryLines: z.array(zEntryLineRoot).min(2),
    metadata: z.optional(z.union([z.record(z.string(), z.unknown()), z.null()])),
});
export const zJournalEntryRoot = z.object({
    journalEntryId: z.string().readonly(),
    transactionId: z.string(),
    transactionType: z.enum([
        "PAYMENT",
        "REFUND",
        "SETTLEMENT",
        "COMMISSION",
        "ADJUSTMENT",
        "REVERSAL",
        "BALANCE_TRANSITION",
    ]),
    entryLines: z.array(zEntryLineRoot).min(2),
    totalDebit: zMoneyRoot,
    totalCredit: zMoneyRoot,
    status: zEntryStatusRoot,
    postedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    metadata: z.optional(z.union([z.record(z.string(), z.unknown()), z.null()])),
    createdAt: z.iso.datetime().readonly(),
});
export const zTrialBalanceEntryRoot = z.object({
    accountId: z.string(),
    accountCode: z.string(),
    accountName: z.string(),
    accountType: zAccountTypeRoot,
    debitTotal: zMoneyRoot,
    creditTotal: zMoneyRoot,
    balance: zMoneyRoot,
});
export const zTrialBalanceResponseRoot2 = z.object({
    asOfDate: z.iso.datetime(),
    periodStart: z.optional(z.union([z.iso.datetime(), z.null()])),
    periodEnd: z.optional(z.union([z.iso.datetime(), z.null()])),
    accounts: z.array(zTrialBalanceEntryRoot),
    totalDebits: zMoneyRoot,
    totalCredits: zMoneyRoot,
    isBalanced: z.boolean(),
    generatedAt: z.iso.datetime(),
});
export const zOrderItemRoot = z.object({
    productListingId: z.string(),
    saleOrderNumber: z.optional(z.union([z.int().gte(1), z.null()])),
    purchaseNumber: z.optional(z.union([z.int().gte(1), z.null()])),
    product: zProductBriefRoot,
    productName: z.string(),
    quantity: z.int().gte(1),
    unitPrice: zMoneyRoot,
    subtotal: zMoneyRoot,
});
export const zOrderItemCreateRoot = z.object({
    productListingId: z.string(),
    productName: z.string(),
    quantity: z.int().gte(1),
    unitPrice: zMoneyRoot,
});
export const zOrderItemCreate = zOrderItemCreateRoot;
export const zOrderCreateRoot = z.object({
    buyerId: z.string(),
    dealerId: z.string(),
    broadcastId: z.optional(z.union([z.string(), z.null()])),
    productListingId: z.string(),
    orderType: z.enum(["AUCTION", "INSTANT_PURCHASE", "GROUP_BUY", "GIVEAWAY"]),
    orderItems: z.array(zOrderItemCreateRoot).min(1),
    totalAmount: zMoneyRoot,
    shippingAddressId: z.string(),
    paymentId: z.string(),
});
export const zOrderItemSummaryRoot = z.object({
    productId: z.string(),
    saleOrderNumber: z.optional(z.union([z.int().gte(1), z.null()])),
    purchaseNumber: z.optional(z.union([z.int().gte(1), z.null()])),
    productName: z.string(),
    productImageUrl: z.union([z.url(), z.null()]),
    quantity: z.int().gte(1),
    unitPrice: zMoneyRoot,
    subtotal: zMoneyRoot,
});
export const zCancellationRequestResponseRoot = z.object({
    cancellationId: z.string().readonly(),
    orderId: z.string().readonly(),
    orderItems: z.optional(z.array(zOrderItemSummaryRoot).readonly()),
    buyerId: z.string().readonly(),
    initiatedBy: z.enum(["BUYER", "SYSTEM", "ADMIN"]),
    reasonType: z.enum([
        "BUYER_CHANGED_MIND",
        "BUYER_FOUND_BETTER_PRICE",
        "DEALER_OUT_OF_STOCK",
        "DEALER_CANNOT_FULFILL",
        "PAYMENT_FAILED",
        "PAYMENT_EXPIRED",
        "SYSTEM_ERROR",
        "ADMIN_FORCE_CANCEL",
    ]),
    reasonDescription: z.optional(z.union([z.string().max(500), z.null()])),
    status: z.enum(["REQUESTED", "APPROVED", "COMPLETED", "REJECTED"]),
    rejectionReason: z.optional(z.union([z.string(), z.null()])),
    requestedAt: z.iso.datetime().readonly(),
    approvedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    rejectedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    completedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zCancellationRequestResponse = zCancellationRequestResponseRoot;
export const zBatchCancelOrderResultRoot = z.object({
    orderId: z.string(),
    success: z.boolean(),
    cancellation: z.optional(z.union([zCancellationRequestResponseRoot, z.null()])),
    error: z.optional(z.union([z.string(), z.null()])),
});
export const zBatchCancelOrderResult = zBatchCancelOrderResultRoot;
export const zBatchCancelOrdersResponseRoot = z.object({
    fulfillmentOrderId: z.string(),
    processedCount: z.int().gte(0),
    failedCount: z.int().gte(0),
    results: z.array(zBatchCancelOrderResultRoot),
});
export const zBatchCancelOrdersResponse = zBatchCancelOrdersResponseRoot;
export const zFulfillmentOrderCancellationResponseRoot = z.object({
    fulfillmentOrderId: z.string(),
    cancellationRequests: z.array(zCancellationRequestResponseRoot),
    skippedOrders: z.array(zFulfillmentOrderCancellationSkippedOrderRoot),
});
export const zFulfillmentOrderCancellationResponse = zFulfillmentOrderCancellationResponseRoot;
export const zOrderSummaryRoot = z.object({
    orderId: z.string().readonly(),
    fulfillmentOrderId: z.string().readonly(),
    orderNumber: z.string().readonly(),
    saleOrderNumber: z.optional(z.union([z.int().gte(1).readonly(), z.null()]).readonly()),
    purchaseNumber: z.optional(z.union([z.int().gte(1).readonly(), z.null()]).readonly()),
    orderType: z.enum(["AUCTION", "INSTANT_PURCHASE", "GROUP_BUY", "GIVEAWAY"]),
    auctionType: z.nullable(z.enum(["GENERAL", "FIRST_COME", "BLIND"])),
    saleType: zSaleTypeRoot,
    status: z.enum([
        "CREATED",
        "PAYMENT_REQUESTED",
        "AWAITING_REPAYMENT",
        "PAID",
        "SHIPPED",
        "DELIVERED",
        "CONFIRMED",
        "CANCELLED",
        "RETURNED",
        "EXPIRED",
    ]),
    paymentId: z.optional(z.union([z.string().readonly(), z.null()]).readonly()),
    totalAmount: zMoneyRoot,
    shippingFee: zMoneyNonNegativeRoot,
    shippingCharge: z.optional(z.union([zShippingChargeRoot, z.null()])),
    orderItems: z.array(zOrderItemSummaryRoot),
    buyer: zUserBriefRoot,
    dealer: zUserBriefRoot,
    broadcast: z.optional(z.union([zBroadcastBriefRoot, z.null()])),
    activeReturn: z.optional(z.union([zActiveReturnBriefRoot, z.null()])),
    activeCancellation: z.optional(z.union([zActiveCancellationBriefRoot, z.null()])),
    createdAt: z.iso.datetime().readonly(),
    paidAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    updatedAt: z.iso.datetime().readonly(),
});
export const zFulfillmentOrderRoot = z.object({
    fulfillmentOrderId: z.string().readonly(),
    broadcast: z.union([zBroadcastBriefRoot, z.null()]),
    buyer: zUserBriefRoot,
    dealer: zUserBriefRoot,
    salesChannel: z.enum(["BROADCAST", "MARKETPLACE"]),
    shippingFee: zMoneyNonNegativeRoot,
    shippingCharges: z.optional(z.array(zShippingChargeRoot).readonly()),
    combinedShippingGroupId: z.optional(z.union([z.uuid().readonly(), z.null()]).readonly()),
    parcelFulfillmentOrderIds: z.optional(z.array(z.uuid()).readonly()),
    parcelSummary: z.optional(zParcelSummaryRoot),
    combinedShippingGroupKey: z.string().readonly(),
    displayStatus: zFulfillmentOrderDisplayStatusRoot,
    annotation: zFulfillmentOrderAnnotationRoot,
    summary: z
        .object({
        total: z.int().gte(0),
        active: z.int().gte(0),
        cancelled: z.int().gte(0),
        returned: z.int().gte(0),
    })
        .readonly(),
    orders: z.array(zOrderSummaryRoot).readonly(),
    shippingAddress: z.optional(z.union([zDeliveryAddressRoot, z.null()])),
    shippingOption: z.optional(z.union([zShippingOptionRoot, z.null()])),
    carrier: z.optional(z.union([zCarrierRoot, z.null()])),
    trackingNumber: z.optional(z.union([z.string(), z.null()])),
    shippedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    deliveredAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    confirmedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    shippingFeeRefundedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    canRequestConfirmation: z.optional(z.boolean().readonly()),
    nextConfirmationRequestAvailableAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    autoConfirmScheduledAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    reversalBlockedBySettlement: z.optional(z.boolean().readonly()),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zFulfillmentOrder = zFulfillmentOrderRoot;
export const zBuyerNewOrderGroupResponseRoot = z.object({
    buyerId: z.uuid(),
    fulfillmentOrders: z.array(zFulfillmentOrderRoot),
});
export const zFulfillmentOrderSummaryRoot = z.object({
    fulfillmentOrderId: z.string().readonly(),
    broadcast: z.union([zBroadcastBriefRoot, z.null()]),
    buyer: zUserBriefRoot,
    dealer: zUserBriefRoot,
    salesChannel: z.enum(["BROADCAST", "MARKETPLACE"]),
    shippingFee: zMoneyNonNegativeRoot,
    shippingCharges: z.optional(z.array(zShippingChargeRoot).readonly()),
    shippingAddressId: z.optional(z.union([z.uuid().readonly(), z.null()]).readonly()),
    combinedShippingGroupId: z.optional(z.union([z.uuid().readonly(), z.null()]).readonly()),
    parcelSummary: z.optional(zParcelSummaryRoot),
    combinedShippingGroupKey: z.string().readonly(),
    displayStatus: zFulfillmentOrderDisplayStatusRoot,
    annotation: zFulfillmentOrderAnnotationRoot,
    summary: z
        .object({
        total: z.int().gte(0),
        active: z.int().gte(0),
        cancelled: z.int().gte(0),
        returned: z.int().gte(0),
    })
        .readonly(),
    orders: z.array(zOrderSummaryRoot).readonly(),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zFulfillmentOrderSummary = zFulfillmentOrderSummaryRoot;
export const zSalesHistoryBroadcastGroupRoot = z.object({
    broadcast: z.union([zBroadcastBriefRoot, z.null()]),
    fulfillmentOrders: z.array(zFulfillmentOrderSummaryRoot).readonly(),
});
export const zSalesHistoryBroadcastGroup = zSalesHistoryBroadcastGroupRoot;
export const zSalesHistoryDateGroupRoot = z.object({
    date: z.iso.date().readonly(),
    fulfillmentOrderCount: z.int().gte(0).readonly(),
    broadcastGroups: z.array(zSalesHistoryBroadcastGroupRoot).readonly(),
});
export const zSalesHistoryDateGroup = zSalesHistoryDateGroupRoot;
export const zOrderBundleSummaryRoot = z.object({
    broadcast: z.union([zBroadcastBriefRoot, z.null()]),
    buyer: z.union([zUserBriefRoot, z.null()]),
    orderCount: z.int().gte(1).readonly(),
    auctionWinCount: z.int().gte(0).readonly(),
    instantPurchaseCount: z.int().gte(0).readonly(),
    giveawayCount: z.int().gte(0).readonly(),
    groupBuyCount: z.int().gte(0).readonly(),
    totalAmount: zMoneyRoot,
    orders: z.array(zOrderSummaryRoot).readonly(),
    latestOrderAt: z.iso.datetime().readonly(),
});
export const zProductListingSnapshotRoot = z.object({
    snapshotId: z.uuid().readonly(),
    productListingId: z.uuid().readonly(),
    name: z.string().readonly(),
    description: z.optional(z.union([z.string(), z.null()])),
    images: z.array(zSnapshotImageRoot).readonly(),
    price: zMoneyRoot,
    shippingFee: zMoneyNonNegativeRoot,
    capturedAt: z.iso.datetime().readonly(),
});
export const zOrderRoot = z.object({
    orderId: z.string().readonly(),
    fulfillmentOrderId: z.string().readonly(),
    buyer: zUserBriefRoot,
    dealer: zUserBriefRoot,
    broadcast: z.union([zBroadcastBriefRoot, z.null()]),
    productListingId: z.string().readonly(),
    product: zProductBriefRoot,
    snapshot: z.optional(z.union([zProductListingSnapshotRoot, z.null()])),
    orderType: z.enum(["AUCTION", "INSTANT_PURCHASE", "GROUP_BUY", "GIVEAWAY"]),
    auctionType: z.nullable(z.enum(["GENERAL", "FIRST_COME", "BLIND"])),
    saleType: z.optional(zSaleTypeRoot),
    saleOrderNumber: z.optional(z.union([z.int().gte(1).readonly(), z.null()]).readonly()),
    purchaseNumber: z.optional(z.union([z.int().gte(1).readonly(), z.null()]).readonly()),
    orderItems: z.array(zOrderItemRoot).min(1).readonly(),
    totalAmount: zMoneyRoot,
    shippingFee: zMoneyNonNegativeRoot,
    shippingCharge: z.optional(z.union([zShippingChargeRoot, z.null()])),
    shippingAddress: zDeliveryAddressRoot,
    paymentId: z.string().readonly(),
    status: z.enum([
        "CREATED",
        "PAYMENT_REQUESTED",
        "AWAITING_REPAYMENT",
        "PAID",
        "SHIPPED",
        "DELIVERED",
        "CONFIRMED",
        "CANCELLED",
        "RETURNED",
        "EXPIRED",
    ]),
    shipment: z.optional(z.union([zShipmentRoot, z.null()])),
    activeReturn: z.optional(z.union([zActiveReturnBriefRoot, z.null()])),
    activeCancellation: z.optional(z.union([zActiveCancellationBriefRoot, z.null()])),
    createdAt: z.iso.datetime().readonly(),
    paidAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    shippedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    deliveredAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    confirmedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    shippingFeeRefundedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    updatedAt: z.iso.datetime().readonly(),
});
export const zReceivedCancellationRequestRoot = z.object({
    cancellationId: z.string().readonly(),
    order: zOrderBriefRoot,
    orderItems: z.optional(z.array(zOrderItemSummaryRoot).readonly()),
    expectedRefundAmount: zMoneyRoot,
    buyer: zUserBriefRoot,
    initiatedBy: z.enum(["BUYER", "SYSTEM", "ADMIN"]),
    reasonType: z.enum([
        "BUYER_CHANGED_MIND",
        "BUYER_FOUND_BETTER_PRICE",
        "DEALER_OUT_OF_STOCK",
        "DEALER_CANNOT_FULFILL",
        "PAYMENT_FAILED",
        "PAYMENT_EXPIRED",
        "SYSTEM_ERROR",
        "ADMIN_FORCE_CANCEL",
    ]),
    reasonDescription: z.optional(z.union([z.string().max(500), z.null()])),
    status: z.enum(["REQUESTED", "APPROVED", "COMPLETED", "REJECTED"]),
    rejectionReason: z.optional(z.union([z.string(), z.null()])),
    requestedAt: z.iso.datetime().readonly(),
    approvedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    rejectedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zReceivedCancellationRequest = zReceivedCancellationRequestRoot;
export const zReceivedOrdersAnnualSalesRoot = z.object({
    annualSales: zMoneyRoot,
});
export const zReturnItemRoot = z.object({
    productListingId: z.string(),
    productName: z.string(),
    productThumbnailUrl: z.union([z.string(), z.null()]),
    quantity: z.int().gte(1),
    unitPrice: z.optional(zMoneyRoot),
    subtotal: z.optional(zMoneyRoot),
    reason: z.string(),
});
export const zReturnRoot = z.object({
    returnId: z.string().readonly(),
    order: zOrderBriefRoot,
    buyer: zUserBriefRoot,
    dealerId: z.string().readonly(),
    requestedBy: z.string().readonly(),
    returnItems: z.array(zReturnItemRoot).min(1),
    returnReason: z.enum([
        "WRONG_DELIVERY",
        "MISSING_ITEMS",
        "DAMAGED_DEFECTIVE",
        "NOT_AS_DESCRIBED",
        "OTHER",
    ]),
    returnDescription: z.optional(z.union([z.string().max(1000), z.null()])),
    images: z.optional(z.array(z.url()).readonly()),
    returnShipmentId: z.optional(z.union([z.string(), z.null()])),
    status: z.enum(["REQUESTED", "APPROVED", "REJECTED", "REFUNDED"]),
    requestedAt: z.iso.datetime().readonly(),
    approvedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    rejectedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    rejectionReason: z.optional(z.union([z.string(), z.null()])),
    receivedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    refundedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    refundAmount: z.optional(zMoneyRoot),
    isPartialRefund: z.optional(z.boolean().readonly()),
    isRefundAmountFinal: z.optional(z.boolean().readonly()),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zFulfillmentOrderReturnResponseRoot = z.object({
    fulfillmentOrderId: z.string(),
    returnRequests: z.array(zReturnRoot),
    skippedOrders: z.array(zFulfillmentOrderReturnSkippedOrderRoot),
});
export const zFulfillmentOrderReturnResponse = zFulfillmentOrderReturnResponseRoot;
export const zPaymentRoot = z.object({
    paymentId: z.string().readonly(),
    order: zOrderBriefRoot,
    buyer: zUserBriefRoot,
    amount: zMoneyRoot,
    shippingFee: zMoneyNonNegativeRoot,
    refundedAmount: zMoneyNonNegativeRoot,
    status: zPaymentStatusRoot,
    gateway: zPaymentGatewayRoot,
    createdAt: z.iso.datetime().readonly(),
});
export const zPaymentDetailsRoot2 = z.object({
    paymentId: z.string().readonly(),
    order: zOrderBriefRoot,
    buyer: zUserBriefRoot,
    broadcastId: z.string(),
    broadcastTitle: z.optional(z.union([z.string(), z.null()])),
    amount: zMoneyRoot,
    shippingFee: zMoneyNonNegativeRoot,
    refundedAmount: zMoneyNonNegativeRoot,
    currency: z.enum(["KRW"]),
    paymentMethodId: z.optional(z.union([z.string(), z.null()])),
    paymentMethodType: z.optional(z.union([zPaymentMethodTypeRoot, z.null()])),
    lastFourDigits: z.optional(z.union([z.string().regex(/^[0-9]{4}$/), z.null()])),
    cardIssuer: z.optional(z.union([z.string(), z.null()])),
    gateway: zPaymentGatewayRoot,
    pgTransactionId: z.optional(z.union([z.string(), z.null()])),
    approvalNumber: z.optional(z.union([z.string(), z.null()])),
    status: zPaymentStatusRoot,
    initiatedAt: z.iso.datetime().readonly(),
    authorizedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    completedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    failedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    cancelledAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    failedReason: z.optional(z.union([z.string(), z.null()])),
});
export const zRefundRoot2 = z.object({
    refundId: z.string().readonly(),
    paymentId: z.string(),
    order: zOrderBriefRoot,
    refundAmount: zMoneyRoot,
    refundReason: zRefundReasonRoot,
    status: zRefundStatusRoot,
    gateway: zPaymentGatewayRoot,
    pgRefundTransactionId: z.optional(z.union([z.string(), z.null()])),
    requestedBy: z.string(),
    requester: zUserBriefRoot,
    dealer: zUserBriefRoot,
    requestedAt: z.iso.datetime().readonly(),
    processedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    failedReason: z.optional(z.union([z.string(), z.null()])),
    failedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
});
export const zRefundRequestRoot = z.object({
    orderId: z.uuid(),
    refundAmount: zMoneyRoot,
    refundReason: zRefundReasonRoot,
});
export const zBackofficeProductDetailsRoot = z.object({
    id: z.string().readonly(),
    dealerId: z.string(),
    dealer: zUserBriefRoot,
    broadcastId: z.optional(z.union([z.string(), z.null()])),
    name: z.string().min(1).max(200),
    description: z.optional(z.union([z.string().max(2000), z.null()])),
    categories: z.array(zCategorySummaryRoot),
    price: zMoneyRoot,
    quantity: z.int().gte(0),
    images: z.array(z.url()).min(1),
    status: z.enum(["DRAFT", "PUBLISHED", "ARCHIVED", "SOLD_OUT"]),
    salesChannel: z.enum(["BROADCAST", "MARKETPLACE"]),
    shippingFee: z.optional(zMoneyNonNegativeRoot),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
    deletedAt: z.union([z.iso.datetime().readonly(), z.null()]).readonly(),
    hiddenAt: z.union([z.iso.datetime().readonly(), z.null()]).readonly(),
    isBoltbCertified: z.boolean(),
});
export const zBackofficeProductDetails = zBackofficeProductDetailsRoot;
export const zBackofficeProductSummaryRoot = z.object({
    id: z.string(),
    dealerId: z.string(),
    dealer: zUserBriefRoot,
    name: z.string(),
    categories: z.array(zCategorySummaryRoot),
    price: zMoneyRoot,
    thumbnailImage: z.url(),
    status: z.enum(["DRAFT", "PUBLISHED", "ARCHIVED", "SOLD_OUT"]),
    salesChannel: z.enum(["BROADCAST", "MARKETPLACE"]),
    createdAt: z.iso.datetime(),
    quantity: z.int().gte(0),
    deletedAt: z.union([z.iso.datetime().readonly(), z.null()]).readonly(),
    hiddenAt: z.union([z.iso.datetime().readonly(), z.null()]).readonly(),
    isBoltbCertified: z.boolean(),
});
export const zBackofficeProductSummary = zBackofficeProductSummaryRoot;
export const zGroupBuyListingRoot = z.object({
    id: z.string().readonly(),
    productListingId: z.string(),
    product: zProductBriefRoot,
    dealerId: z.string(),
    broadcast: zBroadcastBriefRoot,
    totalSlots: z.int().gte(1),
    soldSlots: z.int().gte(0),
    availableSlots: z.int().gte(0).readonly(),
    slotPrice: zMoneyRoot,
    breakSchedule: z.iso.datetime(),
    status: z.enum(["PENDING", "ACTIVE", "BREAKING", "COMPLETED", "CANCELLED"]),
    createdAt: z.iso.datetime().readonly(),
});
export const zGroupBuyListingCreateRoot = z.object({
    dealerId: z.optional(z.string()),
    broadcastId: z.string(),
    totalSlots: z.int().gte(1),
    slotPrice: zMoneyRoot,
    breakSchedule: z.iso.datetime(),
});
export const zProductDetailsRoot = z.object({
    id: z.string().readonly(),
    dealerId: z.string(),
    dealer: zUserBriefRoot,
    broadcastId: z.optional(z.union([z.string(), z.null()])),
    name: z.string().min(1).max(200),
    description: z.optional(z.union([z.string().max(2000), z.null()])),
    categories: z.array(zCategorySummaryRoot),
    price: zMoneyRoot,
    quantity: z.int().gte(0),
    images: z.array(z.url()).min(1),
    status: z.enum(["DRAFT", "PUBLISHED", "ARCHIVED", "SOLD_OUT"]),
    salesChannel: z.enum(["BROADCAST", "MARKETPLACE"]),
    shippingFee: z.optional(zMoneyNonNegativeRoot),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
    hiddenAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    isBoltbCertified: z.boolean(),
});
export const zProductListingRoot = z.object({
    id: z.string().readonly(),
    dealerId: z.string(),
    broadcastId: z.optional(z.union([z.string(), z.null()])),
    name: z.string().min(1).max(200),
    description: z.optional(z.union([z.string().max(2000), z.null()])),
    productCategoryIds: z.array(z.uuid()),
    price: zMoneyRoot,
    shippingFee: zMoneyNonNegativeRoot,
    quantity: z.int().gte(0),
    images: z.array(z.url()).min(1),
    status: z.enum(["DRAFT", "PUBLISHED", "ARCHIVED", "SOLD_OUT"]),
    salesChannel: z.enum(["BROADCAST", "MARKETPLACE"]),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zProductListingCreateRoot = z.object({
    dealerId: z.optional(z.string()),
    broadcastId: z.optional(z.union([z.string(), z.null()])),
    name: z.string().min(1).max(200),
    description: z.optional(z.union([z.string().max(2000), z.null()])),
    productCategoryIds: z.array(z.uuid()).min(0),
    price: zMoneyRoot,
    shippingFee: z.optional(zMoneyNonNegativeRoot),
    quantity: z.int().gte(0),
    images: z.array(z.url()).min(1),
    salesChannel: z.enum(["BROADCAST", "MARKETPLACE"]),
});
export const zProductPricingUpdateRoot = z.object({
    dealerId: z.optional(z.string()),
    price: zMoneyRoot,
    quantity: z.int().gte(0),
    expectedQuantity: z.optional(z.int().gte(0)),
    shippingFee: z.optional(zMoneyNonNegativeRoot),
});
export const zProductSummaryRoot = z.object({
    id: z.string(),
    dealerId: z.string(),
    dealer: zUserBriefRoot,
    name: z.string(),
    categories: z.array(zCategorySummaryRoot),
    price: zMoneyRoot,
    thumbnailImage: z.url(),
    status: z.enum(["DRAFT", "PUBLISHED", "ARCHIVED", "SOLD_OUT"]),
    salesChannel: z.enum(["BROADCAST", "MARKETPLACE"]),
    createdAt: z.iso.datetime(),
    quantity: z.int().gte(0),
    hiddenAt: z.union([z.iso.datetime().readonly(), z.null()]).readonly(),
    isBoltbCertified: z.boolean(),
});
export const zServerPageProductsBlockRoot = z.object({
    type: z.literal("products"),
    title: z.optional(z.string().max(40)),
    categoryId: z.optional(z.uuid()),
    sort: z.union([
        z.literal("newest"),
        z.literal("oldest"),
        z.literal("lowestPrice"),
        z.literal("highestPrice"),
    ]),
    maxItems: z.int().gte(1).lte(30),
    layout: z.union([z.literal("grid"), z.literal("horizontal")]),
    items: z.array(zProductSummaryRoot),
});
export const zServerPageBlockRoot = z.union([
    zServerPageImageBlockRoot,
    zServerPageTextBlockRoot,
    zServerPageButtonBlockRoot,
    zServerPageSpacerBlockRoot,
    zServerPageProductsBlockRoot,
    zServerPageLiveBroadcastsBlockRoot,
    zServerPageScheduledBroadcastsBlockRoot,
    zServerPageNoticesBlockRoot,
]);
export const zServerPageRoot = z.object({
    slug: z.string().max(40),
    title: z.string().max(40),
    blocks: z.array(zServerPageBlockRoot),
});
export const zAuctionRoot = z.object({
    auctionId: z.string().readonly(),
    broadcast: zBroadcastBriefRoot,
    productListingId: z.string(),
    product: zProductBriefRoot,
    dealerId: z.string(),
    dealer: zUserBriefRoot,
    auctionType: z.enum(["GENERAL", "FIRST_COME", "BLIND"]),
    startingPrice: zMoneyRoot,
    currentPrice: zMoneyRoot,
    winner: z.optional(z.union([zWinnerBriefRoot, z.null()])),
    status: z.enum(["SCHEDULED", "ACTIVE", "ENDED", "UNSUCCESSFUL", "CANCELLED"]),
    startTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    endTime: z.iso.datetime(),
    extensionCount: z.int().gte(0),
    bidCount: z.int().gte(0),
    useAnonymousNicknames: z.boolean(),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zAuctionCreateRoot = z.object({
    broadcastId: z.string(),
    productListingId: z.string(),
    auctionType: z.enum(["GENERAL", "FIRST_COME", "BLIND"]),
    startingPrice: zMoneyRoot,
    useAnonymousNicknames: z.optional(z.boolean()),
});
export const zAuctionWithProductCreateRoot = z.object({
    broadcastId: z.string(),
    productName: z.string().min(1).max(200),
    imageUrl: z.url(),
    auctionType: z.enum(["GENERAL", "FIRST_COME", "BLIND"]),
    startingPrice: zMoneyRoot,
    shippingFee: z.optional(zMoneyNonNegativeRoot),
});
export const zBidRoot = z.object({
    bidId: z.string().readonly(),
    auctionId: z.string(),
    bidder: zBidderBriefRoot,
    bidAmount: zMoneyRoot,
    minimumBidPrice: zMoneyRoot,
    bidTime: z.iso.datetime(),
    isWinning: z.boolean(),
    isPrivate: z.boolean(),
    createdAt: z.iso.datetime(),
});
export const zAuctionDetailsRoot = z.object({
    auctionId: z.uuid(),
    broadcastId: z.string(),
    productListingId: z.uuid(),
    dealerId: z.uuid(),
    dealer: zUserBriefRoot,
    auctionType: z.enum(["GENERAL", "FIRST_COME", "BLIND"]),
    startingPrice: zMoneyRoot,
    currentPrice: zMoneyRoot,
    winner: z.optional(z.union([zWinnerBriefRoot, z.null()])),
    status: z.enum(["SCHEDULED", "ACTIVE", "ENDED", "UNSUCCESSFUL", "CANCELLED"]),
    startTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    endTime: z.iso.datetime(),
    extensionCount: z.int().gte(0),
    bidCount: z.int().gte(0),
    useAnonymousNicknames: z.boolean(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
    bids: z.array(zBidRoot),
    product: zProductBriefRoot,
    userParticipationStatus: z.optional(zAuctionUserParticipationStatusRoot),
});
export const zBidCreateRoot = z.object({
    bidAmount: zMoneyRoot,
});
export const zGroupBuySalesRoot = z.object({
    groupBuySalesId: z.string().readonly(),
    broadcastId: z.string(),
    groupBuyListingId: z.string(),
    dealerId: z.string(),
    totalSlots: z.int().gte(1),
    reservedSlots: z.int().gte(0),
    confirmedSlots: z.int().gte(0),
    availableSlots: z.int().gte(0),
    slotPrice: zMoneyRoot,
    breakScheduledTime: z.iso.datetime(),
    breakStartedTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    status: z.enum(["OPEN", "BREAK_IN_PROGRESS", "COMPLETED", "CANCELLED"]),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zGroupBuySalesCreateRoot = z.object({
    broadcastId: z.string(),
    groupBuyListingId: z.string(),
    totalSlots: z.int().gte(1),
    slotPrice: zMoneyRoot,
    breakScheduledTime: z.iso.datetime(),
});
export const zInstantPurchaseRoot = z.object({
    instantPurchaseId: z.string().readonly(),
    broadcast: z.optional(z.union([zBroadcastBriefRoot, z.null()])),
    productListingId: z.string(),
    product: zProductBriefRoot,
    dealerId: z.string(),
    dealer: zUserBriefRoot,
    price: zMoneyRoot,
    availableQuantity: z.int().gte(0),
    soldQuantity: z.int().gte(0),
    salesChannel: z.enum(["BROADCAST", "MARKETPLACE"]),
    status: z.enum(["AVAILABLE", "SOLD_OUT", "ENDED", "CANCELLED"]),
    buyers: z.array(zInstantPurchaseBuyerRoot).readonly(),
    createdAt: z.iso.datetime().readonly(),
    updatedAt: z.iso.datetime().readonly(),
});
export const zInstantPurchaseCreateRoot = z.object({
    broadcastId: z.optional(z.union([z.string(), z.null()])),
    productListingId: z.string(),
    price: zMoneyRoot,
    availableQuantity: z.int().gte(1),
    salesChannel: z.enum(["BROADCAST", "MARKETPLACE"]),
});
export const zInstantPurchaseWithProductCreateRoot = z.object({
    broadcastId: z.string(),
    productName: z.string().min(1).max(200),
    imageUrl: z.url(),
    price: zMoneyRoot,
    availableQuantity: z.int().gte(1),
    shippingFee: z.optional(zMoneyNonNegativeRoot),
});
export const zSlotReservationRoot2 = z.object({
    groupBuySalesId: z.string(),
    buyerId: z.string(),
    slotNumber: z.int().gte(1),
    slotPrice: zMoneyRoot,
    reservedAt: z.iso.datetime(),
    paymentConfirmed: z.boolean(),
});
export const zBackofficeSettlementSummaryRoot = z.object({
    settlementId: z.string().readonly(),
    settlementKind: z.optional(z.enum(["PRODUCT", "SHIPPING"])),
    shippingChargeId: z.optional(z.union([z.uuid().readonly(), z.null()]).readonly()),
    dealer: zBackofficeSettlementDealerRoot,
    order: zOrderBriefRoot,
    totalPaymentAmount: zMoneyRoot,
    platformFeeAmount: zMoneyRoot,
    pgFeeAmount: zMoneyRoot,
    shippingPgFeeAmount: zMoneyRoot,
    payoutAmount: zMoneyRoot,
    netPayoutAmount: zMoneyRoot,
    status: zSettlementStatusRoot,
    eligibilityDate: z.iso.datetime(),
    orderConfirmedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    paidAt: z.optional(z.union([z.iso.datetime(), z.null()])),
});
export const zBackofficeSettlementSummary = zBackofficeSettlementSummaryRoot;
export const zSettlementCreateRoot = z.object({
    dealerId: z.string(),
    orderId: z.uuid(),
    payoutAmount: zMoneyRoot,
    platformCommission: zMoneyRoot,
    totalPaymentAmount: zMoneyRoot,
    eligibilityDate: z.iso.datetime(),
});
export const zSettlementOffsetSummaryRoot = z.object({
    offsetId: z.string().readonly(),
    dealerId: z.string(),
    originalSettlementId: z.string(),
    refundId: z.string(),
    offsetAmount: zMoneyRoot,
    reason: z.string(),
    status: z.enum(["PENDING", "APPLIED", "WRITTEN_OFF"]),
    createdAt: z.iso.datetime().readonly(),
});
export const zSettlementOffsetSummary = zSettlementOffsetSummaryRoot;
export const zBackofficeSettlementDetailRoot = z.object({
    settlementId: z.string().readonly(),
    settlementKind: z.optional(z.enum(["PRODUCT", "SHIPPING"])),
    shippingChargeId: z.optional(z.union([z.uuid().readonly(), z.null()]).readonly()),
    dealer: zUserBriefRoot,
    order: zOrderBriefRoot,
    productAmount: zMoneyRoot,
    shippingFee: zMoneyRoot,
    payoutAmount: zMoneyRoot,
    netPayoutAmount: z.optional(z.union([zMoneyRoot, z.null()])),
    pgFeeAmount: zMoneyRoot,
    platformFeeAmount: zMoneyRoot,
    platformCommission: zMoneyRoot,
    shippingPgFeeAmount: zMoneyRoot,
    totalPaymentAmount: zMoneyRoot,
    status: zSettlementStatusRoot,
    eligibilityDate: z.iso.datetime(),
    orderConfirmedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    confirmedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    paidAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    paymentAgencyTransactionId: z.optional(z.union([z.string(), z.null()])),
    failureReason: z.optional(z.union([z.string(), z.null()])),
    errorCode: z.optional(z.union([z.string(), z.null()])),
    settlementAccount: z.optional(z.union([zSettlementAccountRoot2, z.null()])),
    offsets: z.array(zSettlementOffsetSummaryRoot),
    createdAt: z.iso.datetime().readonly(),
});
export const zBackofficeSettlementDetail = zBackofficeSettlementDetailRoot;
export const zSettlementRoot2 = z.object({
    settlementId: z.string().readonly(),
    settlementKind: z.optional(z.enum(["PRODUCT", "SHIPPING"])),
    shippingChargeId: z.optional(z.union([z.uuid().readonly(), z.null()]).readonly()),
    dealerId: z.string(),
    order: zOrderBriefRoot,
    payoutAmount: zMoneyRoot,
    netPayoutAmount: z.optional(z.union([zMoneyRoot, z.null()])),
    platformCommission: zMoneyRoot,
    totalPaymentAmount: zMoneyRoot,
    status: zSettlementStatusRoot,
    eligibilityDate: z.iso.datetime(),
    confirmedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    paidAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    paymentAgencyTransactionId: z.optional(z.union([z.string(), z.null()])),
    commissionTransactionId: z.optional(z.union([z.string(), z.null()])),
    failureReason: z.optional(z.union([z.string(), z.null()])),
    errorCode: z.optional(z.union([z.string(), z.null()])),
    offsets: z.optional(z.array(zSettlementOffsetSummaryRoot)),
    createdAt: z.iso.datetime().readonly(),
});
export const zSettlementOffsetListResponseRoot = z.object({
    data: z.array(zSettlementOffsetSummaryRoot),
});
export const zSettlementOffsetListResponse = zSettlementOffsetListResponseRoot;
export const zSettlementSummaryRoot = z.object({
    settlementId: z.string().readonly(),
    settlementKind: z.optional(z.enum(["PRODUCT", "SHIPPING"])),
    shippingChargeId: z.optional(z.union([z.uuid().readonly(), z.null()]).readonly()),
    totalPaymentAmount: z.optional(zMoneyRoot),
    dealerId: z.string(),
    order: zOrderBriefRoot,
    payoutAmount: zMoneyRoot,
    netPayoutAmount: z.optional(z.union([zMoneyRoot, z.null()])),
    status: zSettlementStatusRoot,
    eligibilityDate: z.iso.datetime(),
    orderConfirmedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    paidAt: z.optional(z.union([z.iso.datetime(), z.null()])),
});
export const zForegroundListingRoot = z.object({
    listingType: z.enum(["AUCTION", "IMMEDIATE_PURCHASE"]),
    productId: z.string(),
    productName: z.string(),
    productImageUrl: z.string(),
    auctionId: z.optional(z.uuid()),
    auctionType: z.optional(z.enum(["GENERAL", "FIRST_COME", "BLIND"])),
    instantPurchaseId: z.optional(z.uuid()),
    currentHighestBidPrice: z.optional(z.union([zMoneyRoot, z.null()])),
    currentMinimumBidPrice: z.optional(zMoneyRoot),
    currentPrice: z.optional(zMoneyRoot),
    currentHighestBidder: z.optional(z.union([zBidderBriefRoot, z.null()])),
    auctionStatus: z.optional(z.enum(["IN_PROGRESS", "SUCCESSFUL_BID", "NO_BID", "CANCELLED"])),
    successfulBidder: z.optional(z.union([zUserBriefRoot, z.null()])),
    winningBidAmount: z.optional(z.union([zMoneyRoot, z.null()])),
    endsAt: z.optional(z.iso.datetime()),
    displayUntil: z.optional(z.union([z.iso.datetime(), z.null()])),
    instantPurchaseStatus: z.optional(z.enum(["ON_SALE", "SOLD_OUT", "ENDED"])),
    salesPrice: z.optional(zMoneyRoot),
    remainingQuantity: z.optional(z.int()),
    totalQuantity: z.optional(z.int()),
});
export const zBroadcastScreenStateRoot = z.object({
    broadcastId: z.uuid(),
    version: z.int().gte(0),
    serverNow: z.iso.datetime(),
    foregroundListing: z.optional(z.union([zForegroundListingRoot, z.null()])),
    instantListings: z.optional(z.array(zForegroundListingRoot)),
    instantPurchaseLocked: z.optional(z.boolean()),
    instantListingLimit: z.optional(z.int().gte(1)),
    giveawaySummary: z.optional(z.union([zGiveawaySummaryRoot, z.null()])),
    groupPurchaseSummary: z.array(zGroupPurchaseSummaryRoot),
    topPurchasers: z.optional(z.array(zBroadcastTopPurchaserRoot)),
});
export const zPaginationMetaRoot = z.object({
    page: z.int().gte(1),
    pageSize: z.int().gte(1),
    totalItems: z.int().gte(0),
    totalPages: z.int().gte(0),
    hasNext: z.boolean(),
    hasPrevious: z.boolean(),
});
export const zPaginationMeta = zPaginationMetaRoot;
export const zSalesHistoryListResponseRoot = z.object({
    data: z.array(zSalesHistoryDateGroupRoot),
    meta: zPaginationMetaRoot,
});
export const zSalesHistoryListResponse = zSalesHistoryListResponseRoot;
export const zAdminAccountListRoot = z.object({
    data: z.array(zAdminAccountRoot),
    meta: zPaginationMetaRoot,
});
export const zAdminHistoryEntryListRoot = z.object({
    data: z.array(zAdminHistoryEntryRoot),
    meta: zPaginationMetaRoot,
});
export const zAdminLoginLockListRoot = z.object({
    data: z.array(zAdminLoginLockRoot),
    meta: zPaginationMetaRoot,
});
export const zAdminMemoEntryListRoot = z.object({
    data: z.array(zAdminMemoEntryRoot),
    meta: zPaginationMetaRoot,
});
export const zAdminMemoEntryList = zAdminMemoEntryListRoot;
export const zDealerHistoryEntryListRoot = z.object({
    data: z.array(zDealerHistoryEntryRoot),
    meta: zPaginationMetaRoot,
});
export const zPublicUserSearchListRoot2 = z.object({
    data: z.array(zPublicUserSearchResultRoot),
    meta: zPaginationMetaRoot,
});
export const zUserHistoryEntryListRoot = z.object({
    data: z.array(zUserHistoryEntryRoot),
    meta: zPaginationMetaRoot,
});
export const zAccountListResponseRoot = z.object({
    data: z.array(zAccountRoot),
    meta: zPaginationMetaRoot,
});
export const zDiscrepancyListResponseRoot = z.object({
    data: z.array(zDiscrepancyRoot),
    meta: zPaginationMetaRoot,
});
export const zJournalEntryListResponseRoot = z.object({
    data: z.array(zJournalEntryRoot),
    meta: zPaginationMetaRoot,
});
export const zReconciliationReportListResponseRoot = z.object({
    data: z.array(zReconciliationReportRoot),
    meta: zPaginationMetaRoot,
});
export const zBackofficeLiveSnapshotListRoot = z.object({
    data: z.array(zBackofficeLiveSnapshotRoot),
    meta: zPaginationMetaRoot,
});
export const zBackofficeDmConversationListRoot = z.object({
    data: z.array(zBackofficeDmConversationRoot),
    meta: zPaginationMetaRoot,
});
export const zBackofficeDmConversationList = zBackofficeDmConversationListRoot;
export const zBackofficeDmMessageListRoot = z.object({
    conversation: zBackofficeDmConversationDetailRoot,
    data: z.array(zBackofficeDmMessageRoot),
    meta: zPaginationMetaRoot,
});
export const zBackofficeDmMessageList = zBackofficeDmMessageListRoot;
export const zBackofficeMessageListRoot = z.object({
    data: z.array(zBackofficeMessageRoot),
    meta: zPaginationMetaRoot,
});
export const zBackofficeOpenChatMessageListRoot = z.object({
    data: z.array(zBackofficeOpenChatMessageRoot),
    meta: zPaginationMetaRoot,
});
export const zBackofficeOpenChatMessageList = zBackofficeOpenChatMessageListRoot;
export const zBackofficeOpenChatRoomListRoot = z.object({
    data: z.array(zBackofficeOpenChatRoomRoot),
    meta: zPaginationMetaRoot,
});
export const zBackofficeOpenChatRoomList = zBackofficeOpenChatRoomListRoot;
export const zChatRoomListRoot2 = z.object({
    data: z.array(zChatRoomRoot2),
    meta: zPaginationMetaRoot,
});
export const zMyChatRoomListRoot2 = z.object({
    data: z.array(zMyChatRoomRoot),
    meta: zPaginationMetaRoot,
});
export const zOpenChatRoomListRoot2 = z.object({
    data: z.array(zOpenChatRoomRoot2),
    meta: zPaginationMetaRoot,
});
export const zOpenChatRoomParticipantListRoot = z.object({
    data: z.array(zOpenChatRoomParticipantRoot),
    meta: zPaginationMetaRoot,
});
export const zBackofficeNotificationHistoryListRoot = z.object({
    data: z.array(zBackofficeNotificationHistoryItemRoot),
    meta: zPaginationMetaRoot,
});
export const zBroadcastPushSendHistoryListRoot = z.object({
    data: z.array(zBroadcastPushSendHistoryRoot),
    meta: zPaginationMetaRoot,
});
export const zNotificationDispatchListRoot = z.object({
    data: z.array(zNotificationDispatchRoot),
    meta: zPaginationMetaRoot,
});
export const zNotificationDispatchRecipientListRoot = z.object({
    data: z.array(zNotificationDispatchRecipientRoot),
    meta: zPaginationMetaRoot,
});
export const zBackofficeReturnListResponseRoot = z.object({
    data: z.array(zReturnRoot),
    meta: zPaginationMetaRoot,
});
export const zBackofficeReturnListResponse = zBackofficeReturnListResponseRoot;
export const zBackofficeShipmentListResponseRoot = z.object({
    data: z.array(zShipmentRoot),
    meta: zPaginationMetaRoot,
});
export const zBackofficeShipmentListResponse = zBackofficeShipmentListResponseRoot;
export const zFulfillmentOrderListResponseRoot = z.object({
    data: z.array(zFulfillmentOrderSummaryRoot),
    meta: zPaginationMetaRoot,
});
export const zFulfillmentOrderListResponse = zFulfillmentOrderListResponseRoot;
export const zOrderBundleListResponseRoot = z.object({
    data: z.array(zOrderBundleSummaryRoot),
    meta: zPaginationMetaRoot,
});
export const zOrderListResponseRoot = z.object({
    data: z.array(zOrderSummaryRoot),
    meta: zPaginationMetaRoot,
});
export const zReceivedCancellationRequestListResponseRoot = z.object({
    data: z.array(zReceivedCancellationRequestRoot),
    meta: zPaginationMetaRoot,
});
export const zReceivedCancellationRequestListResponse = zReceivedCancellationRequestListResponseRoot;
export const zReturnListResponseRoot = z.object({
    data: z.array(zReturnRoot),
    meta: zPaginationMetaRoot,
});
export const zBackofficePaymentListResponseRoot = z.object({
    data: z.array(zPaymentDetailsRoot2),
    meta: zPaginationMetaRoot,
});
export const zBackofficeRefundListResponseRoot = z.object({
    data: z.array(zRefundRoot2),
    meta: zPaginationMetaRoot,
});
export const zPointTransactionListRoot = z.object({
    data: z.array(zPointTransactionItemRoot),
    meta: zPaginationMetaRoot,
});
export const zPointTransactionList = zPointTransactionListRoot;
export const zBackofficeSettlementListResponseRoot = z.object({
    data: z.array(zBackofficeSettlementSummaryRoot),
    meta: zPaginationMetaRoot,
    nextCursor: z.optional(z.union([z.string(), z.null()])),
});
export const zBackofficeSettlementListResponse = zBackofficeSettlementListResponseRoot;
export const zBackofficeLoungeCommentListRoot = z.object({
    data: z.array(zBackofficeLoungeCommentRoot),
    meta: zPaginationMetaRoot,
});
export const zBackofficeLoungeCommentList = zBackofficeLoungeCommentListRoot;
export const zBackofficeLoungePostListRoot = z.object({
    data: z.array(zBackofficeLoungePostSummaryRoot),
    meta: zPaginationMetaRoot,
});
export const zBackofficeLoungePostList = zBackofficeLoungePostListRoot;
export const zBlockedUserListResponseRoot = z.object({
    data: z.array(zBlockedUserItemRoot),
    meta: zPaginationMetaRoot,
});
export const zFollowRelationshipListRoot = z.object({
    data: z.array(zFollowRelationshipRoot),
    meta: zPaginationMetaRoot,
});
export const zInvitationListRoot = z.object({
    data: z.array(zInvitationRoot),
    meta: zPaginationMetaRoot,
});
export const zLoungeCommentListRoot = z.object({
    data: z.array(zLoungeCommentRoot),
    meta: zPaginationMetaRoot,
});
export const zLoungePostListRoot = z.object({
    data: z.array(zLoungePostSummaryRoot),
    meta: zPaginationMetaRoot,
});
export const zMyLoungeCommentListRoot = z.object({
    data: z.array(zMyLoungeCommentRoot),
    meta: zPaginationMetaRoot,
});
export const zMyLoungeCommentList = zMyLoungeCommentListRoot;
export const zReferredUserListRoot = z.object({
    data: z.array(zReferredUserItemRoot),
    meta: zPaginationMetaRoot,
});
export const zReferredUserList = zReferredUserListRoot;
export const zUserReportListRoot = z.object({
    data: z.array(zUserReportRoot),
    meta: zPaginationMetaRoot,
});
export const zBackofficeBroadcastChatMessageListRoot = z.object({
    data: z.array(zChatMessageRoot),
    meta: zPaginationMetaRoot,
});
export const zBackofficeBroadcastChatMessageList = zBackofficeBroadcastChatMessageListRoot;
export const zBackofficeBroadcastListRoot = z.object({
    data: z.array(zBackofficeBroadcastRoot),
    meta: zPaginationMetaRoot,
});
export const zBroadcastTelemetrySessionListRoot = z.object({
    data: z.array(zBroadcastTelemetrySessionSummaryRoot),
    meta: zPaginationMetaRoot,
});
export const zBroadcastTelemetrySessionList = zBroadcastTelemetrySessionListRoot;
export const zPhoneNumberRoot = z.object({
    countryCode: z.string().regex(/^\+[1-9]\d{0,3}$/),
    number: z.string().regex(/^\d{8,15}$/),
    formatted: z.optional(z.string().readonly()),
});
export const zPhoneNumber = zPhoneNumberRoot;
export const zBackofficeUserAccountDetailsRoot = z.object({
    userId: z.string().readonly(),
    sellerId: z.string().readonly(),
    nickname: z.string(),
    email: z.optional(z.union([z.email(), z.null()])),
    phoneNumber: z.optional(z.union([zPhoneNumberRoot, z.null()])),
    phoneVerifiedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    consents: z.optional(z.array(zBackofficeUserAccountDetailsUserConsentItem).readonly()),
    socialProvider: z.enum(["GOOGLE", "APPLE", "KAKAO", "NAVER", "BOLTB"]),
    roles: z.array(zUserRoleRoot).min(1),
    status: z.enum(["ACTIVE", "SUSPENDED", "WITHDRAWN"]),
    profileImage: z.optional(z.union([z.url(), z.null()])),
    bio: z.optional(z.union([z.string(), z.null()])),
    dealerPermission: z.optional(z.union([zBackofficeUserAccountDetailsDealerPermissionDetails, z.null()])),
    suspensionDetails: z.optional(z.union([zBackofficeUserAccountDetailsSuspensionDetails, z.null()])),
    notificationSettings: z.optional(zNotificationSettingsRoot2),
    lastNicknameChangeAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    createdAt: z.iso.datetime().readonly(),
    lastAccessAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
});
export const zPhoneNumberUpdateRoot = z.object({
    phoneNumber: zPhoneNumberRoot,
});
export const zPhoneVerificationRoot = z.object({
    phoneNumber: zPhoneNumberRoot,
    verificationCode: z.string().regex(/^\d{6}$/),
});
export const zPhoneVerificationCodeRequestRoot = z.object({
    phoneNumber: zPhoneNumberRoot,
    agreedConsentTypes: z.optional(z.array(zConsentTypeRoot).max(10)),
});
export const zUserAccountListItemRoot = z.object({
    userId: z.string().readonly(),
    nickname: z.string(),
    email: z.optional(z.union([z.email(), z.null()])),
    phoneNumber: z.optional(z.union([zPhoneNumberRoot, z.null()])),
    phoneVerifiedAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    socialProvider: z.enum(["GOOGLE", "APPLE", "KAKAO", "NAVER", "BOLTB"]),
    roles: z.array(zUserRoleRoot).min(1),
    status: z.enum(["ACTIVE", "SUSPENDED", "WITHDRAWN"]),
    createdAt: z.iso.datetime().readonly(),
    lastAccessAt: z.iso.datetime().readonly(),
    deliveryAddressSummary: z
        .object({
        defaultPhoneNumber: z.union([z.string(), z.null()]),
        count: z.int().gte(0),
    })
        .readonly(),
    interestCategorySummary: z
        .object({
        setAt: z.union([z.iso.datetime(), z.null()]),
        count: z.int().gte(0),
    })
        .readonly(),
    appInstallationSummary: z
        .union([
        z
            .object({
            platform: z.enum(["ANDROID", "IOS"]),
            appVersion: z.string(),
            appUpdatedAt: z.iso.datetime(),
        })
            .readonly(),
        z.null(),
    ])
        .readonly(),
});
export const zUserAccountListRoot2 = z.object({
    data: z.array(zUserAccountListItemRoot),
    meta: zPaginationMetaRoot,
});
export const zUserDetailsRoot2 = z.object({
    userId: z.string().readonly(),
    socialProvider: z.enum(["GOOGLE", "APPLE", "KAKAO", "NAVER"]),
    email: z.optional(z.union([z.email(), z.null()])),
    phoneNumber: z.optional(z.union([zPhoneNumberRoot, z.null()])),
    nickname: z.string(),
    profileImage: z.optional(z.union([z.url(), z.null()])),
    bio: z.optional(z.union([z.string(), z.null()])),
    notificationSettings: zNotificationSettingsRoot2,
    roles: z.array(zUserRoleRoot).min(1),
    status: z.enum(["ACTIVE", "SUSPENDED", "WITHDRAWN"]),
    themeMode: zThemeModeRoot,
    lastNicknameChangeAt: z.optional(z.union([z.iso.datetime().readonly(), z.null()]).readonly()),
    createdAt: z.iso.datetime().readonly(),
    lastLoginAt: z.iso.datetime().readonly(),
    interestCategoryIds: z.array(z.uuid()).readonly(),
    shouldPromptInterestCategories: z.boolean().readonly(),
    interestPromptReason: z.union([z.string().readonly(), z.null()]).readonly(),
    isPhoneVerified: z.boolean().readonly(),
    hasPhoneNumberCollectionConsent: z.boolean().readonly(),
    requiresPhoneVerification: z.boolean().readonly(),
    requiresInterestCategories: z.boolean().readonly(),
    shouldShowProfileSetupGate: z.boolean().readonly(),
});
export const zUserLoginResponseRoot = z.object({
    userId: z.string().readonly(),
    agoraUserId: z.int().readonly(),
    socialProvider: z.enum(["GOOGLE", "APPLE", "KAKAO", "NAVER"]),
    email: z.optional(z.union([z.email(), z.null()])),
    phoneNumber: z.optional(z.union([zPhoneNumberRoot, z.null()])),
    nickname: z.string(),
    profileImage: z.optional(z.union([z.url(), z.null()])),
    roles: z.array(zUserRoleRoot).min(1),
    status: z.enum(["ACTIVE", "SUSPENDED", "WITHDRAWN"]),
    lastAccessAt: z.iso.datetime().readonly(),
    createdAt: z.iso.datetime().readonly(),
    accessToken: z.string(),
    refreshToken: z.string().readonly(),
    expiresIn: z.int().readonly(),
});
export const zSocialLoginResponseRoot = z.object({
    result: z.enum(["LOGGED_IN", "SIGNUP_REQUIRED", "DEALER_ROLE_REQUIRED"]),
    session: z.union([zUserLoginResponseRoot, z.null()]),
    signup: z.union([zSocialSignupTicketRoot, z.null()]),
});
export const zUserPhoneNumberRoot2 = z.object({
    userId: z.string().readonly(),
    phoneNumber: zPhoneNumberRoot,
    updatedAt: z.iso.datetime().readonly(),
});
export const zUserSummaryRoot = z.object({
    userId: z.string().readonly(),
    accessToken: z.optional(z.string()),
    email: z.optional(z.union([z.email(), z.null()])),
    phoneNumber: z.optional(z.union([zPhoneNumberRoot, z.null()])),
    nickname: z.string(),
    profileImage: z.optional(z.union([z.url(), z.null()])),
    roles: z.array(zUserRoleRoot).min(1),
    status: z.enum(["ACTIVE", "SUSPENDED", "WITHDRAWN"]),
    createdAt: z.iso.datetime().readonly(),
    refreshToken: z.optional(z.string().readonly()),
    expiresIn: z.optional(z.int().readonly()),
});
export const zVerificationResultRoot2 = z.object({
    userId: z.string().readonly(),
    phoneNumber: zPhoneNumberRoot,
    verified: z.boolean(),
    verifiedAt: z.iso.datetime().readonly(),
});
export const zProblemDetailsRoot = z.object({
    type: z.optional(z.url()),
    title: z.string(),
    status: z.int().gte(100).lte(599),
    detail: z.optional(z.string()),
    code: z.string(),
    userMessage: z.string(),
    instance: z.optional(z.string()),
    errors: z.optional(z.array(zFieldValidationErrorRoot)),
});
export const zProblemDetails = zProblemDetailsRoot;
export const zApiKeyPaymentAgencyRoot = z.unknown();
export const zBearerJwtRoot = z.unknown();
export const zCarrierWritable = zCarrierRoot;
export const zBlockingStatusWritable = zBlockingStatusRoot;
export const zProfileUnavailableReasonWritable = zProfileUnavailableReasonRoot;
export const zAnonymousNicknameWordKindWritable = zAnonymousNicknameWordKindRoot;
export const zShippingOptionWritable = zShippingOptionRoot;
export const zFulfillmentOrderDisplayStatusWritable = zFulfillmentOrderDisplayStatusRoot;
export const zFulfillmentOrderAnnotationWritable = zFulfillmentOrderAnnotationRoot;
export const zSaleTypeWritable = zSaleTypeRoot;
export const zAppUiSettingValueWritable = zAppUiSettingValueRoot;
export const zBalanceStateWritable = zBalanceStateRoot;
export const zKoreanBankWritable = zKoreanBankRoot;
export const zKpiDashboardPeriodWritable = zKpiDashboardPeriodRoot;
export const zKpiDashboardSalesChannelWritable = zKpiDashboardSalesChannelRoot;
export const zBackofficeCategoriesAllIconSettingsRootWritable = z.unknown();
export const zBackofficeCategoriesCollectionRootWritable = z.unknown();
export const zBackofficeCategoriesItemRootWritable = z.unknown();
export const zAllCategoryIconSettingRootWritable = z.object({
    imageUrl: z.union([z.url(), z.null()]),
});
export const zAllCategoryIconSettingWritable = zAllCategoryIconSettingRootWritable;
export const zCategoryRootWritable = z.object({
    name: z.string().min(1).max(255),
    description: z.optional(z.union([z.string(), z.null()])),
    displayOrder: z.int().gte(0),
    imageUrl: z.optional(z.union([z.url(), z.null()])),
    thumbnailImageUrl: z.optional(z.union([z.url(), z.null()])),
    parentId: z.optional(z.union([z.uuid(), z.null()])),
});
export const zCategoryWritable = zCategoryRootWritable;
export const zCategoryListRootWritable = z.object({
    categories: z.array(zCategoryRootWritable),
    totalCount: z.int().gte(0),
    allCategoryImageUrl: z.optional(z.union([z.url(), z.null()])),
});
export const zCategoryListWritable = zCategoryListRootWritable;
export const zCategorySummaryRootWritable = z.object({
    id: z.uuid(),
    name: z.string(),
    displayOrder: z.int(),
    imageUrl: z.optional(z.union([z.url(), z.null()])),
    thumbnailImageUrl: z.optional(z.union([z.url(), z.null()])),
    parentId: z.optional(z.union([z.uuid(), z.null()])),
});
export const zCategorySummaryWritable = zCategorySummaryRootWritable;
export const zBackofficeBannersCollectionRootWritable = z.unknown();
export const zBackofficeBannersItemRootWritable = z.unknown();
export const zBackofficeContentPagesCollectionRootWritable = z.unknown();
export const zBackofficeContentPagesItemRootWritable = z.unknown();
export const zBackofficeNoticesCollectionRootWritable = z.unknown();
export const zBackofficeNoticesItemRootWritable = z.unknown();
export const zBannerRootWritable = z.object({
    title: z.string().max(100),
    imageUrl: z.url().max(500),
    linkUrl: z.optional(z.union([z.url().max(500), z.null()])),
    displayOrder: z.int().gte(0),
    displayFrom: z.optional(z.union([z.iso.datetime(), z.null()])),
    displayUntil: z.optional(z.union([z.iso.datetime(), z.null()])),
    status: zBannerStatusRoot,
});
export const zBannerListRootWritable = z.object({
    banners: z.array(zBannerRootWritable),
    totalCount: z.int().gte(0),
});
export const zContentPageRootWritable = z.object({
    title: z.string().max(200),
    contentHtml: z.string(),
    attachments: z.array(zContentPageAttachmentRoot).max(10),
    isPublished: z.boolean(),
    publicPath: z.string(),
});
export const zContentPageListRootWritable = z.object({
    pages: z.array(zContentPageRootWritable),
    totalCount: z.int().gte(0),
});
export const zNoticeRootWritable = z.object({
    title: z.string().max(200),
    contentHtml: z.string(),
    isPublished: z.boolean(),
    isPinned: z.boolean(),
    publishedAt: z.union([z.iso.datetime(), z.null()]),
    popupEnabled: z.boolean(),
    popupStartAt: z.union([z.iso.datetime(), z.null()]),
    popupEndAt: z.union([z.iso.datetime(), z.null()]),
    popupImageUrl: z.union([z.url().max(1000), z.null()]),
    popupDismissPolicy: zNoticePopupDismissPolicyRoot,
    popupPriority: z.int().gte(0),
    bannerEnabled: z.boolean(),
    bannerImageUrl: z.union([z.url().max(1000), z.null()]),
    bannerPriority: z.int().gte(0),
    categoryIds: z.array(z.uuid()).max(50),
});
export const zNoticeListRootWritable = z.object({
    notices: z.array(zNoticeRootWritable),
    totalCount: z.int().gte(0),
});
export const zSalesHistoryBroadcastGroupRootWritable = z.record(z.string(), z.never());
export const zSalesHistoryBroadcastGroupWritable = zSalesHistoryBroadcastGroupRootWritable;
export const zSalesHistoryDateGroupRootWritable = z.record(z.string(), z.never());
export const zSalesHistoryDateGroupWritable = zSalesHistoryDateGroupRootWritable;
export const zSalesHistoryListResponseRootWritable = z.object({
    data: z.array(zSalesHistoryDateGroupRootWritable),
    meta: zPaginationMetaRoot,
});
export const zSalesHistoryListResponseWritable = zSalesHistoryListResponseRootWritable;
export const zAdminAuthLoginRootWritable = z.unknown();
export const zAdminAuthRefreshRootWritable = z.unknown();
export const zAuthDealerProxyTokensRootWritable = z.unknown();
export const zBackofficeAdminAccountsIdRootWritable = z.unknown();
export const zBackofficeAdminAccountsRootWritable = z.unknown();
export const zBackofficeUsersUserIdAdminMemosRootWritable = z.unknown();
export const zBackofficeUsersUserIdForceChangeNicknameRootWritable = z.unknown();
export const zBackofficeUsersUserIdInterestCategoriesRepromptRequestsRootWritable = z.unknown();
export const zBackofficeUsersUserIdInterestCategoriesRootWritable = z.unknown();
export const zBackofficeUsersUserIdProfileImagesRootWritable = z.unknown();
export const zBackofficeUsersUserIdRootWritable = z.unknown();
export const zBackofficeUsersRootWritable = z.unknown();
export const zPublicAuthKakaoLoginRootWritable = z.unknown();
export const zPublicAuthSocialLoginRootWritable = z.unknown();
export const zPublicAuthSocialSignupRootWritable = z.unknown();
export const zUsersInterestCategoriesRootWritable = z.unknown();
export const zUsersItemRootWritable = z.unknown();
export const zUsersLoginRootWritable = z.unknown();
export const zUsersPhoneNumberRootWritable = z.unknown();
export const zUsersPhoneVerificationCodesRootWritable = z.unknown();
export const zUsersRegisterRootWritable = z.unknown();
export const zUsersUserIdWithdrawRootWritable = z.unknown();
export const zUsersVerifyPhoneRootWritable = z.unknown();
export const zBackofficeUserInterestCategoriesRootWritable = z.unknown();
export const zDealerPermissionResultRootWritable = z.unknown();
export const zDeviceTokenRootWritable = z.unknown();
export const zNotificationSettingsRootWritable = z.unknown();
export const zProfileSummaryRootWritable = z.unknown();
export const zUserAccountListRootWritable = z.unknown();
export const zUserAccountStatusRootWritable = z.unknown();
export const zUserDetailsRootWritable = z.unknown();
export const zUserInterestCategoriesRootWritable = z.unknown();
export const zUserPhoneNumberRootWritable = z.unknown();
export const zVerificationResultRootWritable = z.unknown();
export const zAdminAccountRootWritable = z.object({
    username: z
        .string()
        .min(4)
        .max(50)
        .regex(/^[a-zA-Z0-9_]+$/),
    adminLevel: zAdminLevelRoot,
    status: zAdminStatusRoot,
});
export const zAdminAccountCreateRootWritable = z.object({
    username: z
        .string()
        .min(4)
        .max(50)
        .regex(/^[a-zA-Z0-9_]+$/),
    password: z.string().min(8),
    adminLevel: zAdminLevelRoot,
});
export const zAdminAccountListRootWritable = z.object({
    data: z.array(zAdminAccountRootWritable),
    meta: zPaginationMetaRoot,
});
export const zAdminHistoryEntryRootWritable = z.object({
    actorType: zOperationActorTypeRoot,
    domain: zOperationDomainRoot,
});
export const zAdminHistoryEntryListRootWritable = z.object({
    data: z.array(zAdminHistoryEntryRootWritable),
    meta: zPaginationMetaRoot,
});
export const zAdminLoginLockListRootWritable = z.object({
    data: z.array(z.unknown()),
    meta: zPaginationMetaRoot,
});
export const zAdminLoginRequestRootWritable = z.object({
    username: z
        .string()
        .min(4)
        .max(50)
        .regex(/^[a-zA-Z0-9_]+$/),
    password: z.string().min(8),
});
export const zAdminLoginResponseRootWritable = z.object({
    admin: zAdminAccountRootWritable,
});
export const zAdminMemoEntryRootWritable = z.object({
    content: z.string(),
});
export const zAdminMemoEntryWritable = zAdminMemoEntryRootWritable;
export const zAdminMemoEntryListRootWritable = z.object({
    data: z.array(zAdminMemoEntryRootWritable),
    meta: zPaginationMetaRoot,
});
export const zAdminMemoEntryListWritable = zAdminMemoEntryListRootWritable;
export const zBackofficeUserAccountDetailsSuspensionDetailsWritable = z.object({
    type: z.enum(["TEMPORARY", "PERMANENT"]),
    reason: z.string(),
    expiresAt: z.optional(z.union([z.iso.datetime(), z.null()])),
});
export const zBackofficeUserAccountDetailsUserConsentItemWritable = z.object({
    consentType: zConsentTypeRoot,
});
export const zDealerHistoryEntryRootWritable = z.object({
    channel: zDealerHistoryChannelRoot,
    actorType: zDealerHistoryActorTypeRoot,
    domain: zOperationDomainRoot,
});
export const zDealerHistoryEntryListRootWritable = z.object({
    data: z.array(zDealerHistoryEntryRootWritable),
    meta: zPaginationMetaRoot,
});
export const zDealerPermissionResultRoot2Writable = z.object({
    status: z.enum(["GRANTED", "REVOKED"]),
});
export const zDeviceTokenRoot2Writable = z.object({
    token: z.string(),
    platform: z.enum(["ANDROID", "IOS"]),
    installationId: z.string(),
    isActive: z.boolean(),
});
export const zDeviceTokenWritable = zDeviceTokenRoot2Writable;
export const zInterestCategoryRepromptRequestRootWritable = z.object({
    scope: z.enum(["GLOBAL", "USER"]),
    userId: z.union([z.string(), z.null()]),
    reason: z.string().min(1).max(300),
    source: z.enum([
        "ADMIN",
        "CATEGORY_CREATED",
        "CATEGORY_UPDATED",
        "CATEGORY_DELETED",
    ]),
    requestedBy: z.union([z.string(), z.null()]),
});
export const zInterestCategoryRepromptRequestWritable = zInterestCategoryRepromptRequestRootWritable;
export const zBackofficeUserInterestCategoriesRoot2Writable = z.object({
    categoryIds: z.array(z.uuid()).max(50),
    setAt: z.union([z.iso.datetime(), z.null()]),
    shouldPrompt: z.boolean(),
    promptReason: z.union([z.string(), z.null()]),
    pendingRequest: z.union([
        zInterestCategoryRepromptRequestRootWritable,
        z.null(),
    ]),
    latestGlobalRequest: z.union([
        zInterestCategoryRepromptRequestRootWritable,
        z.null(),
    ]),
});
export const zBackofficeUserInterestCategoriesWritable = zBackofficeUserInterestCategoriesRoot2Writable;
export const zNotificationSettingsRoot2Writable = z.object({
    broadcastNotifications: z.boolean(),
    messageNotifications: z.boolean(),
    orderNotifications: z.boolean(),
    promotionNotifications: z.boolean(),
    loungeNotifications: z.boolean(),
    channels: z.array(z.enum(["PUSH", "IN_APP"])).min(1),
    quietHoursEnabled: z.boolean(),
    quietHoursStart: z.union([z.iso.time(), z.null()]),
    quietHoursEnd: z.union([z.iso.time(), z.null()]),
});
export const zProfileSummaryRoot2Writable = z.object({
    nickname: z.string(),
    profileImage: z.optional(z.union([z.url(), z.null()])),
    bio: z.optional(z.union([z.string(), z.null()])),
    themeMode: zThemeModeRoot,
});
export const zUserAccountStatusRoot2Writable = z.object({
    status: z.enum(["ACTIVE", "SUSPENDED", "WITHDRAWN"]),
    suspendedBy: z.optional(z.union([z.string(), z.null()])),
    suspensionReason: z.optional(z.union([z.string(), z.null()])),
    suspensionType: z.optional(z.nullable(z.enum(["TEMPORARY", "PERMANENT"]))),
    suspensionExpiresAt: z.optional(z.union([z.iso.datetime(), z.null()])),
});
export const zUserHistoryEntryRootWritable = z.object({
    category: zUserHistoryCategoryRoot,
    actorType: zUserHistoryActorTypeRoot,
});
export const zUserHistoryEntryListRootWritable = z.object({
    data: z.array(zUserHistoryEntryRootWritable),
    meta: zPaginationMetaRoot,
});
export const zUserInterestCategoriesRoot2Writable = z.object({
    categoryIds: z.array(z.uuid()).max(50),
});
export const zUserInterestCategoriesWritable = zUserInterestCategoriesRoot2Writable;
export const zAccountsRootWritable = z.unknown();
export const zAccounts7BaccountId7dRootWritable = z.unknown();
export const zJournalEntriesRootWritable = z.unknown();
export const zJournalEntries7BentryId7dRootWritable = z.unknown();
export const zJournalEntries7BentryId7dReverseRootWritable = z.unknown();
export const zReconciliationRootWritable = z.unknown();
export const zReconciliation7BreportId7dRootWritable = z.unknown();
export const zReconciliationControlAccountsRootWritable = z.unknown();
export const zAccountResponseRootWritable = z.unknown();
export const zJournalEntryResponseRootWritable = z.unknown();
export const zReconciliationReportResponseRootWritable = z.unknown();
export const zAccountRootWritable = z.object({
    accountCode: z.string().regex(/^[0-9]{4,6}$/),
    accountName: z.string().min(1).max(200),
    accountType: zAccountTypeRoot,
    balance: zMoneyRoot,
    dealerId: z.union([z.string(), z.null()]),
    isActive: z.boolean().default(true),
});
export const zAccountListResponseRootWritable = z.object({
    data: z.array(zAccountRootWritable),
    meta: zPaginationMetaRoot,
});
export const zDiscrepancyRootWritable = z.object({
    "discrepancy-type": z.string(),
    "affected-records": z.array(z.string()).min(1),
    severity: zDiscrepancySeverityRoot,
    description: z.string().min(1).max(1000),
});
export const zDiscrepancyListResponseRootWritable = z.object({
    data: z.array(zDiscrepancyRootWritable),
    meta: zPaginationMetaRoot,
});
export const zEntryLineRootWritable = z.object({
    accountId: z.string(),
    amount: zMoneyRoot,
    type: zEntryTypeRoot,
    description: z.string().min(1).max(500),
});
export const zCreateJournalEntryRequestRootWritable = z.object({
    transactionId: z.string().min(1).max(255),
    transactionType: z.enum([
        "PAYMENT",
        "REFUND",
        "SETTLEMENT",
        "COMMISSION",
        "ADJUSTMENT",
        "REVERSAL",
        "BALANCE_TRANSITION",
    ]),
    entryLines: z.array(zEntryLineRootWritable).min(2),
    metadata: z.optional(z.union([z.record(z.string(), z.unknown()), z.null()])),
});
export const zJournalEntryRootWritable = z.object({
    transactionId: z.string(),
    transactionType: z.enum([
        "PAYMENT",
        "REFUND",
        "SETTLEMENT",
        "COMMISSION",
        "ADJUSTMENT",
        "REVERSAL",
        "BALANCE_TRANSITION",
    ]),
    entryLines: z.array(zEntryLineRootWritable).min(2),
    totalDebit: zMoneyRoot,
    totalCredit: zMoneyRoot,
    status: zEntryStatusRoot,
    metadata: z.optional(z.union([z.record(z.string(), z.unknown()), z.null()])),
});
export const zJournalEntryListResponseRootWritable = z.object({
    data: z.array(zJournalEntryRootWritable),
    meta: zPaginationMetaRoot,
});
export const zReconciliationReportRootWritable = z.object({
    periodStart: z.iso.datetime(),
    periodEnd: z.iso.datetime(),
    targetContext: z.enum(["PAYMENT", "SETTLEMENT", "CONTROL_ACCOUNT"]),
    status: zReconciliationStatusRoot,
    totalLedgerEntries: z.int().gte(0),
    totalExternalRecords: z.int().gte(0),
    discrepancyCount: z.int().gte(0),
    metadata: z.optional(z.union([z.record(z.string(), z.unknown()), z.null()])),
});
export const zReconciliationReportListResponseRootWritable = z.object({
    data: z.array(zReconciliationReportRootWritable),
    meta: zPaginationMetaRoot,
});
export const zBackofficeLiveSnapshotsCollectionRootWritable = z.unknown();
export const zLiveSnapshotsCollectionRootWritable = z.unknown();
export const zLiveSnapshotsItemRootWritable = z.unknown();
export const zLiveSnapshotSummaryRootWritable = z.object({
    imageUrl: z.url(),
    broadcastTitle: z.string(),
    productName: z.string(),
    categories: z.optional(z.array(zLiveSnapshotCategoryRoot)),
    dealerMemo: z.optional(z.union([z.string(), z.null()])),
    buyer: z.union([zLiveSnapshotBuyerRoot, z.null()]),
});
export const zLiveSnapshotListRootWritable = z.object({
    data: z.array(zLiveSnapshotSummaryRootWritable),
    nextCursor: z.union([z.string(), z.null()]),
});
export const zBackofficeOpenChatRoomsCollectionRootWritable = z.unknown();
export const zBackofficeOpenChatRoomsItemKickedUsersCollectionRootWritable = z.unknown();
export const zBackofficeOpenChatRoomsItemUpdateCategoryRootWritable = z.unknown();
export const zBackofficeOpenChatRoomsItemUpdateThumbnailRootWritable = z.unknown();
export const zBackofficeOpenChatRoomsItemUpdateTitleRootWritable = z.unknown();
export const zBackofficeSupportChatsCollectionRootWritable = z.unknown();
export const zBackofficeSupportChatsItemMessagesCollectionRootWritable = z.unknown();
export const zChatRoomsMessagesCollectionRootWritable = z.unknown();
export const zChatRoomsCollectionRootWritable = z.unknown();
export const zChatRoomsItemImagesRootWritable = z.unknown();
export const zChatRoomsItemRootWritable = z.unknown();
export const zDealerChatRoomsCollectionRootWritable = z.unknown();
export const zMyChatRoomsCollectionRootWritable = z.unknown();
export const zOpenChatRoomsMessagesCollectionRootWritable = z.unknown();
export const zOpenChatRoomsMessagesImageRootWritable = z.unknown();
export const zOpenChatRoomsCollectionRootWritable = z.unknown();
export const zOpenChatRoomsCommunityHomeRootWritable = z.unknown();
export const zOpenChatRoomsItemJoinRootWritable = z.unknown();
export const zOpenChatRoomsItemLeaveRootWritable = z.unknown();
export const zOpenChatRoomsItemRootWritable = z.unknown();
export const zChatRoomRootWritable = z.unknown();
export const zChatRoomListRootWritable = z.unknown();
export const zMessageListRootWritable = z.unknown();
export const zMyChatRoomListRootWritable = z.unknown();
export const zOpenChatRoomRootWritable = z.unknown();
export const zOpenChatRoomListRootWritable = z.unknown();
export const zBackofficeDmConversationRootWritable = z.record(z.string(), z.never());
export const zBackofficeDmConversationWritable = zBackofficeDmConversationRootWritable;
export const zBackofficeDmConversationDetailRootWritable = z.record(z.string(), z.never());
export const zBackofficeDmConversationDetailWritable = zBackofficeDmConversationDetailRootWritable;
export const zBackofficeDmConversationListRootWritable = z.object({
    data: z.array(zBackofficeDmConversationRootWritable),
    meta: zPaginationMetaRoot,
});
export const zBackofficeDmConversationListWritable = zBackofficeDmConversationListRootWritable;
export const zBackofficeDmMessageRootWritable = z.object({
    messageType: z.enum(["TEXT", "IMAGE", "SYSTEM"]),
    content: z.union([z.string(), z.null()]),
    imageUrls: z.optional(z.array(z.string())),
});
export const zBackofficeDmMessageWritable = zBackofficeDmMessageRootWritable;
export const zBackofficeDmMessageListRootWritable = z.object({
    conversation: zBackofficeDmConversationDetailRootWritable,
    data: z.array(zBackofficeDmMessageRootWritable),
    meta: zPaginationMetaRoot,
});
export const zBackofficeDmMessageListWritable = zBackofficeDmMessageListRootWritable;
export const zBackofficeMessageRootWritable = z.object({
    chatType: z.enum(["BROADCAST_CHAT", "PRIVATE_DM"]),
    messageType: z.enum(["TEXT", "IMAGE", "SYSTEM"]),
    content: z.union([z.string(), z.null()]),
    imageUrls: z.optional(z.array(z.string())),
});
export const zBackofficeMessageListRootWritable = z.object({
    data: z.array(zBackofficeMessageRootWritable),
    meta: zPaginationMetaRoot,
});
export const zBackofficeOpenChatMessageRootWritable = z.object({
    messageType: z.enum(["TEXT_MESSAGE", "IMAGE_MESSAGE"]),
});
export const zBackofficeOpenChatMessageWritable = zBackofficeOpenChatMessageRootWritable;
export const zBackofficeOpenChatMessageListRootWritable = z.object({
    data: z.array(zBackofficeOpenChatMessageRootWritable),
    meta: zPaginationMetaRoot,
});
export const zBackofficeOpenChatMessageListWritable = zBackofficeOpenChatMessageListRootWritable;
export const zBackofficeOpenChatRoomRootWritable = z.object({
    title: z.string(),
    thumbnail: z.optional(z.union([z.url(), z.null()])),
    categoryId: z.string(),
    categoryName: z.string(),
    currentParticipantCount: z.int().gte(0),
    status: z.enum(["OPEN", "CLOSED", "ARCHIVED"]),
});
export const zBackofficeOpenChatRoomWritable = zBackofficeOpenChatRoomRootWritable;
export const zBackofficeOpenChatRoomListRootWritable = z.object({
    data: z.array(zBackofficeOpenChatRoomRootWritable),
    meta: zPaginationMetaRoot,
});
export const zBackofficeOpenChatRoomListWritable = zBackofficeOpenChatRoomListRootWritable;
export const zOpenChatRoomRoot2Writable = z.object({
    title: z.string(),
    thumbnail: z.optional(z.union([z.url(), z.null()])),
    maxParticipants: z.int().gte(1),
    currentParticipantCount: z.int().gte(0),
    status: z.enum(["OPEN", "CLOSED", "ARCHIVED"]),
    noticeBanner: z.optional(z.union([z.string(), z.null()])),
});
export const zOpenChatRoomListRoot2Writable = z.object({
    data: z.array(zOpenChatRoomRoot2Writable),
    meta: zPaginationMetaRoot,
});
export const zTypeFilterQueryRootWritable = z.unknown();
export const zBackofficeBroadcastPushSendHistoriesCollectionRootWritable = z.unknown();
export const zBackofficeNotificationDispatchesCollectionRootWritable = z.unknown();
export const zBackofficeNotificationDispatchesPreviewRootWritable = z.unknown();
export const zBackofficeNotificationOperationSettingsRootWritable = z.unknown();
export const zBackofficeNotificationSettingItemsItemRootWritable = z.unknown();
export const zBackofficeNotificationTemplatesItemRootWritable = z.unknown();
export const zNotificationPreferencesItemRootWritable = z.unknown();
export const zNotificationsUnreadCollectionRootWritable = z.unknown();
export const zNotificationsCollectionRootWritable = z.unknown();
export const zNotificationsItemRootWritable = z.unknown();
export const zNotificationRootWritable = z.unknown();
export const zNotificationListRootWritable = z.unknown();
export const zNotificationPreferenceRootWritable = z.unknown();
export const zBroadcastPushSendHistoryRootWritable = z.object({
    title: z.string().min(1).max(100),
    body: z.string().min(1).max(500),
});
export const zBroadcastPushSendHistoryListRootWritable = z.object({
    data: z.array(zBroadcastPushSendHistoryRootWritable),
    meta: zPaginationMetaRoot,
});
export const zNotificationRoot2Writable = z.object({
    sourceEventId: z.optional(z.union([z.string(), z.null()])),
    type: zNotificationTypeRoot,
    title: z.string().min(1).max(100),
    body: z.string().min(1).max(500),
    data: z.optional(z.union([z.record(z.string(), z.unknown()), z.null()])),
    channel: zNotificationChannelRoot,
    inboxCategory: z.optional(zNotificationInboxCategoryRoot),
});
export const zNotificationDispatchRootWritable = z.record(z.string(), z.never());
export const zNotificationDispatchListRootWritable = z.object({
    data: z.array(zNotificationDispatchRootWritable),
    meta: zPaginationMetaRoot,
});
export const zNotificationDispatchRecipientListRootWritable = z.object({
    data: z.array(z.unknown()),
    meta: zPaginationMetaRoot,
});
export const zNotificationListRoot2Writable = z.object({
    notifications: z.array(zNotificationRoot2Writable),
    unreadCount: z.int().gte(0),
    totalCount: z.int().gte(0),
    page: z.optional(z.union([z.int().gte(1), z.null()])),
    inboxTabs: z.optional(z.array(zNotificationInboxTabRoot)),
});
export const zNotificationOperationSettingsRootWritable = z.object({
    osPermissionShowUnknown: z.boolean(),
    osPermissionJudgmentDays: z.int().gte(1).lte(365),
    permissionPromptEnabled: z.boolean(),
    permissionPromptReplaceFirstRun: z.boolean(),
    permissionPromptIntervalDays: z.int().gte(1).lte(365),
    permissionPromptMaxCount: z.int().gte(1).lte(20),
    permissionPromptUndeterminedTitle: z.string().min(1).max(40),
    permissionPromptUndeterminedBody: z.string().min(1).max(150),
    permissionPromptUndeterminedConfirm: z.string().min(1).max(10),
    permissionPromptDeniedTitle: z.string().min(1).max(40),
    permissionPromptDeniedBody: z.string().min(1).max(150),
    permissionPromptDeniedCancel: z.string().min(1).max(10),
    permissionPromptDeniedConfirm: z.string().min(1).max(10),
    pushOpenMarksRead: z.boolean(),
    operatorPushSaveToInbox: z.boolean(),
    alimtalkProvider: zAlimtalkProviderRoot,
    updatedAt: z.union([z.iso.datetime(), z.null()]),
    updatedByAdminId: z.union([z.uuid(), z.null()]),
});
export const zNotificationPreferenceRoot2Writable = z.object({
    broadcastNotifications: z.boolean(),
    messageNotifications: z.boolean(),
    orderNotifications: z.boolean(),
    promotionNotifications: z.boolean(),
    loungeNotifications: z.boolean(),
    channels: z.array(z.enum(["PUSH", "IN_APP"])).min(1),
    quietHoursEnabled: z.boolean(),
    quietHoursStart: z.optional(z.union([z.iso.time(), z.null()])),
    quietHoursEnd: z.optional(z.union([z.iso.time(), z.null()])),
});
export const zNotificationSettingItemRootWritable = z.object({
    groupTitle: z.union([z.string(), z.null()]),
    label: z.string(),
    description: z.string(),
    sortOrder: z.int(),
    active: z.boolean(),
    defaultEnabled: z.boolean(),
    includedByKey: z.union([z.string(), z.null()]),
    turnOffConfirmTitle: z.union([z.string(), z.null()]),
    turnOffConfirmBody: z.union([z.string(), z.null()]),
});
export const zNotificationSettingItemListRootWritable = z.object({
    items: z.array(zNotificationSettingItemRootWritable),
});
export const zNotificationTemplateRootWritable = z.object({
    category: zNotificationTemplateCategoryRoot,
    deliveryMethod: zNotificationTemplateDeliveryMethodRoot,
    enabled: z.boolean(),
    pushEnabled: z.boolean(),
    inAppEnabled: z.boolean(),
    titleTemplate: z.union([z.string(), z.null()]),
    bodyTemplate: z.string(),
    preferenceKey: zNotificationTemplatePreferenceKeyRoot,
    respectQuietHours: z.boolean(),
    inboxCategory: zNotificationInboxCategoryRoot,
    foregroundDisplay: zNotificationForegroundDisplayRoot,
    suppressOnTargetScreen: z.boolean(),
    alimtalkTemplateId: z.union([z.string(), z.null()]),
    nhnAlimtalkTemplateCode: z.union([z.string().max(20), z.null()]),
});
export const zNotificationTemplateListRootWritable = z.object({
    templates: z.array(zNotificationTemplateRootWritable),
});
export const zBackofficeFulfillmentOrdersItemRootWritable = z.unknown();
export const zBackofficeOrdersItemRootWritable = z.unknown();
export const zBackofficeReturnsItemRootWritable = z.unknown();
export const zBackofficeUsersUserIdDeliveryAddressesRootWritable = z.unknown();
export const zBuyersOrdersRootWritable = z.unknown();
export const zCancellationRequestsReceivedItemRootWritable = z.unknown();
export const zCancellationRequestsApproveRootWritable = z.unknown();
export const zCancellationRequestsRejectRootWritable = z.unknown();
export const zDeliveryAddressesCollectionRootWritable = z.unknown();
export const zDeliveryAddressesItemRootWritable = z.unknown();
export const zDeliveryAddressesSetDefaultRootWritable = z.unknown();
export const zFulfillmentOrdersBatchCancellationRequestsRootWritable = z.unknown();
export const zFulfillmentOrdersItemRootWritable = z.unknown();
export const zOrdersMineCollectionRootWritable = z.unknown();
export const zOrdersReceivedCollectionRootWritable = z.unknown();
export const zOrdersCancellationRequestsRootWritable = z.unknown();
export const zOrdersCollectionRootWritable = z.unknown();
export const zOrdersItemRootWritable = z.unknown();
export const zOrdersReturnsCollectionRootWritable = z.unknown();
export const zOrdersReturnsItemRootWritable = z.unknown();
export const zReturnsApproveRootWritable = z.unknown();
export const zReturnsRejectRootWritable = z.unknown();
export const zUsersDeliveryAddressesRootWritable = z.unknown();
export const zCancellationRequestResponseRootWritable = z.object({
    reasonType: z.enum([
        "BUYER_CHANGED_MIND",
        "BUYER_FOUND_BETTER_PRICE",
        "DEALER_OUT_OF_STOCK",
        "DEALER_CANNOT_FULFILL",
        "PAYMENT_FAILED",
        "PAYMENT_EXPIRED",
        "SYSTEM_ERROR",
        "ADMIN_FORCE_CANCEL",
    ]),
    reasonDescription: z.optional(z.union([z.string().max(500), z.null()])),
});
export const zCancellationRequestResponseWritable = zCancellationRequestResponseRootWritable;
export const zBatchCancelOrderResultRootWritable = z.object({
    orderId: z.string(),
    success: z.boolean(),
    cancellation: z.optional(z.union([zCancellationRequestResponseRootWritable, z.null()])),
    error: z.optional(z.union([z.string(), z.null()])),
});
export const zBatchCancelOrderResultWritable = zBatchCancelOrderResultRootWritable;
export const zBatchCancelOrdersResponseRootWritable = z.object({
    fulfillmentOrderId: z.string(),
    processedCount: z.int().gte(0),
    failedCount: z.int().gte(0),
    results: z.array(zBatchCancelOrderResultRootWritable),
});
export const zBatchCancelOrdersResponseWritable = zBatchCancelOrdersResponseRootWritable;
export const zDeliveryAddressRootWritable = z.object({
    recipientName: z.string().min(1).max(100),
    phoneNumber: z.string().regex(/^01[016789]-?\d{3,4}-?\d{4}$/),
    postalCode: z.string().regex(/^\d{5}$/),
    addressLine1: z.string().min(1).max(200),
    addressLine2: z.optional(z.union([z.string().max(200), z.null()])),
    nickname: z.optional(z.union([z.string().max(50), z.null()])),
});
export const zChangeFulfillmentOrderShippingAddressResponseRootWritable = z.object({
    fulfillmentOrderId: z.uuid(),
    shippingAddress: zDeliveryAddressRootWritable,
    changedFulfillmentOrderIds: z.array(z.uuid()),
    changedOrderCount: z.int().gte(0),
});
export const zFulfillmentOrderRootWritable = z.record(z.string(), z.never());
export const zFulfillmentOrderWritable = zFulfillmentOrderRootWritable;
export const zBuyerNewOrderGroupResponseRootWritable = z.object({
    buyerId: z.uuid(),
    fulfillmentOrders: z.array(zFulfillmentOrderRootWritable),
});
export const zFulfillmentOrderBuyerDeliveryAddressesResponseRootWritable = z.object({
    data: z.array(zDeliveryAddressRootWritable),
});
export const zFulfillmentOrderCancellationResponseRootWritable = z.object({
    fulfillmentOrderId: z.string(),
    cancellationRequests: z.array(zCancellationRequestResponseRootWritable),
    skippedOrders: z.array(zFulfillmentOrderCancellationSkippedOrderRoot),
});
export const zFulfillmentOrderCancellationResponseWritable = zFulfillmentOrderCancellationResponseRootWritable;
export const zFulfillmentOrderSummaryRootWritable = z.record(z.string(), z.never());
export const zFulfillmentOrderSummaryWritable = zFulfillmentOrderSummaryRootWritable;
export const zFulfillmentOrderListResponseRootWritable = z.object({
    data: z.array(zFulfillmentOrderSummaryRootWritable),
    meta: zPaginationMetaRoot,
});
export const zFulfillmentOrderListResponseWritable = zFulfillmentOrderListResponseRootWritable;
export const zOrderBundleSummaryRootWritable = z.record(z.string(), z.never());
export const zOrderBundleListResponseRootWritable = z.object({
    data: z.array(zOrderBundleSummaryRootWritable),
    meta: zPaginationMetaRoot,
});
export const zOrderSummaryRootWritable = z.object({
    orderType: z.enum(["AUCTION", "INSTANT_PURCHASE", "GROUP_BUY", "GIVEAWAY"]),
    status: z.enum([
        "CREATED",
        "PAYMENT_REQUESTED",
        "AWAITING_REPAYMENT",
        "PAID",
        "SHIPPED",
        "DELIVERED",
        "CONFIRMED",
        "CANCELLED",
        "RETURNED",
        "EXPIRED",
    ]),
    totalAmount: zMoneyRoot,
    shippingFee: zMoneyNonNegativeRoot,
    orderItems: z.array(zOrderItemSummaryRoot),
});
export const zOrderListResponseRootWritable = z.object({
    data: z.array(zOrderSummaryRootWritable),
    meta: zPaginationMetaRoot,
});
export const zParcelSummaryRootWritable = z.record(z.string(), z.never());
export const zProductListingSnapshotRootWritable = z.record(z.string(), z.never());
export const zReceivedCancellationRequestRootWritable = z.object({
    reasonType: z.enum([
        "BUYER_CHANGED_MIND",
        "BUYER_FOUND_BETTER_PRICE",
        "DEALER_OUT_OF_STOCK",
        "DEALER_CANNOT_FULFILL",
        "PAYMENT_FAILED",
        "PAYMENT_EXPIRED",
        "SYSTEM_ERROR",
        "ADMIN_FORCE_CANCEL",
    ]),
    reasonDescription: z.optional(z.union([z.string().max(500), z.null()])),
});
export const zReceivedCancellationRequestWritable = zReceivedCancellationRequestRootWritable;
export const zReceivedCancellationRequestListResponseRootWritable = z.object({
    data: z.array(zReceivedCancellationRequestRootWritable),
    meta: zPaginationMetaRoot,
});
export const zReceivedCancellationRequestListResponseWritable = zReceivedCancellationRequestListResponseRootWritable;
export const zReturnRootWritable = z.object({
    returnItems: z.array(zReturnItemRoot).min(1),
    returnReason: z.enum([
        "WRONG_DELIVERY",
        "MISSING_ITEMS",
        "DAMAGED_DEFECTIVE",
        "NOT_AS_DESCRIBED",
        "OTHER",
    ]),
    returnDescription: z.optional(z.union([z.string().max(1000), z.null()])),
});
export const zBackofficeReturnListResponseRootWritable = z.object({
    data: z.array(zReturnRootWritable),
    meta: zPaginationMetaRoot,
});
export const zBackofficeReturnListResponseWritable = zBackofficeReturnListResponseRootWritable;
export const zFulfillmentOrderReturnResponseRootWritable = z.object({
    fulfillmentOrderId: z.string(),
    returnRequests: z.array(zReturnRootWritable),
    skippedOrders: z.array(zFulfillmentOrderReturnSkippedOrderRoot),
});
export const zFulfillmentOrderReturnResponseWritable = zFulfillmentOrderReturnResponseRootWritable;
export const zReturnListResponseRootWritable = z.object({
    data: z.array(zReturnRootWritable),
    meta: zPaginationMetaRoot,
});
export const zShipmentRootWritable = z.record(z.string(), z.never());
export const zShipmentWritable = zShipmentRootWritable;
export const zBackofficeShipmentListResponseRootWritable = z.object({
    data: z.array(zShipmentRootWritable),
    meta: zPaginationMetaRoot,
});
export const zBackofficeShipmentListResponseWritable = zBackofficeShipmentListResponseRootWritable;
export const zShippingChargeRootWritable = z.record(z.string(), z.never());
export const zBackofficePaymentsItemRootWritable = z.unknown();
export const zBackofficeRefundsItemRootWritable = z.unknown();
export const zPaymentMethodsCollectionRootWritable = z.unknown();
export const zPaymentMethodsItemRootWritable = z.unknown();
export const zPaymentMethodsSetDefaultRootWritable = z.unknown();
export const zPaymentsCollectionRootWritable = z.unknown();
export const zPaymentsItemRootWritable = z.unknown();
export const zRefundsItemRootWritable = z.unknown();
export const zPaymentDetailsRootWritable = z.unknown();
export const zPaymentMethodRootWritable = z.unknown();
export const zRefundRootWritable = z.unknown();
export const zPaymentMethodRoot2Writable = z.object({
    userId: z.string(),
    methodType: zPaymentMethodTypeRoot,
    gateway: zPaymentGatewayRoot,
    cardIssuer: z.optional(z.union([z.string(), z.null()])),
    lastFourDigits: z.string().regex(/^[0-9]{4}$/),
    expiryDate: z.optional(z.union([z.string().regex(/^(0[1-9]|1[0-2])\/[0-9]{2}$/), z.null()])),
    nickname: z.optional(z.union([z.string().max(50), z.null()])),
    isDefault: z.boolean(),
});
export const zPaymentMethodCreateRootWritable = z.object({
    userId: z.string(),
    cardNumber: z.string().regex(/^[0-9]{13,19}$/),
    expiryDate: z.string().regex(/^(0[1-9]|1[0-2])\/[0-9]{2}$/),
    cvc: z.string().regex(/^[0-9]{3,4}$/),
    nickname: z.optional(z.union([z.string().max(50), z.null()])),
});
export const zBackofficeChatBannedWordsCollectionRootWritable = z.unknown();
export const zBackofficeCommissionConfigsRootWritable = z.unknown();
export const zBackofficeCompanyInfoSettingsRootWritable = z.unknown();
export const zBackofficePgFeeConfigsRootWritable = z.unknown();
export const zBackofficeSettlementConfigsRootWritable = z.unknown();
export const zPublicCompanyInfoSettingsRootWritable = z.unknown();
export const zPublicPagesItemRootWritable = z.unknown();
export const zChatBannedWordRootWritable = z.object({
    word: z.string(),
});
export const zChatBannedWordWritable = zChatBannedWordRootWritable;
export const zChatBannedWordListRootWritable = z.object({
    items: z.array(zChatBannedWordRootWritable),
    maxWordLength: z.int().gte(1),
});
export const zChatBannedWordListWritable = zChatBannedWordListRootWritable;
export const zCommissionConfigRootWritable = z.object({
    commissionRatePercentage: z.number().gte(0).lte(30),
    effectiveFrom: z.iso.datetime(),
    updatedBy: z.string(),
});
export const zCommissionConfigWritable = zCommissionConfigRootWritable;
export const zCompanyInfoRootWritable = z.object({
    name: z.union([z.string(), z.null()]),
    addressLabel: z.union([z.string(), z.null()]),
    address: z.union([z.string(), z.null()]),
    representativeLabel: z.union([z.string(), z.null()]),
    representativeName: z.union([z.string(), z.null()]),
    businessNumberLabel: z.union([z.string(), z.null()]),
    businessNumber: z.union([z.string(), z.null()]),
    onlineMarketingNumberLabel: z.union([z.string(), z.null()]),
    onlineMarketingNumber: z.union([z.string(), z.null()]),
    hostingProviderLabel: z.union([z.string(), z.null()]),
    hostingProvider: z.union([z.string(), z.null()]),
    hostingProviderUrl: z.union([z.string(), z.null()]),
    email: z.union([z.string(), z.null()]),
    phone: z.union([z.string(), z.null()]),
    privacyPolicyLabel: z.union([z.string(), z.null()]),
    privacyPolicyUrl: z.union([z.string(), z.null()]),
    termsOfServiceLabel: z.union([z.string(), z.null()]),
    termsOfServiceUrl: z.union([z.string(), z.null()]),
    operatingPolicyLabel: z.union([z.string(), z.null()]),
    operatingPolicyUrl: z.union([z.string(), z.null()]),
    marketingConsentUrl: z.union([z.string(), z.null()]),
    noticeUrl: z.union([z.string(), z.null()]),
    sanctionHistoryUrl: z.union([z.string(), z.null()]),
    faqUrl: z.union([z.string(), z.null()]),
    penaltyPolicyUrl: z.union([z.string(), z.null()]),
    disclaimer: z.union([z.string(), z.null()]),
});
export const zCompanyInfoWritable = zCompanyInfoRootWritable;
export const zPgFeeConfigRootWritable = z.object({
    pgFeeRatePercentage: z.number().gte(0).lte(10),
    pgProvider: z.string(),
    effectiveFrom: z.iso.datetime(),
    updatedBy: z.string(),
});
export const zPgFeeConfigWritable = zPgFeeConfigRootWritable;
export const zSettlementConfigRootWritable = z.object({
    holdPeriodDays: z.int().gte(0).lte(30),
    effectiveFrom: z.iso.datetime(),
    updatedBy: z.string(),
});
export const zSettlementConfigWritable = zSettlementConfigRootWritable;
export const zBackofficeUsersUserIdPointsCreditsRootWritable = z.unknown();
export const zBackofficeUsersUserIdPointsDebitsRootWritable = z.unknown();
export const zBackofficeUserPointAdjustmentResponseRootWritable = z.object({
    balance: z.int().gte(0),
});
export const zBackofficeUserPointAdjustmentResponseWritable = zBackofficeUserPointAdjustmentResponseRootWritable;
export const zPointTransactionItemRootWritable = z.object({
    amount: z.int(),
    transactionType: z.string(),
    description: z.optional(z.union([z.string(), z.null()])),
    adminId: z.optional(z.union([z.string(), z.null()])),
});
export const zPointTransactionItemWritable = zPointTransactionItemRootWritable;
export const zPointTransactionListRootWritable = z.object({
    data: z.array(zPointTransactionItemRootWritable),
    meta: zPaginationMetaRoot,
});
export const zPointTransactionListWritable = zPointTransactionListRootWritable;
export const zBackofficeProductsCollectionRootWritable = z.unknown();
export const zBackofficeProductsItemRootWritable = z.unknown();
export const zBroadcastsItemProductsRootWritable = z.unknown();
export const zGroupBuysCollectionRootWritable = z.unknown();
export const zGroupBuysItemActivateRootWritable = z.unknown();
export const zGroupBuysItemBreakRootWritable = z.unknown();
export const zGroupBuysItemRootWritable = z.unknown();
export const zProductsCollectionRootWritable = z.unknown();
export const zProductsItemDetailsRootWritable = z.unknown();
export const zProductsItemGroupBuysRootWritable = z.unknown();
export const zProductsItemImagesRootWritable = z.unknown();
export const zProductsItemPricingRootWritable = z.unknown();
export const zProductsItemPublishRootWritable = z.unknown();
export const zProductsItemSalesChannelRootWritable = z.unknown();
export const zProductsItemRootWritable = z.unknown();
export const zBackofficeProductDetailsRootWritable = z.object({
    dealerId: z.string(),
    broadcastId: z.optional(z.union([z.string(), z.null()])),
    name: z.string().min(1).max(200),
    description: z.optional(z.union([z.string().max(2000), z.null()])),
    categories: z.array(zCategorySummaryRootWritable),
    price: zMoneyRoot,
    quantity: z.int().gte(0),
    images: z.array(z.url()).min(1),
    status: z.enum(["DRAFT", "PUBLISHED", "ARCHIVED", "SOLD_OUT"]),
    salesChannel: z.enum(["BROADCAST", "MARKETPLACE"]),
    shippingFee: z.optional(zMoneyNonNegativeRoot),
    isBoltbCertified: z.boolean(),
});
export const zBackofficeProductDetailsWritable = zBackofficeProductDetailsRootWritable;
export const zBackofficeProductSummaryRootWritable = z.object({
    id: z.string(),
    dealerId: z.string(),
    name: z.string(),
    categories: z.array(zCategorySummaryRootWritable),
    price: zMoneyRoot,
    thumbnailImage: z.url(),
    status: z.enum(["DRAFT", "PUBLISHED", "ARCHIVED", "SOLD_OUT"]),
    salesChannel: z.enum(["BROADCAST", "MARKETPLACE"]),
    createdAt: z.iso.datetime(),
    quantity: z.int().gte(0),
    isBoltbCertified: z.boolean(),
});
export const zBackofficeProductSummaryWritable = zBackofficeProductSummaryRootWritable;
export const zProductDetailsRootWritable = z.object({
    dealerId: z.string(),
    broadcastId: z.optional(z.union([z.string(), z.null()])),
    name: z.string().min(1).max(200),
    description: z.optional(z.union([z.string().max(2000), z.null()])),
    categories: z.array(zCategorySummaryRootWritable),
    price: zMoneyRoot,
    quantity: z.int().gte(0),
    images: z.array(z.url()).min(1),
    status: z.enum(["DRAFT", "PUBLISHED", "ARCHIVED", "SOLD_OUT"]),
    salesChannel: z.enum(["BROADCAST", "MARKETPLACE"]),
    shippingFee: z.optional(zMoneyNonNegativeRoot),
    isBoltbCertified: z.boolean(),
});
export const zProductListingRootWritable = z.object({
    dealerId: z.string(),
    broadcastId: z.optional(z.union([z.string(), z.null()])),
    name: z.string().min(1).max(200),
    description: z.optional(z.union([z.string().max(2000), z.null()])),
    productCategoryIds: z.array(z.uuid()),
    price: zMoneyRoot,
    shippingFee: zMoneyNonNegativeRoot,
    quantity: z.int().gte(0),
    images: z.array(z.url()).min(1),
    status: z.enum(["DRAFT", "PUBLISHED", "ARCHIVED", "SOLD_OUT"]),
    salesChannel: z.enum(["BROADCAST", "MARKETPLACE"]),
});
export const zProductSummaryRootWritable = z.object({
    id: z.string(),
    dealerId: z.string(),
    name: z.string(),
    categories: z.array(zCategorySummaryRootWritable),
    price: zMoneyRoot,
    thumbnailImage: z.url(),
    status: z.enum(["DRAFT", "PUBLISHED", "ARCHIVED", "SOLD_OUT"]),
    salesChannel: z.enum(["BROADCAST", "MARKETPLACE"]),
    createdAt: z.iso.datetime(),
    quantity: z.int().gte(0),
    isBoltbCertified: z.boolean(),
});
export const zServerPageProductsBlockRootWritable = z.object({
    type: z.literal("products"),
    title: z.optional(z.string().max(40)),
    categoryId: z.optional(z.uuid()),
    sort: z.union([
        z.literal("newest"),
        z.literal("oldest"),
        z.literal("lowestPrice"),
        z.literal("highestPrice"),
    ]),
    maxItems: z.int().gte(1).lte(30),
    layout: z.union([z.literal("grid"), z.literal("horizontal")]),
    items: z.array(zProductSummaryRootWritable),
});
export const zAuctionsCollectionRootWritable = z.unknown();
export const zAuctionsItemBidsRootWritable = z.unknown();
export const zAuctionsItemEndRootWritable = z.unknown();
export const zAuctionsItemPriceReductionRootWritable = z.unknown();
export const zAuctionsItemRevealRootWritable = z.unknown();
export const zAuctionsItemStartRootWritable = z.unknown();
export const zAuctionsItemRootWritable = z.unknown();
export const zAuctionsWithProductCollectionRootWritable = z.unknown();
export const zBackofficeAnonymousNicknameWordsCollectionRootWritable = z.unknown();
export const zBroadcastSoldListingsCollectionRootWritable = z.unknown();
export const zBroadcastUnsoldListingsCollectionRootWritable = z.unknown();
export const zGiveawaysCollectionRootWritable = z.unknown();
export const zGiveawaysItemCloseRootWritable = z.unknown();
export const zGiveawaysItemRootWritable = z.unknown();
export const zGiveawaysWithProductCollectionRootWritable = z.unknown();
export const zGroupBuysCollectionRoot2Writable = z.unknown();
export const zGroupBuysItemBreakCompleteRootWritable = z.unknown();
export const zGroupBuysItemBreakStartRootWritable = z.unknown();
export const zGroupBuysItemCancelRootWritable = z.unknown();
export const zGroupBuysItemRoot2Writable = z.unknown();
export const zInstantPurchasesCollectionRootWritable = z.unknown();
export const zInstantPurchasesItemUpdateQuantityRootWritable = z.unknown();
export const zInstantPurchasesItemRootWritable = z.unknown();
export const zInstantPurchasesWithProductCollectionRootWritable = z.unknown();
export const zAnonymousNicknameWordRootWritable = z.object({
    kind: zAnonymousNicknameWordKindRoot,
    word: z.string(),
});
export const zAnonymousNicknameWordWritable = zAnonymousNicknameWordRootWritable;
export const zAnonymousNicknameWordListRootWritable = z.object({
    adjectives: z.array(zAnonymousNicknameWordRootWritable),
    animals: z.array(zAnonymousNicknameWordRootWritable),
    minWordsPerKind: z.int().gte(1),
    maxWordLength: z.int().gte(1),
});
export const zAnonymousNicknameWordListWritable = zAnonymousNicknameWordListRootWritable;
export const zBroadcastUnsoldListingRootWritable = z.object({
    transactionType: z.enum(["AUCTION", "INSTANT_PURCHASE", "GIVEAWAY"]),
    productName: z.string(),
    productImageUrl: z.union([z.url(), z.null()]),
    startingPrice: z.number(),
    startingPriceCurrency: z.string(),
});
export const zGroupBuySalesRootWritable = z.object({
    broadcastId: z.string(),
    groupBuyListingId: z.string(),
    dealerId: z.string(),
    totalSlots: z.int().gte(1),
    reservedSlots: z.int().gte(0),
    confirmedSlots: z.int().gte(0),
    availableSlots: z.int().gte(0),
    slotPrice: zMoneyRoot,
    breakScheduledTime: z.iso.datetime(),
    breakStartedTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    status: z.enum(["OPEN", "BREAK_IN_PROGRESS", "COMPLETED", "CANCELLED"]),
});
export const zInstantPurchaseBuyerRootWritable = z.object({
    quantity: z.int().gte(1),
});
export const zInstantPurchaseBuyerWritable = zInstantPurchaseBuyerRootWritable;
export const zBackofficeSettlementsItemRootWritable = z.unknown();
export const zBackofficeSettlementsReversalRootWritable = z.unknown();
export const zSettlementAccountsItemRootWritable = z.unknown();
export const zSettlementsCollectionRootWritable = z.unknown();
export const zSettlementsConfirmRootWritable = z.unknown();
export const zSettlementsFailRootWritable = z.unknown();
export const zSettlementsItemRootWritable = z.unknown();
export const zSettlementRootWritable = z.unknown();
export const zSettlementAccountRootWritable = z.unknown();
export const zSettlementsListRootWritable = z.unknown();
export const zBackofficeSettlementDealerRootWritable = z.object({
    nickname: z.string(),
    profileImageUrl: z.union([z.url(), z.null()]),
});
export const zBackofficeSettlementDealerWritable = zBackofficeSettlementDealerRootWritable;
export const zBackofficeSettlementExportItemRootWritable = z.object({
    dealerNickname: z.string(),
    productAmount: z.number(),
    shippingFee: z.number(),
    totalPaymentAmount: z.number(),
    platformFeeAmount: z.number(),
    pgFeeAmount: z.number(),
    shippingPgFeeAmount: z.number(),
    payoutAmount: z.number(),
    netPayoutAmount: z.number(),
    status: zSettlementStatusRoot,
    eligibilityDate: z.iso.datetime(),
    orderCreatedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    orderConfirmedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    bankName: z.union([z.string(), z.null()]),
    accountNumber: z.union([z.string(), z.null()]),
});
export const zBackofficeSettlementExportItemWritable = zBackofficeSettlementExportItemRootWritable;
export const zBackofficeSettlementExportResponseRootWritable = z.object({
    data: z.array(zBackofficeSettlementExportItemRootWritable),
    totalItems: z.int(),
});
export const zBackofficeSettlementExportResponseWritable = zBackofficeSettlementExportResponseRootWritable;
export const zSettlementAccountRoot2Writable = z.object({
    dealerId: z.string(),
    bankName: zKoreanBankRoot,
    accountNumber: z.string(),
    accountNumberMasked: z.string(),
});
export const zSettlementAccountWritable = zSettlementAccountRoot2Writable;
export const zSettlementOffsetSummaryRootWritable = z.object({
    dealerId: z.string(),
    originalSettlementId: z.string(),
    refundId: z.string(),
    offsetAmount: zMoneyRoot,
    reason: z.string(),
    status: z.enum(["PENDING", "APPLIED", "WRITTEN_OFF"]),
});
export const zSettlementOffsetSummaryWritable = zSettlementOffsetSummaryRootWritable;
export const zSettlementOffsetListResponseRootWritable = z.object({
    data: z.array(zSettlementOffsetSummaryRootWritable),
});
export const zSettlementOffsetListResponseWritable = zSettlementOffsetListResponseRootWritable;
export const zAdminReportReasonCategoriesCollectionRootWritable = z.unknown();
export const zAdminReportReasonCategoriesItemRootWritable = z.unknown();
export const zBackofficeLoungePostsItemRootWritable = z.unknown();
export const zInvitationsCollectionRootWritable = z.unknown();
export const zInvitationsItemAcceptRootWritable = z.unknown();
export const zLoungePostsCollectionRootWritable = z.unknown();
export const zLoungePostsItemRootWritable = z.unknown();
export const zReferralLinksMyReferredUsersRootWritable = z.unknown();
export const zReferralLinksMyRootWritable = z.unknown();
export const zReportsItemRootWritable = z.unknown();
export const zUsersItemBlockRootWritable = z.unknown();
export const zUsersItemFollowRootWritable = z.unknown();
export const zUsersItemReportRootWritable = z.unknown();
export const zInvitationRootWritable = z.object({
    inviterId: z.string(),
    inviteePhone: z.string(),
    status: z.enum(["PENDING", "ACCEPTED", "EXPIRED"]),
});
export const zInvitationListRootWritable = z.object({
    data: z.array(zInvitationRootWritable),
    meta: zPaginationMetaRoot,
});
export const zLoungePostSummaryRootWritable = z.object({
    categoryIds: z.array(z.uuid()),
    title: z.string(),
    content: z.string(),
    thumbnailUrl: z.union([z.url(), z.null()]),
    images: z.array(zLoungePostImageRoot).max(5),
    author: zLoungePostAuthorRoot,
    viewCount: z.int().gte(0),
    commentCount: z.int().gte(0),
    likeCount: z.int().gte(0),
    isLiked: z.union([z.boolean(), z.null()]),
    isPinned: z.boolean(),
});
export const zLoungePostListRootWritable = z.object({
    data: z.array(zLoungePostSummaryRootWritable),
    meta: zPaginationMetaRoot,
});
export const zReferralLinkResponseRootWritable = z.object({
    referralCode: z.string(),
    shortUrl: z.url(),
});
export const zReportBroadcastContextRootWritable = z.object({
    targetType: z.enum(["BROADCAST"]),
});
export const zReportBroadcastContextWritable = zReportBroadcastContextRootWritable;
export const zReportChatContextRootWritable = z.object({
    targetType: z.enum(["CHAT"]),
    chatType: z.enum(["BROADCAST_CHAT", "PRIVATE_DM", "OPEN_CHAT"]),
});
export const zReportChatContextWritable = zReportChatContextRootWritable;
export const zReportContextMessageRootWritable = z.object({
    messageType: z.enum(["TEXT_MESSAGE", "IMAGE_MESSAGE", "SYSTEM"]),
    content: z.union([z.string(), z.null()]),
    isReportedMessage: z.boolean(),
    isDeleted: z.boolean(),
});
export const zReportContextMessageWritable = zReportContextMessageRootWritable;
export const zReportPostContextRootWritable = z.object({
    targetType: z.enum(["POST"]),
});
export const zReportPostContextWritable = zReportPostContextRootWritable;
export const zReportProductContextRootWritable = z.object({
    targetType: z.enum(["PRODUCT"]),
});
export const zReportProductContextWritable = zReportProductContextRootWritable;
export const zReportReasonCategoryRootWritable = z.object({
    name: z.string().min(1).max(100),
    description: z.optional(z.union([z.string().max(500), z.null()])),
    isActive: z.boolean(),
});
export const zReportReasonCategoryListRootWritable = z.object({
    categories: z.array(zReportReasonCategoryRootWritable),
});
export const zReportUserContextRootWritable = z.object({
    targetType: z.enum(["USER"]),
});
export const zReportUserContextWritable = zReportUserContextRootWritable;
export const zReportTargetContextRootWritable = z.union([
    z
        .object({
        targetType: z.literal("ReportUserContext_rootWritable"),
    })
        .and(zReportUserContextRootWritable),
    z
        .object({
        targetType: z.literal("ReportBroadcastContext_rootWritable"),
    })
        .and(zReportBroadcastContextRootWritable),
    z
        .object({
        targetType: z.literal("ReportChatContext_rootWritable"),
    })
        .and(zReportChatContextRootWritable),
    z
        .object({
        targetType: z.literal("ReportPostContext_rootWritable"),
    })
        .and(zReportPostContextRootWritable),
    z
        .object({
        targetType: z.literal("ReportProductContext_rootWritable"),
    })
        .and(zReportProductContextRootWritable),
]);
export const zReportTargetContextWritable = zReportTargetContextRootWritable;
export const zUserProfileSummaryRootWritable = z.object({
    nickname: z.string(),
    profileImage: z.optional(z.union([z.url(), z.null()])),
    bio: z.optional(z.union([z.string(), z.null()])),
    roles: z.array(zUserRoleRoot).min(1),
});
export const zBlockRelationshipRootWritable = z.object({
    blockerId: z.string(),
    blockedId: z.string(),
    reason: z.optional(z.union([z.string(), z.null()])),
    userProfile: z.optional(z.union([zUserProfileSummaryRootWritable, z.null()])),
});
export const zBlockedUserItemRootWritable = z.object({
    blockedId: z.string(),
    reason: z.optional(z.union([z.string(), z.null()])),
    userProfile: z.optional(z.union([zUserProfileSummaryRootWritable, z.null()])),
});
export const zBlockedUserListResponseRootWritable = z.object({
    data: z.array(zBlockedUserItemRootWritable),
    meta: zPaginationMetaRoot,
});
export const zFollowRelationshipRootWritable = z.object({
    followerId: z.string(),
    followeeId: z.string(),
    userProfile: z.optional(z.union([zUserProfileSummaryRootWritable, z.null()])),
    viewerIsFollowing: z.optional(z.union([z.boolean(), z.null()])),
});
export const zFollowRelationshipListRootWritable = z.object({
    data: z.array(zFollowRelationshipRootWritable),
    meta: zPaginationMetaRoot,
});
export const zReferredUserItemRootWritable = z.object({
    userId: z.uuid(),
    referredAt: z.iso.datetime(),
    userProfile: zUserProfileSummaryRootWritable,
});
export const zReferredUserItemWritable = zReferredUserItemRootWritable;
export const zReferredUserListRootWritable = z.object({
    data: z.array(zReferredUserItemRootWritable),
    meta: zPaginationMetaRoot,
});
export const zReferredUserListWritable = zReferredUserListRootWritable;
export const zUserReportRootWritable = z.object({
    reporterId: z.string(),
    reportedId: z.string(),
    targetType: z.enum(["USER", "BROADCAST", "CHAT", "POST", "PRODUCT"]),
    targetEntityId: z.string(),
    chatType: z.optional(z.nullable(z.enum(["BROADCAST_CHAT", "PRIVATE_DM", "OPEN_CHAT"]))),
    messageId: z.optional(z.union([z.string(), z.null()])),
    categoryId: z.uuid(),
    category: z.object({
        name: z.string(),
        description: z.union([z.string(), z.null()]),
    }),
    detailedMessage: z.optional(z.union([z.string(), z.null()])),
    reason: z.optional(z.union([z.string(), z.null()])),
    status: z.enum(["PENDING", "UNDER_REVIEW", "RESOLVED", "REJECTED"]),
    resolution: z.optional(z.union([z.string(), z.null()])),
    resolutionType: z.optional(z.nullable(z.enum(["DISMISS", "WARN", "SUSPEND"]))),
    reviewedBy: z.optional(z.union([z.string(), z.null()])),
});
export const zUserReportDetailRootWritable = z.object({
    reporterId: z.string(),
    reportedId: z.string(),
    targetType: z.enum(["USER", "BROADCAST", "CHAT", "POST", "PRODUCT"]),
    targetEntityId: z.string(),
    chatType: z.optional(z.nullable(z.enum(["BROADCAST_CHAT", "PRIVATE_DM", "OPEN_CHAT"]))),
    messageId: z.optional(z.union([z.string(), z.null()])),
    categoryId: z.uuid(),
    category: z.object({
        name: z.string(),
        description: z.union([z.string(), z.null()]),
    }),
    detailedMessage: z.optional(z.union([z.string(), z.null()])),
    reason: z.optional(z.union([z.string(), z.null()])),
    status: z.enum(["PENDING", "UNDER_REVIEW", "RESOLVED", "REJECTED"]),
    resolution: z.optional(z.union([z.string(), z.null()])),
    resolutionType: z.optional(z.nullable(z.enum(["DISMISS", "WARN", "SUSPEND"]))),
    reviewedBy: z.optional(z.union([z.string(), z.null()])),
});
export const zUserReportDetailWritable = zUserReportDetailRootWritable;
export const zUserReportListRootWritable = z.object({
    data: z.array(zUserReportRootWritable),
    meta: zPaginationMetaRoot,
});
export const zBroadcastsCollectionRootWritable = z.unknown();
export const zBroadcastsFeaturedRootWritable = z.unknown();
export const zBroadcastsItemAnnouncementRootWritable = z.unknown();
export const zBroadcastsItemChatCollectionRootWritable = z.unknown();
export const zBroadcastsItemChatImageRootWritable = z.unknown();
export const zBroadcastsItemChatUserContextRootWritable = z.unknown();
export const zBroadcastsItemConfigRootWritable = z.unknown();
export const zBroadcastsItemEndRootWritable = z.unknown();
export const zBroadcastsItemMemosCollectionRootWritable = z.unknown();
export const zBroadcastsItemMemosItemRootWritable = z.unknown();
export const zBroadcastsItemScreenStateRootWritable = z.unknown();
export const zBroadcastsItemStartRootWritable = z.unknown();
export const zBroadcastsItemRootWritable = z.unknown();
export const zBroadcastsLiveRootWritable = z.unknown();
export const zBroadcastsScheduledItemRootWritable = z.unknown();
export const zBroadcastsScheduledRootWritable = z.unknown();
export const zBroadcastsTestRootWritable = z.unknown();
export const zBroadcastsTrendingRootWritable = z.unknown();
export const zDealersBroadcastsCollectionRootWritable = z.unknown();
export const zBackofficeBroadcastRootWritable = z.object({
    title: z.string(),
    thumbnail: z.union([z.string(), z.null()]),
    status: z.enum(["SCHEDULED", "LIVE", "ENDED"]),
    viewerCount: z.int().gte(0),
    scheduledStartTime: z.union([z.iso.datetime(), z.null()]),
    startTime: z.union([z.iso.datetime(), z.null()]),
    endTime: z.union([z.iso.datetime(), z.null()]),
    endReasonMessage: z.union([z.string(), z.null()]),
    isTestBroadcast: z.boolean(),
    dealer: zBackofficeDealerSummaryRoot,
    categories: z.array(zCategorySummaryRootWritable),
});
export const zBackofficeBroadcastListRootWritable = z.object({
    data: z.array(zBackofficeBroadcastRootWritable),
    meta: zPaginationMetaRoot,
});
export const zChatMessageRootWritable = z.object({
    broadcastId: z.string(),
    senderId: z.string(),
    senderType: zSenderTypeRoot,
    senderNickname: z.string(),
    senderAvatar: z.optional(z.union([z.string(), z.null()])),
    messageType: zMessageTypeRoot,
    content: z.optional(z.union([z.string(), z.null()])),
    imageUrl: z.optional(z.union([z.string(), z.null()])),
    isDeleted: z.boolean(),
    emphasis: z.optional(z.nullable(z.enum(["ACCENT"]))),
    seq: z.optional(z.union([z.int().gte(1), z.null()])),
});
export const zBackofficeBroadcastChatMessageListRootWritable = z.object({
    data: z.array(zChatMessageRootWritable),
    meta: zPaginationMetaRoot,
});
export const zBackofficeBroadcastChatMessageListWritable = zBackofficeBroadcastChatMessageListRootWritable;
export const zLiveMemoRootWritable = z.object({
    broadcastId: z.string(),
    dealerId: z.string(),
    content: z.string(),
    imageUrl: z.optional(z.union([z.string(), z.null()])),
    imageUrls: z.array(z.string()).max(100),
});
export const zScheduledBroadcastRootWritable = z.object({
    dealerId: z.string(),
    status: z.enum(["SCHEDULED"]),
    title: z.string(),
    thumbnail: z.optional(z.union([z.string(), z.null()])),
    announcement: z.optional(z.union([z.string(), z.null()])),
    shippingFee: zMoneyNonNegativeRoot,
    scheduledStartTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    autoLoadShippingFee: z.boolean(),
    autoLoadAnnouncement: z.boolean(),
    categories: z.array(zCategorySummaryRootWritable),
    isTestBroadcast: z.boolean(),
    isAnonymousAuctionBroadcast: z.boolean(),
    showTopPurchasersToHost: z.boolean(),
    showTopPurchasersToViewers: z.boolean(),
});
export const zBidderBriefRootWritable = z.object({
    anonymousNickname: z.string(),
    isAnonymous: z.boolean(),
});
export const zBidderBriefWritable = zBidderBriefRootWritable;
export const zBidRootWritable = z.object({
    auctionId: z.string(),
    bidder: zBidderBriefRootWritable,
    bidAmount: zMoneyRoot,
    minimumBidPrice: zMoneyRoot,
    bidTime: z.iso.datetime(),
    isWinning: z.boolean(),
    isPrivate: z.boolean(),
    createdAt: z.iso.datetime(),
});
export const zBroadcastBriefRootWritable = z.object({
    title: z.string(),
    thumbnailUrl: z.union([z.url(), z.null()]),
    broadcastStatus: z.enum(["SCHEDULED", "LIVE", "ENDED"]),
});
export const zBroadcastBriefWritable = zBroadcastBriefRootWritable;
export const zOrderBriefRootWritable = z.object({
    orderType: z.enum(["AUCTION", "INSTANT_PURCHASE", "GROUP_BUY", "GIVEAWAY"]),
    totalAmount: z.number(),
    orderStatus: z.enum([
        "CREATED",
        "PAYMENT_REQUESTED",
        "AWAITING_REPAYMENT",
        "PAID",
        "SHIPPED",
        "DELIVERED",
        "CONFIRMED",
        "CANCELLED",
        "RETURNED",
        "EXPIRED",
    ]),
});
export const zOrderBriefWritable = zOrderBriefRootWritable;
export const zPaymentRootWritable = z.object({
    order: zOrderBriefRootWritable,
    amount: zMoneyRoot,
    shippingFee: zMoneyNonNegativeRoot,
    refundedAmount: zMoneyNonNegativeRoot,
    status: zPaymentStatusRoot,
    gateway: zPaymentGatewayRoot,
});
export const zPaymentDetailsRoot2Writable = z.object({
    order: zOrderBriefRootWritable,
    broadcastId: z.string(),
    broadcastTitle: z.optional(z.union([z.string(), z.null()])),
    amount: zMoneyRoot,
    shippingFee: zMoneyNonNegativeRoot,
    refundedAmount: zMoneyNonNegativeRoot,
    currency: z.enum(["KRW"]),
    paymentMethodId: z.optional(z.union([z.string(), z.null()])),
    paymentMethodType: z.optional(z.union([zPaymentMethodTypeRoot, z.null()])),
    lastFourDigits: z.optional(z.union([z.string().regex(/^[0-9]{4}$/), z.null()])),
    cardIssuer: z.optional(z.union([z.string(), z.null()])),
    gateway: zPaymentGatewayRoot,
    pgTransactionId: z.optional(z.union([z.string(), z.null()])),
    approvalNumber: z.optional(z.union([z.string(), z.null()])),
    status: zPaymentStatusRoot,
    failedReason: z.optional(z.union([z.string(), z.null()])),
});
export const zBackofficePaymentListResponseRootWritable = z.object({
    data: z.array(zPaymentDetailsRoot2Writable),
    meta: zPaginationMetaRoot,
});
export const zRefundRoot2Writable = z.object({
    paymentId: z.string(),
    order: zOrderBriefRootWritable,
    refundAmount: zMoneyRoot,
    refundReason: zRefundReasonRoot,
    status: zRefundStatusRoot,
    gateway: zPaymentGatewayRoot,
    pgRefundTransactionId: z.optional(z.union([z.string(), z.null()])),
    requestedBy: z.string(),
    failedReason: z.optional(z.union([z.string(), z.null()])),
});
export const zBackofficeRefundListResponseRootWritable = z.object({
    data: z.array(zRefundRoot2Writable),
    meta: zPaginationMetaRoot,
});
export const zBackofficeSettlementDetailRootWritable = z.object({
    order: zOrderBriefRootWritable,
    productAmount: zMoneyRoot,
    shippingFee: zMoneyRoot,
    payoutAmount: zMoneyRoot,
    netPayoutAmount: z.optional(z.union([zMoneyRoot, z.null()])),
    pgFeeAmount: zMoneyRoot,
    platformFeeAmount: zMoneyRoot,
    platformCommission: zMoneyRoot,
    shippingPgFeeAmount: zMoneyRoot,
    totalPaymentAmount: zMoneyRoot,
    status: zSettlementStatusRoot,
    eligibilityDate: z.iso.datetime(),
    orderConfirmedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    confirmedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    paidAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    paymentAgencyTransactionId: z.optional(z.union([z.string(), z.null()])),
    failureReason: z.optional(z.union([z.string(), z.null()])),
    errorCode: z.optional(z.union([z.string(), z.null()])),
    settlementAccount: z.optional(z.union([zSettlementAccountRoot2Writable, z.null()])),
    offsets: z.array(zSettlementOffsetSummaryRootWritable),
});
export const zBackofficeSettlementDetailWritable = zBackofficeSettlementDetailRootWritable;
export const zBackofficeSettlementSummaryRootWritable = z.object({
    order: zOrderBriefRootWritable,
    totalPaymentAmount: zMoneyRoot,
    platformFeeAmount: zMoneyRoot,
    pgFeeAmount: zMoneyRoot,
    shippingPgFeeAmount: zMoneyRoot,
    payoutAmount: zMoneyRoot,
    netPayoutAmount: zMoneyRoot,
    status: zSettlementStatusRoot,
    eligibilityDate: z.iso.datetime(),
    orderConfirmedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    paidAt: z.optional(z.union([z.iso.datetime(), z.null()])),
});
export const zBackofficeSettlementSummaryWritable = zBackofficeSettlementSummaryRootWritable;
export const zBackofficeSettlementListResponseRootWritable = z.object({
    data: z.array(zBackofficeSettlementSummaryRootWritable),
    meta: zPaginationMetaRoot,
    nextCursor: z.optional(z.union([z.string(), z.null()])),
});
export const zBackofficeSettlementListResponseWritable = zBackofficeSettlementListResponseRootWritable;
export const zSettlementRoot2Writable = z.object({
    dealerId: z.string(),
    order: zOrderBriefRootWritable,
    payoutAmount: zMoneyRoot,
    netPayoutAmount: z.optional(z.union([zMoneyRoot, z.null()])),
    platformCommission: zMoneyRoot,
    totalPaymentAmount: zMoneyRoot,
    status: zSettlementStatusRoot,
    eligibilityDate: z.iso.datetime(),
    confirmedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    paidAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    paymentAgencyTransactionId: z.optional(z.union([z.string(), z.null()])),
    commissionTransactionId: z.optional(z.union([z.string(), z.null()])),
    failureReason: z.optional(z.union([z.string(), z.null()])),
    errorCode: z.optional(z.union([z.string(), z.null()])),
    offsets: z.optional(z.array(zSettlementOffsetSummaryRootWritable)),
});
export const zSettlementSummaryRootWritable = z.object({
    dealerId: z.string(),
    order: zOrderBriefRootWritable,
    payoutAmount: zMoneyRoot,
    netPayoutAmount: z.optional(z.union([zMoneyRoot, z.null()])),
    status: zSettlementStatusRoot,
    eligibilityDate: z.iso.datetime(),
    orderConfirmedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    paidAt: z.optional(z.union([z.iso.datetime(), z.null()])),
});
export const zProductBriefRootWritable = z.object({
    name: z.string(),
    thumbnailUrl: z.union([z.url(), z.null()]),
    price: z.number(),
});
export const zProductBriefWritable = zProductBriefRootWritable;
export const zOrderRootWritable = z.object({
    product: zProductBriefRootWritable,
});
export const zOrderItemRootWritable = z.object({
    productListingId: z.string(),
    saleOrderNumber: z.optional(z.union([z.int().gte(1), z.null()])),
    purchaseNumber: z.optional(z.union([z.int().gte(1), z.null()])),
    product: zProductBriefRootWritable,
    productName: z.string(),
    quantity: z.int().gte(1),
    unitPrice: zMoneyRoot,
    subtotal: zMoneyRoot,
});
export const zGroupBuyListingRootWritable = z.object({
    productListingId: z.string(),
    product: zProductBriefRootWritable,
    dealerId: z.string(),
    broadcast: zBroadcastBriefRootWritable,
    totalSlots: z.int().gte(1),
    soldSlots: z.int().gte(0),
    slotPrice: zMoneyRoot,
    breakSchedule: z.iso.datetime(),
    status: z.enum(["PENDING", "ACTIVE", "BREAKING", "COMPLETED", "CANCELLED"]),
});
export const zInstantPurchaseRootWritable = z.object({
    broadcast: z.optional(z.union([zBroadcastBriefRootWritable, z.null()])),
    productListingId: z.string(),
    product: zProductBriefRootWritable,
    dealerId: z.string(),
    price: zMoneyRoot,
    availableQuantity: z.int().gte(0),
    soldQuantity: z.int().gte(0),
    salesChannel: z.enum(["BROADCAST", "MARKETPLACE"]),
    status: z.enum(["AVAILABLE", "SOLD_OUT", "ENDED", "CANCELLED"]),
});
export const zUserBriefRootWritable = z.object({
    nickname: z.string(),
    profileImageUrl: z.union([z.url(), z.null()]),
});
export const zUserBriefWritable = zUserBriefRootWritable;
export const zBackofficeLiveSnapshotRootWritable = z.object({
    liveSnapshotId: z.uuid(),
    status: z.enum(["PUBLISHED", "HIDDEN", "DELETED"]),
    imageUrl: z.url(),
    productName: z.string(),
    broadcastId: z.uuid(),
    broadcastTitle: z.string(),
    dealerMemo: z.optional(z.union([z.string(), z.null()])),
    categories: z.array(zLiveSnapshotCategoryRoot),
    dealer: zUserBriefRootWritable,
    buyer: zUserBriefRootWritable,
    buyerAnonymousNickname: z.union([z.string(), z.null()]),
    buyerVisible: z.boolean(),
    sourceType: z.nullable(z.enum(["AUCTION", "INSTANT_PURCHASE", "GIVEAWAY"])),
    sourceId: z.union([z.uuid(), z.null()]),
    orderId: z.union([z.uuid(), z.null()]),
    hiddenAt: z.union([z.iso.datetime(), z.null()]),
    hiddenReason: z.union([z.string(), z.null()]),
    deletedAt: z.union([z.iso.datetime(), z.null()]),
    createdAt: z.iso.datetime(),
});
export const zBackofficeLiveSnapshotListRootWritable = z.object({
    data: z.array(zBackofficeLiveSnapshotRootWritable),
    meta: zPaginationMetaRoot,
});
export const zLiveSnapshotBuyerCandidateListRootWritable = z.object({
    data: z.array(zUserBriefRootWritable),
});
export const zLiveSnapshotDetailRootWritable = z.object({
    imageUrl: z.url(),
    productName: z.string(),
    dealerMemo: z.optional(z.union([z.string(), z.null()])),
    buyer: z.union([zLiveSnapshotBuyerRoot, z.null()]),
    dealer: zUserBriefRootWritable,
    broadcast: zLiveSnapshotBroadcastRoot,
    categories: z.array(zLiveSnapshotCategoryRoot),
    canDelete: z.boolean(),
});
export const zMessageRootWritable = z.object({
    roomId: z.string(),
    sender: zUserBriefRootWritable,
    content: z.string(),
    messageType: z.enum(["TEXT_MESSAGE", "IMAGE_MESSAGE"]),
    imageUrls: z.array(z.string()),
    isDeleted: z.boolean(),
});
export const zChatRoomRoot2Writable = z.object({
    dealer: zUserBriefRootWritable,
    buyer: zUserBriefRootWritable,
    isActive: z.boolean(),
    lastMessage: z.optional(zMessageRootWritable),
});
export const zChatRoomListRoot2Writable = z.object({
    data: z.array(zChatRoomRoot2Writable),
    meta: zPaginationMetaRoot,
});
export const zMessageListRoot2Writable = z.object({
    messages: z.array(zMessageRootWritable),
    hasMore: z.boolean(),
    nextCursor: z.optional(z.union([z.string(), z.null()])),
});
export const zMyChatRoomOpenRootWritable = z.object({
    roomType: z.enum(["OPEN"]),
    title: z.string(),
    thumbnail: z.optional(z.union([z.url(), z.null()])),
    maxParticipants: z.int().gte(1),
    currentParticipantCount: z.int().gte(0),
    status: z.enum(["OPEN", "CLOSED", "ARCHIVED"]),
    noticeBanner: z.optional(z.union([z.string(), z.null()])),
    lastMessage: z.optional(zMessageRootWritable),
});
export const zMyChatRoomPrivateRootWritable = z.object({
    roomType: z.enum(["PRIVATE"]),
    dealer: zUserBriefRootWritable,
    buyer: zUserBriefRootWritable,
    isActive: z.boolean(),
    lastMessage: z.optional(zMessageRootWritable),
});
export const zMyChatRoomRootWritable = z.union([
    z
        .object({
        roomType: z.literal("MyChatRoomPrivate_rootWritable"),
    })
        .and(zMyChatRoomPrivateRootWritable),
    z
        .object({
        roomType: z.literal("MyChatRoomOpen_rootWritable"),
    })
        .and(zMyChatRoomOpenRootWritable),
]);
export const zMyChatRoomListRoot2Writable = z.object({
    data: z.array(zMyChatRoomRootWritable),
    meta: zPaginationMetaRoot,
});
export const zBroadcastSoldListingRootWritable = z.object({
    transactionType: z.enum(["AUCTION", "INSTANT_PURCHASE", "GIVEAWAY"]),
    productName: z.string(),
    productImageUrl: z.union([z.url(), z.null()]),
    tradePrice: z.number(),
    tradePriceCurrency: z.string(),
    buyer: zUserBriefRootWritable,
    slotNumber: z.union([z.int(), z.null()]),
    liveSnapshotId: z.optional(z.union([z.uuid(), z.null()])),
    canCreateLiveSnapshot: z.optional(z.boolean()),
});
export const zBackofficeLoungeCommentRootWritable = z.object({
    postId: z.string(),
    parentCommentId: z.union([z.string(), z.null()]),
    author: zUserBriefRootWritable,
    content: z.union([z.string(), z.null()]),
    imageUrl: z.union([z.string(), z.null()]),
    likeCount: z.int().gte(0),
    replyCount: z.int().gte(0),
    status: z.enum(["PUBLISHED", "HIDDEN", "DELETED"]),
});
export const zBackofficeLoungeCommentWritable = zBackofficeLoungeCommentRootWritable;
export const zBackofficeLoungeCommentListRootWritable = z.object({
    data: z.array(zBackofficeLoungeCommentRootWritable),
    meta: zPaginationMetaRoot,
});
export const zBackofficeLoungeCommentListWritable = zBackofficeLoungeCommentListRootWritable;
export const zBackofficeLoungePostDetailRootWritable = z.object({
    title: z.string(),
    content: z.string(),
    author: zUserBriefRootWritable,
    categories: z.array(zCategorySummaryRootWritable),
    commentCount: z.int().gte(0),
    likeCount: z.int().gte(0),
    viewCount: z.int().gte(0),
    status: z.enum(["PUBLISHED", "HIDDEN", "DELETED"]),
    isPinned: z.boolean(),
    pinnedAt: z.union([z.iso.datetime(), z.null()]),
    images: z.array(zLoungePostImageRoot),
});
export const zBackofficeLoungePostDetailWritable = zBackofficeLoungePostDetailRootWritable;
export const zBackofficeLoungePostSummaryRootWritable = z.object({
    title: z.string(),
    author: zUserBriefRootWritable,
    categories: z.array(zCategorySummaryRootWritable),
    commentCount: z.int().gte(0),
    likeCount: z.int().gte(0),
    viewCount: z.int().gte(0),
    status: z.enum(["PUBLISHED", "HIDDEN", "DELETED"]),
    isPinned: z.boolean(),
    pinnedAt: z.union([z.iso.datetime(), z.null()]),
    images: z.array(zLoungePostImageRoot),
});
export const zBackofficeLoungePostSummaryWritable = zBackofficeLoungePostSummaryRootWritable;
export const zBackofficeLoungePostListRootWritable = z.object({
    data: z.array(zBackofficeLoungePostSummaryRootWritable),
    meta: zPaginationMetaRoot,
});
export const zBackofficeLoungePostListWritable = zBackofficeLoungePostListRootWritable;
export const zBroadcastRootWritable = z.object({
    dealer: zUserBriefRootWritable,
    broadcastCategoryIds: z.array(z.uuid()),
    status: zBroadcastStatusRoot,
    title: z.string(),
    thumbnail: z.optional(z.union([z.string(), z.null()])),
    announcement: z.optional(z.union([z.string(), z.null()])),
    shippingFee: zMoneyNonNegativeRoot,
    scheduledStartTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    startTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    endTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    endReasonMessage: z.optional(z.union([z.string(), z.null()])),
    viewerCount: z.int().gte(0),
    isTestBroadcast: z.boolean(),
    isAnonymousAuctionBroadcast: z.boolean(),
    autoLoadShippingFee: z.optional(z.boolean()),
    autoLoadAnnouncement: z.optional(z.boolean()),
    framerate: zBroadcastFramerateRoot,
    resolution: zBroadcastResolutionRoot,
    agoraBroadcastId: z.optional(z.union([z.string(), z.null()])),
    agoraChannelName: z.optional(z.union([z.string(), z.null()])),
});
export const zServerPageLiveBroadcastsBlockRootWritable = z.object({
    type: z.literal("liveBroadcasts"),
    title: z.optional(z.string().max(40)),
    maxItems: z.int().gte(1).lte(30),
    items: z.array(zBroadcastRootWritable),
});
export const zServerPageScheduledBroadcastsBlockRootWritable = z.object({
    type: z.literal("scheduledBroadcasts"),
    title: z.optional(z.string().max(40)),
    maxItems: z.int().gte(1).lte(30),
    items: z.array(zBroadcastRootWritable),
});
export const zServerPageBlockRootWritable = z.union([
    zServerPageImageBlockRoot,
    zServerPageTextBlockRoot,
    zServerPageButtonBlockRoot,
    zServerPageSpacerBlockRoot,
    zServerPageProductsBlockRootWritable,
    zServerPageLiveBroadcastsBlockRootWritable,
    zServerPageScheduledBroadcastsBlockRootWritable,
    zServerPageNoticesBlockRoot,
]);
export const zServerPageRootWritable = z.object({
    slug: z.string().max(40),
    title: z.string().max(40),
    blocks: z.array(zServerPageBlockRootWritable),
});
export const zBroadcastDetailsRootWritable = z.object({
    dealer: zUserBriefRootWritable,
    broadcastCategoryIds: z.array(z.uuid()),
    status: zBroadcastStatusRoot,
    title: z.string(),
    thumbnail: z.optional(z.union([z.string(), z.null()])),
    announcement: z.optional(z.union([z.string(), z.null()])),
    shippingFee: zMoneyNonNegativeRoot,
    scheduledStartTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    startTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    endTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    endReasonMessage: z.optional(z.union([z.string(), z.null()])),
    viewerCount: z.int().gte(0),
    isTestBroadcast: z.boolean(),
    isAnonymousAuctionBroadcast: z.boolean(),
    showTopPurchasersToHost: z.boolean(),
    showTopPurchasersToViewers: z.boolean(),
    autoLoadShippingFee: z.optional(z.boolean()),
    autoLoadAnnouncement: z.optional(z.boolean()),
    framerate: zBroadcastFramerateRoot,
    resolution: zBroadcastResolutionRoot,
    agoraBroadcastId: z.optional(z.union([z.string(), z.null()])),
    agoraChannelName: z.optional(z.union([z.string(), z.null()])),
    streamUrl: z.optional(z.union([z.string(), z.null()])),
    topPurchasers: z.optional(z.array(zBroadcastTopPurchaserRoot)),
});
export const zForegroundListingRootWritable = z.object({
    listingType: z.enum(["AUCTION", "IMMEDIATE_PURCHASE"]),
    productId: z.string(),
    productName: z.string(),
    productImageUrl: z.string(),
    auctionId: z.optional(z.uuid()),
    auctionType: z.optional(z.enum(["GENERAL", "FIRST_COME", "BLIND"])),
    instantPurchaseId: z.optional(z.uuid()),
    currentHighestBidPrice: z.optional(z.union([zMoneyRoot, z.null()])),
    currentMinimumBidPrice: z.optional(zMoneyRoot),
    currentPrice: z.optional(zMoneyRoot),
    currentHighestBidder: z.optional(z.union([zBidderBriefRootWritable, z.null()])),
    auctionStatus: z.optional(z.enum(["IN_PROGRESS", "SUCCESSFUL_BID", "NO_BID", "CANCELLED"])),
    successfulBidder: z.optional(z.union([zUserBriefRootWritable, z.null()])),
    winningBidAmount: z.optional(z.union([zMoneyRoot, z.null()])),
    endsAt: z.optional(z.iso.datetime()),
    displayUntil: z.optional(z.union([z.iso.datetime(), z.null()])),
    instantPurchaseStatus: z.optional(z.enum(["ON_SALE", "SOLD_OUT", "ENDED"])),
    salesPrice: z.optional(zMoneyRoot),
    remainingQuantity: z.optional(z.int()),
    totalQuantity: z.optional(z.int()),
});
export const zBroadcastScreenStateRootWritable = z.object({
    broadcastId: z.uuid(),
    version: z.int().gte(0),
    serverNow: z.iso.datetime(),
    foregroundListing: z.optional(z.union([zForegroundListingRootWritable, z.null()])),
    instantListings: z.optional(z.array(zForegroundListingRootWritable)),
    instantPurchaseLocked: z.optional(z.boolean()),
    instantListingLimit: z.optional(z.int().gte(1)),
    giveawaySummary: z.optional(z.union([zGiveawaySummaryRoot, z.null()])),
    groupPurchaseSummary: z.array(zGroupPurchaseSummaryRoot),
    topPurchasers: z.optional(z.array(zBroadcastTopPurchaserRoot)),
});
export const zViewerBriefRootWritable = z.object({
    nickname: z.string(),
    profileImageUrl: z.optional(z.union([z.url(), z.null()])),
    viewingMode: z.enum(["FOREGROUND", "BACKGROUND", "PIP", "WEB"]),
});
export const zViewerBriefWritable = zViewerBriefRootWritable;
export const zWinnerBriefRootWritable = z.object({
    nickname: z.union([z.string(), z.null()]),
    anonymousNickname: z.string(),
    profileImageUrl: z.union([z.url(), z.null()]),
});
export const zAuctionRootWritable = z.object({
    broadcast: zBroadcastBriefRootWritable,
    productListingId: z.string(),
    product: zProductBriefRootWritable,
    dealerId: z.string(),
    auctionType: z.enum(["GENERAL", "FIRST_COME", "BLIND"]),
    startingPrice: zMoneyRoot,
    currentPrice: zMoneyRoot,
    winner: z.optional(z.union([zWinnerBriefRootWritable, z.null()])),
    status: z.enum(["SCHEDULED", "ACTIVE", "ENDED", "UNSUCCESSFUL", "CANCELLED"]),
    startTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    endTime: z.iso.datetime(),
    extensionCount: z.int().gte(0),
    bidCount: z.int().gte(0),
    useAnonymousNicknames: z.boolean(),
});
export const zAuctionDetailsRootWritable = z.object({
    auctionId: z.uuid(),
    broadcastId: z.string(),
    productListingId: z.uuid(),
    dealerId: z.uuid(),
    auctionType: z.enum(["GENERAL", "FIRST_COME", "BLIND"]),
    startingPrice: zMoneyRoot,
    currentPrice: zMoneyRoot,
    winner: z.optional(z.union([zWinnerBriefRootWritable, z.null()])),
    status: z.enum(["SCHEDULED", "ACTIVE", "ENDED", "UNSUCCESSFUL", "CANCELLED"]),
    startTime: z.optional(z.union([z.iso.datetime(), z.null()])),
    endTime: z.iso.datetime(),
    extensionCount: z.int().gte(0),
    bidCount: z.int().gte(0),
    useAnonymousNicknames: z.boolean(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
    bids: z.array(zBidRootWritable),
    product: zProductBriefRootWritable,
    userParticipationStatus: z.optional(zAuctionUserParticipationStatusRoot),
});
export const zGiveawayRootWritable = z.object({
    broadcast: zBroadcastBriefRootWritable,
    productListingId: z.string(),
    product: zProductBriefRootWritable,
    dealerId: z.string(),
    shippingFee: zMoneyNonNegativeRoot,
    totalEntries: z.int().gte(0),
    eligibilityRule: z.enum(["ANYONE", "FOLLOWERS", "PURCHASERS"]),
    eligibilityLabel: z.optional(z.string()),
    drawingType: z.enum(["AUTO", "MANUAL"]),
    winner: z.optional(z.union([zWinnerBriefRootWritable, z.null()])),
    status: z.enum(["OPEN", "CLOSED", "DRAWN"]),
    drawnAt: z.optional(z.union([z.iso.datetime(), z.null()])),
});
export const zGiveawayWinnerRootWritable = z.object({
    giveawayId: z.string(),
    winner: zWinnerBriefRootWritable,
    drawnAt: z.iso.datetime(),
    announcedAt: z.optional(z.union([z.iso.datetime(), z.null()])),
});
export const zPhoneNumberRootWritable = z.object({
    countryCode: z.string().regex(/^\+[1-9]\d{0,3}$/),
    number: z.string().regex(/^\d{8,15}$/),
});
export const zPhoneNumberWritable = zPhoneNumberRootWritable;
export const zBackofficeUserAccountDetailsRootWritable = z.object({
    nickname: z.string(),
    email: z.optional(z.union([z.email(), z.null()])),
    phoneNumber: z.optional(z.union([zPhoneNumberRootWritable, z.null()])),
    socialProvider: z.enum(["GOOGLE", "APPLE", "KAKAO", "NAVER", "BOLTB"]),
    roles: z.array(zUserRoleRoot).min(1),
    status: z.enum(["ACTIVE", "SUSPENDED", "WITHDRAWN"]),
    profileImage: z.optional(z.union([z.url(), z.null()])),
    bio: z.optional(z.union([z.string(), z.null()])),
    dealerPermission: z.optional(z.null()),
    suspensionDetails: z.optional(z.union([zBackofficeUserAccountDetailsSuspensionDetailsWritable, z.null()])),
    notificationSettings: z.optional(zNotificationSettingsRoot2Writable),
});
export const zPhoneNumberUpdateRootWritable = z.object({
    phoneNumber: zPhoneNumberRootWritable,
});
export const zPhoneVerificationRootWritable = z.object({
    phoneNumber: zPhoneNumberRootWritable,
    verificationCode: z.string().regex(/^\d{6}$/),
});
export const zPhoneVerificationCodeRequestRootWritable = z.object({
    phoneNumber: zPhoneNumberRootWritable,
    agreedConsentTypes: z.optional(z.array(zConsentTypeRoot).max(10)),
});
export const zUserAccountListItemRootWritable = z.object({
    nickname: z.string(),
    email: z.optional(z.union([z.email(), z.null()])),
    phoneNumber: z.optional(z.union([zPhoneNumberRootWritable, z.null()])),
    socialProvider: z.enum(["GOOGLE", "APPLE", "KAKAO", "NAVER", "BOLTB"]),
    roles: z.array(zUserRoleRoot).min(1),
    status: z.enum(["ACTIVE", "SUSPENDED", "WITHDRAWN"]),
});
export const zUserAccountListRoot2Writable = z.object({
    data: z.array(zUserAccountListItemRootWritable),
    meta: zPaginationMetaRoot,
});
export const zUserDetailsRoot2Writable = z.object({
    socialProvider: z.enum(["GOOGLE", "APPLE", "KAKAO", "NAVER"]),
    email: z.optional(z.union([z.email(), z.null()])),
    phoneNumber: z.optional(z.union([zPhoneNumberRootWritable, z.null()])),
    nickname: z.string(),
    profileImage: z.optional(z.union([z.url(), z.null()])),
    bio: z.optional(z.union([z.string(), z.null()])),
    notificationSettings: zNotificationSettingsRoot2Writable,
    roles: z.array(zUserRoleRoot).min(1),
    status: z.enum(["ACTIVE", "SUSPENDED", "WITHDRAWN"]),
    themeMode: zThemeModeRoot,
});
export const zUserLoginResponseRootWritable = z.object({
    socialProvider: z.enum(["GOOGLE", "APPLE", "KAKAO", "NAVER"]),
    email: z.optional(z.union([z.email(), z.null()])),
    phoneNumber: z.optional(z.union([zPhoneNumberRootWritable, z.null()])),
    nickname: z.string(),
    profileImage: z.optional(z.union([z.url(), z.null()])),
    roles: z.array(zUserRoleRoot).min(1),
    status: z.enum(["ACTIVE", "SUSPENDED", "WITHDRAWN"]),
    accessToken: z.string(),
});
export const zSocialLoginResponseRootWritable = z.object({
    result: z.enum(["LOGGED_IN", "SIGNUP_REQUIRED", "DEALER_ROLE_REQUIRED"]),
    session: z.union([zUserLoginResponseRootWritable, z.null()]),
    signup: z.union([zSocialSignupTicketRoot, z.null()]),
});
export const zUserPhoneNumberRoot2Writable = z.object({
    phoneNumber: zPhoneNumberRootWritable,
});
export const zUserSummaryRootWritable = z.object({
    accessToken: z.optional(z.string()),
    email: z.optional(z.union([z.email(), z.null()])),
    phoneNumber: z.optional(z.union([zPhoneNumberRootWritable, z.null()])),
    nickname: z.string(),
    profileImage: z.optional(z.union([z.url(), z.null()])),
    roles: z.array(zUserRoleRoot).min(1),
    status: z.enum(["ACTIVE", "SUSPENDED", "WITHDRAWN"]),
});
export const zVerificationResultRoot2Writable = z.object({
    phoneNumber: zPhoneNumberRootWritable,
    verified: z.boolean(),
});
export const zPage = z.int().gte(1).default(1);
export const zPageSize = z.int().gte(1).default(20);
export const zSort = z
    .string()
    .regex(/^[a-zA-Z0-9_]+(:(asc|desc))?(,[a-zA-Z0-9_]+(:(asc|desc))?)*$/);
export const zFilter = z.string();
export const zDealerIdQuery = z.string();
export const zDealerNicknameQuery = z.string();
export const zBuyerNicknameQuery = z.string();
export const zIdPath = z.string();
export const zIdentityCreateUserData = z.object({
    body: zUserRegisterRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zIdentityCreateUserResponse = zUserSummaryRoot;
export const zIdentityDeleteDealerProxyTokenData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zIdentityDeleteDealerProxyTokenResponse = z.void();
export const zIdentityCreateDealerProxyTokenData = z.object({
    body: zDealerProxySessionExchangeRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zIdentityCreateDealerProxyTokenResponse = zDealerProxySessionLoginRoot;
export const zIdentityCreateUserSessionData = z.object({
    body: zUserLoginRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zIdentityCreateUserSessionResponse = zUserLoginResponseRoot;
export const zIdentityCreateUserTokenRefreshData = z.object({
    body: zRefreshTokenRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zIdentityCreateUserTokenRefreshResponse = zRefreshTokenResponseRoot;
export const zIdentityGetUserData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityGetUserResponse = zUserDetailsRoot2;
export const zIdentityUpdateProfileData = z.object({
    body: zProfileUpdateRoot,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityUpdateProfileResponse = zProfileSummaryRoot2;
export const zIdentityGetProfileImageUploadUrlData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        fileName: z.string(),
        mimeType: z.enum(["image/jpeg", "image/png", "image/webp", "image/gif"]),
        fileSizeBytes: z.int().gte(1).lte(5242880),
    }),
});
export const zIdentityGetProfileImageUploadUrlResponse = zProfileImageUploadUrlRoot;
export const zIdentityUpdateNotificationSettingsData = z.object({
    body: zNotificationSettingsUpdateRoot,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityUpdateNotificationSettingsResponse = zNotificationSettingsRoot2;
export const zIdentityUpdatePhoneNumberData = z.object({
    body: zPhoneNumberUpdateRootWritable,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityUpdatePhoneNumberResponse = zUserPhoneNumberRoot2;
export const zIdentityCreatePhoneVerificationData = z.object({
    body: zPhoneVerificationRootWritable,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityCreatePhoneVerificationResponse = zVerificationResultRoot2;
export const zIdentityCreatePhoneVerificationCodeData = z.object({
    body: zPhoneVerificationCodeRequestRootWritable,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityCreatePhoneVerificationCodeResponse = zPhoneVerificationCodeSentRoot2;
export const zIdentityDeleteUserAccountData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityDeleteUserAccountResponse = zWithdrawUserAccountResponseRoot2;
export const zIdentityGetInterestCategoriesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityGetInterestCategoriesResponse = zUserInterestCategoriesRoot2;
export const zIdentityUpdateInterestCategoriesData = z.object({
    body: zUserInterestCategoriesUpdateRoot,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityUpdateInterestCategoriesResponse = zUserInterestCategoriesRoot2;
export const zIdentitySearchUsersData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        search: z.string().min(2).max(100),
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        role: z.optional(z.enum(["COLLECTOR", "DEALER"])),
    }),
});
export const zIdentitySearchUsersResponse = zPublicUserSearchListRoot2;
export const zIdentityCreateAdminSessionData = z.object({
    body: zAdminLoginRequestRootWritable,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zIdentityCreateAdminSessionResponse = zAdminLoginResponseRoot;
export const zIdentityCreateAdminTokenRefreshData = z.object({
    body: z.object({
        refreshToken: z.string(),
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zIdentityCreateAdminTokenRefreshResponse = zAdminLoginResponseRoot;
export const zIdentityCreateUserSuspensionData = z.object({
    body: zUserSuspendRoot,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityCreateUserSuspensionResponse = zUserAccountStatusRoot2;
export const zIdentityListAdminAccountsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        adminLevel: z.optional(z.enum(["SUPER_ADMIN"])),
        status: z.optional(z.enum(["ACTIVE", "INACTIVE", "SUSPENDED"])),
    })),
});
export const zIdentityListAdminAccountsResponse = zAdminAccountListRoot;
export const zIdentityCreateAdminAccountData = z.object({
    body: zAdminAccountCreateRootWritable,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zIdentityCreateAdminAccountResponse = zAdminAccountRoot;
export const zIdentityDeleteAdminAccountData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        adminId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zIdentityDeleteAdminAccountResponse = z.void();
export const zIdentityGetAdminAccountData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        adminId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zIdentityGetAdminAccountResponse = zAdminAccountRoot;
export const zIdentityUpdateAdminAccountData = z.object({
    body: zAdminAccountUpdateRoot,
    path: z.object({
        adminId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zIdentityUpdateAdminAccountResponse = zAdminAccountRoot;
export const zIdentityUpdateAdminPasswordData = z.object({
    body: zAdminPasswordChangeRoot,
    path: z.object({
        adminId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zIdentityUpdateAdminPasswordResponse = z.object({
    message: z.string(),
});
export const zIdentityListAdminLoginLocksData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1).lte(100)).default(20),
    })),
});
export const zIdentityListAdminLoginLocksResponse = zAdminLoginLockListRoot;
export const zIdentityCreateAdminLoginLockReleaseData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        lockId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zIdentityCreateAdminLoginLockReleaseResponse = z.void();
export const zIdentityListUserAccountsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.enum(["ACTIVE", "SUSPENDED", "WITHDRAWN", "ALL"])),
        role: z.optional(z.array(zUserRoleRoot)),
        search: z.optional(z.string().min(1)),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
        notificationSetting: z.optional(zNotificationSettingKeyRoot),
        notificationEnabled: z.optional(z.boolean()),
        osNotificationPermission: z.optional(zOsNotificationPermissionStateRoot),
        appPlatform: z.optional(z.enum(["ANDROID", "IOS"])),
        appVersion: z.optional(z.string().max(50)),
    })),
});
export const zIdentityListUserAccountsResponse = zUserAccountListRoot2;
export const zIdentityGetBackofficeUserAccountData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityGetBackofficeUserAccountResponse = zBackofficeUserAccountDetailsRoot;
export const zIdentityCreateUserActivationData = z.object({
    body: z.optional(zUserActivateRoot),
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityCreateUserActivationResponse = zUserAccountStatusRoot2;
export const zIdentityCreateBackofficeDealerProxySessionData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityCreateBackofficeDealerProxySessionResponse = zDealerProxySessionStartRoot;
export const zIdentityUpdateBackofficeUserProfileImageData = z.object({
    body: zBackofficeProfileImageChangeRoot,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityUpdateBackofficeUserProfileImageResponse = zBackofficeProfileImageChangeResultRoot;
export const zIdentityGetBackofficeProfileImageUploadUrlData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        fileName: z.string(),
        mimeType: z.enum(["image/jpeg", "image/png", "image/webp", "image/gif"]),
        fileSizeBytes: z.int().gte(1).lte(5242880),
    }),
});
export const zIdentityGetBackofficeProfileImageUploadUrlResponse = zProfileImageUploadUrlRoot;
export const zIdentityCreateBackofficeGrantDealerPermissionData = z.object({
    body: zGrantDealerPermissionRequestRoot,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityCreateBackofficeGrantDealerPermissionResponse = zDealerPermissionResultRoot2;
export const zIdentityCreateBackofficeRevokeDealerPermissionData = z.object({
    body: zDealerPermissionRevokeRoot,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityCreateBackofficeRevokeDealerPermissionResponse = zDealerPermissionResultRoot2;
export const zIdentityCreateBackofficeForceNicknameChangeData = z.object({
    body: zForceNicknameChangeRoot,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityCreateBackofficeForceNicknameChangeResponse = zProfileSummaryRoot2;
export const zIdentityListBackofficeUserAdminMemosData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zIdentityListBackofficeUserAdminMemosResponse = zAdminMemoEntryListRoot;
export const zIdentityCreateBackofficeUserAdminMemoData = z.object({
    body: zCreateAdminMemoRequestRoot,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityCreateBackofficeUserAdminMemoResponse = zAdminMemoEntryRoot;
export const zIdentityGetBackofficeNotificationSettingsSummaryData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        status: z.optional(z.enum(["ACTIVE", "SUSPENDED", "WITHDRAWN", "ALL"])),
    })),
});
export const zIdentityGetBackofficeNotificationSettingsSummaryResponse = zBackofficeNotificationSettingsSummaryRoot2;
export const zIdentityGetBackofficeAppVersionSummaryData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        status: z.optional(z.enum(["ACTIVE", "SUSPENDED", "WITHDRAWN", "ALL"])),
    })),
});
export const zIdentityGetBackofficeAppVersionSummaryResponse = zBackofficeAppVersionSummaryRoot;
export const zIdentityListBackofficeUserHistoriesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        userId: z.optional(z.uuid()),
        nickname: z.optional(z.string().min(1)),
        category: z.optional(zUserHistoryCategoryRoot),
        changeText: z.optional(z.string().min(1).max(100)),
        actorType: z.optional(zUserHistoryActorTypeRoot),
        dateFrom: z.optional(z.iso.date()),
        dateTo: z.optional(z.iso.date()),
    })),
});
export const zIdentityListBackofficeUserHistoriesResponse = zUserHistoryEntryListRoot;
export const zIdentityListAdminHistoriesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1).lte(500)).default(20),
        actorType: z.optional(zOperationActorTypeRoot),
        adminId: z.optional(z.uuid()),
        adminUsername: z.optional(z.string().max(50)),
        domain: z.optional(zOperationDomainRoot),
        action: z.optional(z.string().max(64)),
        targetId: z.optional(z.string().max(100)),
        changeText: z.optional(z.string().max(100)),
        dateFrom: z.optional(z.iso.date()),
        dateTo: z.optional(z.iso.date()),
        historyId: z.optional(z.uuid()),
    })),
});
export const zIdentityListAdminHistoriesResponse = zAdminHistoryEntryListRoot;
export const zIdentityListDealerHistoriesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1).lte(500)).default(20),
        dealerId: z.optional(z.uuid()),
        dealerNickname: z.optional(z.string().max(50)),
        channel: z.optional(zDealerHistoryChannelRoot),
        actorType: z.optional(zDealerHistoryActorTypeRoot),
        domain: z.optional(zOperationDomainRoot),
        action: z.optional(z.string().max(64)),
        targetId: z.optional(z.string().max(100)),
        changeText: z.optional(z.string().max(100)),
        dateFrom: z.optional(z.iso.date()),
        dateTo: z.optional(z.iso.date()),
    })),
});
export const zIdentityListDealerHistoriesResponse = zDealerHistoryEntryListRoot;
export const zIdentityGetBackofficeUserInterestCategoriesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityGetBackofficeUserInterestCategoriesResponse = zBackofficeUserInterestCategoriesRoot2;
export const zIdentityUpdateBackofficeUserInterestCategoriesData = z.object({
    body: zUserInterestCategoriesUpdateRoot,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityUpdateBackofficeUserInterestCategoriesResponse = zBackofficeUserInterestCategoriesRoot2;
export const zIdentityCreateBackofficeInterestCategoryRepromptRequestData = z.object({
    body: zInterestCategoryRepromptRequestCreateRoot,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityCreateBackofficeInterestCategoryRepromptRequestResponse = zInterestCategoryRepromptRequestRoot;
export const zIdentityCreateBackofficeDatabaseResetData = z.object({
    body: zDatabaseResetRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zIdentityCreateBackofficeDatabaseResetResponse = zDatabaseResetResponseRoot;
export const zIdentityCreateKakaoSessionData = z.object({
    body: zKakaoCodeLoginRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zIdentityCreateKakaoSessionResponse = zUserLoginResponseRoot;
export const zIdentityCreateNaverTokenData = z.object({
    body: zNaverCodeExchangeRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zIdentityCreateNaverTokenResponse = zNaverTokenResponseRoot;
export const zIdentityCreateSocialSessionData = z.object({
    body: zSocialLoginRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zIdentityCreateSocialSessionResponse = zSocialLoginResponseRoot;
export const zIdentityCreateSocialSignupData = z.object({
    body: zSocialSignupRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zIdentityCreateSocialSignupResponse = zSocialLoginResponseRoot;
export const zIdentityDeleteDeviceTokenData = z.object({
    body: z.object({
        installationId: z.string().min(1).max(100),
    }),
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityDeleteDeviceTokenResponse = z.void();
export const zIdentityCreateDeviceTokenData = z.object({
    body: zDeviceTokenRegistrationRoot,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zIdentityCreateDeviceTokenResponse = zDeviceTokenRoot2;
export const zStreamingListBackofficeUserBroadcastTelemetrySessionsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z.string(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zStreamingListBackofficeUserBroadcastTelemetrySessionsResponse = zBroadcastTelemetrySessionListRoot;
export const zIdentityUpdateAppInstallationData = z.object({
    body: zAppInstallationReportRoot,
    path: z.object({
        installationId: z.string().min(1).max(100),
    }),
    query: z.optional(z.never()),
});
export const zIdentityUpdateAppInstallationResponse = zAppInstallationRoot;
export const zOrdersListOrdersData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.enum([
            "CREATED",
            "PAYMENT_REQUESTED",
            "AWAITING_REPAYMENT",
            "PAID",
            "SHIPPED",
            "DELIVERED",
            "CONFIRMED",
            "CANCELLED",
            "RETURNED",
            "EXPIRED",
        ])),
        orderType: z.optional(z.enum(["AUCTION", "INSTANT_PURCHASE", "GROUP_BUY", "GIVEAWAY"])),
        auctionType: z.optional(z.enum(["GENERAL", "FIRST_COME", "BLIND"])),
    })),
});
export const zOrdersListOrdersResponse = z.object({
    data: z.array(zOrderRoot),
    meta: zPaginationMetaRoot,
});
export const zOrdersCreateOrderData = z.object({
    body: zOrderCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zOrdersCreateOrderResponse = zOrderRoot;
export const zOrdersCreateOrderCancellationData = z.object({
    body: z.optional(zCancelOrderRequestRoot),
    path: z.object({
        orderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersCreateOrderCancellationResponse = z.void();
export const zOrdersGetOrderData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        orderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersGetOrderResponse = zOrderRoot;
export const zOrdersCreateOrderRepaymentData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        orderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersCreateOrderRepaymentResponse = zRepayOrderResponseRoot;
export const zOrdersCreateOrderShippingFeeRefundData = z.object({
    body: z.optional(zShippingFeeRefundRequestRoot),
    path: z.object({
        orderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersCreateOrderShippingFeeRefundResponse = z.void();
export const zOrdersCreateFulfillmentOrderConfirmationData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        fulfillmentOrderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersCreateFulfillmentOrderConfirmationResponse = zConfirmFulfillmentOrderResponseRoot;
export const zOrdersPatchFulfillmentOrderDeliveryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        fulfillmentOrderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersPatchFulfillmentOrderDeliveryResponse = zMarkFulfillmentOrderDeliveredResponseRoot;
export const zOrdersCreateFulfillmentOrderConfirmationRequestData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        fulfillmentOrderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersCreateFulfillmentOrderConfirmationRequestResponse = zFulfillmentOrderConfirmationRequestResponseRoot;
export const zOrdersGetFulfillmentOrderData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        fulfillmentOrderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersGetFulfillmentOrderResponse = zFulfillmentOrderRoot;
export const zOrdersListMyFulfillmentOrdersData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        displayStatus: z.optional(zFulfillmentOrderDisplayStatusRoot),
    })),
});
export const zOrdersListMyFulfillmentOrdersResponse = zFulfillmentOrderListResponseRoot;
export const zOrdersListReceivedFulfillmentOrdersData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        displayStatus: z.optional(zFulfillmentOrderDisplayStatusRoot),
    })),
});
export const zOrdersListReceivedFulfillmentOrdersResponse = zFulfillmentOrderListResponseRoot;
export const zOrdersGetFulfillmentOrderCountsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        role: z.enum(["BUYER", "DEALER"]),
    }),
});
export const zOrdersGetFulfillmentOrderCountsResponse = zFulfillmentOrderCountsRoot;
export const zOrdersListReturnsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        orderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersListReturnsResponse = z.array(zReturnRoot);
export const zOrdersCreateReturnData = z.object({
    body: zReturnCreateRoot,
    path: z.object({
        orderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersCreateReturnResponse = zReturnRoot;
export const zOrdersGetReturnData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        orderId: z.string(),
        returnId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersGetReturnResponse = zReturnRoot;
export const zOrdersPatchReturnApprovalData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        returnId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersPatchReturnApprovalResponse = zReturnRoot;
export const zOrdersPatchReturnRejectionData = z.object({
    body: zRejectReturnRequestRoot,
    path: z.object({
        returnId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersPatchReturnRejectionResponse = zReturnRoot;
export const zOrdersGetReturnImageUploadUrlData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        fileName: z.string(),
        mimeType: z.enum(["image/jpeg", "image/png", "image/webp", "image/gif"]),
        fileSizeBytes: z.int().gte(1).lte(10485760),
    }),
});
export const zOrdersGetReturnImageUploadUrlResponse = zReturnImageUploadUrlRoot;
export const zOrdersListMyReturnsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.enum(["REQUESTED", "APPROVED", "REJECTED", "REFUNDED"])),
    })),
});
export const zOrdersListMyReturnsResponse = zReturnListResponseRoot;
export const zOrdersListReceivedReturnsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.enum(["REQUESTED", "APPROVED", "REJECTED", "REFUNDED"])),
    })),
});
export const zOrdersListReceivedReturnsResponse = zReturnListResponseRoot;
export const zOrdersGetShipmentData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        shipmentId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersGetShipmentResponse = zShipmentRoot;
export const zOrdersListDeliveryAddressesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zOrdersListDeliveryAddressesResponse = z.object({
    data: z.array(zDeliveryAddressRoot),
    meta: zPaginationMetaRoot,
});
export const zOrdersCreateDeliveryAddressData = z.object({
    body: zDeliveryAddressCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zOrdersCreateDeliveryAddressResponse = zDeliveryAddressRoot;
export const zOrdersDeleteDeliveryAddressData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        addressId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersDeleteDeliveryAddressResponse = z.void();
export const zOrdersGetDeliveryAddressData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        addressId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersGetDeliveryAddressResponse = zDeliveryAddressRoot;
export const zOrdersUpdateDeliveryAddressData = z.object({
    body: zDeliveryAddressUpdateRoot,
    path: z.object({
        addressId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersUpdateDeliveryAddressResponse = zDeliveryAddressRoot;
export const zOrdersCreateDeliveryAddressDefaultData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        addressId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersCreateDeliveryAddressDefaultResponse = zDeliveryAddressRoot;
export const zOrdersListBuyerOrdersData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        buyerId: z.string(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zOrdersListBuyerOrdersResponse = z.object({
    data: z.array(zOrderRoot),
    meta: zPaginationMetaRoot,
});
export const zOrdersListUserDeliveryAddressesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersListUserDeliveryAddressesResponse = z.object({
    data: z.array(zDeliveryAddressRoot),
});
export const zOrdersListMyOrdersData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.enum([
            "CREATED",
            "PAYMENT_REQUESTED",
            "AWAITING_REPAYMENT",
            "PAID",
            "SHIPPED",
            "DELIVERED",
            "CONFIRMED",
            "CANCELLED",
            "RETURNED",
            "EXPIRED",
        ])),
        orderType: z.optional(z.enum(["AUCTION", "INSTANT_PURCHASE", "GROUP_BUY", "GIVEAWAY"])),
        auctionType: z.optional(z.enum(["GENERAL", "FIRST_COME", "BLIND"])),
        broadcastId: z.optional(z.uuid()),
        groupByBroadcast: z.optional(z.boolean()).default(false),
    })),
});
export const zOrdersListMyOrdersResponse = z.union([
    zOrderListResponseRoot,
    zOrderBundleListResponseRoot,
]);
export const zOrdersListReceivedOrdersData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.enum([
            "CREATED",
            "PAYMENT_REQUESTED",
            "AWAITING_REPAYMENT",
            "PAID",
            "SHIPPED",
            "DELIVERED",
            "CONFIRMED",
            "CANCELLED",
            "RETURNED",
            "EXPIRED",
        ])),
        orderType: z.optional(z.enum(["AUCTION", "INSTANT_PURCHASE", "GROUP_BUY", "GIVEAWAY"])),
        auctionType: z.optional(z.enum(["GENERAL", "FIRST_COME", "BLIND"])),
        groupByBroadcast: z.optional(z.boolean()).default(false),
    })),
});
export const zOrdersListReceivedOrdersResponse = z.union([
    zOrderListResponseRoot,
    zOrderBundleListResponseRoot,
]);
export const zOrdersGetReceivedOrdersAnnualSalesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zOrdersGetReceivedOrdersAnnualSalesResponse = zReceivedOrdersAnnualSalesRoot;
export const zOrdersListBackofficeOrdersData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.enum([
            "CREATED",
            "PAYMENT_REQUESTED",
            "AWAITING_REPAYMENT",
            "PAID",
            "SHIPPED",
            "DELIVERED",
            "CONFIRMED",
            "CANCELLED",
            "RETURNED",
            "EXPIRED",
        ])),
        orderType: z.optional(z.enum(["AUCTION", "INSTANT_PURCHASE", "GROUP_BUY", "GIVEAWAY"])),
        auctionType: z.optional(z.enum(["GENERAL", "FIRST_COME", "BLIND"])),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
        search: z.optional(z.string()),
        broadcastId: z.optional(z.uuid()),
    })),
});
export const zOrdersListBackofficeOrdersResponse = zOrderListResponseRoot;
export const zOrdersGetBackofficeOrderData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        orderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersGetBackofficeOrderResponse = zOrderRoot;
export const zOrdersCreateBackofficeOrderForceCancelRefundData = z.object({
    body: zForceCancelRefundOrderRequestRoot,
    path: z.object({
        orderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersCreateBackofficeOrderForceCancelRefundResponse = z.void();
export const zOrdersCreateBackofficeOrderShippingFeeRefundData = z.object({
    body: z.optional(zShippingFeeRefundRequestRoot),
    path: z.object({
        orderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersCreateBackofficeOrderShippingFeeRefundResponse = z.void();
export const zOrdersListBackofficeUserDeliveryAddressesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z.string(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zOrdersListBackofficeUserDeliveryAddressesResponse = z.object({
    data: z.array(zDeliveryAddressRoot),
    meta: zPaginationMetaRoot,
});
export const zOrdersListBackofficeReturnsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.array(z.enum(["REQUESTED", "APPROVED", "REJECTED", "REFUNDED"]))),
        returnReason: z.optional(z.enum([
            "WRONG_DELIVERY",
            "MISSING_ITEMS",
            "DAMAGED_DEFECTIVE",
            "NOT_AS_DESCRIBED",
            "OTHER",
        ])),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
        search: z.optional(z.string()),
    })),
});
export const zOrdersListBackofficeReturnsResponse = zBackofficeReturnListResponseRoot;
export const zOrdersGetBackofficeReturnData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        returnId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersGetBackofficeReturnResponse = zReturnRoot;
export const zOrdersCreateBackofficeReturnForceApproveRefundData = z.object({
    body: zForceApproveRefundReturnRequestRoot,
    path: z.object({
        returnId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersCreateBackofficeReturnForceApproveRefundResponse = z.void();
export const zOrdersListBackofficeShipmentsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.array(z.enum([
            "PREPARING",
            "IN_TRANSIT",
            "OUT_FOR_DELIVERY",
            "DELIVERED",
            "FAILED",
        ]))),
        carrier: z.optional(z.array(zCarrierRoot)),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
    })),
});
export const zOrdersListBackofficeShipmentsResponse = zBackofficeShipmentListResponseRoot;
export const zOrdersGetBackofficeShipmentData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        shipmentId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersGetBackofficeShipmentResponse = zShipmentRoot;
export const zOrdersListBackofficeFulfillmentOrdersData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        displayStatus: z.optional(zFulfillmentOrderDisplayStatusRoot),
        orderType: z.optional(z.enum(["AUCTION", "INSTANT_PURCHASE", "GROUP_BUY", "GIVEAWAY"])),
        auctionType: z.optional(z.enum(["GENERAL", "FIRST_COME", "BLIND"])),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
        search: z.optional(z.string()),
        searchTarget: z.optional(z.enum([
            "FULFILLMENT_ORDER_ID",
            "BUYER_NICKNAME",
            "DEALER_NICKNAME",
            "ORDER_ID",
        ])),
        confirmationHold: z.optional(z.enum(["HELD_AFTER_HOLD_PERIOD", "PROCESSING_DELAYED"])),
    })),
});
export const zOrdersListBackofficeFulfillmentOrdersResponse = zFulfillmentOrderListResponseRoot;
export const zOrdersGetBackofficeFulfillmentOrderData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        fulfillmentOrderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersGetBackofficeFulfillmentOrderResponse = zFulfillmentOrderRoot;
export const zOrdersCreateBackofficeFulfillmentOrderForceCancelRefundData = z.object({
    body: zForceCancelRefundFulfillmentOrderRequestRoot,
    path: z.object({
        fulfillmentOrderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersCreateBackofficeFulfillmentOrderForceCancelRefundResponse = zForceCancelRefundFulfillmentOrderResponseRoot;
export const zOrdersUpdateBackofficeFulfillmentOrderShipmentTrackingData = z.object({
    body: zChangeShipmentTrackingRequestRoot,
    path: z.object({
        fulfillmentOrderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersUpdateBackofficeFulfillmentOrderShipmentTrackingResponse = zChangeShipmentTrackingResponseRoot;
export const zOrdersUpdateBackofficeFulfillmentOrderShippingAddressData = z.object({
    body: zChangeFulfillmentOrderShippingAddressRequestRoot,
    path: z.object({
        fulfillmentOrderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersUpdateBackofficeFulfillmentOrderShippingAddressResponse = zChangeFulfillmentOrderShippingAddressResponseRoot;
export const zOrdersCreateFulfillmentOrderShipmentData = z.object({
    body: zShipFulfillmentOrderRequestRoot,
    path: z.object({
        fulfillmentOrderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersCreateFulfillmentOrderShipmentResponse = zShipFulfillmentOrderResponseRoot;
export const zOrdersUpdateFulfillmentOrderShippingAddressData = z.object({
    body: zChangeFulfillmentOrderShippingAddressRequestRoot,
    path: z.object({
        fulfillmentOrderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersUpdateFulfillmentOrderShippingAddressResponse = zChangeFulfillmentOrderShippingAddressResponseRoot;
export const zOrdersListFulfillmentOrderBuyerDeliveryAddressesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        fulfillmentOrderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersListFulfillmentOrderBuyerDeliveryAddressesResponse = zFulfillmentOrderBuyerDeliveryAddressesResponseRoot;
export const zOrdersGetFulfillmentOrderTrackingStatusData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        fulfillmentOrderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersGetFulfillmentOrderTrackingStatusResponse = zFulfillmentOrderTrackingResponseRoot;
export const zOrdersUpdateFulfillmentOrderShipmentTrackingData = z.object({
    body: zChangeShipmentTrackingRequestRoot,
    path: z.object({
        fulfillmentOrderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersUpdateFulfillmentOrderShipmentTrackingResponse = zChangeShipmentTrackingResponseRoot;
export const zOrdersCreateTrackingValidationData = z.object({
    body: zTrackingValidationRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zOrdersCreateTrackingValidationResponse = zTrackingValidationResponseRoot;
export const zOrdersCreateOrderCancellationRequestData = z.object({
    body: zCancellationRequestCreateRoot,
    path: z.object({
        orderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersCreateOrderCancellationRequestResponse = zCancellationRequestResponseRoot;
export const zOrdersCreateFulfillmentOrderCancellationRequestData = z.object({
    body: zCancellationRequestCreateRoot,
    path: z.object({
        fulfillmentOrderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersCreateFulfillmentOrderCancellationRequestResponse = zFulfillmentOrderCancellationResponseRoot;
export const zOrdersCreateFulfillmentOrderBatchCancellationRequestData = z.object({
    body: zBatchCancelOrdersRequestRoot,
    path: z.object({
        fulfillmentOrderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersCreateFulfillmentOrderBatchCancellationRequestResponse = zBatchCancelOrdersResponseRoot;
export const zOrdersCreateFulfillmentOrderReturnRequestData = z.object({
    body: zFulfillmentOrderReturnCreateRoot,
    path: z.object({
        fulfillmentOrderId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersCreateFulfillmentOrderReturnRequestResponse = zFulfillmentOrderReturnResponseRoot;
export const zOrdersGetReceivedCancellationRequestData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        cancellationId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersGetReceivedCancellationRequestResponse = zReceivedCancellationRequestRoot;
export const zOrdersPatchCancellationRequestApprovalData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        cancellationId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersPatchCancellationRequestApprovalResponse = zCancellationRequestResponseRoot;
export const zOrdersPatchCancellationRequestRejectionData = z.object({
    body: zRejectCancellationRequestBodyRoot,
    path: z.object({
        cancellationId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zOrdersPatchCancellationRequestRejectionResponse = zCancellationRequestResponseRoot;
export const zOrdersListReceivedCancellationRequestsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.enum(["REQUESTED", "APPROVED", "COMPLETED", "REJECTED"])),
        initiatedBy: z.optional(z.enum(["BUYER", "SYSTEM", "ADMIN"])),
    })),
});
export const zOrdersListReceivedCancellationRequestsResponse = zReceivedCancellationRequestListResponseRoot;
export const zOrdersCreateCancellationRequestBatchApprovalData = z.object({
    body: zBatchApproveCancellationsRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zOrdersCreateCancellationRequestBatchApprovalResponse = zBatchApproveCancellationsResponseRoot;
export const zPaymentListPaymentsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1).lte(100)).default(20),
        status: z.optional(zPaymentStatusRoot),
    })),
});
export const zPaymentListPaymentsResponse = z.object({
    data: z.array(zPaymentRoot),
    totalCount: z.int(),
    page: z.int(),
    pageSize: z.int(),
});
export const zPaymentGetPaymentDetailsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        paymentId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zPaymentGetPaymentDetailsResponse = zPaymentDetailsRoot2;
export const zPaymentCreatePaymentRefundData = z.object({
    body: zRefundRequestRoot,
    path: z.object({
        paymentId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zPaymentCreatePaymentRefundResponse = zRefundRoot2;
export const zPaymentGetRefundStatusData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        refundId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zPaymentGetRefundStatusResponse = zRefundRoot2;
export const zPaymentListPaymentMethodsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zPaymentListPaymentMethodsResponse = z.object({
    data: z.array(zPaymentMethodRoot2),
    meta: zPaginationMetaRoot,
});
export const zPaymentCreatePaymentMethodData = z.object({
    body: zPaymentMethodCreateRootWritable,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPaymentCreatePaymentMethodResponse = zPaymentMethodRoot2;
export const zPaymentDeletePaymentMethodData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        paymentMethodId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zPaymentDeletePaymentMethodResponse = z.void();
export const zPaymentGetPaymentMethodData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        paymentMethodId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zPaymentGetPaymentMethodResponse = zPaymentMethodRoot2;
export const zPaymentCreatePaymentMethodDefaultData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        paymentMethodId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zPaymentCreatePaymentMethodDefaultResponse = zPaymentMethodRoot2;
export const zPaymentCreateAuthorizeData = z.object({
    body: zAuthorizePaymentWebhookRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPaymentCreateAuthorizeResponse = z.object({
    status: z.enum(["ACCEPTED"]),
});
export const zPaymentListBackofficePaymentsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.array(zPaymentStatusRoot)),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
        amountMin: z.optional(z.int().gte(0)),
        amountMax: z.optional(z.int().gte(0)),
        buyerNickname: z.optional(z.string()),
    })),
});
export const zPaymentListBackofficePaymentsResponse = zBackofficePaymentListResponseRoot;
export const zPaymentGetBackofficePaymentData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        paymentId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zPaymentGetBackofficePaymentResponse = zPaymentDetailsRoot2;
export const zPaymentListBackofficeRefundsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.array(zRefundStatusRoot)),
        reason: z.optional(z.array(zRefundReasonRoot)),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
        amountMin: z.optional(z.int().gte(0)),
        amountMax: z.optional(z.int().gte(0)),
        search: z.optional(z.string()),
    })),
});
export const zPaymentListBackofficeRefundsResponse = zBackofficeRefundListResponseRoot;
export const zPaymentGetBackofficeRefundData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        refundId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zPaymentGetBackofficeRefundResponse = zRefundRoot2;
export const zPaymentCreateBackofficeRefundForceProcessData = z.object({
    body: zForceProcessRefundRequestRoot,
    path: z.object({
        refundId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zPaymentCreateBackofficeRefundForceProcessResponse = z.void();
export const zProductCatalogListProductsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.array(z.enum(["DRAFT", "PUBLISHED", "ARCHIVED", "SOLD_OUT"]))),
        broadcastId: z.optional(z.string()),
        dealerId: z.optional(z.string()),
        salesChannel: z.optional(z.enum(["BROADCAST", "MARKETPLACE"])),
        name: z.optional(z.string()),
        categoryId: z.optional(z.array(z.uuid())),
        isBoltbCertified: z.optional(z.boolean()),
        minPrice: z.optional(z.int().gte(0)),
        maxPrice: z.optional(z.int().gte(0)),
        sort: z.optional(z.enum([
            "NEWEST",
            "OLDEST",
            "PRICE_ASC",
            "PRICE_DESC",
            "CATEGORY_NAME",
        ])),
    })),
});
export const zProductCatalogListProductsResponse = z.object({
    data: z.array(zProductSummaryRoot),
    meta: zPaginationMetaRoot,
});
export const zProductCatalogCreateProductData = z.object({
    body: zProductListingCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zProductCatalogCreateProductResponse = zProductListingRoot;
export const zProductCatalogDeleteProductData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        productId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogDeleteProductResponse = z.void();
export const zProductCatalogGetProductData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        productId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogGetProductResponse = zProductDetailsRoot;
export const zProductCatalogUpdateProductDetailsData = z.object({
    body: zProductDetailsUpdateRoot,
    path: z.object({
        productId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogUpdateProductDetailsResponse = zProductListingRoot;
export const zProductCatalogUpdateProductImagesData = z.object({
    body: zProductImagesUpdateRoot,
    path: z.object({
        productId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogUpdateProductImagesResponse = zProductListingRoot;
export const zProductCatalogUpdateProductPricingData = z.object({
    body: zProductPricingUpdateRoot,
    path: z.object({
        productId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogUpdateProductPricingResponse = zProductListingRoot;
export const zProductCatalogPatchProductPublishStatusData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        productId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogPatchProductPublishStatusResponse = zProductListingRoot;
export const zProductCatalogGetProductImageUploadUrlData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        fileName: z.string(),
        mimeType: z.enum(["image/jpeg", "image/png", "image/webp", "image/gif"]),
        fileSizeBytes: z.int().gte(1).lte(10485760),
    }),
});
export const zProductCatalogGetProductImageUploadUrlResponse = zProductImageUploadUrlRoot;
export const zProductCatalogPatchProductArchiveStatusData = z.object({
    body: z.object({
        reason: z.string(),
    }),
    path: z.object({
        productId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogPatchProductArchiveStatusResponse = z.object({
    success: z.boolean(),
    archivedAt: z.iso.datetime(),
});
export const zProductCatalogPatchProductHideStatusData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        productId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogPatchProductHideStatusResponse = z.object({
    success: z.boolean(),
    hiddenAt: z.iso.datetime(),
});
export const zProductCatalogPatchProductUnhideStatusData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        productId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogPatchProductUnhideStatusResponse = z.object({
    success: z.boolean(),
    hiddenAt: z.iso.datetime(),
});
export const zProductCatalogUpdateProductCategoriesData = z.object({
    body: z.object({
        categoryIds: z.array(z.uuid()),
    }),
    path: z.object({
        productId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogUpdateProductCategoriesResponse = z.object({
    success: z.boolean(),
    categoryIds: z.array(z.uuid()),
});
export const zProductCatalogPatchProductSalesChannelData = z.object({
    body: zToggleSalesChannelRoot,
    path: z.object({
        productId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogPatchProductSalesChannelResponse = zProductListingRoot;
export const zProductCatalogCreateGroupBuyData = z.object({
    body: zGroupBuyListingCreateRoot,
    path: z.object({
        productId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogCreateGroupBuyResponse = zGroupBuyListingRoot;
export const zProductCatalogListProductsByBroadcastData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.string(),
    }),
    query: z.optional(z.object({
        status: z.optional(z.enum(["DRAFT", "PUBLISHED", "ARCHIVED", "SOLD_OUT"])),
    })),
});
export const zProductCatalogListProductsByBroadcastResponse = z.array(zProductSummaryRoot);
export const zProductCatalogListGroupBuysData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        broadcastId: z.optional(z.string()),
        dealerId: z.optional(z.string()),
        status: z.optional(z.enum(["PENDING", "ACTIVE", "BREAKING", "COMPLETED", "CANCELLED"])),
    })),
});
export const zProductCatalogListGroupBuysResponse = z.object({
    data: z.array(zGroupBuyListingRoot),
    meta: zPaginationMetaRoot,
});
export const zProductCatalogGetGroupBuyData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        groupBuyId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogGetGroupBuyResponse = zGroupBuyListingRoot;
export const zProductCatalogCreateGroupBuySlotReservationData = z.object({
    body: zSlotReservationRequestRoot,
    path: z.object({
        groupBuyId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogCreateGroupBuySlotReservationResponse = zSlotReservationRoot;
export const zProductCatalogCreateGroupBuySlotReleaseData = z.object({
    body: z.object({
        slotNumber: z.int().gte(1),
        reason: z.optional(z.string()),
    }),
    path: z.object({
        groupBuyId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogCreateGroupBuySlotReleaseResponse = z.object({
    success: z.boolean(),
    slotNumber: z.int(),
    releasedAt: z.iso.datetime(),
});
export const zProductCatalogCreateGroupBuyBreakData = z.object({
    body: z.optional(z.object({
        notes: z.optional(z.string()),
    })),
    path: z.object({
        groupBuyId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogCreateGroupBuyBreakResponse = zGroupBuyListingRoot;
export const zProductCatalogCreateGroupBuyActivationData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        groupBuyId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogCreateGroupBuyActivationResponse = zGroupBuyListingRoot;
export const zProductCatalogListBackofficeProductsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.array(z.enum(["DRAFT", "PUBLISHED", "ARCHIVED", "SOLD_OUT"]))),
        salesChannel: z.optional(z.array(z.enum(["BROADCAST", "MARKETPLACE"]))),
        dealerId: z.optional(z.string()),
        name: z.optional(z.string()),
        categoryId: z.optional(z.array(z.uuid())),
        broadcastId: z.optional(z.string()),
        isBoltbCertified: z.optional(z.boolean()),
    })),
});
export const zProductCatalogListBackofficeProductsResponse = z.object({
    data: z.array(zBackofficeProductSummaryRoot),
    meta: zPaginationMetaRoot,
});
export const zProductCatalogDeleteBackofficeProductData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        productId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogDeleteBackofficeProductResponse = z.void();
export const zProductCatalogGetBackofficeProductData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        productId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogGetBackofficeProductResponse = zBackofficeProductDetailsRoot;
export const zProductCatalogPatchBackofficeProductHideStatusData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        productId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogPatchBackofficeProductHideStatusResponse = z.object({
    success: z.boolean(),
    hiddenAt: z.iso.datetime(),
});
export const zProductCatalogPatchBackofficeProductUnhideStatusData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        productId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogPatchBackofficeProductUnhideStatusResponse = z.object({
    success: z.boolean(),
    hiddenAt: z.iso.datetime(),
});
export const zProductCatalogUpdateBackofficeProductCertificationData = z.object({
    body: zProductCertificationUpdateRoot,
    path: z.object({
        productId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zProductCatalogUpdateBackofficeProductCertificationResponse = z.object({
    productId: z.uuid(),
    isBoltbCertified: z.boolean(),
});
export const zSalesListAuctionsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        dealerNickname: z.optional(z.string()),
        status: z.optional(z.enum(["SCHEDULED", "ACTIVE", "ENDED", "UNSUCCESSFUL", "CANCELLED"])),
        auctionType: z.optional(z.enum(["GENERAL", "FIRST_COME", "BLIND"])),
        broadcastId: z.optional(z.string()),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
        search: z.optional(z.string()),
    })),
});
export const zSalesListAuctionsResponse = z.object({
    data: z.array(zAuctionRoot),
    meta: zPaginationMetaRoot,
});
export const zSalesCreateAuctionData = z.object({
    body: zAuctionCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSalesCreateAuctionResponse = zAuctionRoot;
export const zSalesCreateAuctionWithProductData = z.object({
    body: zAuctionWithProductCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSalesCreateAuctionWithProductResponse = zAuctionRoot;
export const zSalesDeleteAuctionData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        auctionId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesDeleteAuctionResponse = zAuctionRoot;
export const zSalesGetAuctionData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        auctionId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesGetAuctionResponse = zAuctionDetailsRoot;
export const zSalesCreateAuctionStartData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        auctionId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateAuctionStartResponse = zAuctionRoot;
export const zSalesListBidsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        auctionId: z.string(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zSalesListBidsResponse = z.object({
    data: z.array(zBidRoot),
    meta: zPaginationMetaRoot,
});
export const zSalesCreateAuctionBidData = z.object({
    body: zBidCreateRoot,
    path: z.object({
        auctionId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateAuctionBidResponse = zBidRoot;
export const zSalesCreateAuctionCloseData = z.object({
    body: z.optional(z.record(z.string(), z.never())),
    path: z.object({
        auctionId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateAuctionCloseResponse = zAuctionDetailsRoot;
export const zSalesCreateAuctionWinnerRevealData = z.object({
    body: z.optional(z.record(z.string(), z.never())),
    path: z.object({
        auctionId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateAuctionWinnerRevealResponse = zAuctionDetailsRoot;
export const zSalesCreateAuctionPriceReductionData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        auctionId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateAuctionPriceReductionResponse = zAuctionRoot;
export const zSalesListInstantPurchasesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        dealerNickname: z.optional(z.string()),
        status: z.optional(z.enum(["AVAILABLE", "SOLD_OUT", "ENDED", "CANCELLED"])),
        salesChannel: z.optional(z.enum(["BROADCAST", "MARKETPLACE"])),
        broadcastId: z.optional(z.string()),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
    })),
});
export const zSalesListInstantPurchasesResponse = z.object({
    data: z.array(zInstantPurchaseRoot),
    meta: zPaginationMetaRoot,
});
export const zSalesCreateInstantPurchaseData = z.object({
    body: zInstantPurchaseCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSalesCreateInstantPurchaseResponse = zInstantPurchaseRoot;
export const zSalesCreateInstantPurchaseWithProductData = z.object({
    body: zInstantPurchaseWithProductCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSalesCreateInstantPurchaseWithProductResponse = zInstantPurchaseRoot;
export const zSalesGetInstantPurchaseData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        instantPurchaseId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesGetInstantPurchaseResponse = zInstantPurchaseRoot;
export const zSalesCreateInstantPurchaseOrderData = z.object({
    body: zPurchaseRequestRoot,
    path: z.object({
        instantPurchaseId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateInstantPurchaseOrderResponse = zPurchaseAcceptedRoot;
export const zSalesCreateInstantPurchaseEndData = z.object({
    body: zEndSaleRequestRoot,
    path: z.object({
        instantPurchaseId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateInstantPurchaseEndResponse = z.void();
export const zSalesUpdateInstantPurchaseQuantityData = z.object({
    body: zQuantityUpdateRoot,
    path: z.object({
        instantPurchaseId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesUpdateInstantPurchaseQuantityResponse = zInstantPurchaseRoot;
export const zSalesCreateBackofficeInstantPurchaseEndData = z.object({
    body: zEndSaleRequestRoot,
    path: z.object({
        instantPurchaseId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateBackofficeInstantPurchaseEndResponse = z.void();
export const zSalesCreateBackofficeAuctionCancelData = z.object({
    body: zEndSaleRequestRoot,
    path: z.object({
        auctionId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateBackofficeAuctionCancelResponse = z.void();
export const zSalesGetBackofficeBroadcastSalesSettingsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSalesGetBackofficeBroadcastSalesSettingsResponse = zBroadcastSalesSettingsRoot;
export const zSalesUpdateBackofficeBroadcastSalesSettingsData = z.object({
    body: zBroadcastSalesSettingsUpdateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSalesUpdateBackofficeBroadcastSalesSettingsResponse = zBroadcastSalesSettingsRoot;
export const zStreamingGetBackofficeBroadcastHostPresenceSettingsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zStreamingGetBackofficeBroadcastHostPresenceSettingsResponse = zBroadcastHostPresenceSettingsRoot;
export const zStreamingUpdateBackofficeBroadcastHostPresenceSettingsData = z.object({
    body: zBroadcastHostPresenceSettingsUpdateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zStreamingUpdateBackofficeBroadcastHostPresenceSettingsResponse = zBroadcastHostPresenceSettingsRoot;
export const zSalesListBackofficeAnonymousNicknameWordsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSalesListBackofficeAnonymousNicknameWordsResponse = zAnonymousNicknameWordListRoot;
export const zSalesCreateBackofficeAnonymousNicknameWordData = z.object({
    body: zAnonymousNicknameWordCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSalesCreateBackofficeAnonymousNicknameWordResponse = zAnonymousNicknameWordRoot;
export const zSalesDeleteBackofficeAnonymousNicknameWordData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        wordId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zSalesDeleteBackofficeAnonymousNicknameWordResponse = z.void();
export const zSalesListGroupBuySalesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        dealerId: z.optional(z.string()),
        status: z.optional(z.enum(["OPEN", "BREAK_IN_PROGRESS", "COMPLETED", "CANCELLED"])),
        broadcastId: z.optional(z.string()),
    })),
});
export const zSalesListGroupBuySalesResponse = z.object({
    data: z.array(zGroupBuySalesRoot),
    meta: zPaginationMetaRoot,
});
export const zSalesCreateGroupBuySalesData = z.object({
    body: zGroupBuySalesCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSalesCreateGroupBuySalesResponse = zGroupBuySalesRoot;
export const zSalesGetGroupBuySalesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        groupBuyId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesGetGroupBuySalesResponse = zGroupBuySalesRoot;
export const zSalesCreateSlotReservationData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        groupBuyId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateSlotReservationResponse = zSlotReservationRoot2;
export const zSalesCreateGroupBuyBreakStartData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        groupBuyId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateGroupBuyBreakStartResponse = zGroupBuySalesRoot;
export const zSalesCreateGroupBuyBreakCompletionData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        groupBuyId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateGroupBuyBreakCompletionResponse = zGroupBuySalesRoot;
export const zSalesCreateGroupBuyCancellationData = z.object({
    body: z.optional(zCancelGroupBuyRequestRoot),
    path: z.object({
        groupBuyId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateGroupBuyCancellationResponse = zGroupBuySalesRoot;
export const zSalesCreateSlotReleaseData = z.object({
    body: zSlotReleaseRequestRoot,
    path: z.object({
        groupBuyId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateSlotReleaseResponse = z.object({
    message: z.string(),
});
export const zSalesCreateSlotPaymentConfirmationData = z.object({
    body: zSlotConfirmRequestRoot,
    path: z.object({
        groupBuyId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateSlotPaymentConfirmationResponse = zSlotReservationRoot2;
export const zSalesListGiveawaysData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        dealerId: z.optional(z.string()),
        status: z.optional(z.enum(["OPEN", "CLOSED", "DRAWN"])),
        broadcastId: z.optional(z.string()),
    })),
});
export const zSalesListGiveawaysResponse = z.object({
    data: z.array(zGiveawayRoot),
    meta: zPaginationMetaRoot,
});
export const zSalesCreateGiveawayData = z.object({
    body: zGiveawayCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSalesCreateGiveawayResponse = zGiveawayRoot;
export const zSalesCreateGiveawayWithProductData = z.object({
    body: zGiveawayWithProductCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSalesCreateGiveawayWithProductResponse = zGiveawayRoot;
export const zSalesGetGiveawayData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        giveawayId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesGetGiveawayResponse = zGiveawayRoot;
export const zSalesGetGiveawayEntryTermsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        giveawayId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesGetGiveawayEntryTermsResponse = zGiveawayEntryTermsRoot;
export const zSalesCreateGiveawayEntryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        giveawayId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateGiveawayEntryResponse = zGiveawayEntryRoot;
export const zSalesCreateGiveawayDrawData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        giveawayId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateGiveawayDrawResponse = zGiveawayWinnerRoot;
export const zSalesCreateGiveawayEntriesCloseData = z.object({
    body: z.record(z.string(), z.never()),
    path: z.object({
        giveawayId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateGiveawayEntriesCloseResponse = zGiveawayRoot;
export const zSalesCreateGiveawayWinnerAnnouncementData = z.object({
    body: z.record(z.string(), z.never()),
    path: z.object({
        giveawayId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesCreateGiveawayWinnerAnnouncementResponse = zGiveawayWinnerRoot;
export const zSalesGetBroadcastProductCountsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSalesGetBroadcastProductCountsResponse = zBroadcastProductCountsRoot;
export const zSalesGetDefaultProductNameData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.string(),
    }),
    query: z.object({
        productType: z.enum(["AUCTION", "INSTANT_PURCHASE", "GIVEAWAY"]),
    }),
});
export const zSalesGetDefaultProductNameResponse = zDefaultProductNameRoot;
export const zSalesListBroadcastSoldListingsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.string(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zSalesListBroadcastSoldListingsResponse = z.object({
    data: z.array(zBroadcastSoldListingRoot),
    meta: zPaginationMetaRoot,
});
export const zSalesListBroadcastUnsoldListingsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.string(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zSalesListBroadcastUnsoldListingsResponse = z.object({
    data: z.array(zBroadcastUnsoldListingRoot),
    meta: zPaginationMetaRoot,
});
export const zSalesCreateMarketplacePurchaseData = z.object({
    body: zMarketplacePurchaseRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSalesCreateMarketplacePurchaseResponse = zMarketplacePurchaseAcceptedRoot;
export const zStreamingCreateBroadcastData = z.object({
    body: zBroadcastCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zStreamingCreateBroadcastResponse = zBroadcastRoot;
export const zStreamingCreateTestBroadcastData = z.object({
    body: zTestBroadcastCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zStreamingCreateTestBroadcastResponse = zBroadcastRoot;
export const zStreamingListLiveBroadcastsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        categoryId: z.optional(z.uuid()),
        search: z.optional(z.string().max(100)),
    })),
});
export const zStreamingListLiveBroadcastsResponse = z.object({
    data: z.array(zBroadcastRoot),
    meta: zPaginationMetaRoot,
});
export const zStreamingListLiveBroadcastCategoryIdsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zStreamingListLiveBroadcastCategoryIdsResponse = zLiveBroadcastCategoryIdsRoot;
export const zStreamingListScheduledBroadcastsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        categoryId: z.optional(z.uuid()),
        search: z.optional(z.string().max(100)),
    })),
});
export const zStreamingListScheduledBroadcastsResponse = z.object({
    data: z.array(zBroadcastRoot),
    meta: zPaginationMetaRoot,
});
export const zStreamingDeleteScheduledBroadcastData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingDeleteScheduledBroadcastResponse = z.void();
export const zStreamingGetScheduledBroadcastData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingGetScheduledBroadcastResponse = zScheduledBroadcastRoot;
export const zStreamingUpdateScheduledBroadcastData = z.object({
    body: zScheduledBroadcastUpdateRoot,
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingUpdateScheduledBroadcastResponse = zScheduledBroadcastRoot;
export const zStreamingListTrendingBroadcastsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zStreamingListTrendingBroadcastsResponse = z.object({
    data: z.array(zBroadcastRoot),
    meta: zPaginationMetaRoot,
});
export const zStreamingListFeaturedBroadcastsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zStreamingListFeaturedBroadcastsResponse = z.object({
    data: z.array(zBroadcastRoot),
    meta: zPaginationMetaRoot,
});
export const zStreamingGetBroadcastData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingGetBroadcastResponse = zBroadcastDetailsRoot;
export const zStreamingCreateBroadcastStartData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingCreateBroadcastStartResponse = zBroadcastRoot;
export const zStreamingCreateBroadcastEndData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingCreateBroadcastEndResponse = zBroadcastRoot;
export const zStreamingUpdateBroadcastTelemetrySessionData = z.object({
    body: zBroadcastTelemetrySessionReportRoot,
    path: z.object({
        telemetrySessionId: z.string().min(1).max(100),
    }),
    query: z.optional(z.never()),
});
export const zStreamingUpdateBroadcastTelemetrySessionResponse = zBroadcastTelemetryReportAckRoot;
export const zStreamingUpdateBroadcastTelemetryWindowData = z.object({
    body: zBroadcastTelemetryWindowReportRoot,
    path: z.object({
        telemetrySessionId: z.string().min(1).max(100),
        windowIndex: z.int().gte(0).lte(100000),
    }),
    query: z.optional(z.never()),
});
export const zStreamingUpdateBroadcastTelemetryWindowResponse = zBroadcastTelemetryReportAckRoot;
export const zStreamingGetBackofficeBroadcastTelemetrySessionData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        telemetrySessionId: z.string().min(1).max(100),
    }),
    query: z.optional(z.never()),
});
export const zStreamingGetBackofficeBroadcastTelemetrySessionResponse = zBroadcastTelemetrySessionDetailRoot;
export const zStreamingUpdateBroadcastConfigData = z.object({
    body: zBroadcastConfigUpdateRoot,
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingUpdateBroadcastConfigResponse = zBroadcastRoot;
export const zStreamingUpdateAnnouncementData = z.object({
    body: zAnnouncementUpdateRoot,
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingUpdateAnnouncementResponse = zBroadcastRoot;
export const zStreamingUpdateViewingModeData = z.object({
    body: z.object({
        viewingMode: zViewingModeRoot,
    }),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingUpdateViewingModeResponse = z.void();
export const zStreamingGetChatHistoryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        sinceSeq: z.optional(z.int().gte(0)),
        limit: z.optional(z.int().gte(1).lte(500)).default(100),
    })),
});
export const zStreamingGetChatHistoryResponse = z.object({
    data: z.array(zChatMessageRoot),
    meta: zPaginationMetaRoot,
});
export const zStreamingCreateBroadcastChatMessageData = z.object({
    body: zChatMessageCreateRoot,
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingCreateBroadcastChatMessageResponse = zSendMessageResponseRoot;
export const zStreamingCreateChatImageData = z.object({
    body: zChatImageCreateRoot,
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingCreateChatImageResponse = zSendMessageResponseRoot;
export const zStreamingDeleteChatMessageData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
        chatId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingDeleteChatMessageResponse = z.void();
export const zStreamingCreateBroadcastChatBanData = z.object({
    body: z.object({
        userId: z.string(),
        duration: z.enum([
            "ONE_HOUR",
            "TWENTY_FOUR_HOURS",
            "SEVEN_DAYS",
            "PERMANENT",
        ]),
        reason: z.string().min(1).max(500),
    }),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingCreateBroadcastChatBanResponse = z.object({
    success: z.boolean(),
    bannedUserId: z.string(),
    bannedUntil: z.optional(z.union([z.iso.datetime(), z.null()])),
    reason: z.string(),
});
export const zStreamingGetUserChatContextData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.object({
        userId: z.string(),
    }),
});
export const zStreamingGetUserChatContextResponse = z.object({
    userId: z.string(),
    nickname: z.string(),
    isBanned: z.boolean(),
    bannedUntil: z.optional(z.union([z.iso.datetime(), z.null()])),
    messageCount: z.int().gte(0),
    deletedMessageCount: z.int().gte(0),
    lastMessageAt: z.optional(z.union([z.iso.datetime(), z.null()])),
    recentMessages: z.array(zChatMessageRoot),
});
export const zStreamingGetLiveMemosData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingGetLiveMemosResponse = z.object({
    data: z.array(zLiveMemoRoot),
});
export const zStreamingCreateLiveMemoData = z.object({
    body: zLiveMemoCreateRoot,
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingCreateLiveMemoResponse = zLiveMemoRoot;
export const zStreamingDeleteLiveMemoData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
        memoId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingDeleteLiveMemoResponse = z.void();
export const zStreamingUpdateLiveMemoData = z.object({
    body: zLiveMemoUpdateRoot,
    path: z.object({
        broadcastId: z.uuid(),
        memoId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingUpdateLiveMemoResponse = zLiveMemoRoot;
export const zStreamingGetLiveMemoImageUploadUrlData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.object({
        fileName: z.string(),
        mimeType: z.enum(["image/jpeg", "image/png", "image/webp", "image/gif"]),
        fileSizeBytes: z.int().gte(1).lte(10485760),
    }),
});
export const zStreamingGetLiveMemoImageUploadUrlResponse = zLiveMemoImageUploadUrlRoot;
export const zStreamingGetBroadcastScreenStateData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingGetBroadcastScreenStateResponse = zBroadcastScreenStateRoot;
export const zStreamingGetBroadcastSalesSummaryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingGetBroadcastSalesSummaryResponse = zBroadcastSalesSummaryRoot;
export const zStreamingGetBroadcastBuyerPresencesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingGetBroadcastBuyerPresencesResponse = zBroadcastBuyerPresenceListRoot;
export const zStreamingCreateBroadcastBuyerCallData = z.object({
    body: zBroadcastBuyerCallCreateRoot,
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingCreateBroadcastBuyerCallResponse = zBroadcastBuyerPresenceRoot;
export const zStreamingGetBroadcastViewerListData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        cursor: z.optional(z.string()),
    })),
});
export const zStreamingGetBroadcastViewerListResponse = zViewerListResponseRoot;
export const zStreamingGetAdjacentBroadcastsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingGetAdjacentBroadcastsResponse = zAdjacentBroadcastsRoot;
export const zStreamingListDealerBroadcastsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        dealerId: z.string(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.enum(["SCHEDULED", "LIVE", "ENDED"])),
    })),
});
export const zStreamingListDealerBroadcastsResponse = z.object({
    data: z.array(zBroadcastRoot),
    meta: zPaginationMetaRoot,
});
export const zStreamingCreateAgoraChannelData = z.object({
    body: zAgoraChannelCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zStreamingCreateAgoraChannelResponse = zAgoraChannelInfoRoot;
export const zStreamingCreateAgoraTokenData = z.object({
    body: zAgoraTokenRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zStreamingCreateAgoraTokenResponse = zAgoraTokenResponseRoot;
export const zStreamingCreateAgoraSessionHeartbeatData = z.object({
    body: zAgoraSessionRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zStreamingCreateAgoraSessionHeartbeatResponse = z.void();
export const zStreamingDeleteAgoraSessionData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        sessionId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingDeleteAgoraSessionResponse = z.void();
export const zStreamingListBackofficeBroadcastsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.array(z.enum(["SCHEDULED", "LIVE", "ENDED"]))),
        search: z.optional(z.string()),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
        includeTestBroadcasts: z.optional(z.boolean()).default(false),
        dealerId: z.optional(z.uuid()),
        broadcastCategoryId: z.optional(z.uuid()),
    })),
});
export const zStreamingListBackofficeBroadcastsResponse = zBackofficeBroadcastListRoot;
export const zStreamingDeleteBackofficeBroadcastData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingDeleteBackofficeBroadcastResponse = z.void();
export const zStreamingListBackofficeBroadcastChatMessagesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        deletionStatus: z.optional(z.enum(["ALL", "DELETED", "NOT_DELETED"])),
        senderNickname: z.optional(z.string()),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
    })),
});
export const zStreamingListBackofficeBroadcastChatMessagesResponse = zBackofficeBroadcastChatMessageListRoot;
export const zStreamingDeleteBackofficeBroadcastChatMessageData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
        chatId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingDeleteBackofficeBroadcastChatMessageResponse = z.void();
export const zStreamingCreateBackofficeBroadcastForceEndData = z.object({
    body: zForceEndBroadcastRequestRoot,
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingCreateBackofficeBroadcastForceEndResponse = z.void();
export const zStreamingDeleteBroadcastReminderData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingDeleteBroadcastReminderResponse = zBroadcastReminderStatusRoot;
export const zStreamingGetBroadcastReminderData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingGetBroadcastReminderResponse = zBroadcastReminderStatusRoot;
export const zStreamingCreateBroadcastReminderData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zStreamingCreateBroadcastReminderResponse = zBroadcastReminderStatusRoot;
export const zStreamingGetBroadcastThumbnailUploadUrlData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        fileName: z.string(),
        mimeType: z.enum(["image/jpeg", "image/png", "image/webp", "image/gif"]),
        fileSizeBytes: z.int().gte(1).lte(10485760),
    }),
});
export const zStreamingGetBroadcastThumbnailUploadUrlResponse = zBroadcastThumbnailUploadUrlRoot;
export const zMessagingListBackofficeSupportChatRoomsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        unreadOnly: z.optional(z.boolean()).default(false),
        search: z.optional(z.string().max(100)),
    })),
});
export const zMessagingListBackofficeSupportChatRoomsResponse = zMyChatRoomListRoot2;
export const zMessagingCreateBackofficeSupportChatRoomData = z.object({
    body: zBackofficeSupportChatRoomOpenRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zMessagingCreateBackofficeSupportChatRoomResponse = zChatRoomRoot2;
export const zMessagingGetBackofficeSupportChatHistoryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        chatRoomId: z.string(),
    }),
    query: z.optional(z.object({
        beforeMessageId: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
    })),
});
export const zMessagingGetBackofficeSupportChatHistoryResponse = zMessageListRoot2;
export const zMessagingCreateBackofficeSupportChatMessageData = z.object({
    body: zMessageSendRoot,
    path: z.object({
        chatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingCreateBackofficeSupportChatMessageResponse = zMessageRoot;
export const zMessagingCreateBackofficeSupportChatReadReceiptData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        chatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingCreateBackofficeSupportChatReadReceiptResponse = z.void();
export const zMessagingListMyChatRoomsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        sort: z.optional(z.enum(["CREATED", "RECENT_ACTIVITY"])),
        roomType: z.optional(z.enum(["PRIVATE", "OPEN"])),
        unreadOnly: z.optional(z.boolean()).default(false),
        search: z.optional(z.string().max(100)),
    })),
});
export const zMessagingListMyChatRoomsResponse = zMyChatRoomListRoot2;
export const zMessagingListChatRoomsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zMessagingListChatRoomsResponse = zChatRoomListRoot2;
export const zMessagingCreateChatRoomData = z.object({
    body: zChatRoomCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zMessagingCreateChatRoomResponse = zChatRoomRoot2;
export const zMessagingDeleteChatRoomMembershipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        chatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingDeleteChatRoomMembershipResponse = z.void();
export const zMessagingGetChatRoomData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        chatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingGetChatRoomResponse = zChatRoomRoot2;
export const zMessagingGetChatHistoryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        chatRoomId: z.string(),
    }),
    query: z.optional(z.object({
        beforeMessageId: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
    })),
});
export const zMessagingGetChatHistoryResponse = zMessageListRoot2;
export const zMessagingCreateChatRoomMessageData = z.object({
    body: zMessageSendRoot,
    path: z.object({
        chatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingCreateChatRoomMessageResponse = zMessageRoot;
export const zMessagingDeleteMessageData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        chatRoomId: z.string(),
        messageId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingDeleteMessageResponse = z.void();
export const zMessagingCreateChatRoomImageData = z.object({
    body: zImageSendRoot,
    path: z.object({
        chatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingCreateChatRoomImageResponse = zMessageRoot;
export const zMessagingCreateChatRoomReadReceiptData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        chatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingCreateChatRoomReadReceiptResponse = z.void();
export const zMessagingListOpenChatRoomsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.enum(["OPEN", "CLOSED"])),
        search: z.optional(z.string()),
        categoryId: z.optional(z.uuid()),
    })),
});
export const zMessagingListOpenChatRoomsResponse = zOpenChatRoomListRoot2;
export const zMessagingListCommunityHomeOpenChatRoomsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        categoryId: z.optional(z.uuid()),
    })),
});
export const zMessagingListCommunityHomeOpenChatRoomsResponse = z.object({
    data: z.array(zOpenChatRoomRoot2),
});
export const zMessagingDeleteOpenChatRoomData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        openChatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingDeleteOpenChatRoomResponse = z.void();
export const zMessagingGetOpenChatRoomData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        openChatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingGetOpenChatRoomResponse = zOpenChatRoomRoot2;
export const zMessagingUpdateOpenChatRoomNoticeData = z.object({
    body: zOpenChatRoomUpdateRoot,
    path: z.object({
        openChatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingUpdateOpenChatRoomNoticeResponse = zOpenChatRoomRoot2;
export const zMessagingCreateOpenChatRoomMembershipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        openChatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingCreateOpenChatRoomMembershipResponse = zOpenChatRoomRoot2;
export const zMessagingDeleteOpenChatRoomMembershipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        openChatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingDeleteOpenChatRoomMembershipResponse = zOpenChatRoomRoot2;
export const zMessagingListOpenChatRoomParticipantsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        openChatRoomId: z.string(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zMessagingListOpenChatRoomParticipantsResponse = zOpenChatRoomParticipantListRoot;
export const zMessagingListOpenChatMessagesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        openChatRoomId: z.string(),
    }),
    query: z.optional(z.object({
        beforeMessageId: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
    })),
});
export const zMessagingListOpenChatMessagesResponse = zMessageListRoot2;
export const zMessagingCreateOpenChatRoomMessageData = z.object({
    body: zOpenChatMessageSendRoot,
    path: z.object({
        openChatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingCreateOpenChatRoomMessageResponse = zMessageRoot;
export const zMessagingCreateOpenChatImageData = z.object({
    body: zOpenChatImageSendRoot,
    path: z.object({
        openChatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingCreateOpenChatImageResponse = zMessageRoot;
export const zMessagingDeleteOpenChatRoomMessageData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        openChatRoomId: z.string(),
        messageId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingDeleteOpenChatRoomMessageResponse = z.void();
export const zMessagingListBackofficeOpenChatRoomsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.enum(["OPEN", "CLOSED"])),
        search: z.optional(z.string()),
        categoryId: z.optional(z.uuid()),
        roomKind: z.optional(z.enum(["COMMUNITY", "DEALER"])),
    })),
});
export const zMessagingListBackofficeOpenChatRoomsResponse = zBackofficeOpenChatRoomListRoot;
export const zMessagingCreateBackofficeOpenChatRoomData = z.object({
    body: zOpenChatRoomCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zMessagingCreateBackofficeOpenChatRoomResponse = zOpenChatRoomRoot2;
export const zMessagingCreateBackofficeOpenChatRoomCloseData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        openChatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingCreateBackofficeOpenChatRoomCloseResponse = z.void();
export const zMessagingListBackofficeMessagesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        chatType: z.optional(z.enum(["BROADCAST_CHAT", "PRIVATE_DM"])),
        search: z.optional(z.string()),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
    })),
});
export const zMessagingListBackofficeMessagesResponse = zBackofficeMessageListRoot;
export const zMessagingCreateBackofficeOpenChatRoomKickUserData = z.object({
    body: z.object({
        userId: z.uuid(),
    }),
    path: z.object({
        openChatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingCreateBackofficeOpenChatRoomKickUserResponse = z.object({
    success: z.boolean(),
    kickedUserId: z.uuid(),
});
export const zMessagingCreateBackofficeOpenChatRoomUpdateCategoryData = z.object({
    body: z.object({
        categoryId: z.uuid(),
    }),
    path: z.object({
        openChatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingCreateBackofficeOpenChatRoomUpdateCategoryResponse = zOpenChatRoomRoot2;
export const zMessagingCreateBackofficeOpenChatRoomUpdateTitleData = z.object({
    body: z.object({
        title: z.string().min(1).max(100),
    }),
    path: z.object({
        openChatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingCreateBackofficeOpenChatRoomUpdateTitleResponse = zOpenChatRoomRoot2;
export const zMessagingCreateBackofficeOpenChatRoomUpdateThumbnailData = z.object({
    body: z.object({
        thumbnail: z.union([z.url(), z.null()]),
    }),
    path: z.object({
        openChatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingCreateBackofficeOpenChatRoomUpdateThumbnailResponse = zOpenChatRoomRoot2;
export const zMessagingGetBackofficeOpenChatRoomThumbnailUploadUrlData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        fileName: z.string(),
        mimeType: z.enum(["image/jpeg", "image/png", "image/webp", "image/gif"]),
        fileSizeBytes: z.int().gte(1).lte(10485760),
    }),
});
export const zMessagingGetBackofficeOpenChatRoomThumbnailUploadUrlResponse = zOpenChatRoomThumbnailUploadUrlRoot;
export const zMessagingGetBackofficeOpenChatRoomKickedUsersData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        openChatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingGetBackofficeOpenChatRoomKickedUsersResponse = z.object({
    data: z.array(zUserBriefRoot),
});
export const zMessagingDeleteBackofficeOpenChatRoomKickedUserData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        openChatRoomId: z.string(),
        userId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingDeleteBackofficeOpenChatRoomKickedUserResponse = z.void();
export const zMessagingGetBackofficeDealerChatRoomSettingsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zMessagingGetBackofficeDealerChatRoomSettingsResponse = zDealerChatRoomSettingsRoot;
export const zMessagingUpdateBackofficeDealerChatRoomSettingsData = z.object({
    body: zDealerChatRoomSettingsUpdateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zMessagingUpdateBackofficeDealerChatRoomSettingsResponse = zDealerChatRoomSettingsRoot;
export const zMessagingListDealerChatRoomsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        categoryId: z.optional(z.uuid()),
        creatorId: z.optional(z.uuid()),
        joinedOnly: z.optional(z.boolean()).default(false),
        search: z.optional(z.string().max(100)),
        sort: z.optional(z.enum(["ADMIN_SETTING", "RECENT_ACTIVITY"])),
    })),
});
export const zMessagingListDealerChatRoomsResponse = zOpenChatRoomListRoot2;
export const zMessagingCreateDealerChatRoomData = z.object({
    body: zDealerChatRoomCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zMessagingCreateDealerChatRoomResponse = zOpenChatRoomRoot2;
export const zMessagingGetDealerChatRoomCreationEligibilityData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zMessagingGetDealerChatRoomCreationEligibilityResponse = zDealerChatRoomCreationEligibilityRoot;
export const zMessagingCreateDealerChatRoomKickUserData = z.object({
    body: z.object({
        userId: z.uuid(),
    }),
    path: z.object({
        openChatRoomId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingCreateDealerChatRoomKickUserResponse = z.object({
    success: z.boolean(),
    kickedUserId: z.uuid(),
});
export const zMessagingListBackofficeOpenChatRoomMessagesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        openChatRoomId: z.string(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        search: z.optional(z.string()),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
        deletionStatus: z.optional(z.enum(["ALL", "DELETED", "NOT_DELETED"])),
    })),
});
export const zMessagingListBackofficeOpenChatRoomMessagesResponse = zBackofficeOpenChatMessageListRoot;
export const zMessagingDeleteBackofficeOpenChatRoomMessageData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        openChatRoomId: z.string(),
        messageId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMessagingDeleteBackofficeOpenChatRoomMessageResponse = z.void();
export const zMessagingListBackofficeDmConversationsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        participantNickname: z.optional(z.string()),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
    })),
});
export const zMessagingListBackofficeDmConversationsResponse = zBackofficeDmConversationListRoot;
export const zMessagingListBackofficeDmConversationMessagesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        chatRoomId: z.string(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
        deletionStatus: z.optional(z.enum(["ALL", "DELETED", "NOT_DELETED"])),
    })),
});
export const zMessagingListBackofficeDmConversationMessagesResponse = zBackofficeDmMessageListRoot;
export const zNotificationListNotificationsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        typeFilter: z.optional(zNotificationTypeRoot),
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zNotificationListNotificationsResponse = zNotificationListRoot2;
export const zNotificationPatchNotificationData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        notificationId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zNotificationPatchNotificationResponse = zNotificationRoot2;
export const zNotificationCreateNotificationOpenData = z.object({
    body: zNotificationOpenCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zNotificationCreateNotificationOpenResponse = z.void();
export const zNotificationListUnreadNotificationsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
    })),
});
export const zNotificationListUnreadNotificationsResponse = zNotificationListRoot2;
export const zNotificationGetNotificationPreferencesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zNotificationGetNotificationPreferencesResponse = zNotificationPreferenceRoot2;
export const zNotificationUpdateNotificationPreferencesData = z.object({
    body: zNotificationPreferenceUpdateRoot,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zNotificationUpdateNotificationPreferencesResponse = zNotificationPreferenceRoot2;
export const zNotificationUpdateAllNotificationsReadData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zNotificationUpdateAllNotificationsReadResponse = zMarkAllNotificationsAsReadResponseRoot2;
export const zNotificationListBroadcastPushSendHistoriesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zNotificationListBroadcastPushSendHistoriesResponse = zBroadcastPushSendHistoryListRoot;
export const zNotificationCreateBroadcastPushSendHistoryData = z.object({
    body: zBroadcastPushSendHistoryCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zNotificationCreateBroadcastPushSendHistoryResponse = zBroadcastPushSendHistoryRoot;
export const zNotificationListNotificationSettingItemsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zNotificationListNotificationSettingItemsResponse = zNotificationSettingItemStateListRoot;
export const zNotificationUpdateNotificationSettingItemData = z.object({
    body: zNotificationSettingItemValueUpdateRoot,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
        key: z.string().regex(/^[A-Z][A-Z0-9_]{1,39}$/),
    }),
    query: z.optional(z.never()),
});
export const zNotificationUpdateNotificationSettingItemResponse = zNotificationSettingItemStateListRoot;
export const zNotificationListBackofficeNotificationSettingItemsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zNotificationListBackofficeNotificationSettingItemsResponse = zNotificationSettingItemListRoot;
export const zNotificationUpdateBackofficeNotificationSettingItemData = z.object({
    body: zNotificationSettingItemUpdateRoot,
    path: z.object({
        key: z.string().regex(/^[A-Z][A-Z0-9_]{1,39}$/),
    }),
    query: z.optional(z.never()),
});
export const zNotificationUpdateBackofficeNotificationSettingItemResponse = zNotificationSettingItemRoot;
export const zNotificationListBackofficeUserNotificationSettingItemsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zNotificationListBackofficeUserNotificationSettingItemsResponse = zBackofficeUserNotificationSettingsRoot;
export const zNotificationListBackofficeNotificationsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        dateFrom: z.optional(z.iso.date()),
        dateTo: z.optional(z.iso.date()),
        templateCode: z.optional(z.string().max(60)),
        recipient: z.optional(z.string().max(100)),
        sender: z.optional(z.string().max(100)),
        status: z.optional(z.enum(["PENDING", "SENT", "FAILED", "READ"])),
        channel: z.optional(z.enum(["PUSH", "IN_APP", "SMS", "ALIMTALK"])),
    })),
});
export const zNotificationListBackofficeNotificationsResponse = zBackofficeNotificationHistoryListRoot;
export const zNotificationGetNotificationOperationSettingsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zNotificationGetNotificationOperationSettingsResponse = zNotificationOperationSettingsRoot;
export const zNotificationUpdateNotificationOperationSettingsData = z.object({
    body: zNotificationOperationSettingsUpdateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zNotificationUpdateNotificationOperationSettingsResponse = zNotificationOperationSettingsRoot;
export const zNotificationListBackofficeNotificationTemplatesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        category: z.optional(zNotificationTemplateCategoryRoot),
        channel: z.optional(zNotificationTemplateChannelFilterRoot),
        search: z.optional(z.string().min(1).max(100)),
    })),
});
export const zNotificationListBackofficeNotificationTemplatesResponse = zNotificationTemplateListRoot;
export const zNotificationUpdateBackofficeNotificationTemplateData = z.object({
    body: zNotificationTemplateUpdateRoot,
    path: z.object({
        code: z.string().regex(/^[A-Z][A-Z0-9_]{1,59}$/),
    }),
    query: z.optional(z.never()),
});
export const zNotificationUpdateBackofficeNotificationTemplateResponse = zNotificationTemplateRoot;
export const zNotificationListNotificationDispatchesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        channel: z.optional(zNotificationDispatchChannelRoot),
        status: z.optional(zNotificationDispatchStatusRoot),
    })),
});
export const zNotificationListNotificationDispatchesResponse = zNotificationDispatchListRoot;
export const zNotificationCreateNotificationDispatchData = z.object({
    body: zNotificationDispatchCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zNotificationCreateNotificationDispatchResponse = zNotificationDispatchRoot;
export const zNotificationCreateNotificationDispatchPreviewData = z.object({
    body: zNotificationDispatchPreviewRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zNotificationCreateNotificationDispatchPreviewResponse = zNotificationDispatchPreviewRoot;
export const zNotificationSearchNotificationDispatchRecipientsData = z.object({
    body: zNotificationDispatchRecipientSearchRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zNotificationSearchNotificationDispatchRecipientsResponse = zNotificationDispatchRecipientListRoot;
export const zNotificationListNotificationDispatchAlimtalkTemplatesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zNotificationListNotificationDispatchAlimtalkTemplatesResponse = zNotificationDispatchAlimtalkTemplateListRoot;
export const zNotificationCreateNotificationDispatchCancellationData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        dispatchId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zNotificationCreateNotificationDispatchCancellationResponse = zNotificationDispatchRoot;
export const zSettlementListSettlementsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        dealerId: z.string(),
        statusFilter: z.optional(z.enum([
            "ALL",
            "PENDING",
            "PROCESSING",
            "COMPLETED",
            "FAILED",
            "BLOCKED",
        ])),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    }),
});
export const zSettlementListSettlementsResponse = z.object({
    data: z.array(zSettlementSummaryRoot),
    meta: zPaginationMetaRoot,
});
export const zSettlementCreateSettlementData = z.object({
    body: zSettlementCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSettlementCreateSettlementResponse = zSettlementRoot2;
export const zSettlementGetSettlementDetailsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        settlementId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSettlementGetSettlementDetailsResponse = zSettlementRoot2;
export const zSettlementCreateSettlementPayoutData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        settlementId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSettlementCreateSettlementPayoutResponse = zPayoutResultRoot2;
export const zSettlementUpdatePayoutSuccessData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        settlementId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSettlementUpdatePayoutSuccessResponse = zSettlementRoot2;
export const zSettlementUpdatePayoutFailedData = z.object({
    body: z.object({
        failureReason: z.string(),
        errorCode: z.optional(z.string()),
    }),
    path: z.object({
        settlementId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSettlementUpdatePayoutFailedResponse = zSettlementRoot2;
export const zSettlementGetSettlementAccountData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        dealerId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSettlementGetSettlementAccountResponse = zSettlementAccountRoot2;
export const zSettlementCreateSettlementAccountData = z.object({
    body: zSettlementAccountCreateRoot,
    path: z.object({
        dealerId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSettlementCreateSettlementAccountResponse = zSettlementAccountRoot2;
export const zSettlementCreateSettlementReportData = z.object({
    body: zSettlementReportRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSettlementCreateSettlementReportResponse = zSettlementReportResponseRoot;
export const zSettlementListBackofficeSettlementsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        cursor: z.optional(z.string()),
        status: z.optional(z.array(zSettlementStatusRoot)),
        dealerId: z.optional(z.string()),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
        search: z.optional(z.string()),
    })),
});
export const zSettlementListBackofficeSettlementsResponse = zBackofficeSettlementListResponseRoot;
export const zSettlementCreateBackofficeSettlementBatchChangeStatusData = z.object({
    body: zBatchChangeSettlementStatusRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSettlementCreateBackofficeSettlementBatchChangeStatusResponse = zBatchChangeSettlementStatusResponseRoot;
export const zSettlementCreateBackofficeSettlementBatchCompletionData = z.object({
    body: zBatchCompleteSettlementsRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSettlementCreateBackofficeSettlementBatchCompletionResponse = zBatchCompleteSettlementsResponseRoot;
export const zSettlementCreateBackofficeSettlementBatchStartProcessingData = z.object({
    body: zBatchStartProcessingRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSettlementCreateBackofficeSettlementBatchStartProcessingResponse = zBatchStartProcessingResponseRoot;
export const zSettlementCreateBackofficeSettlementProcessStartData = z.object({
    body: zSettlementProcessFilterRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSettlementCreateBackofficeSettlementProcessStartResponse = zSettlementProcessResponseRoot;
export const zSettlementCreateBackofficeSettlementProcessCompleteData = z.object({
    body: zSettlementProcessFilterRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSettlementCreateBackofficeSettlementProcessCompleteResponse = zSettlementProcessResponseRoot;
export const zSettlementCreateBackofficeSettlementProcessCancelData = z.object({
    body: zSettlementProcessFilterRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSettlementCreateBackofficeSettlementProcessCancelResponse = zSettlementProcessResponseRoot;
export const zSettlementListBackofficeSettlementExportsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        status: z.optional(z.array(zSettlementStatusRoot)),
        dealerId: z.optional(z.string()),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
        search: z.optional(z.string()),
    })),
});
export const zSettlementListBackofficeSettlementExportsResponse = zBackofficeSettlementExportResponseRoot;
export const zSettlementGetBackofficeSettlementData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        settlementId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSettlementGetBackofficeSettlementResponse = zBackofficeSettlementDetailRoot;
export const zSettlementCreateBackofficeSettlementReversalData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        settlementId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSettlementCreateBackofficeSettlementReversalResponse = zBackofficeSettlementDetailRoot;
export const zSettlementListDealerOffsetsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        dealerId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSettlementListDealerOffsetsResponse = zSettlementOffsetListResponseRoot;
export const zSettlementUpdatePaymentAgencyCallbackData = z.object({
    body: zSettlementCallbackRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSettlementUpdatePaymentAgencyCallbackResponse = zSettlementCallbackResponseRoot;
export const zSocialNetworkCreateInvitationData = z.object({
    body: zSendInvitationRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSocialNetworkCreateInvitationResponse = zInvitationRoot;
export const zSocialNetworkUpdateInvitationData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        invitationId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkUpdateInvitationResponse = zInvitationRoot;
export const zSocialNetworkListInvitationsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z.string(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.enum(["PENDING", "ACCEPTED", "EXPIRED"])),
    })),
});
export const zSocialNetworkListInvitationsResponse = zInvitationListRoot;
export const zSocialNetworkCreateUserFollowData = z.object({
    body: zFollowUserRequestRoot,
    path: z.object({
        userId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkCreateUserFollowResponse = zFollowRelationshipRoot;
export const zSocialNetworkDeleteUserFollowData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z.string(),
        targetUserId: z.string(),
    }),
    query: z.optional(z.object({
        source: z.optional(z.string().max(64)),
    })),
});
export const zSocialNetworkDeleteUserFollowResponse = z.void();
export const zSocialNetworkListFollowersData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z.string(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        search: z.optional(z.string().max(100)),
    })),
});
export const zSocialNetworkListFollowersResponse = zFollowRelationshipListRoot;
export const zSocialNetworkListFollowingData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z.string(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        search: z.optional(z.string().max(100)),
    })),
});
export const zSocialNetworkListFollowingResponse = zFollowRelationshipListRoot;
export const zSocialNetworkCreateUserBlockData = z.object({
    body: zBlockUserRequestRoot,
    path: z.object({
        userId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkCreateUserBlockResponse = zBlockRelationshipRoot;
export const zSocialNetworkDeleteUserBlockData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z.string(),
        targetUserId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkDeleteUserBlockResponse = z.void();
export const zSocialNetworkListBlockedUsersData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z.string(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zSocialNetworkListBlockedUsersResponse = zBlockedUserListResponseRoot;
export const zSocialNetworkCreateReportData = z.object({
    body: zReportUserRequestRoot,
    path: z.object({
        userId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkCreateReportResponse = zUserReportRoot;
export const zSocialNetworkListBackofficeUserBlockedUsersData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z.string(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zSocialNetworkListBackofficeUserBlockedUsersResponse = zBlockedUserListResponseRoot;
export const zSocialNetworkGetPublicUserProfileData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkGetPublicUserProfileResponse = z.union([
    z
        .object({
        type: z.literal("PublicUserProfile_root"),
    })
        .and(zPublicUserProfileRoot),
    z
        .object({
        type: z.literal("ProfileUnavailableResponse_root"),
    })
        .and(zProfileUnavailableResponseRoot),
]);
export const zSocialNetworkGetPublicFollowerStatsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkGetPublicFollowerStatsResponse = zPublicFollowerStatsRoot;
export const zSocialNetworkListReportsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        status: z.optional(z.enum(["PENDING", "UNDER_REVIEW", "RESOLVED", "REJECTED"])),
        targetType: z.optional(z.array(z.enum(["USER", "BROADCAST", "CHAT", "POST", "PRODUCT"]))),
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
        categoryId: z.optional(z.uuid()),
        search: z.optional(z.string()),
    })),
});
export const zSocialNetworkListReportsResponse = zUserReportListRoot;
export const zSocialNetworkGetReportData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        reportId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkGetReportResponse = zUserReportDetailRoot;
export const zSocialNetworkUpdateReportData = z.object({
    body: zReviewReportRequestRoot,
    path: z.object({
        reportId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkUpdateReportResponse = zUserReportRoot;
export const zSocialNetworkListActiveReportReasonCategoriesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSocialNetworkListActiveReportReasonCategoriesResponse = zReportReasonCategoryListRoot;
export const zSocialNetworkListReportReasonCategoriesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        isActive: z.optional(z.boolean()),
    })),
});
export const zSocialNetworkListReportReasonCategoriesResponse = zReportReasonCategoryListRoot;
export const zSocialNetworkCreateReportReasonCategoryData = z.object({
    body: zCreateReportReasonCategoryRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSocialNetworkCreateReportReasonCategoryResponse = zReportReasonCategoryRoot;
export const zSocialNetworkDeleteReportReasonCategoryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        categoryId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkDeleteReportReasonCategoryResponse = z.void();
export const zSocialNetworkGetReportReasonCategoryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        categoryId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkGetReportReasonCategoryResponse = zReportReasonCategoryRoot;
export const zSocialNetworkUpdateReportReasonCategoryData = z.object({
    body: zUpdateReportReasonCategoryRequestRoot,
    path: z.object({
        categoryId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkUpdateReportReasonCategoryResponse = zReportReasonCategoryRoot;
export const zSocialNetworkListLoungePostsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        categoryId: z.optional(z.uuid()),
        authorId: z.optional(z.uuid()),
        search: z.optional(z.string().min(2).max(200)),
        sort: z.optional(z.enum(["NEWEST", "TRENDING", "MOST_VIEWED"])),
    })),
});
export const zSocialNetworkListLoungePostsResponse = zLoungePostListRoot;
export const zSocialNetworkCreateLoungePostData = z.object({
    body: zCreateLoungePostRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSocialNetworkCreateLoungePostResponse = zLoungePostSummaryRoot;
export const zSocialNetworkDeleteLoungePostData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        postId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkDeleteLoungePostResponse = z.void();
export const zSocialNetworkGetLoungePostData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        postId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkGetLoungePostResponse = zLoungePostSummaryRoot;
export const zSocialNetworkUpdateLoungePostData = z.object({
    body: zUpdateLoungePostRequestRoot,
    path: z.object({
        postId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkUpdateLoungePostResponse = zLoungePostSummaryRoot;
export const zSocialNetworkDeleteLoungePostLikeData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        postId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkDeleteLoungePostLikeResponse = z.void();
export const zSocialNetworkCreateLoungePostLikeData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        postId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkListLoungeCommentsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        postId: z.string(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zSocialNetworkListLoungeCommentsResponse = zLoungeCommentListRoot;
export const zSocialNetworkCreateLoungeCommentData = z.object({
    body: zCreateLoungeCommentRequestRoot,
    path: z.object({
        postId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkCreateLoungeCommentResponse = zCreateLoungeCommentResponseRoot;
export const zSocialNetworkDeleteLoungeCommentData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        commentId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkDeleteLoungeCommentResponse = z.void();
export const zSocialNetworkUpdateLoungeCommentData = z.object({
    body: zUpdateLoungeCommentRequestRoot,
    path: z.object({
        commentId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkUpdateLoungeCommentResponse = zLoungeCommentRoot;
export const zSocialNetworkListLoungeCommentRepliesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        commentId: z.uuid(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zSocialNetworkListLoungeCommentRepliesResponse = zLoungeCommentListRoot;
export const zSocialNetworkCreateLoungeCommentReplyData = z.object({
    body: zCreateLoungeCommentRequestRoot,
    path: z.object({
        commentId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkCreateLoungeCommentReplyResponse = zCreateLoungeCommentResponseRoot;
export const zSocialNetworkDeleteLoungeCommentLikeData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        commentId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkDeleteLoungeCommentLikeResponse = z.void();
export const zSocialNetworkCreateLoungeCommentLikeData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        commentId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkListMyLoungeCommentsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zSocialNetworkListMyLoungeCommentsResponse = zMyLoungeCommentListRoot;
export const zSocialNetworkGetLoungePostImageUploadUrlData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        fileName: z.string(),
        mimeType: z.enum(["image/jpeg", "image/png", "image/webp", "image/gif"]),
        fileSizeBytes: z.int().gte(1).lte(10485760),
    }),
});
export const zSocialNetworkGetLoungePostImageUploadUrlResponse = zLoungePostImageUploadUrlRoot;
export const zSocialNetworkGetMyReferralLinkData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSocialNetworkGetMyReferralLinkResponse = z.union([
    zReferralLinkResponseRoot,
    z.null(),
]);
export const zSocialNetworkCreateMyReferralLinkData = z.object({
    body: zSaveReferralLinkRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSocialNetworkCreateMyReferralLinkResponse = zReferralLinkResponseRoot;
export const zSocialNetworkGetMyReferralStatsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zSocialNetworkGetMyReferralStatsResponse = zMyReferralStatsRoot;
export const zSocialNetworkListMyReferredUsersData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zSocialNetworkListMyReferredUsersResponse = zReferredUserListRoot;
export const zSocialNetworkListBackofficeLoungePostsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.array(z.enum(["PUBLISHED", "HIDDEN", "DELETED"]))),
        categoryId: z.optional(z.string()),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
        search: z.optional(z.string()),
    })),
});
export const zSocialNetworkListBackofficeLoungePostsResponse = zBackofficeLoungePostListRoot;
export const zSocialNetworkGetBackofficeLoungePostData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        postId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkGetBackofficeLoungePostResponse = zBackofficeLoungePostDetailRoot;
export const zSocialNetworkCreateBackofficeLoungePostDeletionData = z.object({
    body: zAdminDeleteLoungePostRequestRoot,
    path: z.object({
        postId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkCreateBackofficeLoungePostDeletionResponse = z.void();
export const zSocialNetworkCreateBackofficeLoungePostPinData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        postId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkCreateBackofficeLoungePostPinResponse = z.void();
export const zSocialNetworkCreateBackofficeLoungePostUnpinData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        postId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkCreateBackofficeLoungePostUnpinResponse = z.void();
export const zSocialNetworkListBackofficeLoungePostCommentsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        postId: z.string(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.array(z.enum(["PUBLISHED", "HIDDEN", "DELETED"]))),
    })),
});
export const zSocialNetworkListBackofficeLoungePostCommentsResponse = zBackofficeLoungeCommentListRoot;
export const zSocialNetworkListBackofficeLoungeCommentRepliesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        commentId: z.uuid(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zSocialNetworkListBackofficeLoungeCommentRepliesResponse = zBackofficeLoungeCommentListRoot;
export const zSocialNetworkCreateBackofficeLoungeCommentDeletionData = z.object({
    body: zAdminDeleteLoungeCommentRequestRoot,
    path: z.object({
        commentId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zSocialNetworkCreateBackofficeLoungeCommentDeletionResponse = z.void();
export const zLiveSnapshotListLiveSnapshotsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        categoryId: z.optional(z.uuid()),
        cursor: z.optional(z.string().max(512)),
        limit: z.optional(z.int().gte(1).lte(50)).default(20),
        userId: z.optional(z.uuid()),
        dealerId: z.optional(z.uuid()),
        dateFrom: z.optional(z.iso.date()),
        dateTo: z.optional(z.iso.date()),
    })),
});
export const zLiveSnapshotListLiveSnapshotsResponse = zLiveSnapshotListRoot;
export const zLiveSnapshotCreateLiveSnapshotData = z.object({
    body: zLiveSnapshotCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zLiveSnapshotCreateLiveSnapshotResponse = zLiveSnapshotDetailRoot;
export const zLiveSnapshotGetLiveSnapshotImageUploadUrlData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        fileName: z.string().max(200),
        mimeType: z.enum(["image/jpeg", "image/png", "image/webp"]),
        fileSizeBytes: z.int().gte(1).lte(10485760),
    }),
});
export const zLiveSnapshotGetLiveSnapshotImageUploadUrlResponse = zLiveSnapshotImageUploadUrlRoot;
export const zLiveSnapshotListLiveSnapshotBuyersData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zLiveSnapshotListLiveSnapshotBuyersResponse = zLiveSnapshotBuyerCandidateListRoot;
export const zLiveSnapshotGetLiveSnapshotData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        liveSnapshotId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zLiveSnapshotGetLiveSnapshotResponse = zLiveSnapshotDetailRoot;
export const zLiveSnapshotDeleteLiveSnapshotData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        liveSnapshotId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zLiveSnapshotDeleteLiveSnapshotResponse = z.void();
export const zLiveSnapshotListBackofficeLiveSnapshotsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        status: z.optional(z.array(z.enum(["PUBLISHED", "HIDDEN", "DELETED"]))),
        categoryId: z.optional(z.string()),
        dateFrom: z.optional(z.iso.datetime()),
        dateTo: z.optional(z.iso.datetime()),
        search: z.optional(z.string()),
    })),
});
export const zLiveSnapshotListBackofficeLiveSnapshotsResponse = zBackofficeLiveSnapshotListRoot;
export const zLiveSnapshotGetBackofficeLiveSnapshotData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        liveSnapshotId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zLiveSnapshotGetBackofficeLiveSnapshotResponse = zBackofficeLiveSnapshotRoot;
export const zLiveSnapshotPatchBackofficeLiveSnapshotHideStatusData = z.object({
    body: zBackofficeLiveSnapshotHideRoot,
    path: z.object({
        liveSnapshotId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zLiveSnapshotPatchBackofficeLiveSnapshotHideStatusResponse = zBackofficeLiveSnapshotRoot;
export const zLiveSnapshotPatchBackofficeLiveSnapshotUnhideStatusData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        liveSnapshotId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zLiveSnapshotPatchBackofficeLiveSnapshotUnhideStatusResponse = zBackofficeLiveSnapshotRoot;
export const zLedgerListAccountsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        accountType: z.optional(z.enum(["ASSET", "LIABILITY", "EQUITY", "REVENUE", "EXPENSE"])),
        dealerId: z.optional(z.string()),
        balanceState: z.optional(z.enum(["PENDING", "AVAILABLE", "RESERVED", "SETTLED"])),
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zLedgerListAccountsResponse = zAccountListResponseRoot;
export const zLedgerCreateAccountData = z.object({
    body: zCreateAccountRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zLedgerCreateAccountResponse = zAccountRoot;
export const zLedgerDeleteAccountData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        accountId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zLedgerDeleteAccountResponse = z.void();
export const zLedgerGetAccountData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        accountId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zLedgerGetAccountResponse = zAccountRoot;
export const zLedgerUpdateAccountData = z.object({
    body: zUpdateAccountRequestRoot,
    path: z.object({
        accountId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zLedgerUpdateAccountResponse = zAccountRoot;
export const zLedgerGetAccountBalanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        accountId: z.string(),
    }),
    query: z.optional(z.object({
        asOfDate: z.optional(z.iso.datetime()),
    })),
});
export const zLedgerGetAccountBalanceResponse = zAccountBalanceResponseRoot;
export const zLedgerListJournalEntriesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        accountId: z.optional(z.string()),
        transactionId: z.optional(z.string()),
        fromDate: z.optional(z.iso.datetime()),
        toDate: z.optional(z.iso.datetime()),
        dealerId: z.optional(z.string()),
        status: z.optional(z.enum(["DRAFT", "POSTED"])),
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zLedgerListJournalEntriesResponse = zJournalEntryListResponseRoot;
export const zLedgerCreateJournalEntryData = z.object({
    body: zCreateJournalEntryRequestRootWritable,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zLedgerCreateJournalEntryResponse = zJournalEntryRoot;
export const zLedgerGetJournalEntryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        entryId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zLedgerGetJournalEntryResponse = zJournalEntryRoot;
export const zLedgerCreateReversingJournalEntryData = z.object({
    body: zReverseJournalEntryRequestRoot,
    path: z.object({
        entryId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zLedgerCreateReversingJournalEntryResponse = zJournalEntryRoot;
export const zLedgerListReconciliationReportsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        targetContext: z.optional(z.enum(["PAYMENT", "SETTLEMENT", "CONTROL_ACCOUNT"])),
        status: z.optional(z.enum(["IN_PROGRESS", "COMPLETED", "FAILED"])),
        fromDate: z.optional(z.iso.date()),
        toDate: z.optional(z.iso.date()),
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zLedgerListReconciliationReportsResponse = zReconciliationReportListResponseRoot;
export const zLedgerCreateReconciliationData = z.object({
    body: zStartReconciliationRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zLedgerCreateReconciliationResponse = zReconciliationReportRoot;
export const zLedgerGetReconciliationReportData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        reportId: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zLedgerGetReconciliationReportResponse = zReconciliationReportRoot;
export const zLedgerListDiscrepanciesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        reportId: z.string(),
    }),
    query: z.optional(z.object({
        severity: z.optional(z.enum(["LOW", "MEDIUM", "HIGH", "CRITICAL"])),
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zLedgerListDiscrepanciesResponse = zDiscrepancyListResponseRoot;
export const zLedgerGetDealerBalanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        dealerId: z.string(),
    }),
    query: z.optional(z.object({
        asOfDate: z.optional(z.iso.datetime()),
    })),
});
export const zLedgerGetDealerBalanceResponse = zDealerBalanceResponseRoot2;
export const zLedgerGetTrialBalanceData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        asOfDate: z.optional(z.iso.datetime()),
        periodStart: z.optional(z.iso.datetime()),
        periodEnd: z.optional(z.iso.datetime()),
    })),
});
export const zLedgerGetTrialBalanceResponse = zTrialBalanceResponseRoot2;
export const zLedgerCreateControlAccountReconciliationData = z.object({
    body: zControlAccountReconciliationRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zLedgerCreateControlAccountReconciliationResponse = zReconciliationReportRoot;
export const zPointGetMyPointBalanceData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPointGetMyPointBalanceResponse = zMyPointBalanceRoot;
export const zPointListMyPointTransactionsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zPointListMyPointTransactionsResponse = zPointTransactionListRoot;
export const zPointGetBackofficeUserPointBalanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zPointGetBackofficeUserPointBalanceResponse = zBackofficeUserPointBalanceRoot;
export const zPointListBackofficeUserPointTransactionsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zPointListBackofficeUserPointTransactionsResponse = zPointTransactionListRoot;
export const zPointCreateBackofficeUserPointCreditData = z.object({
    body: zBackofficeUserPointCreditRequestRoot,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zPointCreateBackofficeUserPointCreditResponse = zBackofficeUserPointAdjustmentResponseRoot;
export const zPointCreateBackofficeUserPointDebitData = z.object({
    body: zBackofficeUserPointDebitRequestRoot,
    path: z.object({
        userId: z
            .string()
            .min(1)
            .max(100)
            .regex(/^[a-zA-Z0-9_-]+$/),
    }),
    query: z.optional(z.never()),
});
export const zPointCreateBackofficeUserPointDebitResponse = zBackofficeUserPointAdjustmentResponseRoot;
export const zMarketplacePaymentGetCallbackData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        code: z.string(),
        customerKey: z.string(),
    }),
});
export const zMarketplacePaymentGetCallbackResponse = z.object({
    accessToken: z.string(),
    expiresIn: z.number(),
});
export const zMarketplacePaymentListBrandPayPaymentMethodsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zMarketplacePaymentListBrandPayPaymentMethodsResponse = z.array(zBrandPayPaymentMethodRoot);
export const zMarketplacePaymentCreateBrandPayPaymentMethodDefaultData = z.object({
    body: zSetBrandPayMainCardRequestRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zMarketplacePaymentCreateBrandPayPaymentMethodDefaultResponse = z.void();
export const zMarketplacePaymentDeleteBrandPayPaymentMethodData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        methodKey: z.string(),
    }),
    query: z.optional(z.never()),
});
export const zMarketplacePaymentDeleteBrandPayPaymentMethodResponse = z.void();
export const zMarketplacePaymentGetBrandPayRegistrationStatusData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zMarketplacePaymentGetBrandPayRegistrationStatusResponse = zBrandPayRegistrationStatusRoot;
export const zContentManagementListBannersData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zContentManagementListBannersResponse = zBannerListRoot;
export const zContentManagementCreateBannerData = z.object({
    body: zBannerCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zContentManagementCreateBannerResponse = zBannerRoot;
export const zContentManagementUpdateBannerDisplayOrdersData = z.object({
    body: zBannerReorderRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zContentManagementUpdateBannerDisplayOrdersResponse = zBannerListRoot;
export const zContentManagementGetBannerImageUploadUrlData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        fileName: z.string(),
        mimeType: z.enum(["image/jpeg", "image/png", "image/webp"]),
        fileSizeBytes: z.int().gte(1).lte(10485760),
    }),
});
export const zContentManagementGetBannerImageUploadUrlResponse = zBannerImageUploadUrlRoot;
export const zContentManagementDeleteBannerData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        bannerId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zContentManagementDeleteBannerResponse = z.void();
export const zContentManagementGetBannerData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        bannerId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zContentManagementGetBannerResponse = zBannerRoot;
export const zContentManagementUpdateBannerData = z.object({
    body: zBannerUpdateRoot,
    path: z.object({
        bannerId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zContentManagementUpdateBannerResponse = zBannerRoot;
export const zContentManagementListPublicBannersData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zContentManagementListPublicBannersResponse = zActiveBannerListRoot;
export const zContentManagementListNoticesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zContentManagementListNoticesResponse = zNoticeListRoot;
export const zContentManagementCreateNoticeData = z.object({
    body: zNoticeCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zContentManagementCreateNoticeResponse = zNoticeRoot;
export const zContentManagementDeleteNoticeData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        noticeId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zContentManagementDeleteNoticeResponse = z.void();
export const zContentManagementGetNoticeData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        noticeId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zContentManagementGetNoticeResponse = zNoticeRoot;
export const zContentManagementUpdateNoticeData = z.object({
    body: zNoticeUpdateRoot,
    path: z.object({
        noticeId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zContentManagementUpdateNoticeResponse = zNoticeRoot;
export const zContentManagementGetContentFileUploadUrlData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        purpose: zContentFilePurposeRoot,
        fileName: z.string().min(1).max(255),
        mimeType: z.string().min(1).max(150),
        fileSizeBytes: z.int().gte(1).lte(20971520),
    }),
});
export const zContentManagementGetContentFileUploadUrlResponse = zContentFileUploadUrlRoot;
export const zContentManagementListContentPagesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zContentManagementListContentPagesResponse = zContentPageListRoot;
export const zContentManagementCreateContentPageData = z.object({
    body: zContentPageCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zContentManagementCreateContentPageResponse = zContentPageRoot;
export const zContentManagementDeleteContentPageData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        pageId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zContentManagementDeleteContentPageResponse = z.void();
export const zContentManagementGetContentPageData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        pageId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zContentManagementGetContentPageResponse = zContentPageRoot;
export const zContentManagementUpdateContentPageData = z.object({
    body: zContentPageUpdateRoot,
    path: z.object({
        pageId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zContentManagementUpdateContentPageResponse = zContentPageRoot;
export const zContentManagementListPublicNoticesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1).lte(50)).default(20),
        categoryId: z.optional(z.uuid()),
        excludeBannerNotices: z.optional(z.boolean()).default(false),
    })),
});
export const zContentManagementListPublicNoticesResponse = zPublicNoticeListRoot;
export const zContentManagementGetPublicNoticeData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        noticeId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zContentManagementGetPublicNoticeResponse = zPublicNoticeRoot;
export const zContentManagementListPublicNoticePopupsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zContentManagementListPublicNoticePopupsResponse = zPublicNoticePopupListRoot;
export const zContentManagementListPublicNoticeBannersData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        categoryId: z.optional(z.uuid()),
    })),
});
export const zContentManagementListPublicNoticeBannersResponse = zPublicNoticeBannerListRoot;
export const zContentManagementGetPublicContentPageData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        pageId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zContentManagementGetPublicContentPageResponse = zPublicContentPageRoot;
export const zPlatformConfigGetCommissionConfigData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetCommissionConfigResponse = zCommissionConfigRoot;
export const zPlatformConfigUpdateCommissionConfigData = z.object({
    body: zCommissionConfigUpdateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigUpdateCommissionConfigResponse = zCommissionConfigRoot;
export const zPlatformConfigGetPgFeeConfigData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetPgFeeConfigResponse = zPgFeeConfigRoot;
export const zPlatformConfigUpdatePgFeeConfigData = z.object({
    body: zPgFeeConfigUpdateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigUpdatePgFeeConfigResponse = zPgFeeConfigRoot;
export const zPlatformConfigGetSettlementConfigData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetSettlementConfigResponse = zSettlementConfigRoot;
export const zPlatformConfigUpdateSettlementConfigData = z.object({
    body: zSettlementConfigUpdateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigUpdateSettlementConfigResponse = zSettlementConfigRoot;
export const zPlatformConfigGetFeeRatesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetFeeRatesResponse = zFeeRatesRoot;
export const zPlatformConfigGetAppVersionPoliciesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetAppVersionPoliciesResponse = zAppVersionPolicyListRoot;
export const zPlatformConfigUpdateAppVersionPolicyData = z.object({
    body: zAppVersionPolicyUpdateRoot,
    path: z.object({
        platform: z.enum(["IOS", "ANDROID"]),
    }),
    query: z.optional(z.never()),
});
export const zPlatformConfigUpdateAppVersionPolicyResponse = zAppVersionPolicyRoot;
export const zPlatformConfigGetBoltbMarketSectionAllowedCategoriesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetBoltbMarketSectionAllowedCategoriesResponse = zBoltbMarketSectionAllowedCategoryListRoot;
export const zPlatformConfigUpdateBoltbMarketSectionAllowedCategoriesData = z.object({
    body: zBoltbMarketSectionAllowedCategoryListUpdateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigUpdateBoltbMarketSectionAllowedCategoriesResponse = zBoltbMarketSectionAllowedCategoryListRoot;
export const zPlatformConfigGetMobileRuntimePoliciesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetMobileRuntimePoliciesResponse = zMobileRuntimePolicyListRoot;
export const zPlatformConfigUpdateMobileRuntimePolicyData = z.object({
    body: zMobileRuntimePolicyUpdateRoot,
    path: z.object({
        platform: z.enum(["IOS", "ANDROID"]),
    }),
    query: z.optional(z.never()),
});
export const zPlatformConfigUpdateMobileRuntimePolicyResponse = zMobileRuntimePolicyRoot;
export const zPlatformConfigGetCompanyInfoData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetCompanyInfoResponse = zCompanyInfoRoot;
export const zPlatformConfigUpdateCompanyInfoData = z.object({
    body: zCompanyInfoUpdateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigUpdateCompanyInfoResponse = zCompanyInfoRoot;
export const zPlatformConfigGetAppDownloadSettingsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetAppDownloadSettingsResponse = zAppDownloadSettingRoot;
export const zPlatformConfigUpdateAppDownloadSettingsData = z.object({
    body: zAppDownloadSettingUpdateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigUpdateAppDownloadSettingsResponse = zAppDownloadSettingRoot;
export const zPlatformConfigGetBroadcastChatNoticesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetBroadcastChatNoticesResponse = zBroadcastChatNoticeListRoot;
export const zPlatformConfigCreateBroadcastChatNoticeData = z.object({
    body: zBroadcastChatNoticeCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigCreateBroadcastChatNoticeResponse = zBroadcastChatNoticeRoot;
export const zPlatformConfigUpdateBroadcastChatNoticeOrderData = z.object({
    body: zBroadcastChatNoticeOrderUpdateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigUpdateBroadcastChatNoticeOrderResponse = zBroadcastChatNoticeListRoot;
export const zPlatformConfigUpdateBroadcastChatNoticeData = z.object({
    body: zBroadcastChatNoticeUpdateRoot,
    path: z.object({
        noticeId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zPlatformConfigUpdateBroadcastChatNoticeResponse = zBroadcastChatNoticeRoot;
export const zPlatformConfigGetBroadcastChatNoticeSettingsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetBroadcastChatNoticeSettingsResponse = zBroadcastChatNoticeSettingsRoot;
export const zPlatformConfigUpdateBroadcastChatNoticeSettingsData = z.object({
    body: zBroadcastChatNoticeSettingsUpdateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigUpdateBroadcastChatNoticeSettingsResponse = zBroadcastChatNoticeSettingsRoot;
export const zPlatformConfigListChatBannedWordsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigListChatBannedWordsResponse = zChatBannedWordListRoot;
export const zPlatformConfigCreateChatBannedWordData = z.object({
    body: zChatBannedWordCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigCreateChatBannedWordResponse = zChatBannedWordRoot;
export const zPlatformConfigDeleteChatBannedWordData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        wordId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zPlatformConfigDeleteChatBannedWordResponse = z.void();
export const zPlatformConfigGetAppUiSettingsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetAppUiSettingsResponse = zAppUiSettingListRoot;
export const zPlatformConfigUpdateAppUiSettingsData = z.object({
    body: zAppUiSettingUpdateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigUpdateAppUiSettingsResponse = zAppUiSettingListRoot;
export const zPlatformConfigCreateAppUiSettingResetData = z.object({
    body: zAppUiSettingResetRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigCreateAppUiSettingResetResponse = zAppUiSettingListRoot;
export const zPlatformConfigListUiConfigFilesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigListUiConfigFilesResponse = zUiConfigFileListRoot;
export const zPlatformConfigGetUiConfigFileData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        name: z.string().max(64),
    }),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetUiConfigFileResponse = zUiConfigFileDetailRoot;
export const zPlatformConfigDeleteUiConfigDraftData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        name: z.string().max(64),
    }),
    query: z.optional(z.never()),
});
export const zPlatformConfigDeleteUiConfigDraftResponse = z.void();
export const zPlatformConfigUpdateUiConfigDraftData = z.object({
    body: zUiConfigDraftSaveRoot,
    path: z.object({
        name: z.string().max(64),
    }),
    query: z.optional(z.never()),
});
export const zPlatformConfigUpdateUiConfigDraftResponse = zUiConfigFileDetailRoot;
export const zPlatformConfigCreateUiConfigPublishData = z.object({
    body: zUiConfigPublishRoot,
    path: z.object({
        name: z.string().max(64),
    }),
    query: z.optional(z.never()),
});
export const zPlatformConfigCreateUiConfigPublishResponse = zUiConfigFileDetailRoot;
export const zPlatformConfigCreateUiConfigRevertData = z.object({
    body: zUiConfigRevertRoot,
    path: z.object({
        name: z.string().max(64),
    }),
    query: z.optional(z.never()),
});
export const zPlatformConfigCreateUiConfigRevertResponse = zUiConfigFileDetailRoot;
export const zPlatformConfigUpdateUiConfigSwitchesData = z.object({
    body: zUiConfigSwitchesRoot,
    path: z.object({
        name: z.string().max(64),
    }),
    query: z.optional(z.never()),
});
export const zPlatformConfigUpdateUiConfigSwitchesResponse = zUiConfigFileDetailRoot;
export const zPlatformConfigGetPublicMobileRuntimePolicyData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        platform: z.enum(["IOS", "ANDROID"]),
        buildNumber: z.int().gte(1),
    }),
});
export const zPlatformConfigGetPublicMobileRuntimePolicyResponse = zPublicMobileRuntimePolicyRoot2;
export const zPlatformConfigGetPublicAppVersionPoliciesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetPublicAppVersionPoliciesResponse = zAppVersionPolicyListRoot;
export const zPlatformConfigGetPublicBoltbMarketSectionAllowedCategoriesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetPublicBoltbMarketSectionAllowedCategoriesResponse = zBoltbMarketSectionAllowedCategoryListRoot;
export const zPlatformConfigGetPublicCompanyInfoData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetPublicCompanyInfoResponse = zCompanyInfoRoot;
export const zPlatformConfigGetPublicAppDownloadSettingsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetPublicAppDownloadSettingsResponse = zAppDownloadSettingRoot;
export const zPlatformConfigGetPublicBroadcastChatNoticeSettingsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        locale: z.optional(z.string()),
    })),
});
export const zPlatformConfigGetPublicBroadcastChatNoticeSettingsResponse = zPublicBroadcastChatNoticeSettingsRoot;
export const zPlatformConfigGetAppSyncChangesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        platform: z.enum(["IOS", "ANDROID", "WEB"]),
        buildNumber: z.int().gte(0),
        uiRevision: z.int().gte(0),
        fingerprints: z.optional(z.string().max(2000)),
        uiConfig: z.optional(z.string().max(2000)),
    }),
});
export const zPlatformConfigGetAppSyncChangesResponse = zAppSyncResultRoot;
export const zPlatformConfigGetPublicUiConfigManifestData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetPublicUiConfigManifestResponse = zUiConfigManifestRoot;
export const zPlatformConfigGetPublicUiConfigVersionData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        name: z.string().max(64),
        version: z.int().gte(1),
    }),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetPublicUiConfigVersionResponse = zUiConfigVersionContentRoot;
export const zPlatformConfigGetPublicPageData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        slug: z
            .string()
            .max(40)
            .regex(/^[a-z\d][a-z\d-]{0,39}$/),
    }),
    query: z.optional(z.never()),
});
export const zPlatformConfigGetPublicPageResponse = zServerPageRoot;
export const zCategoryListPublicCategoriesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zCategoryListPublicCategoriesResponse = zCategoryListRoot;
export const zCategoryListCategoriesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zCategoryListCategoriesResponse = zCategoryListRoot;
export const zCategoryCreateCategoryData = z.object({
    body: zCategoryCreateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zCategoryCreateCategoryResponse = zCategoryRoot;
export const zCategoryDeleteCategoryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        categoryId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zCategoryDeleteCategoryResponse = z.void();
export const zCategoryGetCategoryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        categoryId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zCategoryGetCategoryResponse = zCategoryRoot;
export const zCategoryUpdateCategoryData = z.object({
    body: zCategoryUpdateRoot,
    path: z.object({
        categoryId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zCategoryUpdateCategoryResponse = zCategoryRoot;
export const zCategoryGetCategoryImageUploadUrlData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        fileName: z.string(),
        mimeType: z.enum(["image/jpeg", "image/png", "image/webp"]),
        fileSizeBytes: z.int().gte(1).lte(10485760),
    }),
});
export const zCategoryGetCategoryImageUploadUrlResponse = zCategoryImageUploadUrlRoot;
export const zCategoryGetAllCategoryIconSettingData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zCategoryGetAllCategoryIconSettingResponse = zAllCategoryIconSettingRoot;
export const zCategoryUpdateAllCategoryIconSettingData = z.object({
    body: zAllCategoryIconSettingUpdateRoot,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zCategoryUpdateAllCategoryIconSettingResponse = zAllCategoryIconSettingRoot;
export const zKpiGetBackofficeKpiDashboardData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        period: z.optional(zKpiDashboardPeriodRoot),
        salesChannel: z.optional(zKpiDashboardSalesChannelRoot),
    })),
});
export const zKpiGetBackofficeKpiDashboardResponse = zBackofficeKpiDashboardResponseRoot;
export const zKpiListBackofficeKpiDashboardExportsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        period: z.optional(zKpiDashboardPeriodRoot),
        salesChannel: z.optional(zKpiDashboardSalesChannelRoot),
    })),
});
export const zKpiListBackofficeKpiDashboardExportsResponse = zBackofficeKpiDashboardExportResponseRoot;
export const zDealerBackofficeGetDashboardSummaryData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
});
export const zDealerBackofficeGetDashboardSummaryResponse = zDealerDashboardSummaryRoot22;
export const zDealerBackofficeListSalesHistoryData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
        displayStatus: z.optional(zFulfillmentOrderDisplayStatusRoot),
    })),
});
export const zDealerBackofficeListSalesHistoryResponse = zSalesHistoryListResponseRoot;
export const zDealerBackofficeGetBuyerNewOrderGroupData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        buyerId: z.uuid(),
    }),
    query: z.optional(z.never()),
});
export const zDealerBackofficeGetBuyerNewOrderGroupResponse = zBuyerNewOrderGroupResponseRoot;
export const zDealerBackofficeListBuyerHistoriesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        buyerId: z.uuid(),
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gte(1)).default(1),
        pageSize: z.optional(z.int().gte(1)).default(20),
    })),
});
export const zDealerBackofficeListBuyerHistoriesResponse = zUserHistoryEntryListRoot;
//# sourceMappingURL=zod.gen.js.map